/* RTB Engine v3 — data model: devices, formats, verifier, tracking pixel, glossary (RU) */
(function () {
  const CW = 1440, CH = 760;

  const CAT = {
    user:      { color: '#7aa2ff', glow: 'rgba(122,162,255,.55)' },
    publisher: { color: '#38bdf8', glow: 'rgba(56,189,248,.55)' },
    ssp:       { color: '#2dd4bf', glow: 'rgba(45,212,191,.55)' },
    verifier:  { color: '#f472b6', glow: 'rgba(244,114,182,.5)' },
    exchange:  { color: '#67e8f9', glow: 'rgba(103,232,249,.6)' },
    dsp:       { color: '#a78bfa', glow: 'rgba(167,139,250,.55)' },
    dmp:       { color: '#fbbf24', glow: 'rgba(251,191,36,.55)' },
    tracking:  { color: '#fb7185', glow: 'rgba(251,113,133,.5)' },
    adserver:  { color: '#34d399', glow: 'rgba(52,211,153,.5)' },
  };
  const CAT_LIGHT = {
    user:      { color: '#4f6fd6', glow: 'rgba(79,111,214,.30)' },
    publisher: { color: '#0a86c9', glow: 'rgba(10,134,201,.30)' },
    ssp:       { color: '#0d9488', glow: 'rgba(13,148,136,.30)' },
    verifier:  { color: '#c0398a', glow: 'rgba(192,57,138,.28)' },
    exchange:  { color: '#0c95b6', glow: 'rgba(12,149,182,.32)' },
    dsp:       { color: '#7c5cdb', glow: 'rgba(124,92,219,.30)' },
    dmp:       { color: '#bd7a06', glow: 'rgba(189,122,6,.30)' },
    tracking:  { color: '#dc3f63', glow: 'rgba(220,63,99,.28)' },
    adserver:  { color: '#059669', glow: 'rgba(5,150,105,.30)' },
  };
  const STAGE_LIGHT = {
    user: '#4f6fd6', request: '#0d9488', toExchange: '#0c95b6', broadcast: '#0c95b6',
    verify: '#c0398a', enrich: '#bd7a06', bid: '#7c5cdb', auction: '#0c95b6',
    response: '#0c95b6', render: '#0a86c9', track: '#dc3f63',
  };

  // ── devices & formats ──
  const DEVICES = {
    desktop: { label: 'Десктоп', sub: 'Браузер', formats: ['display', 'video', 'native'], mult: 1.0 },
    mobile:  { label: 'Мобайл',  sub: 'In-app / web', formats: ['display', 'video', 'native'], mult: 1.05 },
    ctv:     { label: 'CTV',     sub: 'Smart TV', formats: ['video'], mult: 1.6 },
  };
  const FORMATS = {
    display: { label: 'Дисплей', sub: 'Баннер', mult: 1.0 },
    video:   { label: 'Видео',   sub: 'In-stream', mult: 1.9 },
    native:  { label: 'Нативный', sub: 'In-feed', mult: 1.25 },
  };

  // ── fixed (non-DSP) nodes ──
  const FIXED_NODES = [
    { id: 'user', cat: 'user', x: 124, y: 116, w: 200, h: 98,
      title: 'Пользователь', sub: 'Cookie / ID',
      info: 'Заходит на сайт или в приложение со своего устройства (десктоп, мобайл, CTV). Тип устройства определяет доступные форматы рекламы и влияет на ценность показа.' },
    { id: 'publisher', cat: 'publisher', x: 120, y: 432, w: 196, h: 176,
      title: 'Паблишер', sub: 'Сайт · рекламное место',
      info: 'Владелец рекламного инвентаря. Каждое свободное рекламное место имеет формат (дисплей, видео, нативный) и хочет продаться как можно дороже — за доли секунды.' },
    { id: 'verifier', cat: 'verifier', x: 720, y: 96, w: 248, h: 100,
      title: 'Верификатор', sub: 'Fraud · Brand Safety',
      info: 'Независимый вендор (типа IAS / DoubleVerify). Проверяет показ до ставки: не бот ли это (fraud / IVT) и безопасен ли контент для бренда (brand safety). После показа 3rd-party pixel замеряет видимость (viewability). Если показ «грязный» — он блокируется.' },
    { id: 'exchange', cat: 'exchange', x: 720, y: 320, w: 184, h: 184,
      title: 'Ad Exchange', sub: 'Аукцион sell-side — внутри SSP',
      info: 'Здесь идёт аукцион: запрос от SSP уходит всем DSP, возвращаются ставки, выбирается победитель — меньше чем за 100 мс. На карте это отдельная станция, чтобы шаги было видно; в реальности такой аукционный движок — часть самой SSP, а не отдельная компания. Отдельные биржи ещё существуют (крупнейшая — Google AdX), но перепродажа трафика через лишние звенья — сжимающийся путь. Комиссию за аукцион удерживает sell-side, одной строкой вместе с SSP.' },
    { id: 'dmp', cat: 'dmp', x: 720, y: 624, w: 200, h: 100,
      title: 'Данные и ID', sub: 'сегменты и идентификаторы',
      info: 'Слой данных: хранит сегменты («был в корзине», «18–24») и связывает идентификаторы пользователя. DSP забирает сегменты заранее, по eids находит их в своём профиле — узнали «горячего», ставка выросла в разы. Классический DMP на 3P-cookie — уходящая категория (Oracle закрыл свой в 2024); его место заняли first-party CDP, ID-графы (UID2 / ID5) и курируемые сделки на стороне SSP.' },
    { id: 'adserver', cat: 'adserver', x: 120, y: 636, w: 196, h: 96,
      title: 'Ad server паблишера', sub: 'что показать в этом месте',
      info: 'Финальная точка решения на стороне паблишера. Сравнивает три источника спроса и выбирает, чей креатив показать: прямые продажи (проданные заранее по фиксированной цене), гарантированные сделки и победителя header bidding. Именно ради этого сравнения header bidding и придумали: раньше ad server сначала предлагал остаток собственной бирже, и внешний спрос видел только то, что осталось. Рынок почти целиком за Google Ad Manager — и это ровно тот актив, вокруг которого идут антимонопольные дела: суд признал ad server паблишера и биржу двумя отдельными монополизированными рынками, а их связывание — незаконным; Еврокомиссия отдельно оштрафовала Google на €2,95 млрд.' },
    { id: 'tracking', cat: 'tracking', x: 404, y: 624, w: 200, h: 100,
      title: 'Трекинг кампании', sub: '3rd-party tag · pixel',
      info: 'В креатив зашит 3rd-party tag / tracking pixel рекламодателя. При показе и клике он шлёт постбэк в ad server рекламодателя и в аналитику (в мобильных кампаниях — в MMP) — так считаются показы, клики, конверсии и оптимизируются следующие ставки. Сегодня события всё чаще уходят server-to-server: браузерные пиксели режут блокировщики и ITP.' },
  ];

  const FIXED_PIPES = [
    { id: 'userPub',  from: 'user',      to: 'publisher', orient: 'v' },
    { id: 'exVer',    from: 'exchange',  to: 'verifier',  orient: 'v' },
    { id: 'pubAdsrv', from: 'publisher', to: 'adserver',  orient: 'v' },
    { id: 'pubTrack', from: 'publisher', to: 'tracking',  orient: 'v' },
    { id: 'trackDmp', from: 'tracking',  to: 'dmp',       orient: 'h' },
  ];

  // ── DSP archetypes (first N used) ──
  const DSP_POOL = [
    { label: 'Бренд', sub: 'Demand-Side Platform',
      info: 'Бренд-кампания: важен охват и качественный контекст. Платит за заметные показы нужной аудитории, но не гонится за каждым кликом.',
      lo: 2.4, hi: 4.6, segProb: 0.5, upLo: 0.3, upHi: 0.9, fav: 'video' },
    { label: 'Ретаргетинг', sub: 'Demand-Side Platform',
      info: 'Ретаргетинг: «догоняет» пользователей, которые уже были на сайте рекламодателя. Если DMP узнаёт человека — ставка резко растёт.',
      lo: 1.0, hi: 2.2, segProb: 0.6, upLo: 1.6, upHi: 3.6, fav: 'display' },
    { label: 'Перформанс', sub: 'Demand-Side Platform',
      info: 'Перформанс: оптимизирует ставку под конверсии и CPA. Считает вероятность целевого действия и платит ровно столько, сколько окупится.',
      lo: 1.4, hi: 3.2, segProb: 0.55, upLo: 0.4, upHi: 1.4, fav: 'native' },
    { label: 'Видео', sub: 'Demand-Side Platform',
      info: 'Видео-реклама: дорогой формат с высоким CPM. Платит премию за досмотры и качественный инвентарь, особенно на CTV.',
      lo: 3.0, hi: 6.0, segProb: 0.4, upLo: 0.5, upHi: 1.3, fav: 'video' },
    { label: 'Mobile-app', sub: 'Demand-Side Platform',
      info: 'Продвижение приложений: оптимизирует под установки. Ставка зависит от устройства пользователя и похожести на «платящую» аудиторию.',
      lo: 1.2, hi: 2.8, segProb: 0.5, upLo: 0.7, upHi: 1.8, fav: 'display' },
    { label: 'Аудио', sub: 'Demand-Side Platform',
      info: 'Аудиореклама (подкасты, стриминг). Узкий, но лояльный охват; ставка выше при точном попадании в сегмент DMP.',
      lo: 1.0, hi: 2.4, segProb: 0.45, upLo: 0.6, upHi: 1.6, fav: 'video' },
  ];

  const SSP_POOL = [
    { label: 'SSP', sub: 'Supply-Side Platform' },
    { label: 'SSP-2', sub: 'Supply-Side Platform' },
    { label: 'SSP-3', sub: 'Supply-Side Platform' },
  ];
  const SSP_INFO = 'Представляет интересы паблишера. Упаковывает показ в bid request, выставляет floor price и сама проводит аукцион среди подключённых DSP — её аукционный движок и есть та самая «биржа». Берёт свою комиссию с продажи. Паблишер обычно подключает несколько SSP сразу — при header bidding они конкурируют параллельно.';

  function buildModel(opts) {
    opts = opts || {};
    const count = Math.max(2, Math.min(6, (opts.count || 3) | 0));
    const sspCount = Math.max(1, Math.min(3, (opts.sspCount || 1) | 0));
    const useVerifier = opts.verifier !== false;
    const useDmp = opts.dmp !== false;
    const useTracking = opts.tracking !== false;
    const useAdServer = opts.adserver !== false;
    const top = 116, bottom = 620;
    const h = count <= 4 ? 116 : (count === 5 ? 100 : 86);
    const dsps = [];
    for (let i = 0; i < count; i++) {
      const a = DSP_POOL[i];
      const y = count === 1 ? 368 : top + (bottom - top) * (i / (count - 1));
      dsps.push({ id: 'dsp' + i, cat: 'dsp', dsp: i, x: 1112, y, w: 198, h,
        title: 'DSP · ' + a.label, sub: a.sub, info: a.info });
    }
    // SSP column (1–3), vertically centered around y=300
    const ssps = [];
    const sTop = 196, sBot = 432, sh = sspCount >= 3 ? 84 : 96;
    for (let i = 0; i < sspCount; i++) {
      const a = SSP_POOL[i];
      const y = sspCount === 1 ? 300 : sTop + (sBot - sTop) * (i / (sspCount - 1));
      ssps.push({ id: 'ssp' + i, cat: 'ssp', x: 430, y, w: 176, h: sh,
        title: a.label, sub: a.sub, info: SSP_INFO });
    }
    let fixed = FIXED_NODES.slice();
    if (!useVerifier) fixed = fixed.filter(n => n.id !== 'verifier');
    if (!useDmp) fixed = fixed.filter(n => n.id !== 'dmp');
    if (!useTracking) fixed = fixed.filter(n => n.id !== 'tracking');
    if (!useAdServer) fixed = fixed.filter(n => n.id !== 'adserver');
    const nodes = fixed.concat(ssps).concat(dsps);
    const N = Object.fromEntries(nodes.map(n => [n.id, n]));

    let pipes = FIXED_PIPES.filter((p) => {
      if (p.id === 'exVer') return useVerifier;
      if (p.id === 'pubAdsrv') return useAdServer;
      if (p.id === 'pubTrack') return useTracking;
      if (p.id === 'trackDmp') return useTracking && useDmp;
      return true;
    });
    for (let i = 0; i < sspCount; i++) {
      pipes.push({ id: 'pubSSP' + i, from: 'publisher', to: 'ssp' + i, orient: 'h' });
      pipes.push({ id: 'sspEx' + i, from: 'ssp' + i, to: 'exchange', orient: 'h' });
    }
    for (let i = 0; i < count; i++) {
      pipes.push({ id: 'exD' + i, from: 'exchange', to: 'dsp' + i, orient: 'h' });
      if (useDmp) pipes.push({ id: 'dmpD' + i, from: 'dmp', to: 'dsp' + i, orient: 'h' });
    }
    return { nodes, N, pipes, count, sspCount, useVerifier, useDmp, useTracking, useAdServer };
  }

  // ── stage timeline ──
  const STAGES = [
    { id: 'user', title: '01 · Открытие страницы', actor: 'user', clock: 6, color: '#7aa2ff',
      desc: 'Пользователь открывает сайт или приложение со своего устройства. Браузер загружает страницу, и одно из рекламных мест оказывается свободным — его нужно заполнить.',
      pipes: [{ id: 'userPub', dir: 1 }] },
    { id: 'request', title: '02 · Запрос показа (bid request)', actor: 'ssp', clock: 16, color: '#2dd4bf',
      desc: 'Код рекламного места обращается к SSP. Та формирует bid request: формат, размер, URL, гео, устройство, данные о пользователе — и выставляет floor price.',
      pipes: [], fans: [{ prefix: 'pubSSP', dir: 1 }] },
    { id: 'toExchange', title: '03 · В аукцион', actor: 'exchange', clock: 26, color: '#67e8f9',
      desc: 'Запрос попадает в аукционный движок sell-side — на карте он нарисован отдельной станцией «Ad Exchange», чтобы шаги было видно, хотя обычно это часть самой SSP. Запускается таймер торгов (tmax): каждому DSP даётся ~100 мс на ответ. Это бюджет на сбор ставок, а не на весь путь до показа — рендер и трекинг идут уже после закрытия аукциона.',
      pipes: [], fans: [{ prefix: 'sspEx', dir: 1 }] },
    { id: 'verify', title: '04 · Верификация (Fraud / Brand Safety)', actor: 'verifier', clock: 38, color: '#f472b6',
      desc: 'Перед аукционом показ проходит верификацию: не бот ли это (fraud / IVT) и безопасен ли контент для бренда (brand safety). На стороне предложения это делают биржа/SSP, на стороне спроса — сам DSP (pre-bid). «Грязный» показ блокируется и на аукцион не попадает.',
      pipes: [{ id: 'exVer', dir: 1 }], verify: true },
    { id: 'broadcast', title: '05 · Рассылка DSP', actor: 'exchange', clock: 48, color: '#67e8f9',
      desc: 'Биржа одновременно рассылает bid request всем подключённым DSP. Каждая платформа решает за себя: интересен ли ей этот показ, формат и этот пользователь.',
      pipes: [], fan: { prefix: 'exD', dir: 1 } },
    { id: 'enrich', title: '06 · Данные и идентификация', actor: 'dmp', clock: 60, color: '#fbbf24',
      desc: 'Сегменты пользователя у DSP уже есть — они синхронизированы заранее через cookie-sync с DMP, вне окна аукциона. По eids/ID платформа находит сегменты в своём профиле: узнали «горячего» — ставка вырастет, не узнали — DSP может промолчать.',
      pipes: [], fan: { prefix: 'dmpD', dir: 1 } },
    { id: 'bid', title: '07 · Ставки (bid response)', actor: 'dsp', clock: 72, color: '#a78bfa',
      desc: 'Каждый DSP считает свою цену за тысячу показов (CPM) с учётом формата и возвращает ставку на биржу. Ставки ниже floor price отбрасываются, кто-то может не успеть ответить (timeout).',
      pipes: [], fan: { prefix: 'exD', dir: -1 } },
    { id: 'auction', title: '08 · Аукцион', actor: 'exchange', clock: 82, color: '#67e8f9', reveal: true,
      desc: 'Биржа сравнивает ставки и выбирает победителя. Цена, которую он заплатит, зависит от типа аукциона (см. панель Tweaks).',
      pipes: [] },
    { id: 'response', title: '09 · Возврат победителя', actor: 'exchange', clock: 88, color: '#67e8f9',
      desc: 'Креатив победившего DSP уходит обратно через биржу и SSP на страницу паблишера. Аукцион закрыт, цена зафиксирована. Последнее слово — за ad server паблишера: он сравнивает победителя header bidding с прямыми продажами и гарантированными сделками и решает, чей креатив реально покажут.',
      pipes: [{ id: 'pubAdsrv', dir: 1 }], fans: [{ prefix: 'sspEx', dir: -1 }, { prefix: 'pubSSP', dir: -1 }] },
    { id: 'render', title: '10 · Показ объявления', actor: 'publisher', clock: 90, color: '#38bdf8', render: true,
      desc: 'Баннер или видео победителя отрисовывается в рекламном месте. Зашитый в креатив 3rd-party pixel срабатывает, а верификатор замеряет видимость (viewability). На CTV браузерного рендера обычно нет: SSAI-сервер вшивает ролик прямо в видеопоток, а события отдаёт плеер.',
      pipes: [], pixel: true },
    { id: 'track', title: '11 · Трекинг и деньги', actor: 'tracking', clock: 92, color: '#fb7185',
      desc: '3rd-party tag / pixel фиксирует показ и клик, отправляет постбэк в ad server рекламодателя и MMP. Из цены вычитается комиссия sell-side (SSP вместе со своим аукционом) — остальное получает паблишер.',
      pipes: [{ id: 'pubTrack', dir: 1 }, { id: 'trackDmp', dir: 1 }], pixel: true },
  ];

  // terminal stage when a threat is detected
  const BLOCK_STAGE = {
    id: 'blocked', title: 'Показ заблокирован', actor: 'verifier', clock: 38, color: '#fb7185',
    desc: '', blocked: true,
  };

  // ── auction generation ──
  function makeAuction(opts) {
    opts = opts || {};
    const count = Math.max(2, Math.min(6, (opts.count || 3) | 0));
    const dmpOn = opts.dmpOn !== false;
    const firstPrice = opts.auctionType === 'first';
    const cookieless = !!opts.cookieless;
    // GDPR / IAB TCF: may this user be processed for personalised advertising? This is NOT the same
    // lever as `cookieless`. Cookieless is TECHNICAL — match rates fall, bids get weaker. No consent
    // is LEGAL — no personal data may be processed at all, so demand that lives on the user ID
    // (retargeting) cannot function and simply DOES NOT BID. That is the part cookieless never
    // captures: it is not a lower bid, it is a MISSING BIDDER. Whoever is left bids contextually.
    const consent = opts.consent !== false;
    const dataReliant = (a) => ((a.upLo + a.upHi) / 2) > 1.0;   // its whole model is the user profile
    const inAuction = (a) => consent || !dataReliant(a);
    const device = DEVICES[opts.device] ? opts.device : 'desktop';
    let format = FORMATS[opts.format] ? opts.format : 'display';
    if (!DEVICES[device].formats.includes(format)) format = DEVICES[device].formats[0];
    const fmtMult = FORMATS[format].mult * DEVICES[device].mult;

    // ── bid shading + floor ───────────────────────────────────────────────────────────────
    // FIRST price: the winner pays its own bid, so a DSP bids BELOW what the impression is really
    // worth to it (bid shading). SECOND price: truthful bidding is the dominant strategy, so it
    // bids its full value. This is exactly why the floor matters — it is the publisher's only
    // lever against shading: a bidder that values the impression above the floor will bid up to
    // the floor rather than lose it.
    // A DSP does NOT shade a flat % off its own valuation — it bids toward what it believes it
    // takes to WIN (the expected clearing price), only partly exposing the value above that. So a
    // bidder worth $6 in a market that clears near $2.5 bids nowhere near $6. That is what makes
    // the floor the publisher's real lever: raise it above the market's shading target and every
    // bidder that still wants the impression must bid up to it.
    const SHADE_K = 0.5;                     // share of value-above-clearing still exposed in the bid
    const EXPCLEAR_K = 0.62;                 // buyers' belief: ~62% of the top expected value wins
    // A DYNAMIC floor is predicted per impression by the SSP from the demand model alone (pool
    // means × format/device/data multipliers). It never peeks at this run's random draws — so it
    // can and does overshoot, and then nothing clears. That trade-off is the whole lesson.
    // RESOLD PATH: the impression reaches the buyer through an extra intermediary that bought it from
    // another platform and resells it. Two things happen, and both are the lesson:
    //   money  — the reseller's cut is STACKED SEQUENTIALLY on an already-sell-side-fee'd price (this
    //            is where the old two-fee model was actually true), so the publisher nets visibly less;
    //   demand — big buyers run SPO (supply path optimisation) and increasingly refuse resold auctions
    //            outright, so a premium bidder disappears rather than bidding lower.
    const resellerHop = !!opts.resellerHop;
    const RESELL_FEE = 0.12;
    const spoRefuses = (i) => resellerHop && i === 0;   // the brand buyer is the strictest about supply paths

    // Per-impression demand factor: how good THIS user/context happens to be. Everyone observes it —
    // the DSPs price it into their bids, and it moves where buyers expect the auction to clear. So
    // two runs of the same config are not just noise: some impressions are genuinely hotter.
    const hot = +(0.75 + Math.random() * 0.5).toFixed(3);
    const expValue = (a, h) => {
      let b = ((a.lo + a.hi) / 2) * fmtMult * h;
      if (!consent) b *= 0.8;                                  // contextual only: no personalisation, no freq. cap
      if (a.fav === format) b *= 1.15;
      if (cookieless) b *= 0.85;
      const recP = consent ? (cookieless ? a.segProb * 0.3 : a.segProb) : 0;   // no consent → nobody is recognised
      const up = dmpOn ? recP * ((a.upLo + a.upHi) / 2) * (cookieless ? 0.4 : 1) : 0;
      return b + up;
    };
    let expTop = 0;
    for (let i = 0; i < count; i++) {
      const a = DSP_POOL[i];
      if (!inAuction(a) || spoRefuses(i)) continue;            // a bidder that is not there cannot set the price
      const v = expValue(a, hot); if (v > expTop) expTop = v;
    }
    const expClear = +(expTop * EXPCLEAR_K).toFixed(2);   // where buyers believe this impression lands
    const floor = +(opts.floor != null ? opts.floor : 1.5);
    // NOTE on dynamic floors (deliberately NOT modelled): a revenue-per-opportunity sweep over this
    // demand model showed the floor is not a profitable lever at ANY level or bidder count — where it
    // does not bind it changes nothing, where it binds it costs more in lost fill than it gains in
    // price. That is a property of a SINGLE-SHOT auction: in the real market floors pay off through
    // the repeated game (buyers adapt their shading to the floors they keep meeting, and without
    // floors the clearing price drifts down). Modelling that needs a multi-round learner, so rather
    // than tune constants until a "dynamic floor wins" story appeared, the feature was dropped.
    // What IS modelled below is real and visible: a bid gets bumped UP to the floor, and a floor set
    // too high leaves the impression unsold — drag the floor slider and you can see both.

    // verification
    const verify = opts.verify !== false;
    const threat = !!opts.threat;
    let blocked = false, blockReason = '';
    if (verify && threat) {
      blocked = true;
      blockReason = Math.random() < 0.5 ? 'fraud' : 'safety';
    }

    // deal config
    const dealType = (opts.dealType === 'pmp' || opts.dealType === 'preferred') ? opts.dealType : 'open';
    let dealFloor = 0, prefPrice = 0, dealParticipants = [];
    if (dealType === 'pmp') {
      dealFloor = +(floor * 1.7).toFixed(2);
      dealParticipants = [0, 1].filter((i) => i < count);
    } else if (dealType === 'preferred') {
      prefPrice = +(floor * 1.5).toFixed(2);
      dealParticipants = [0].filter((i) => i < count);
    }
    const dealIds = {};
    dealParticipants.forEach((i) => {
      dealIds[i] = 'DL-' + (0x1000 + Math.floor(Math.random() * 0xefff)).toString(16).toUpperCase();
    });

    // ONE sell-side take. The exchange is the SSP's own auction engine, not a separate company on a
    // direct path, so audited supply-chain studies (ISBA/PwC, ANA/PwC) itemise a single sell-side fee
    // of roughly 13% of advertiser spend — 15% of the clearing price lands there once the buy-side
    // margin is added on top. STACKED sell-side fees are real only on RESOLD multi-hop paths, which
    // are a shrinking minority; that story belongs to a future `resellerHop` lever, not the default.
    const SELL_FEE = 0.15, DSP_FEE = 0.15;
    const bids = [];
    for (let i = 0; i < count; i++) {
      const a = DSP_POOL[i];
      let base = a.lo + Math.random() * (a.hi - a.lo);
      base *= fmtMult;
      base *= hot;                                        // this impression's context/user quality — everyone sees it
      if (a.fav === format) base *= 1.15;
      if (cookieless) base *= 0.85;
      if (!consent) base *= 0.8;                          // contextual only: no personalisation, no freq. cap
      base = +base.toFixed(2);
      const recProb = cookieless ? a.segProb * 0.3 : a.segProb;
      const recognized = consent && (Math.random() < recProb);   // no consent → nobody is recognised
      const upMul = cookieless ? 0.4 : 1;
      const uplift = dmpOn && recognized ? +((a.upLo + Math.random() * (a.upHi - a.upLo)) * upMul).toFixed(2) : 0;
      const value = +(base + uplift).toFixed(2);           // what the impression is really worth to this DSP
      let cpm = value;                                     // 2nd price → truthful bidding is dominant
      if (firstPrice) {
        // 1st price → bid toward the expected clearing price, exposing only part of the value above it
        cpm = value > expClear ? +(expClear + (value - expClear) * SHADE_K).toFixed(2) : value;
        if (value >= floor && cpm < floor) cpm = floor;    // …but bid up to the floor rather than lose it
      }
      const timeout = Math.random() < 0.08;
      const noconsent = !inAuction(a);                    // cannot work without the user ID → no bid at all
      const resold = spoRefuses(i);                       // SPO: refuses to buy this impression via a reseller
      const b = { dsp: i, label: a.label, base, value, cpm, uplift, shaded: firstPrice && cpm < value, recognized: dmpOn && recognized, valid: false, reason: '', timeout, noconsent, resold };
      if (dealParticipants.indexOf(i) >= 0) { b.deal = true; b.dealId = dealIds[i]; }
      if (blocked) b.reason = 'blocked';
      else if (noconsent) b.reason = 'noconsent';
      else if (resold) b.reason = 'resold';
      else if (timeout) b.reason = 'timeout';
      bids.push(b);
    }

    const clearPrice = (sorted, fl) => {
      const w = sorted[0], s = sorted[1];
      if (!w) return 0;
      if (firstPrice) return w.cpm;
      return +Math.min(w.cpm, Math.max(s ? s.cpm : fl, fl) + 0.01).toFixed(2);
    };
    const supplyPath = opts.supplyPath === 'waterfall' ? 'waterfall' : 'header';
    let wasted = 0;
    const openAuction = () => {
      bids.forEach((b) => {
        if (b.noconsent) { b.valid = false; b.reason = 'noconsent'; return; }
        if (b.resold) { b.valid = false; b.reason = 'resold'; return; }
        if (b.timeout) { b.valid = false; b.reason = 'timeout'; return; }
        b.valid = b.cpm >= floor;
        b.reason = b.valid ? '' : 'below';
      });
      const passed = bids.filter((b) => b.valid);
      if (!passed.length) return { winner: null, clearing: 0, via: null };
      if (supplyPath === 'waterfall') {
        // sequential cascade: sold to the FIRST source (priority = index order) that clears floor,
        // at its own price (tag-based first price). Highest bidder may be skipped → money left on table.
        const w = passed[0]; // first in index/priority order that passed
        const best = passed.reduce((m, b) => Math.max(m, b.cpm), 0);
        wasted = +Math.max(0, best - w.cpm).toFixed(2);
        return { winner: w, clearing: w.cpm, via: 'open' };
      }
      const v = passed.slice().sort((x, y) => y.cpm - x.cpm);
      return { winner: v[0], clearing: clearPrice(v, floor), via: 'open' };
    };

    let winner = null, clearing = 0, wonVia = null;
    if (!blocked) {
      if (dealType === 'preferred') {
        const p = bids[0];
        if (p && !p.noconsent && !p.resold && !p.timeout && p.cpm >= prefPrice) {
          p.valid = true; p.accepted = true; p.reason = '';
          bids.forEach((b) => { if (b !== p) { b.valid = false; b.reason = b.noconsent ? 'noconsent' : b.resold ? 'resold' : b.timeout ? 'timeout' : 'skipped'; } });
          winner = p; clearing = prefPrice; wonVia = 'preferred';
        } else {
          if (p) p.reason = p.noconsent ? 'noconsent' : p.resold ? 'resold' : p.timeout ? 'timeout' : 'declined';
          const r = openAuction(); winner = r.winner; clearing = r.clearing; wonVia = r.via;
        }
      } else if (dealType === 'pmp') {
        bids.forEach((b) => {
          if (b.noconsent) { b.valid = false; b.reason = 'noconsent'; return; }
          if (b.resold) { b.valid = false; b.reason = 'resold'; return; }
          if (b.timeout) { b.valid = false; b.reason = 'timeout'; return; }
          if (b.deal) { b.valid = b.cpm >= dealFloor; b.reason = b.valid ? '' : 'below_deal'; }
          else { b.valid = b.cpm >= floor; b.reason = b.valid ? '' : 'below'; }
        });
        const dealBids = bids.filter((b) => b.deal && b.valid).sort((x, y) => y.cpm - x.cpm);
        if (dealBids.length) {
          winner = dealBids[0]; clearing = clearPrice(dealBids, dealFloor); wonVia = 'deal';
        } else {
          const r = openAuction(); winner = r.winner; clearing = r.clearing; wonVia = r.via;
        }
      } else {
        const r = openAuction(); winner = r.winner; clearing = r.clearing; wonVia = r.via;
      }
    }

    // Buy-side first: the advertiser's gross media spend = the clearing price (what enters the
    // exchange auction) PLUS the DSP's margin. Then sell-side: exchange cut, then SSP cut, then publisher net.
    const dspCut = +(clearing * DSP_FEE).toFixed(2);
    const advGross = +(clearing + dspCut).toFixed(2);
    const sellCut = +(clearing * SELL_FEE).toFixed(2);
    const afterSell = clearing - sellCut;
    const resellCut = resellerHop ? +(afterSell * RESELL_FEE).toFixed(2) : 0;
    const pubNet = +(afterSell - resellCut).toFixed(2);

    return {
      floor, expClear, hot, dmpOn, firstPrice, count, device, format, fmtMult, verify, threat, blocked, blockReason, cookieless, consent, resellerHop,
      dealType, dealFloor, prefPrice, dealParticipants, wonVia, supplyPath, wasted,
      bids, winnerDsp: winner ? winner.dsp : null, clearing,
      money: { advPays: advGross, mediaCost: clearing, dspCut, sellCut, resellCut, pubNet, dspPct: DSP_FEE, sellPct: SELL_FEE, resellPct: RESELL_FEE },
    };
  }

  // ── glossary ──
  const GLOSSARY = {
    'RTB': 'Real-Time Bidding — закупка показов через аукцион в реальном времени, отдельно за каждый показ.',
    'programmatic': 'Programmatic — автоматизированная закупка рекламы через платформы и алгоритмы.',
    'SSP': 'Supply-Side Platform — платформа на стороне паблишера: продаёт его рекламные места на аукционе.',
    'DSP': 'Demand-Side Platform — платформа на стороне рекламодателя: автоматически делает ставки за показы.',
    'DMP': 'Data-Management Platform — хранит и сегментирует данные о пользователях для таргетинга. Легаси-категория: строилась на 3P-cookie, Oracle закрыл свой DMP в 2024. Функции разошлись по first-party CDP, ID-графам (UID2 / ID5), clean room и курации на стороне SSP — поэтому узел на карте называется «Данные и ID», а не DMP.',
    'Ad Exchange': 'Ad Exchange — аукционный маркетплейс между предложением и спросом. В 2026 у каждой крупной SSP аукцион свой, и рынок считает их одной категорией — поэтому и комиссия на прямом пути одна, sell-side. Единственная большая отдельная биржа — Google AdX; вокруг неё идут антимонопольные разбирательства в США и ЕС, исход пока не решён. Независимые биржи, перепродающие чужой трафик, ещё есть, но это сжимающийся и хуже оплачиваемый путь, который крупные DSP всё чаще блокируют.',
    'bid request': 'Bid request — запрос на ставку: описание показа, формата и пользователя, которое биржа рассылает DSP.',
    'bid response': 'Bid response — ответ DSP со ставкой и креативом, который он готов показать.',
    'floor price': 'Floor price — минимальная цена, ниже которой паблишер не продаёт показ.',
    'CPM': 'CPM — цена за тысячу показов (Cost Per Mille). Основная валюта ставок в programmatic.',
    'аукцион первой цены': 'Аукцион первой цены — победитель платит свою ставку. С ~2019 это норма открытого аукциона: биржи и SSP перешли на first-price. Поэтому DSP заранее занижает ставку (bid shading) до ожидаемой цены клиринга.',
    'аукцион второй цены': 'Аукцион второй цены — победитель платит цену второго места + 1 цент. Историческая модель: была нормой до ~2019, сегодня в открытом аукционе почти не встречается (остаётся внутри отдельных стеков и приватных сделок).',
    'bid shading': 'Bid shading — DSP занижает ставку до ожидаемой цены клиринга. При первой цене победитель платит свою ставку, поэтому бить в полную оценку показа невыгодно.',
    'SSAI': 'SSAI — server-side ad insertion: реклама вшивается в видеопоток на сервере, а не запрашивается плеером. Норма для CTV: браузера нет, блокировщик не работает — но и измерять сложнее, события шлёт плеер или сервер.',
    'TCF': 'IAB TCF (Transparency & Consent Framework) — отраслевой стандарт согласия в ЕС: CMP на сайте собирает согласие и кодирует его в consent string, которая едет дальше по всей цепочке bid request.',
    'consent string': 'Consent string — закодированное согласие пользователя (TCF), которое передаётся в bid request (user.consent + regs.gdpr). По ней каждый участник цепочки понимает, что ему можно делать с данными. Нет согласия — нет ID и сегментов, а спрос, живущий на профиле (ретаргетинг), просто не выходит на торги. Это не то же самое, что cookieless: там ID технически трудно сматчить, здесь его юридически нельзя передавать.',
    'клиринговая цена': 'Клиринговая цена — итоговая цена, которую победитель реально платит за показ.',
    'постбэк': 'Постбэк — обратный сигнал о событии (показ, клик, конверсия), который уходит для оптимизации.',
    'сегменты': 'Сегменты — группы пользователей по интересам/поведению, по которым DSP оценивает ценность показа.',
    'креатив': 'Креатив — само рекламное объявление (баннер, видео, нативный блок), которое видит пользователь.',
    'паблишер': 'Паблишер — владелец сайта или приложения, который продаёт рекламные места.',
    'рекламное место': 'Рекламное место (ad slot) — конкретная позиция на странице, куда вставляется объявление.',
    '3rd-party tag': '3rd-party tag — сторонний рекламный тег в креативе, который грузит объявление и шлёт данные во внешний ad server.',
    '3rd-party pixel': '3rd-party pixel — невидимый пиксель стороннего вендора: фиксирует показ/клик и замеряет видимость и фрод.',
    'pixel': 'Tracking pixel — невидимый пиксель 1×1, который при загрузке фиксирует событие (показ, клик, конверсию).',
    'fraud': 'Fraud — рекламный фрод: накрутка показов и кликов ботами вместо живых людей.',
    'IVT': 'IVT (Invalid Traffic) — невалидный трафик: боты, дата-центры, накрутка. Верификатор отсеивает такие показы.',
    'brand safety': 'Brand Safety — универсальный «пол»: контент, рядом с которым не должна идти ничья реклама вообще (терроризм, эксплуатация детей, пиратство, разжигание ненависти). Одинаков для всех брендов. Настройка под конкретный бренд — это уже brand suitability.',
    'brand suitability': 'Brand Suitability — пригодность под конкретный бренд: один и тот же контент подходит одному рекламодателю и не подходит другому. Новость о смертельном ДТП убийственна для автобренда и идеальна для страховщика. Работает в обе стороны: не только запрет, но и поиск «своего» контекста.',
    'blocklist': 'Blocklist — список стоп-слов или доменов, по которому показ отклоняют. Ищет подстроку и не понимает смысла, поэтому массово выключает нормальные новости: «стрельба» в репортаже с Олимпиады блокируется так же, как в криминальной хронике.',
    'MFA': 'MFA (Made for Advertising) — сайты, существующие ради показов: агрессивная реклама, купленный трафик, контент как предлог. Это не brand safety (контент обычно безобиден), а вопрос качества: CPM там примерно на четверть ниже, поэтому оптимизаторы туда и идут.',
    'pre-bid / post-bid': 'Pre-bid — проверка ДО ставки: плохой показ просто не покупают, деньги целы. Post-bid — показ уже куплен, а тег на странице отказывается отрисовать креатив: бренд спасён, деньги в основном потрачены.',
    'viewability': 'Viewability — видимость: реально ли показ попал в зону видимости экрана, а не прокручен мимо.',
    'attention': 'Attention (внимание) — реально ли человек посмотрел на показ и сколько секунд. Ступень качества выше viewability: «мог увидеть» ≠ «увидел».',
    'attention seconds': 'Attention-секунды — сколько секунд реального внимания собрал показ. Осязаемая метрика вместо бинарного «viewable / не viewable».',
    'Adelaide AU': 'Adelaide AU — единый балл внимания (0–100) от вендора Adelaide по сигналам показа и страницы; пример предиктивной attention-метрики.',
    'верификатор': 'Верификатор — независимый вендор (IAS, DoubleVerify), проверяющий fraud, brand safety и viewability.',
    'CTV': 'CTV (Connected TV) — реклама на Smart TV и приставках, обычно видеоформат с высоким CPM.',
    'формат': 'Формат — тип рекламы: дисплей (баннер), видео (in-stream) или нативный (в ленте контента).',
    'устройств': 'Устройство — десктоп, мобайл или CTV. Определяет доступные форматы и влияет на цену показа.',
    'видео': 'Видеореклама — формат с высоким CPM: in-stream (в плеере) или out-stream (в контенте).',
    'нативн': 'Нативный формат — реклама, вписанная в ленту контента и повторяющая его вид.',
    'PMP': 'PMP (Private Marketplace) — приватный аукцион: показы доступны только приглашённым покупателям по Deal ID, обычно с повышенным floor.',
    'Deal ID': 'Deal ID — идентификатор прямой сделки между паблишером и покупателем с согласованными условиями (цена, доступ, приоритет).',
    'deal floor': 'Deal floor — повышенная минимальная цена в рамках прямой сделки (PMP), выше обычного floor открытого аукциона.',
    'Preferred': 'Preferred Deal — сделка с «первым взглядом» (first-look): приоритетный покупатель может выкупить показ по фикс. цене до открытого аукциона.',
    'first-look': 'First-look — право приоритетного покупателя первым решить, брать ли показ по согласованной цене, до открытого аукциона.',
    'приватн': 'Приватный аукцион — закрытые торги среди приглашённых по Deal ID покупателей, с приоритетом над открытым RTB.',
    'header bidding': 'Header bidding — паблишер запускает единый аукцион среди многих источников спроса параллельно (в «шапке» страницы) до вызова ad server. Все конкурируют одновременно — выше доход.',
    'waterfall': 'Waterfall — «водопад»: источники спроса опрашиваются последовательно по приоритету. Первый, кто берёт показ по своей цене, выигрывает — более высокий спрос ниже по цепочке не успевает поучаствовать. Историческая модель: норма до ~2016–18, в вебе вытеснена header bidding; сохраняется как фолбэк в in-app и CTV.',
    'ad server': 'Ad server — у паблишера это финальная точка решения: чьё объявление показать (прямые продажи, сделки, победитель header bidding); рынок почти целиком за Google Ad Manager. У рекламодателя свой ad server — он хостит креативы и считает показы/клики независимо от паблишера, отсюда вечные расхождения в цифрах.',
    'SPO': 'SPO (supply path optimisation) — покупатель осознанно сужает набор путей, через которые берёт показ: меньше звеньев, меньше комиссий, больше прозрачности. На практике крупные DSP просто перестают биддить на перепроданных многозвенных путях — то есть лишний посредник стоит паблишеру не только маржи, но и спроса.',
    'reseller': 'Реселлер — посредник, который купил инвентарь у другой платформы и перепродаёт его дальше. Его комиссия ложится поверх уже удержанных, а из-за SPO крупнейшие покупатели такие пути всё чаще отказываются брать. Перепроданный трафик — сжимающаяся доля расходов; это единственный случай, когда старая картинка «две комиссии» действительно верна.',
    'curation': 'Курация — инвентарь + данные + правила упаковываются в Deal ID на стороне sell-side. Таргетинг переезжает с buy-side (где им занимался DMP) на SSP: куратор собирает пакет, покупатель берёт его одной сделкой. Один из главных сдвигов 2024–26 и фактический наследник DMP-обогащения.',
    'eids': 'eids (alt-ID) — массив альтернативных идентификаторов в bid request (user.eids): UID2, ID5, RampID. Бывают детерминированные (по хешу email или логину) и вероятностные. Пришли на смену 3P-cookie как переносчик идентичности между участниками цепочки.',
    'clean room': 'Clean room — нейтральная среда, где рекламодатель и паблишер сопоставляют свои first-party данные, не передавая их друг другу: строят аудитории и меряют результат. Работает офлайн, вне 100-мс окна аукциона, — поэтому на карте RTB её нет.',
  };
  // The glossary panel groups terms by canonical English ids (GLOSS_GROUPS); some RU terms are keyed
  // in Russian, so alias those English ids to the same RU definitions — otherwise the RU panel drops them.
  [['verifier', 'верификатор'], ['publisher', 'паблишер'], ['clearing price', 'клиринговая цена'],
   ['segments', 'сегменты'], ['creative', 'креатив'], ['ad slot', 'рекламное место'],
   ['device', 'устройств'], ['native', 'нативн'], ['format', 'формат'], ['video', 'видео'],
   ['first-price auction', 'аукцион первой цены'], ['second-price auction', 'аукцион второй цены'],
   ['postback', 'постбэк']].forEach((p) => { if (GLOSSARY[p[1]] && !GLOSSARY[p[0]]) GLOSSARY[p[0]] = GLOSSARY[p[1]]; });

  // ── per-pipe transmitted payloads (hover to inspect) ──
  const SIGNALS = {
    userPub: { title: 'Загрузка страницы', dir: 'Пользователь → Паблишер', fields: [
      ['url', '{url}'],
      ['referrer', 'google.com'],
      ['user-agent', 'Chrome 124 · {dev}'],
      ['cookie / ID', 'u-9f3a…e21'],
      ['гео', '{geo}'],
      ['язык', '{lng}'],
    ] },
    pubSSP: { title: 'Запрос рекламы', dir: 'Паблишер → SSP', fields: [
      ['размер места', '{size}'],
      ['формат', '{fmt}'],
      ['позиция', 'above the fold'],
      ['домен', '{domain}'],
      ['категория', 'IAB12 · News'],
      ['floor', '${floor} CPM'],
    ], back: { dir: '← обратно', fields: [['креатив', 'adm (HTML/VAST)'], ['win notice', 'nurl']] } },
    sspEx: { title: 'Bid request · OpenRTB', dir: 'SSP → Ad Exchange', fields: [
      ['imp.id', '1'],
      ['imp.banner.w×h', '{size}'],
      ['bidfloor', '${floor} CPM'],
      ['device', '{dev}'],
      ['geo', '{geoip}'],
      ['user.id', 'u-9f3a…e21'],
      ['tmax', '100 ms'],
    ], back: { dir: '← обратно', fields: [['seatbid.price', '${clr} CPM'], ['crid', 'cr-7781'], ['adomain', '["brand.com"]']] },
      json: '{\n  "id": "a91f-7e21",\n  "imp": [{\n    "id": "1",\n    "banner": { "w": 300, "h": 250 },\n    "bidfloor": {floor}, "bidfloorcur": "USD"\n  }],\n  "site": { "domain": "{domain}", "cat": ["IAB12"] },\n  "device": { "ua": "Chrome/124", "geo": { "country": "{cc}" } },\n  "user": { "id": "u-9f3a…e21" },\n  "tmax": 100\n}' },
    exVer: { title: 'Контекст на проверку', dir: 'Ad Exchange → Верификатор', fields: [
      ['ip', '95.♢.♢.♢'],
      ['user-agent', 'Chrome 124'],
      ['домен', '{domain}'],
      ['IVT-сигналы', 'data-center? bot?'],
      ['контент', 'brand-safety scan'],
    ] },
    exD: { title: 'Bid request → DSP', dir: 'Ad Exchange → DSP', fields: [
      ['imp + sizes', '{size} · {fmt}'],
      ['bidfloor', '${floor} CPM'],
      ['device / geo', '{dev} · {cc}'],
      ['regs.gdpr', '1 · EU'],
      ['user.consent · TCF', '{tcf}'],
      ['user.id', 'u-9f3a…e21'],
      ['user.eids', 'UID2 / ID5 / RampID'],
      ['tmax', '100 ms'],
    ], back: { dir: 'Bid response ← DSP', fields: [['price', 'CPM ставка'], ['crid', 'creative id'], ['adomain', '["brand.com"]'], ['dealid', 'если PMP']] },
      json: '{\n  "seatbid": [{\n    "seat": "dsp-acme",\n    "bid": [{\n      "id": "bid-1",\n      "impid": "1",\n      "price": {clr},\n      "adm": "<creative/>",\n      "nurl": "https://dsp/win",\n      "burl": "https://dsp/bill",\n      "crid": "cr-7781",\n      "adomain": ["brand.com"],\n      "dealid": null\n    }]\n  }],\n  "cur": "USD"\n}' },
    dmpD: { title: 'Сегменты пользователя', dir: 'DMP ↔ DSP', fields: [
      ['запрос', 'по cookie / ID'],
      ['сегменты', '«авто», «в корзине»'],
      ['возраст', '25–34'],
      ['интересы', 'tech, travel'],
      ['lookalike', '0.82'],
    ] },
    pubTrack: { title: 'События показа / клика', dir: 'Паблишер → Трекинг', fields: [
      ['событие', 'impression'],
      ['креатив', 'cr-7781'],
      ['viewability', 'MRC 50% / 1s'],
      ['клик', 'click → landing'],
      ['t', 't0 + 92 ms'],
    ] },
    trackDmp: { title: 'Постбэк', dir: 'Трекинг → ad server рекламодателя / MMP', fields: [
      ['событие', 'imp / click / conv'],
      ['win price', '${clr} CPM'],
      ['user', 'u-9f3a…e21'],
      ['кампания', 'camp-2231'],
      ['оптимизация', 'модель CTR / CR'],
    ] },
  };

  function getSignal(pipeId, ctx) {
    ctx = ctx || {};
    let key = pipeId;
    if (/^exD\d+$/.test(pipeId)) key = 'exD';
    else if (/^dmpD\d+$/.test(pipeId)) key = 'dmpD';
    else if (/^sspEx\d+$/.test(pipeId)) key = 'sspEx';
    else if (/^pubSSP\d+$/.test(pipeId)) key = 'pubSSP';
    const sig = SIGNALS[key];
    if (!sig) return null;
    const lng3 = window.__lang;
    const en = lng3 === 'en';
    const pl = lng3 === 'pl';
    const intl = en || pl; // international values (.com/.pl, European capital)
    const fmt = ctx.format || 'display';
    const sizeMap = { display: '300×250', video: '640×480 (VAST)', native: 'fluid native' };
    const fmtMap = !intl ? { display: 'дисплей', video: 'видео', native: 'нативный' }
      : pl ? { display: 'display', video: 'wideo', native: 'natywny' }
      : { display: 'display', video: 'video', native: 'native' };
    const devMap = !intl ? { desktop: 'Десктоп · Web', mobile: 'Мобайл · In-app', ctv: 'CTV · видео' }
      : pl ? { desktop: 'Desktop · Web', mobile: 'Mobile · In-app', ctv: 'CTV · wideo' }
      : { desktop: 'Desktop · Web', mobile: 'Mobile · In-app', ctv: 'CTV · video' };
    const domain = pl ? 'news-site.pl' : en ? 'news-site.com' : 'news-site.ru';
    const geo = pl ? 'PL · Warszawa' : en ? 'DE · Berlin' : 'RU · Москва';
    const cc = pl ? 'PL' : en ? 'DE' : 'RU';
    const lng = pl ? 'pl-PL' : en ? 'en-US' : 'ru-RU';
    // No consent (GDPR/TCF) beats cookieless: it is not that the ID is hard to match — it is that no
    // personal identifier may be sent at all. So the id AND the eids drop out of the bid request.
    const noCon = ctx.consent === false;
    const uid = noCon ? (pl ? '∅ brak zgody (TCF)' : en ? '∅ no consent (TCF)' : '∅ нет согласия (TCF)')
      : ctx.cookieless ? (pl ? '∅ bez 3P cookie' : en ? '∅ no 3P cookie' : '∅ без 3P cookie') : 'u-9f3a…e21';
    const eidsTxt = noCon ? (pl ? '∅ brak zgody' : en ? '∅ no consent' : '∅ нет согласия') : 'UID2 / ID5 / RampID';
    const tcf = noCon ? (pl ? 'brak zgody · cele ✕' : en ? 'no consent · purposes ✕' : 'нет согласия · purposes ✕')
      : 'CO9x…AgAA · purposes 1–4 ✓';
    const repl = (s) => String(s)
      .replace(/UID2 \/ ID5 \/ RampID/g, eidsTxt)
      .replace(/\{tcf\}/g, tcf)
      .replace(/u-9f3a\u2026e21/g, uid)
      .replace(/\{size\}/g, sizeMap[fmt] || sizeMap.display)
      .replace(/\{fmt\}/g, fmtMap[fmt] || fmt)
      .replace(/\{dev\}/g, devMap[ctx.device] || devMap.desktop)
      .replace(/\{url\}/g, domain + '/article/42')
      .replace(/\{domain\}/g, domain)
      .replace(/\{geoip\}/g, geo + ' · IP 95.♢.♢.♢')
      .replace(/\{geo\}/g, geo)
      .replace(/\{cc\}/g, cc)
      .replace(/\{lng\}/g, lng)
      .replace(/\{floor\}/g, (ctx.floor != null ? ctx.floor : 1.5).toFixed(2))
      .replace(/\{clr\}/g, (ctx.clearing != null && ctx.clearing ? ctx.clearing : 0).toFixed(2));
    const map = (arr) => arr.map(([k, v]) => [k, repl(v)]);
    const out = { title: sig.title, dir: sig.dir, fields: map(sig.fields) };
    if (sig.back) out.back = { dir: sig.back.dir, fields: map(sig.back.fields) };
    if (sig.json) out.json = repl(sig.json);
    return out;
  }

  // ── deep-dive internals (DSP / SSP) — schematic "factory" ──
  // Shared layout (language-agnostic) + per-language text keyed by module id.
  const INTERNALS = {
    dsp: {
      accent: '#a78bfa',
      layout: {
        w: 960, h: 470,
        modules: [
          { id: 'in',         x: 24,  y: 196, w: 120, h: 64, io: 'in' },
          { id: 'targeting',  x: 184, y: 30,  w: 158, h: 70 },
          { id: 'triggers',   x: 184, y: 138, w: 158, h: 70 },
          { id: 'datacloud',  x: 184, y: 300, w: 158, h: 70, side: true },
          { id: 'partners',   x: 24,  y: 300, w: 120, h: 60, side: true },
          { id: 'pixel',      x: 24,  y: 388, w: 120, h: 56, side: true },
          { id: 'predictive', x: 384, y: 24,  w: 182, h: 66, side: true },
          { id: 'brain',      x: 384, y: 138, w: 182, h: 100, brain: true },
          { id: 'campaigns',  x: 384, y: 300, w: 182, h: 70, side: true },
          { id: 'prebid',     x: 612, y: 138, w: 150, h: 100 },
          { id: 'out',        x: 812, y: 168, w: 124, h: 64, io: 'out' },
          { id: 'reports',    x: 612, y: 312, w: 150, h: 66, side: true },
        ],
        links: [
          ['in','targeting'], ['in','triggers'],
          ['partners','datacloud'], ['pixel','datacloud'],
          ['datacloud','brain'], ['predictive','brain'], ['campaigns','brain'],
          ['targeting','brain'], ['triggers','brain'],
          ['brain','prebid'], ['prebid','out'], ['out','reports'],
        ],
      },
      text: {
        ru: {
          title: 'Как устроен DSP', sub: 'Demand-Side Platform · цех закупки', accent: '#a78bfa',
          intro: 'Завод спроса: со всех бирж летят запросы, а внутри за ~50 мс «мозг» решает — ставить ли и сколько. Наведи на блок.',
          dc: 'Дата-центры DSP стоят физически рядом с биржами: ответ за единицы миллисекунд, иначе timeout — и показ уходит конкурентам.',
          m: {
            in:        { t: 'Bid request', h: 'Сырьё конвейера: тысячи запросов в секунду с бирж (QPS 100k+), мгновенный фильтр.' },
            targeting: { t: 'Таргетинг', h: 'Подходит ли показ кампаниям: гео, устройство, аудитория, frequency cap, время суток.' },
            triggers:  { t: 'Триггеры', h: 'Условия запуска ставки: ретаргетинг-пиксель, сегмент «в корзине», white/blacklist, контекст.' },
            datacloud: { t: 'Облако данных', h: 'Профили и сегменты пользователей, синки с DMP и партнёрами — топливо для оценки.' },
            partners:  { t: 'Дата-партнёры', h: '3rd-party данные: интересы, намерения, оффлайн-сегменты.' },
            pixel:     { t: 'Пиксель', h: 'Tracking pixel на сайте рекламодателя: пишет визиты и события в облако данных.' },
            predictive:{ t: 'Predictive аналитика', h: 'ML-модели предсказывают pCTR и pCVR для каждого показа.' },
            brain:     { t: 'Алгоритм закупки', h: 'Главный мозг: из прогнозов, бюджета и целей считает оптимальную ставку (bid shading).' },
            campaigns: { t: 'Кампании и бюджет', h: 'Активные кампании, лимиты, pacing бюджета и CPA-цели.' },
            prebid:    { t: 'Pre-bid проверки', h: 'Бренд-безопасность, антифрод и прогноз viewability до отправки ставки.' },
            out:       { t: 'Bid response', h: 'Готовый «продукт»: креатив + цена + Deal ID уходят на биржу.' },
            reports:   { t: 'Репорты', h: 'Постбэки о показах/кликах/конверсиях — обучают модели и кормят дашборды.' },
          },
        },
        en: {
          title: 'Inside a DSP', sub: 'Demand-Side Platform · buying floor', accent: '#a78bfa',
          intro: 'A demand factory: requests pour in from every exchange, and in ~50 ms the "brain" decides whether — and how much — to bid. Hover a block.',
          dc: 'DSP data centers sit physically next to exchanges: a reply in milliseconds, or it times out and the impression goes to competitors.',
          m: {
            in:        { t: 'Bid request', h: 'Raw material: thousands of requests per second from exchanges (QPS 100k+), filtered instantly.' },
            targeting: { t: 'Targeting', h: 'Does the impression fit campaigns: geo, device, audience, frequency cap, daypart.' },
            triggers:  { t: 'Triggers', h: 'Bid trigger conditions: retargeting pixel, "in cart" segment, white/blacklist, context.' },
            datacloud: { t: 'Data cloud', h: 'User profiles and segments, synced with the DMP and partners — fuel for valuation.' },
            partners:  { t: 'Data partners', h: '3rd-party data: interests, intent, offline segments.' },
            pixel:     { t: 'Pixel', h: 'Tracking pixel on the advertiser site: writes visits and events into the data cloud.' },
            predictive:{ t: 'Predictive analytics', h: 'ML models predict pCTR and pCVR for each impression.' },
            brain:     { t: 'Buying algorithm', h: 'The main brain: from forecasts, budget and goals it computes the optimal bid (bid shading).' },
            campaigns: { t: 'Campaigns & budget', h: 'Active campaigns, caps, budget pacing and CPA goals.' },
            prebid:    { t: 'Pre-bid checks', h: 'Brand safety, anti-fraud and viewability prediction before the bid goes out.' },
            out:       { t: 'Bid response', h: 'The finished product: creative + price + Deal ID go to the exchange.' },
            reports:   { t: 'Reports', h: 'Postbacks on impressions/clicks/conversions — train the models and feed dashboards.' },
          },
        },
      },
    },
    ssp: {
      accent: '#2dd4bf',
      layout: {
        w: 960, h: 470,
        modules: [
          { id: 'sites',      x: 24,  y: 40,  w: 122, h: 56, io: 'in' },
          { id: 'apps',       x: 24,  y: 150, w: 122, h: 56, io: 'in' },
          { id: 'ctv',        x: 24,  y: 260, w: 122, h: 56, io: 'in' },
          { id: 'firstparty', x: 24,  y: 372, w: 122, h: 60, side: true },
          { id: 'intake',     x: 188, y: 138, w: 156, h: 80, brain: true },
          { id: 'identity',   x: 188, y: 300, w: 156, h: 70 },
          { id: 'content',    x: 388, y: 30,  w: 166, h: 70, side: true },
          { id: 'floor',      x: 388, y: 138, w: 166, h: 80 },
          { id: 'data',       x: 388, y: 300, w: 166, h: 70, side: true },
          { id: 'connectors', x: 600, y: 96,  w: 168, h: 90 },
          { id: 'adapter',    x: 600, y: 224, w: 168, h: 76 },
          { id: 'out',        x: 812, y: 150, w: 124, h: 64, io: 'out' },
          { id: 'reports',    x: 600, y: 330, w: 168, h: 60, side: true },
        ],
        links: [
          ['sites','intake'], ['apps','intake'], ['ctv','intake'],
          ['firstparty','identity'], ['identity','intake'],
          ['intake','content'], ['intake','floor'], ['intake','data'],
          ['content','connectors'], ['floor','connectors'], ['data','connectors'],
          ['connectors','adapter'], ['adapter','out'], ['adapter','reports'],
        ],
      },
      text: {
        ru: {
          title: 'Как устроен SSP', sub: 'Supply-Side Platform · цех инвентаря', accent: '#2dd4bf',
          intro: 'Завод предложения: сайты, приложения и CTV сдают сюда свободные показы, а SSP упаковывает их и продаёт спросу. Наведи на блок.',
          dc: 'Дата-центры SSP обрабатывают миллионы запросов в секунду и держат весь бюджет задержки <100 мс на показ.',
          m: {
            sites:      { t: 'Сайты', h: 'Веб-инвентарь: ad tag / Prebid.js в «шапке» страницы.' },
            apps:       { t: 'Приложения', h: 'Mobile-app инвентарь через SDK (in-app показы).' },
            ctv:        { t: 'CTV', h: 'Connected TV: видеопоказы на Smart TV и приставках.' },
            firstparty: { t: 'Свои данные (CRM, почта)', h: 'First-party данные паблишера: подписки, email, логины — обогащают профиль.' },
            intake:     { t: 'Приём и нормализация', h: 'Сводит все источники в единый формат запроса, считает контекст места.' },
            identity:   { t: 'Идентификация', h: 'Пользователи: cookie matching, eids, согласие (GDPR/TCF).' },
            content:    { t: 'Контент-анализ', h: 'Категоризация страницы и brand safety: куда можно ставить рекламу.' },
            floor:      { t: 'Прайс-флор и правила', h: 'Динамический floor, unified pricing, правила прямых сделок.' },
            data:       { t: 'Хранилище данных', h: 'Логи, аудитория, отчётные данные — для оптимизации и аналитики.' },
            connectors: { t: 'Коннекторы спроса', h: 'Подключённые DSP и биржи: рассылка bid request по OpenRTB-эндпоинтам.' },
            adapter:    { t: 'Аукционный адаптер', h: 'Собирает ставки, дедуплицирует, выбирает лучшую за отведённый timeout.' },
            out:        { t: 'На биржу / показ', h: 'Лучшее предложение уходит на биржу, победитель — в рекламное место.' },
            reports:    { t: 'Репорты / yield', h: 'Доходность, fill rate, eCPM — дашборды паблишера и оптимизация выручки.' },
          },
        },
        en: {
          title: 'Inside an SSP', sub: 'Supply-Side Platform · inventory floor', accent: '#2dd4bf',
          intro: 'A supply factory: sites, apps and CTV hand in their free impressions; the SSP packages and sells them to demand. Hover a block.',
          dc: 'SSP data centers handle millions of requests per second and keep the whole latency budget under 100 ms per impression.',
          m: {
            sites:      { t: 'Websites', h: 'Web inventory: ad tag / Prebid.js in the page header.' },
            apps:       { t: 'Apps', h: 'Mobile-app inventory via SDK (in-app impressions).' },
            ctv:        { t: 'CTV', h: 'Connected TV: video impressions on smart TVs and set-top boxes.' },
            firstparty: { t: '1st-party data (CRM, email)', h: 'Publisher first-party data: subscriptions, email, logins — enrich the profile.' },
            intake:     { t: 'Intake & normalize', h: 'Merges all sources into one request format, computes slot context.' },
            identity:   { t: 'Identity', h: 'Users: cookie matching, eids, consent (GDPR/TCF).' },
            content:    { t: 'Content analysis', h: 'Page categorization and brand safety: where ads may run.' },
            floor:      { t: 'Floor & rules', h: 'Dynamic floor, unified pricing, direct-deal rules.' },
            data:       { t: 'Data store', h: 'Logs, audiences, reporting data — for optimization and analytics.' },
            connectors: { t: 'Demand connectors', h: 'Connected DSPs and exchanges: bid-request fan-out over OpenRTB endpoints.' },
            adapter:    { t: 'Auction adapter', h: 'Collects bids, de-duplicates, picks the best within the timeout.' },
            out:        { t: 'To exchange / render', h: 'The best offer goes to the exchange; the winner into the ad slot.' },
            reports:    { t: 'Reports / yield', h: 'Revenue, fill rate, eCPM — publisher dashboards and yield optimization.' },
          },
        },
      },
    },
  };

  window.RTB = {
    CW, CH, CAT, CAT_LIGHT, STAGE_LIGHT, DEVICES, FORMATS,
    FIXED_NODES, FIXED_PIPES, DSP_POOL, buildModel, STAGES, BLOCK_STAGE, makeAuction, GLOSSARY,
    SIGNALS, getSignal, INTERNALS,
  };
})();

;
/* RTB Engine — deep-dive enrichment: flow run, live metrics, JSON, ext-mapping,
   "why no bid" drop scenarios, Polish text, deeper SSP layout. Patches window.RTB.INTERNALS. */
(function () {
  if (!window.RTB || !window.RTB.INTERNALS) return;
  const INT = window.RTB.INTERNALS;
  const rnd = (lo, hi, d) => { const v = lo + Math.random() * (hi - lo); return d === 0 ? Math.round(v) : +v.toFixed(d); };

  // ───────── DSP enrichment ─────────
  INT.dsp.flow = ['in', 'targeting', 'triggers', 'datacloud', 'predictive', 'campaigns', 'brain', 'prebid', 'out', 'reports'];
  INT.dsp.ext = {
    in:        { dir: 'in',  node: 'exchange' },
    out:       { dir: 'out', node: 'exchange' },
    datacloud: { dir: 'in',  node: 'dmp' },
    pixel:     { dir: 'in',  node: 'tracking' },
    reports:   { dir: 'out', node: 'dmp' },
  };
  INT.dsp.json = {
    in:        '{ "imp":[{ "banner":"300x250" }], "tmax":100 }',
    targeting: '{ "geo":"{cc}", "device":"{dev}", "match":true }',
    triggers:  '{ "segment":"cart_abandoners", "hit":true }',
    datacloud: '{ "segments":{seg}, "recency":"2d" }',
    partners:  '{ "provider":"3p-data", "interests":["auto"] }',
    pixel:     '{ "event":"visit", "url":"adv.com/cart" }',
    predictive:'{ "pCTR":{pctr}, "pCVR":{pcvr} }',
    campaigns: '{ "budget_left":"{bud}%", "pacing":"even" }',
    brain:     '{ "bid":{bid}, "shading":{shade}, "auction":"1st-price" }',
    prebid:    '{ "brand_safe":true, "viewability":{view} }',
    out:       '{ "price":{bid}, "crid":"cr-7781" }',
    reports:   '{ "event":"win", "postback":"sent" }',
  };
  // metric snapshot generator (ctx: {cc,dev})
  INT.dsp.snap = function () {
    const pctr = rnd(0.6, 2.6, 1), pcvr = rnd(0.2, 0.9, 2), bud = rnd(28, 92, 0), bid = rnd(1.8, 5.2, 2), view = rnd(58, 88, 0), seg = rnd(120, 640, 0), shade = rnd(0.80, 0.95, 2);
    return {
      vals: { pctr, pcvr, bud, bid, view, seg, shade },
      metric: {
        in: rnd(80, 180, 0) + 'k/s', targeting: '✓ match', triggers: '✓ segment', datacloud: seg + ' seg',
        partners: '3P data', pixel: 'visit', predictive: 'pCTR ' + pctr + '%', campaigns: 'budget ' + bud + '%',
        brain: '$' + bid.toFixed(2), prebid: 'view ' + view + '%', out: '$' + bid.toFixed(2) + ' CPM', reports: 'logged',
      },
    };
  };
  // why-no-bid scenarios: drop at a module
  INT.dsp.drops = [
    { id: 'ok',     ru: 'Обычный прогон',  en: 'Normal run',     pl: 'Normalny przebieg', at: null },
    { id: 'noseg',  ru: 'Нет сегмента',    en: 'No segment',     pl: 'Brak segmentu',     at: 'triggers',
      ru_w: 'DMP не узнала пользователя — ретаргетинг-триггер не сработал, ставка не сформирована.',
      en_w: 'The DMP did not recognize the user — the retargeting trigger never fired, no bid was formed.',
      pl_w: 'DMP nie rozpoznał użytkownika — trigger retargetingu nie zadziałał, oferta nie powstała.' },
    { id: 'budget', ru: 'Бюджет исчерпан', en: 'Budget spent',   pl: 'Budżet wyczerpany', at: 'campaigns',
      ru_w: 'Дневной бюджет выбран, pacing обнулил ставку — кампания на паузе.',
      en_w: 'The daily budget is spent, pacing zeroed the bid — the campaign is throttled.',
      pl_w: 'Dzienny budżet wyczerpany, pacing wyzerował ofertę — kampania wstrzymana.' },
    { id: 'brand',  ru: 'Brand safety',    en: 'Brand safety',   pl: 'Brand safety',      at: 'prebid',
      ru_w: 'Pre-bid проверка отклонила инвентарь — небезопасный для бренда контент.',
      en_w: 'The pre-bid check rejected the inventory — content unsafe for the brand.',
      pl_w: 'Sprawdzenie pre-bid odrzuciło powierzchnię — treść niebezpieczna dla marki.' },
    { id: 'timeout',ru: 'Timeout',         en: 'Timeout',        pl: 'Timeout',           at: 'out',
      ru_w: 'DSP не успел ответить за 100 мс — ставка не учтена биржей.',
      en_w: 'The DSP did not answer within 100 ms — the bid was ignored by the exchange.',
      pl_w: 'DSP nie odpowiedział w 100 ms — oferta zignorowana przez giełdę.' },
  ];

  // ───────── SSP: deeper layout (header-bidding wrapper, ad quality, rebates) ─────────
  INT.ssp.layout = {
    w: 1040, h: 480,
    modules: [
      { id: 'sites',      x: 22,  y: 26,  w: 120, h: 52, io: 'in' },
      { id: 'apps',       x: 22,  y: 110, w: 120, h: 52, io: 'in' },
      { id: 'ctv',        x: 22,  y: 194, w: 120, h: 52, io: 'in' },
      { id: 'firstparty', x: 22,  y: 300, w: 120, h: 58, side: true },
      { id: 'wrapper',    x: 174, y: 96,  w: 150, h: 80 },
      { id: 'identity',   x: 174, y: 300, w: 150, h: 64 },
      { id: 'intake',     x: 360, y: 96,  w: 150, h: 80, brain: true },
      { id: 'content',    x: 546, y: 16,  w: 158, h: 58, side: true },
      { id: 'adquality',  x: 546, y: 92,  w: 158, h: 64 },
      { id: 'floor',      x: 546, y: 174, w: 158, h: 70 },
      { id: 'data',       x: 546, y: 300, w: 158, h: 58, side: true },
      { id: 'connectors', x: 738, y: 64,  w: 160, h: 82 },
      { id: 'adapter',    x: 738, y: 168, w: 160, h: 74 },
      { id: 'rebates',    x: 738, y: 300, w: 160, h: 58, side: true },
      { id: 'out',        x: 916, y: 140, w: 110, h: 62, io: 'out' },
      { id: 'reports',    x: 916, y: 300, w: 110, h: 58, side: true },
    ],
    links: [
      ['sites', 'wrapper'], ['apps', 'wrapper'], ['ctv', 'wrapper'],
      ['firstparty', 'identity'], ['identity', 'intake'], ['wrapper', 'intake'],
      ['intake', 'content'], ['intake', 'adquality'], ['intake', 'floor'], ['intake', 'data'],
      ['adquality', 'connectors'], ['floor', 'connectors'], ['data', 'connectors'],
      ['connectors', 'adapter'], ['adapter', 'out'], ['adapter', 'rebates'], ['adapter', 'reports'],
    ],
  };
  INT.ssp.flow = ['sites', 'wrapper', 'identity', 'intake', 'adquality', 'floor', 'connectors', 'adapter', 'out', 'reports'];
  INT.ssp.ext = {
    sites:      { dir: 'in',  node: 'publisher' },
    apps:       { dir: 'in',  node: 'publisher' },
    ctv:        { dir: 'in',  node: 'publisher' },
    connectors: { dir: 'out', node: 'exchange' },
    out:        { dir: 'out', node: 'exchange' },
    reports:    { dir: 'out', node: 'publisher' },
  };
  INT.ssp.json = {
    sites:      '{ "tagid":"div-gpt-1", "sizes":["300x250"] }',
    apps:       '{ "sdk":"sdk-ios-5", "bundle":"app.id" }',
    ctv:        '{ "video":{ "w":1920,"h":1080 }, "ctv":true }',
    firstparty: '{ "crm":"sub_id", "hashed_email":"…" }',
    wrapper:    '{ "prebid":"8.x", "bidders":{bidders}, "timeout":{tmo} }',
    identity:   '{ "consent":"GDPR ok", "eids":{eids} }',
    intake:     '{ "imp":1, "normalized":true }',
    content:    '{ "cat":["IAB12"], "safe":true }',
    adquality:  '{ "creative_scan":"ok", "malware":false }',
    floor:      '{ "floor":{floor}, "unified":true }',
    data:       '{ "logged":true, "rows":1 }',
    connectors: '{ "endpoints":{bidders}, "sent":{bidders} }',
    adapter:    '{ "bids":{bids}, "best":{best} }',
    rebates:    '{ "ssp_fee":"15%", "rebate":"2%" }',
    out:        '{ "price":{best}, "to":"exchange" }',
    reports:    '{ "fill":"{fill}%", "ecpm":{ecpm} }',
  };
  INT.ssp.snap = function () {
    const bidders = rnd(4, 9, 0), tmo = 1000, eids = rnd(1, 4, 0), floor = rnd(0.8, 2.2, 2), bids = rnd(2, 7, 0), best = rnd(1.8, 4.6, 2), fill = rnd(48, 86, 0), ecpm = rnd(1.4, 3.6, 1);
    return {
      vals: { bidders, tmo, eids, floor, bids, best, fill, ecpm },
      metric: {
        sites: 'web', apps: 'in-app', ctv: 'video', firstparty: '1P data', wrapper: bidders + ' bidders',
        identity: eids + ' eids', intake: 'norm ✓', content: 'IAB ✓', adquality: 'scan ✓', floor: '$' + floor.toFixed(2),
        data: 'logged', connectors: bidders + ' sent', adapter: bids + ' bids', rebates: 'fee 15%',
        out: '$' + best.toFixed(2), reports: 'fill ' + fill + '%',
      },
    };
  };
  INT.ssp.drops = [
    { id: 'ok',       ru: 'Обычный прогон',   en: 'Normal run',    pl: 'Normalny przebieg', at: null },
    { id: 'consent',  ru: 'Нет согласия',     en: 'No consent',    pl: 'Brak zgody',        at: 'identity',
      ru_w: 'Пользователь не дал согласие (GDPR/TCF) — запрос нельзя обогатить, спрос отваливается.',
      en_w: 'The user gave no consent (GDPR/TCF) — the request cannot be enriched, demand drops off.',
      pl_w: 'Użytkownik nie wyraził zgody (GDPR/TCF) — żądania nie można wzbogacić, popyt odpada.' },
    { id: 'quality',  ru: 'Ad quality',       en: 'Ad quality',    pl: 'Ad quality',        at: 'adquality',
      ru_w: 'Креатив не прошёл проверку качества (malware/политики) — инвентарь не выставлен.',
      en_w: 'The creative failed the quality scan (malware/policy) — the inventory is not offered.',
      pl_w: 'Kreacja nie przeszła kontroli jakości (malware/polityki) — powierzchnia nie wystawiona.' },
    { id: 'floor',    ru: 'Ниже floor',       en: 'Below floor',   pl: 'Poniżej floor',     at: 'floor',
      ru_w: 'Все ставки ниже floor price — показ не продан.',
      en_w: 'All bids are below the floor price — the impression goes unsold.',
      pl_w: 'Wszystkie oferty poniżej floor price — odsłona niesprzedana.' },
    { id: 'timeout',  ru: 'Timeout DSP',      en: 'DSP timeout',   pl: 'Timeout DSP',       at: 'adapter',
      ru_w: 'DSP не успели ответить в окно timeout — собирать нечего, продавать нечего.',
      en_w: 'DSPs did not answer within the timeout window — nothing to collect, nothing to sell.',
      pl_w: 'DSP nie odpowiedziały w oknie timeout — nie ma czego zebrać ani sprzedać.' },
  ];

  // ───────── Polish text + new SSP module strings ─────────
  // DSP — add pl, mirror en structure
  INT.dsp.text.pl = {
    title: 'Jak działa DSP', sub: 'Demand-Side Platform · hala zakupu', accent: '#a78bfa',
    intro: 'Fabryka popytu: ze wszystkich giełd lecą żądania, a w środku w ~50 ms „mózg” decyduje — licytować czy nie i ile. Najedź lub kliknij blok.',
    dc: 'Centra danych DSP stoją fizycznie obok giełd: odpowiedź w milisekundach, inaczej timeout — i odsłona trafia do konkurencji.',
    m: {
      in:        { t: 'Bid request', h: 'Surowiec taśmy: tysiące żądań na sekundę z giełd (QPS 100k+), natychmiastowy filtr.' },
      targeting: { t: 'Targetowanie', h: 'Czy odsłona pasuje do kampanii: geo, urządzenie, grupa, frequency cap, pora dnia.' },
      triggers:  { t: 'Triggery', h: 'Warunki uruchomienia oferty: pixel retargetingu, segment „w koszyku”, white/blacklist, kontekst.' },
      datacloud: { t: 'Chmura danych', h: 'Profile i segmenty użytkowników, synchronizacja z DMP i partnerami — paliwo do wyceny.' },
      partners:  { t: 'Partnerzy danych', h: 'Dane 3rd-party: zainteresowania, intencje, segmenty offline.' },
      pixel:     { t: 'Pixel', h: 'Tracking pixel na stronie reklamodawcy: zapisuje wizyty i zdarzenia do chmury danych.' },
      predictive:{ t: 'Analityka predykcyjna', h: 'Modele ML przewidują pCTR i pCVR dla każdej odsłony.' },
      brain:     { t: 'Algorytm zakupu', h: 'Główny mózg: z prognoz, budżetu i celów liczy optymalną ofertę (bid shading).' },
      campaigns: { t: 'Kampanie i budżet', h: 'Aktywne kampanie, limity, pacing budżetu i cele CPA.' },
      prebid:    { t: 'Kontrole pre-bid', h: 'Brand safety, antyfraud i prognoza viewability przed wysłaniem oferty.' },
      out:       { t: 'Bid response', h: 'Gotowy „produkt”: kreacja + cena + Deal ID jadą na giełdę.' },
      reports:   { t: 'Raporty', h: 'Postbacki o odsłonach/kliknięciach/konwersjach — uczą modele i zasilają dashboardy.' },
    },
  };
  // SSP — extend ru/en with new modules, add pl
  Object.assign(INT.ssp.text.ru.m, {
    wrapper:   { t: 'Header-bidding wrapper', h: 'Prebid.js в «шапке» сайта: параллельно опрашивает источники до вызова ad server.' },
    adquality: { t: 'Ad quality', h: 'Скан креатива: malware, авто-редирект, тяжёлый вес, нарушения политик.' },
    rebates:   { t: 'Комиссии и ребейты', h: 'Take rate SSP (~15%), ребейты и sponsorship-сборы — экономика сделки.' },
  });
  Object.assign(INT.ssp.text.en.m, {
    wrapper:   { t: 'Header-bidding wrapper', h: 'Prebid.js in the page header: queries sources in parallel before calling the ad server.' },
    adquality: { t: 'Ad quality', h: 'Creative scan: malware, auto-redirects, heavy weight, policy violations.' },
    rebates:   { t: 'Fees & rebates', h: 'SSP take rate (~15%), rebates and sponsorship fees — the economics of the deal.' },
  });
  INT.ssp.text.pl = {
    title: 'Jak działa SSP', sub: 'Supply-Side Platform · hala powierzchni', accent: '#2dd4bf',
    intro: 'Fabryka podaży: strony, aplikacje i CTV oddają tu wolne odsłony, a SSP pakuje je i sprzedaje popytowi. Najedź lub kliknij blok.',
    dc: 'Centra danych SSP obsługują miliony żądań na sekundę i trzymają cały budżet opóźnienia <100 ms na odsłonę.',
    m: {
      sites:      { t: 'Strony', h: 'Powierzchnia web: ad tag / Prebid.js w „nagłówku” strony.' },
      apps:       { t: 'Aplikacje', h: 'Powierzchnia mobile-app przez SDK (odsłony in-app).' },
      ctv:        { t: 'CTV', h: 'Connected TV: odsłony wideo na Smart TV i dekoderach.' },
      firstparty: { t: 'Dane własne (CRM, e-mail)', h: 'Dane first-party wydawcy: subskrypcje, e-mail, loginy — wzbogacają profil.' },
      wrapper:    { t: 'Header-bidding wrapper', h: 'Prebid.js w nagłówku strony: równolegle odpytuje źródła przed wywołaniem ad servera.' },
      identity:   { t: 'Identyfikacja', h: 'Użytkownicy: cookie matching, eids, zgoda (GDPR/TCF).' },
      intake:     { t: 'Przyjęcie i normalizacja', h: 'Sprowadza wszystkie źródła do jednego formatu żądania, liczy kontekst miejsca.' },
      content:    { t: 'Analiza treści', h: 'Kategoryzacja strony i brand safety: gdzie można umieścić reklamę.' },
      adquality:  { t: 'Ad quality', h: 'Skan kreacji: malware, auto-przekierowania, duży rozmiar, naruszenia polityk.' },
      floor:      { t: 'Floor i reguły', h: 'Dynamiczny floor, unified pricing, reguły transakcji bezpośrednich.' },
      data:       { t: 'Magazyn danych', h: 'Logi, grupy, dane raportowe — do optymalizacji i analityki.' },
      connectors: { t: 'Konektory popytu', h: 'Podłączone DSP i giełdy: rozsyłka bid request po endpointach OpenRTB.' },
      adapter:    { t: 'Adapter aukcyjny', h: 'Zbiera oferty, deduplikuje, wybiera najlepszą w oknie timeout.' },
      rebates:    { t: 'Opłaty i rabaty', h: 'Take rate SSP (~15%), rabaty i opłaty sponsorskie — ekonomia transakcji.' },
      out:        { t: 'Na giełdę / odsłona', h: 'Najlepsza oferta jedzie na giełdę, zwycięzca — w miejsce reklamowe.' },
      reports:    { t: 'Raporty / yield', h: 'Przychód, fill rate, eCPM — dashboardy wydawcy i optymalizacja wpływów.' },
    },
  };

  INT.exchange = {
    accent: '#67e8f9',
    layout: {
      w: 960, h: 470,
      modules: [
        { id: 'in',        x: 22,  y: 196, w: 120, h: 66, io: 'in' },
        { id: 'validate',  x: 182, y: 104, w: 158, h: 74 },
        { id: 'brandsafe', x: 182, y: 300, w: 158, h: 66, side: true },
        { id: 'broadcast', x: 384, y: 52,  w: 166, h: 74 },
        { id: 'collect',   x: 384, y: 168, w: 166, h: 74 },
        { id: 'floor',     x: 384, y: 300, w: 166, h: 70 },
        { id: 'auction',   x: 604, y: 150, w: 172, h: 108, brain: true },
        { id: 'fee',       x: 604, y: 300, w: 172, h: 68, side: true },
        { id: 'out',       x: 812, y: 168, w: 126, h: 70, io: 'out' },
        { id: 'logs',      x: 812, y: 300, w: 126, h: 62, side: true },
      ],
      links: [
        ['in', 'validate'], ['validate', 'brandsafe'], ['brandsafe', 'broadcast'],
        ['broadcast', 'collect'], ['collect', 'floor'],
        ['validate', 'auction'], ['floor', 'auction'], ['collect', 'auction'],
        ['auction', 'fee'], ['auction', 'out'], ['auction', 'logs'],
      ],
    },
    flow: ['in', 'validate', 'brandsafe', 'broadcast', 'collect', 'floor', 'auction', 'fee', 'out', 'logs'],
    ext: {
      in:        { dir: 'in',  node: 'ssp' },
      brandsafe: { dir: 'in',  node: 'verifier' },
      broadcast: { dir: 'out', node: 'dsp' },
      collect:   { dir: 'in',  node: 'dsp' },
      out:       { dir: 'out', node: 'ssp' },
      logs:      { dir: 'out', node: 'tracking' },
    },
    json: {
      in:        '{ "imp":[{ "id":"1","bidfloor":{floor} }], "tmax":100 }',
      validate:  '{ "openrtb":"2.6", "valid":true, "schain":"ok" }',
      brandsafe: '{ "ivt":"clean", "brand_safe":true }',
      broadcast: '{ "seats":{seats}, "sent":{seats}, "tmax":100 }',
      collect:   '{ "bids":{bids}, "timeouts":{tmo}, "below_floor":{blw} }',
      floor:     '{ "floor":{floor}, "deals":["PMP-77"], "priority":"deal>open" }',
      auction:   '{ "rule":"1st-price", "clearing":{clr} }',
      fee:       '{ "gross":{clr}, "sell_side_fee_pct":{fee}, "net_to_publisher":{net} }',
      out:       '{ "seatbid":[{ "price":{clr}, "crid":"cr-7781" }], "nurl":"win" }',
      logs:      '{ "auction_id":"a91f", "win":true, "logged":true }',
    },
    snap: function () {
      const seats = rnd(4, 9, 0), bids = rnd(2, 7, 0), tmo = rnd(0, 3, 0), blw = rnd(0, 3, 0),
            floor = rnd(0.8, 2.2, 2), clr = rnd(1.8, 4.6, 2), fee = rnd(8, 15, 0);
      const net = +(clr * (1 - fee / 100)).toFixed(2);
      return {
        vals: { seats, bids, tmo, blw, floor, clr, fee, net },
        metric: {
          in: rnd(120, 480, 0) + 'k/s', validate: 'OpenRTB ✓', brandsafe: 'clean ✓', broadcast: seats + ' seats',
          collect: bids + ' bids', floor: '$' + floor.toFixed(2), auction: '$' + clr.toFixed(2),
          fee: fee + '%', out: '$' + clr.toFixed(2), logs: 'logged',
        },
      };
    },
    drops: [
      { id: 'ok',      ru: 'Обычный прогон', en: 'Normal run',  pl: 'Normalny przebieg', at: null },
      { id: 'blocked', ru: 'Верификатор блок', en: 'Verifier block', pl: 'Blok weryfikatora', at: 'brandsafe',
        ru_w: 'Верификатор пометил показ как fraud / небезопасный — запрос снят до рассылки DSP, аукцион не проводится.',
        en_w: 'The verifier flagged the impression as fraud / unsafe — the request is pulled before DSP fan-out, no auction runs.',
        pl_w: 'Weryfikator oznaczył odsłonę jako fraud / niebezpieczną — żądanie zdjęte przed rozesłaniem do DSP, aukcja się nie odbywa.' },
      { id: 'timeout', ru: 'Все DSP timeout', en: 'All DSPs time out', pl: 'Wszystkie DSP timeout', at: 'collect',
        ru_w: 'Ни один DSP не успел ответить в окно 100 мс — собирать нечего, победителя нет.',
        en_w: 'No DSP answered within the 100 ms window — nothing to collect, no winner.',
        pl_w: 'Żaden DSP nie odpowiedział w oknie 100 ms — nie ma czego zebrać, brak zwycięzcy.' },
      { id: 'nofloor', ru: 'Ниже floor', en: 'Below floor', pl: 'Poniżej floor', at: 'auction',
        ru_w: 'Все ставки ниже floor price — показ не продан, паблишер ничего не получает.',
        en_w: 'All bids are below the floor price — the impression goes unsold, the publisher earns nothing.',
        pl_w: 'Wszystkie oferty poniżej floor price — odsłona niesprzedana, wydawca nic nie zarabia.' },
    ],
    text: {
      ru: {
        title: 'Как устроен Ad Exchange', sub: 'Аукционный движок · изнутри', accent: '#67e8f9',
        intro: 'Сердце RTB: биржа принимает запрос от SSP, проверяет его, рассылает всем DSP, собирает ставки и за &lt;100 мс проводит аукцион. Наведи или кликни блок.',
        dc: 'Биржа обрабатывает сотни тысяч запросов в секунду и держит весь аукцион в окне 100 мс — иначе показ не успеет отрисоваться.',
        m: {
          in:        { t: 'Приём bid request', h: 'Запрос от SSP по OpenRTB: формат, floor, гео, данные пользователя.' },
          validate:  { t: 'Валидация', h: 'Разбор OpenRTB, проверка schain/sellers.json, дедупликация запроса.' },
          brandsafe: { t: 'Проверка (pre-bid)', h: 'Хук к верификатору: fraud / IVT и brand safety до рассылки DSP.' },
          broadcast: { t: 'Рассылка DSP', h: 'Фан-аут запроса по всем подключённым seat/DSP параллельно.' },
          collect:   { t: 'Сбор ставок', h: 'Приём bid response в окне timeout; опоздавшие и невалидные отбрасываются.' },
          floor:     { t: 'Floor и сделки', h: 'Проверка floor price и приоритета прямых сделок (PMP / Preferred) над открытым аукционом.' },
          auction:   { t: 'Аукцион', h: 'Главный мозг: сравнивает ставки и по правилу 1-й/2-й цены считает клиринговую цену.' },
          fee:       { t: 'Комиссия sell-side', h: 'Из клиринга удерживается take rate sell-side — SSP вместе со своим аукционом; остальное уходит паблишеру.' },
          out:       { t: 'Ответ победителя', h: 'Креатив и цена победителя уходят обратно через SSP на страницу.' },
          logs:      { t: 'Логи / метрики', h: 'QPS, win rate, fill, латентность — в трекинг и дашборды биржи.' },
        },
      },
      en: {
        title: 'Inside an Ad Exchange', sub: 'Auction engine · internals', accent: '#67e8f9',
        intro: 'The heart of RTB: the exchange takes the SSP request, checks it, broadcasts to all DSPs, collects bids and runs the auction in &lt;100 ms. Hover or click a block.',
        dc: 'The exchange handles hundreds of thousands of requests per second and keeps the whole auction within a 100 ms window — or the impression won’t render in time.',
        m: {
          in:        { t: 'Bid request intake', h: 'The SSP request over OpenRTB: format, floor, geo, user data.' },
          validate:  { t: 'Validation', h: 'OpenRTB parsing, schain/sellers.json checks, request de-duplication.' },
          brandsafe: { t: 'Check (pre-bid)', h: 'A verifier hook: fraud / IVT and brand safety before DSP fan-out.' },
          broadcast: { t: 'Broadcast to DSPs', h: 'Fan out the request to all connected seats/DSPs in parallel.' },
          collect:   { t: 'Bid collection', h: 'Receive bid responses within the timeout; late and invalid ones are dropped.' },
          floor:     { t: 'Floor & deals', h: 'Check the floor price and the priority of direct deals (PMP / Preferred) over the open auction.' },
          auction:   { t: 'Auction', h: 'The main brain: compares bids and computes the clearing price by the 1st/2nd-price rule.' },
          fee:       { t: 'Sell-side fee', h: 'The sell-side take rate — the SSP together with its own auction — is withheld from the clearing price; the rest goes to the publisher.' },
          out:       { t: 'Winner response', h: 'The winner’s creative and price travel back through the SSP to the page.' },
          logs:      { t: 'Logs / metrics', h: 'QPS, win rate, fill, latency — into tracking and the exchange dashboards.' },
        },
      },
      pl: {
        title: 'Jak działa Ad Exchange', sub: 'Silnik aukcyjny · wnętrze',
        intro: 'Serce RTB: giełda przyjmuje żądanie od SSP, sprawdza je, rozsyła do wszystkich DSP, zbiera oferty i w &lt;100 ms przeprowadza aukcję. Najedź lub kliknij blok.',
        dc: 'Giełda obsługuje setki tysięcy żądań na sekundę i trzyma całą aukcję w oknie 100 ms — inaczej odsłona nie zdąży się wyrenderować.',
        m: {
          in:        { t: 'Przyjęcie bid request', h: 'Żądanie od SSP przez OpenRTB: format, floor, geo, dane użytkownika.' },
          validate:  { t: 'Walidacja', h: 'Parsowanie OpenRTB, kontrola schain/sellers.json, deduplikacja żądania.' },
          brandsafe: { t: 'Kontrola (pre-bid)', h: 'Hook do weryfikatora: fraud / IVT i brand safety przed rozesłaniem DSP.' },
          broadcast: { t: 'Rozesłanie do DSP', h: 'Fan-out żądania do wszystkich podłączonych seat/DSP równolegle.' },
          collect:   { t: 'Zbieranie ofert', h: 'Odbiór bid response w oknie timeout; spóźnione i nieważne są odrzucane.' },
          floor:     { t: 'Floor i transakcje', h: 'Kontrola floor price i priorytetu transakcji bezpośrednich (PMP / Preferred) nad aukcją otwartą.' },
          auction:   { t: 'Aukcja', h: 'Główny mózg: porównuje oferty i wg reguły 1./2. ceny liczy cenę rozliczenia.' },
          fee:       { t: 'Prowizja sell-side', h: 'Z ceny rozliczenia potrącany jest take rate sell-side — SSP wraz z własną aukcją; reszta idzie do wydawcy.' },
          out:       { t: 'Odpowiedź zwycięzcy', h: 'Kreacja i cena zwycięzcy wracają przez SSP na stronę.' },
          logs:      { t: 'Logi / metryki', h: 'QPS, win rate, fill, opóźnienie — do śledzenia i dashboardów giełdy.' },
        },
      },
    },
  };

  // external-node display names per language
  window.RTB_EXT_NAMES = {
    ru: { exchange: 'Ad Exchange', dmp: 'Данные и ID', tracking: 'Трекинг', publisher: 'Паблишер' },
    en: { exchange: 'Ad Exchange', dmp: 'Data & Identity', tracking: 'Tracking', publisher: 'Publisher' },
    pl: { exchange: 'Ad Exchange', dmp: 'Dane i ID', tracking: 'Śledzenie', publisher: 'Wydawca' },
  };
})();

;
/* RTB Engine — i18n (RU source → EN). window.tr(text) returns EN when active, else RU. */
(function () {
  // RU → EN map. Anything not present passes through unchanged.
  const RU2EN = {
    'Представляет интересы паблишера. Упаковывает показ в bid request, выставляет floor price и сама проводит аукцион среди подключённых DSP — её аукционный движок и есть та самая «биржа». Берёт свою комиссию с продажи. Паблишер обычно подключает несколько SSP сразу — при header bidding они конкурируют параллельно.': 'Represents the publisher. Packages the impression into a bid request, sets the floor price and runs the auction itself among the connected DSPs — its auction engine is what "the exchange" actually is. Takes its own cut of the sale. A publisher usually connects several SSPs at once — under header bidding they compete in parallel.',
    'Баннер': 'Banner',
    'гео': 'geo',
    'язык': 'language',
    'контент': 'content',
    'IVT-сигналы': 'IVT signals',
    '3rd-party pixel сработал': '3rd-party pixel fired',
    // ── brand / chrome ──
    'RTB ДВИЖОК': 'RTB ENGINE',
    'Programmatic · как устроена закупка рекламы в реальном времени': 'Programmatic · how real-time ad buying works',
    'скорость': 'speed',
    'Авто': 'Auto',
    'Пошагово': 'Step',
    'Запустить аукцион': 'Run auction',
    'Идёт…': 'Running…',
    'Далее': 'Next',
    'Сброс': 'Reset',
    'Тёмная тема': 'Dark theme',
    'Светлая тема': 'Light theme',
    'Конфигуратор экосистемы': 'Ecosystem configurator',

    // ── nodes: titles & subs ──
    'Пользователь': 'User',
    'Cookie / ID': 'Cookie / ID',
    'Браузер': 'Browser',
    'In-app / web': 'In-app / web',
    'Smart TV': 'Smart TV',
    'Паблишер': 'Publisher',
    'Сайт · рекламное место': 'Site · ad slot',
    'Supply-Side Platform': 'Supply-Side Platform',
    'Верификатор': 'Verifier',
    'Fraud · Brand Safety': 'Fraud · Brand Safety',
    'Ad Exchange': 'Ad Exchange',
    'Аукцион sell-side — внутри SSP': 'Sell-side auction — inside the SSP',
    'аукцион': 'auction',
    'Данные и ID': 'Data & Identity',
    'сегменты и идентификаторы': 'segments & identifiers',
    'Трекинг кампании': 'Campaign tracking',
    '3rd-party tag · pixel': '3rd-party tag · pixel',
    'Demand-Side Platform': 'Demand-Side Platform',
    'DSP · Бренд': 'DSP · Brand',
    'DSP · Ретаргетинг': 'DSP · Retargeting',
    'DSP · Перформанс': 'DSP · Performance',
    'DSP · Видео': 'DSP · Video',
    'DSP · Mobile-app': 'DSP · Mobile-app',
    'DSP · Аудио': 'DSP · Audio',
    'Бренд': 'Brand',
    'Ретаргетинг': 'Retargeting',
    'Перформанс': 'Performance',
    'Видео': 'Video',
    'Mobile-app': 'Mobile-app',
    'Аудио': 'Audio',

    // ── nodes: info ──
    'Заходит на сайт или в приложение со своего устройства (десктоп, мобайл, CTV). Тип устройства определяет доступные форматы рекламы и влияет на ценность показа.':
      'Opens a site or app on their device (desktop, mobile, CTV). The device type determines the available ad formats and affects the value of the impression.',
    'Владелец рекламного инвентаря. Каждое свободное рекламное место имеет формат (дисплей, видео, нативный) и хочет продаться как можно дороже — за доли секунды.':
      'Owner of the ad inventory. Every free ad slot has a format (display, video, native) and wants to sell as high as possible — in a fraction of a second.',
    'Представляет интересы паблишера. Упаковывает показ в bid request, выставляет floor price и отправляет инвентарь на аукцион биржи. Берёт свою комиссию с продажи.':
      'Represents the publisher. Packages the impression into a bid request, sets the floor price and sends the inventory to the exchange auction. Takes its own cut of the sale.',
    'Независимый вендор (типа IAS / DoubleVerify). Проверяет показ до ставки: не бот ли это (fraud / IVT) и безопасен ли контент для бренда (brand safety). После показа 3rd-party pixel замеряет видимость (viewability). Если показ «грязный» — он блокируется.':
      'An independent vendor (like IAS / DoubleVerify). Checks the impression before bidding: is it a bot (fraud / IVT) and is the content brand-safe? After render a 3rd-party pixel measures viewability. A "dirty" impression is blocked.',
    'Здесь идёт аукцион: запрос от SSP уходит всем DSP, возвращаются ставки, выбирается победитель — меньше чем за 100 мс. На карте это отдельная станция, чтобы шаги было видно; в реальности такой аукционный движок — часть самой SSP, а не отдельная компания. Отдельные биржи ещё существуют (крупнейшая — Google AdX), но перепродажа трафика через лишние звенья — сжимающийся путь. Комиссию за аукцион удерживает sell-side, одной строкой вместе с SSP.':
      'This is where the auction runs: the SSP\'s request goes out to every DSP, bids come back, a winner is picked — in under 100 ms. It is drawn as its own station so the steps stay visible; in reality this auction engine is part of the SSP itself, not a separate company. Standalone exchanges do still exist (Google AdX is the big one), but reselling traffic through extra hops is a shrinking path. The auction fee is taken by the sell side, as one line together with the SSP.',
    'Слой данных: хранит сегменты («был в корзине», «18–24») и связывает идентификаторы пользователя. DSP забирает сегменты заранее, по eids находит их в своём профиле — узнали «горячего», ставка выросла в разы. Классический DMP на 3P-cookie — уходящая категория (Oracle закрыл свой в 2024); его место заняли first-party CDP, ID-графы (UID2 / ID5) и курируемые сделки на стороне SSP.':
      'The data layer: it stores segments ("abandoned cart", "18–24") and ties a user\'s identifiers together. A DSP syncs the segments in advance and looks them up by eids in its own profile — recognise a "hot" user and the bid grows several-fold. The classic 3P-cookie DMP is a fading category (Oracle shut its own down in 2024); first-party CDPs, ID graphs (UID2 / ID5) and sell-side curated deals took its place.',
    'В креатив зашит 3rd-party tag / tracking pixel рекламодателя. При показе и клике он шлёт постбэк в ad server рекламодателя и в аналитику (в мобильных кампаниях — в MMP) — так считаются показы, клики, конверсии и оптимизируются следующие ставки. Сегодня события всё чаще уходят server-to-server: браузерные пиксели режут блокировщики и ITP.':
      'The advertiser\'s 3rd-party tag / tracking pixel is embedded in the creative. On render and click it fires a postback to the advertiser\'s ad server and analytics (on mobile campaigns, to an MMP) — that is how impressions, clicks and conversions are counted and future bids optimized. These days the events increasingly go server-to-server: blockers and ITP cut browser pixels.',
    'Бренд-кампания: важен охват и качественный контекст. Платит за заметные показы нужной аудитории, но не гонится за каждым кликом.':
      'Brand campaign: reach and quality context matter. Pays for visible impressions to the right audience, but does not chase every click.',
    '«догоняет» пользователей, которые уже были на сайте рекламодателя. Если DMP узнаёт человека — ставка резко растёт.':
      '"chases" users who already visited the advertiser\'s site. If the DMP recognizes the person, the bid jumps sharply.',
    'Ретаргетинг: «догоняет» пользователей, которые уже были на сайте рекламодателя. Если DMP узнаёт человека — ставка резко растёт.':
      'Retargeting: "chases" users who already visited the advertiser\'s site. If the DMP recognizes the person, the bid jumps sharply.',
    'Перформанс: оптимизирует ставку под конверсии и CPA. Считает вероятность целевого действия и платит ровно столько, сколько окупится.':
      'Performance: optimizes the bid for conversions and CPA. Estimates the probability of the target action and pays exactly what pays off.',
    'Видео-реклама: дорогой формат с высоким CPM. Платит премию за досмотры и качественный инвентарь, особенно на CTV.':
      'Video advertising: an expensive format with high CPM. Pays a premium for completions and quality inventory, especially on CTV.',
    'Продвижение приложений: оптимизирует под установки. Ставка зависит от устройства пользователя и похожести на «платящую» аудиторию.':
      'App promotion: optimizes for installs. The bid depends on the user\'s device and similarity to a "paying" audience.',
    'Аудиореклама (подкасты, стриминг). Узкий, но лояльный охват; ставка выше при точном попадании в сегмент DMP.':
      'Audio advertising (podcasts, streaming). Narrow but loyal reach; the bid is higher on a precise DMP-segment match.',

    // ── stage titles (without number prefix) ──
    'Открытие страницы': 'Page open',
    'Запрос показа (bid request)': 'Impression request (bid request)',
    'В аукцион': 'Into the auction',
    'Верификация (Fraud / Brand Safety)': 'Verification (Fraud / Brand Safety)',
    'Рассылка DSP': 'Broadcast to DSPs',
    'Данные и идентификация': 'Data & identity',
    'Ставки (bid response)': 'Bids (bid response)',
    'Аукцион': 'Auction',
    'Возврат победителя': 'Returning the winner',
    'Показ объявления': 'Ad render',
    'Трекинг и деньги': 'Tracking & money',
    'Показ заблокирован': 'Impression blocked',
    'Готово к запуску': 'Ready to run',

    // ── stage descriptions ──
    'Пользователь открывает сайт или приложение со своего устройства. Браузер загружает страницу, и одно из рекламных мест оказывается свободным — его нужно заполнить.':
      'The user opens a site or app on their device. The browser loads the page and one of the ad slots is free — it needs to be filled.',
    'Код рекламного места обращается к SSP. Та формирует bid request: формат, размер, URL, гео, устройство, данные о пользователе — и выставляет floor price.':
      'The ad slot\'s code calls the SSP. It builds a bid request: format, size, URL, geo, device, user data — and sets the floor price.',
    'Запрос попадает в аукционный движок sell-side — на карте он нарисован отдельной станцией «Ad Exchange», чтобы шаги было видно, хотя обычно это часть самой SSP. Запускается таймер торгов (tmax): каждому DSP даётся ~100 мс на ответ. Это бюджет на сбор ставок, а не на весь путь до показа — рендер и трекинг идут уже после закрытия аукциона.':
      'The request enters the sell side\'s auction engine — drawn on the map as a separate "Ad Exchange" station so the steps stay visible, though it is usually part of the SSP itself. The bidding timer (tmax) starts: each DSP gets ~100 ms to respond. That budget is for collecting bids, not the whole path to render — rendering and tracking happen after the auction closes.',
    'Перед аукционом показ проходит верификацию: не бот ли это (fraud / IVT) и безопасен ли контент для бренда (brand safety). На стороне предложения это делают биржа/SSP, на стороне спроса — сам DSP (pre-bid). «Грязный» показ блокируется и на аукцион не попадает.':
      'Before the auction the impression is verified: is it a bot (fraud / IVT) and is the content brand-safe? On the supply side the exchange/SSP do this; on the demand side the DSP runs its own pre-bid check. A "dirty" impression is blocked and never reaches the auction.',
    'Биржа одновременно рассылает bid request всем подключённым DSP. Каждая платформа решает за себя: интересен ли ей этот показ, формат и этот пользователь.':
      'The exchange simultaneously broadcasts the bid request to all connected DSPs. Each platform decides for itself: is this impression, format and user interesting.',
    'Сегменты пользователя у DSP уже есть — они синхронизированы заранее через cookie-sync с DMP, вне окна аукциона. По eids/ID платформа находит сегменты в своём профиле: узнали «горячего» — ставка вырастет, не узнали — DSP может промолчать.':
      'The DSP already has the user segments — synced ahead of time with the DMP via cookie-sync, outside the auction window. By eids/ID it looks them up in its own profile store: a "hot" user lifts the bid; an unknown one may get no bid.',
    'Каждый DSP считает свою цену за тысячу показов (CPM) с учётом формата и возвращает ставку на биржу. Ставки ниже floor price отбрасываются, кто-то может не успеть ответить (timeout).':
      'Each DSP computes its price per thousand impressions (CPM) for the format and returns a bid to the exchange. Bids below the floor price are dropped; some may fail to answer in time (timeout).',
    'Биржа сравнивает ставки и выбирает победителя. Цена, которую он заплатит, зависит от типа аукциона (см. панель Tweaks).':
      'The exchange compares the bids and picks a winner. The price it pays depends on the auction type (see the configurator).',
    'Креатив победившего DSP уходит обратно через биржу и SSP на страницу паблишера. Аукцион закрыт, цена зафиксирована. Последнее слово — за ad server паблишера: он сравнивает победителя header bidding с прямыми продажами и гарантированными сделками и решает, чей креатив реально покажут.':
      'The winning DSP\'s creative travels back through the exchange and SSP to the publisher\'s page. The auction is closed, the price fixed. The last word belongs to the publisher\'s ad server: it compares the header bidding winner against direct-sold campaigns and guaranteed deals, and decides whose creative actually runs.',
    'Ad server паблишера': 'Publisher ad server',
    'что показать в этом месте': 'what to show in this slot',
    'Финальная точка решения на стороне паблишера. Сравнивает три источника спроса и выбирает, чей креатив показать: прямые продажи (проданные заранее по фиксированной цене), гарантированные сделки и победителя header bidding. Именно ради этого сравнения header bidding и придумали: раньше ad server сначала предлагал остаток собственной бирже, и внешний спрос видел только то, что осталось. Рынок почти целиком за Google Ad Manager — и это ровно тот актив, вокруг которого идут антимонопольные дела: суд признал ad server паблишера и биржу двумя отдельными монополизированными рынками, а их связывание — незаконным; Еврокомиссия отдельно оштрафовала Google на €2,95 млрд.':
      'The publisher\'s final decision point. It compares three demand sources and picks whose creative runs: direct-sold campaigns (sold in advance at a fixed price), guaranteed deals, and the header bidding winner. That comparison is exactly why header bidding was invented: the ad server used to offer the remnant to its own exchange first, so outside demand only ever saw what was left. The market is almost entirely Google Ad Manager — and this is precisely the asset the antitrust cases turn on: a court found the publisher ad server and the ad exchange to be two separate monopolized markets and their tying unlawful, and the European Commission separately fined Google €2.95bn.',
    'Баннер или видео победителя отрисовывается в рекламном месте. Зашитый в креатив 3rd-party pixel срабатывает, а верификатор замеряет видимость (viewability). На CTV браузерного рендера обычно нет: SSAI-сервер вшивает ролик прямо в видеопоток, а события отдаёт плеер.':
      'The winner\'s banner or video renders in the ad slot. The 3rd-party pixel embedded in the creative fires, and the verifier measures viewability. On CTV there is usually no browser render at all: an SSAI server stitches the spot straight into the video stream and the player reports the events.',
    '3rd-party tag / pixel фиксирует показ и клик, отправляет постбэк в ad server рекламодателя и MMP. Из цены вычитается комиссия sell-side (SSP вместе со своим аукционом) — остальное получает паблишер.':
      'The 3rd-party tag / pixel records the impression and click, sends a postback to the advertiser\'s ad server and MMP. The sell-side fee (the SSP together with its own auction) is subtracted from the price — the publisher keeps the rest.',
    'Нажмите «Запустить аукцион», чтобы прогнать одну сделку через всю цепочку — от открытия страницы до показа. Кликайте по узлам, наводите на подчёркнутые термины. Состав экосистемы и настройки — по кнопке ⚙ вверху (Конфигуратор).':
      'Press "Run auction" to send one deal through the whole chain — from page open to render. Click the nodes, hover the underlined terms. The ecosystem makeup and settings live under the ⚙ button on top (Configurator).',

    // ── bottom bar / stats ──
    'Время аукциона': 'Auction time',
    'Ставок': 'Bids',
    'Клиринговая цена': 'Clearing price',
    'Победитель': 'Winner',
    'нет ставок': 'no bids',
    'блокировка': 'blocked',
    '1-я цена': '1st price',
    '2-я цена': '2nd price',
    'Согласие GDPR / TCF': 'GDPR / TCF consent',
    'Режим': 'Mode',
    'стартовая точка — дальше меняй что угодно по одному': 'a starting point — then change anything, one switch at a time',
    'Перепродажа (reseller hop)': 'Resold path (reseller hop)',
    'лишнее звено в цепочке: своя комиссия сверху, а SPO-покупатели такой путь не берут': 'an extra link in the chain: its own cut on top, and SPO buyers refuse such a path',
    'перепродажа': 'resold',
    'Комиссия реселлера': 'Reseller fee',
    'лишнее звено в цепочке': 'an extra link in the chain',
    'не берёт перепродажу': 'refuses resold',
    'выключи — и нет ни ID, ни сегментов; часть спроса вообще не торгуется': 'switch it off: no ID, no segments — and some demand does not bid at all',
    'нет согласия': 'no consent',
    'Десктоп': 'Desktop',
    'Мобайл': 'Mobile',
    'Дисплей': 'Display',
    'Нативный': 'Native',
    'Вериф.': 'Verif.',
    'Верификатор отклонил показ до аукциона — см. красный блок слева. Ни один DSP не получил bid request, деньги не списаны. Выключите «Симулировать угрозу» в Tweaks, чтобы увидеть обычный прогон.':
      'The verifier rejected the impression before the auction — see the red panel on the left. No DSP received a bid request, no money was charged. Turn off "Simulate threat" in the configurator to see a normal run.',

    // ── block banner ──
    'Показ заблокирован верификатором': 'Impression blocked by the verifier',
    'Обнаружен невалидный трафик (fraud / IVT) — бот, а не живой пользователь. Показ снят с аукциона, деньги не списаны.':
      'Invalid traffic detected (fraud / IVT) — a bot, not a real user. The impression is pulled from the auction, no money charged.',
    'Контент не прошёл brand safety — небезопасное окружение для бренда. Показ снят с аукциона, деньги не списаны.':
      'The content failed brand safety — an unsafe environment for the brand. The impression is pulled from the auction, no money charged.',

    // ── money panel ──
    'Денежный поток': 'Money flow',
    'CPM за показ': 'CPM per impression',
    'Рекламодатель': 'Advertiser',
    'платит · ': 'pays · ',
    'Комиссия биржи': 'Exchange fee',
    'Комиссия SSP': 'SSP fee',
    'Комиссия sell-side': 'Sell-side fee',
    'SSP вместе со своим аукционом': 'the SSP together with its own auction',
    'Комиссия DSP': 'DSP fee',
    'сторона спроса': 'demand side',
    'с остатка': 'of remainder',
    'чистыми, после комиссий': 'net, after fees',

    // ── auction panel ──
    'платит': 'pays',
    'свою ставку': 'its own bid',
    'Аукцион 1-й цены: победитель платит свою ставку — поэтому DSP заранее занижает её (bid shading) до ожидаемой цены клиринга.':
      'First-price auction: the winner pays its own bid — so the DSP shades that bid down (bid shading) toward the expected clearing price.',
    'Ставка победителя была': 'The winner bid',
    'но платит он': 'but pays the',
    'цену второго места': 'second-place price',
    'экономия': 'savings',
    'Ни одна ставка не прошла floor price — показ не продан.': 'No bid cleared the floor price — the impression went unsold.',
    'first-look = ': 'first-look = ',
    'фикс.': 'fixed',
    'first-look': 'first-look',
    'Preferred deal': 'Preferred deal',
    ': цена согласована заранее, аукцион не проводится.': ': the price is agreed in advance, no auction is run.',
    'приватный аукцион, deal floor': 'private auction, deal floor',
    'Сделка прошла floor и победила в приоритете над открытым аукционом.':
      'The deal cleared the floor and won with priority over the open auction.',
    'Сделки не прошли deal floor → ушло в открытый аукцион.':
      'Deals did not clear the deal floor → it went to the open auction.',
    'first-look по фикс. цене': 'first-look at a fixed price',
    'Покупатель взял показ по фикс. цене вне аукциона.':
      'The buyer took the impression at a fixed price outside the auction.',
    'Покупатель отказался → ушло в открытый аукцион.':
      'The buyer declined → it went to the open auction.',
    'источники по очереди. Показ ушёл': 'sources are queried in turn. The impression went to the',
    'первому подходящему': 'first eligible',
    'по приоритету, а не самому высокому.': 'by priority, not the highest one.',
    'Более высокая ставка': 'A higher bid',
    'не успела поучаствовать —': 'did not get to compete —',
    'потеря': 'lost',
    'Это и есть минус waterfall.': 'That is exactly the downside of waterfall.',
    'Здесь первый подошедший оказался и лучшим — потерь нет. Но так бывает не всегда.':
      'Here the first eligible was also the best — no loss. But that is not always the case.',

    // ── DSP card ──
    'ставка CPM': 'bid CPM',
    'timeout': 'timeout',
    'no bid': 'no bid',
    'отказ': 'declined',
    'Прибавка к ставке за счёт данных DMP': 'Bid uplift from DMP data',
    'Прямая сделка — Deal ID': 'Direct deal — Deal ID',
    'Заглянуть внутрь': 'Look inside',

    // ── configurator ──
    'Конфигуратор': 'Configurator',
    'экосистема RTB': 'RTB ecosystem',
    'Узлы экосистемы': 'Ecosystem nodes',
    'вкл / выкл': 'on / off',
    'данные и сегменты': 'data & segments',
    'Трекинг кампании ': 'Campaign tracking ',
    'Спрос': 'Demand',
    'Число DSP': 'DSP count',
    'Число SSP': 'SSP count',
    'Показ': 'Impression',
    'Устройство': 'Device',
    'Формат': 'Format',
    'Тип сделки': 'Deal type',
    'Открытый': 'Open',
    'Тип цены': 'Price type',
    'Floor price': 'Floor price',
    'DMP обогащает ставки': 'DMP enriches bids',
    'прибавка за сегменты': 'uplift from segments',
    'Путь инвентаря': 'Supply path',
    'как продаётся показ': 'how the impression sells',
    'Способ': 'Method',
    'Сценарий верификации': 'Verification scenario',
    'Инструменты': 'Tools',
    'Сценарии': 'Scenarios',
    'один клик — настройка и прогон': 'one click — configure and run',
    'Глоссарий': 'Glossary',
    'Пройти квиз': 'Take the quiz',
    'Подача': 'Delivery',
    'Глубина пояснений': 'Explanation depth',
    'Новичок': 'Beginner',
    'Профи': 'Pro',
    'Cookieless / приватность': 'Cookieless / privacy',
    'без 3P cookie (Safari / Firefox / ATT) · alt-ID: UID2 / ID5': 'no 3P cookie (Safari / Firefox / ATT) · alt-ID: UID2 / ID5',
    'Сессия из 5 показов': 'Session of 5 impressions',
    'Поделиться сценарием': 'Share scenario',
    'Сравнить прогоны': 'Compare runs',
    'Экспорт PDF': 'Export PDF',
    'Латентность': 'Latency',
    'бюджет 100 мс': '100 ms budget',
    'Симулировать угрозу': 'Simulate threat',
    'бот / небезопасный контент → блок': 'bot / unsafe content → block',

    // ── signals (titles, dirs, field keys/values) ──
    'Загрузка страницы': 'Page load',
    'Пользователь → Паблишер': 'User → Publisher',
    'Запрос рекламы': 'Ad request',
    'Паблишер → SSP': 'Publisher → SSP',
    '← обратно': '← back',
    'Bid request · OpenRTB': 'Bid request · OpenRTB',
    'SSP → Ad Exchange': 'SSP → Ad Exchange',
    'Контекст на проверку': 'Context for checking',
    'Ad Exchange → Верификатор': 'Ad Exchange → Verifier',
    'Bid request → DSP': 'Bid request → DSP',
    'Ad Exchange → DSP': 'Ad Exchange → DSP',
    'Bid response ← DSP': 'Bid response ← DSP',
    'Сегменты пользователя': 'User segments',
    'DMP ↔ DSP': 'DMP ↔ DSP',
    'События показа / клика': 'Render / click events',
    'Паблишер → Трекинг': 'Publisher → Tracking',
    'Постбэк': 'Postback',
    'Трекинг → ad server рекламодателя / MMP': 'Tracking → advertiser ad server / MMP',
    'размер места': 'slot size',
    'формат': 'format',
    'позиция': 'position',
    'домен': 'domain',
    'категория': 'category',
    'дисплей': 'display',
    'видео': 'video',
    'нативный': 'native',
    'креатив': 'creative',
    'запрос': 'request',
    'по cookie / ID': 'by cookie / ID',
    'сегменты': 'segments',
    '«авто», «в корзине»': '"auto", "in cart"',
    'возраст': 'age',
    'интересы': 'interests',
    'событие': 'event',
    'клик': 'click',
    'кампания': 'campaign',
    'оптимизация': 'optimization',
    'модель CTR / CR': 'CTR / CR model',
    'если PMP': 'if PMP',
    'CPM ставка': 'CPM bid',
    'win notice': 'win notice',
    'обратно': 'back',
    'Десктоп · Web': 'Desktop · Web',
    'Мобайл · In-app': 'Mobile · In-app',
    'CTV · видео': 'CTV · video',
  };

  // EN glossary (term → definition). Used for the hover-underline in EN mode.
  const GLOSSARY_EN = {
    'RTB': 'Real-Time Bidding — buying impressions through a real-time auction, one impression at a time.',
    'programmatic': 'Programmatic — automated ad buying via platforms and algorithms.',
    'SSP': 'Supply-Side Platform — the publisher\'s side: sells its ad slots at auction.',
    'DSP': 'Demand-Side Platform — the advertiser\'s side: bids for impressions automatically.',
    'DMP': 'Data-Management Platform — stores and segments user data for targeting. A legacy category: it was built on the 3P cookie, and Oracle shut its own DMP down in 2024. The functions dispersed into first-party CDPs, ID graphs (UID2 / ID5), clean rooms and sell-side curation — which is why the node on the map is called "Data & Identity" rather than DMP.',
    'Ad Exchange': 'Ad Exchange — the auction marketplace between supply and demand. In 2026 every major SSP runs its own auction and the industry counts them as one category — which is why a direct path carries one sell-side fee, not two. The one big standalone exchange left is Google AdX, the subject of US and EU antitrust proceedings whose outcome is still open. Independent exchanges that resell other platforms\' traffic still exist, but that is a shrinking, lower-paying path which major DSPs increasingly block.',
    'bid request': 'Bid request — a description of the impression and user that the exchange broadcasts to DSPs.',
    'bid response': 'Bid response — a DSP\'s reply with its bid and the creative it is ready to show.',
    'floor price': 'Floor price — the minimum price below which the publisher will not sell the impression.',
    'CPM': 'CPM — cost per mille (thousand impressions). The core currency of programmatic bids.',
    'clearing price': 'Clearing price — the final price the winner actually pays for the impression.',
    'postback': 'Postback — a signal of an event (impression, click, conversion) sent back for optimization.',
    'segments': 'Segments — groups of users by interest/behavior used by a DSP to value an impression.',
    'creative': 'Creative — the ad itself (banner, video, native unit) shown to the user.',
    'publisher': 'Publisher — the owner of a site or app who sells ad slots.',
    'ad slot': 'Ad slot — a specific position on a page where an ad is inserted.',
    '3rd-party tag': '3rd-party tag — a third-party ad tag in the creative that loads the ad and sends data to an external ad server.',
    '3rd-party pixel': '3rd-party pixel — an invisible vendor pixel that records render/click and measures viewability and fraud.',
    'pixel': 'Tracking pixel — an invisible 1×1 pixel that fires an event (impression, click, conversion) when loaded.',
    'fraud': 'Fraud — ad fraud: faking impressions and clicks with bots instead of real people.',
    'IVT': 'IVT (Invalid Traffic) — bots, data centers, fake activity. The verifier filters such impressions out.',
    'brand safety': 'Brand Safety — the universal floor: content no one at all should advertise against (terrorism, child exploitation, piracy, incitement). The same for every brand. Tuning it to a specific brand is brand suitability.',
    'brand suitability': 'Brand Suitability — fit for a specific brand: the same content suits one advertiser and not another. A report on a fatal crash is lethal for a car brand and ideal for an insurer. It works both ways: not only avoidance, but seeking the right context.',
    'blocklist': 'Blocklist — a list of stop-words or domains used to reject an impression. It matches substrings and understands no meaning, so it switches off legitimate news wholesale: "shooting" in an Olympics report is blocked exactly like "shooting" in a crime report.',
    'MFA': 'MFA (Made for Advertising) — sites that exist for the impressions: aggressive ad load, purchased traffic, content as a pretext. Not a brand safety issue (the content is usually harmless) but a quality one: CPMs there run about a quarter lower, which is why optimisers go there.',
    'pre-bid / post-bid': 'Pre-bid — checking BEFORE the bid: the bad impression is simply never bought, the money is intact. Post-bid — the impression is already bought and the tag on the page refuses to render the creative: the brand is saved, the money mostly is not.',
    'viewability': 'Viewability — whether the impression actually entered the visible area, not scrolled past.',
    'attention': 'Attention — whether a human actually looked at the impression, and for how many seconds. The quality rung above viewability: "could have seen" ≠ "saw".',
    'attention seconds': 'Attention seconds — how many seconds of real attention an impression earned. A tangible metric instead of a binary viewable / not-viewable.',
    'Adelaide AU': 'Adelaide AU — a single 0–100 attention score from the vendor Adelaide, modelled from ad and page signals; an example of a predictive attention metric.',
    'verifier': 'Verifier — an independent vendor (IAS, DoubleVerify) checking fraud, brand safety and viewability.',
    'CTV': 'CTV (Connected TV) — ads on smart TVs and set-top boxes, usually high-CPM video.',
    'format': 'Format — the ad type: display (banner), video (in-stream) or native (in-feed).',
    'device': 'Device — desktop, mobile or CTV. Determines available formats and affects the price.',
    'video': 'Video advertising — a high-CPM format: in-stream (in the player) or out-stream (in content).',
    'native': 'Native format — an ad woven into the content feed, matching its look.',
    'PMP': 'PMP (Private Marketplace) — a private auction: impressions are available only to invited buyers via Deal ID, usually with a higher floor.',
    'Deal ID': 'Deal ID — the identifier of a direct deal between publisher and buyer with agreed terms (price, access, priority).',
    'deal floor': 'Deal floor — an elevated minimum price within a direct deal (PMP), above the open-auction floor.',
    'Preferred': 'Preferred Deal — a first-look deal: a priority buyer can buy the impression at a fixed price before the open auction.',
    'first-look': 'First-look — the priority buyer\'s right to decide first whether to take the impression at the agreed price, before the open auction.',
    'header bidding': 'Header bidding — the publisher runs a single auction across many demand sources in parallel (in the page header) before calling the ad server. All compete at once — higher yield.',
    'first-price auction': 'First-price auction — the winner pays its own bid. Since ~2019 this is the norm in the open auction (exchanges and SSPs moved to first price), which is why a DSP shades its bid down to the expected clearing price.',
    'second-price auction': 'Second-price auction — the winner pays the runner-up price plus a cent. The historical model: the norm until ~2019, today rare in the open auction (it survives inside some stacks and private deals).',
    'bid shading': 'Bid shading — a DSP lowers its bid toward the expected clearing price. Under first price the winner pays its own bid, so bidding the full value of the impression is wasteful.',
    'SSAI': 'SSAI — server-side ad insertion: the ad is stitched into the video stream on the server instead of being requested by the player. The norm on CTV: no browser, ad blockers do not work — but measurement is harder, since the player or the server reports the events.',
    'TCF': 'IAB TCF (Transparency & Consent Framework) — the EU industry standard for consent: the CMP on the page collects it and encodes it into a consent string that then travels the whole bid-request chain.',
    'consent string': 'Consent string — the user’s consent, encoded (TCF) and carried in the bid request (user.consent + regs.gdpr). Every party in the chain reads it to know what it may do with the data. No consent means no ID and no segments — and demand that lives on the user profile (retargeting) simply does not enter the auction. This is not the same as cookieless: there the ID is technically hard to match, here it may not legally be sent at all.',
    'waterfall': 'Waterfall — demand sources are queried sequentially by priority. The first one that takes the impression at its price wins — higher demand further down never competes. A historic model: the norm until ~2016–18, displaced by header bidding on the web; it survives as an in-app and CTV fallback.',
    'ad server': 'Ad server — on the publisher side it is the final decision point: which ad to show (direct sales, deals, the header-bidding winner); the market is almost entirely Google Ad Manager. The advertiser has its own ad server, which hosts the creatives and counts impressions/clicks independently — hence the perennial discrepancies between the two sets of numbers.',
    'SPO': 'SPO (supply path optimisation) — the buyer deliberately narrows which paths it will buy an impression through: fewer hops, fewer fees, better transparency. In practice big DSPs simply stop bidding on resold multi-hop paths, so an extra intermediary costs the publisher demand, not just margin.',
    'reseller': 'Reseller — an intermediary that buys inventory from another platform and resells it onward. Its cut stacks on top of the fees already taken, and because of SPO the biggest buyers increasingly refuse such paths. Resold traffic is a shrinking share of spend — this is the one case where the old two-fee picture is genuinely true.',
    'curation': 'Curation — inventory + data + rules packaged into a Deal ID on the sell side. Targeting moves from the buy side (where the DMP used to do it) to the SSP: a curator assembles the package and the buyer takes it as a single deal. One of the defining shifts of 2024–26 and the de-facto heir to DMP enrichment.',
    'eids': 'eids (alt-IDs) — the array of alternative identifiers in the bid request (user.eids): UID2, ID5, RampID. They are either deterministic (from a hashed email or a login) or probabilistic. They replaced the 3P cookie as the way identity travels between parties in the chain.',
    'clean room': 'Clean room — a neutral environment where an advertiser and a publisher match their first-party data without handing it to each other: they build audiences and measure outcomes. It runs offline, outside the 100 ms auction window — which is why it does not appear on the RTB map.',
  };

  // ── RU → PL map (Polish). Anything not present passes through unchanged. ──
  const RU2PL = {
    'Представляет интересы паблишера. Упаковывает показ в bid request, выставляет floor price и сама проводит аукцион среди подключённых DSP — её аукционный движок и есть та самая «биржа». Берёт свою комиссию с продажи. Паблишер обычно подключает несколько SSP сразу — при header bidding они конкурируют параллельно.': 'Reprezentuje interesy wydawcy. Pakuje odsłonę w bid request, ustawia floor price i sama prowadzi aukcję wśród podłączonych DSP — jej silnik aukcyjny to właśnie owa „giełda”. Pobiera własną prowizję od sprzedaży. Wydawca zwykle podłącza kilka SSP naraz — przy header biddingu konkurują one równolegle.',
    'Баннер': 'Baner',
    'гео': 'geo',
    'язык': 'język',
    'контент': 'treść',
    'IVT-сигналы': 'sygnały IVT',
    '3rd-party pixel сработал': '3rd-party pixel zadziałał',
    'RTB ДВИЖОК': 'SILNIK RTB',
    'Programmatic · как устроена закупка рекламы в реальном времени': 'Programmatic · jak działa zakup reklamy w czasie rzeczywistym',
    'скорость': 'prędkość',
    'Авто': 'Auto',
    'Пошагово': 'Krok po kroku',
    'Запустить аукцион': 'Uruchom aukcję',
    'Идёт…': 'Trwa…',
    'Далее': 'Dalej',
    'Сброс': 'Reset',
    'Тёмная тема': 'Tryb ciemny',
    'Светлая тема': 'Tryb jasny',
    'Конфигуратор экосистемы': 'Konfigurator ekosystemu',

    'Пользователь': 'Użytkownik',
    'Cookie / ID': 'Cookie / ID',
    'Браузер': 'Przeglądarka',
    'In-app / web': 'In-app / web',
    'Smart TV': 'Smart TV',
    'Паблишер': 'Wydawca',
    'Сайт · рекламное место': 'Strona · miejsce reklamowe',
    'Supply-Side Platform': 'Supply-Side Platform',
    'Верификатор': 'Weryfikator',
    'Fraud · Brand Safety': 'Fraud · Brand Safety',
    'Ad Exchange': 'Ad Exchange',
    'Аукцион sell-side — внутри SSP': 'Aukcja sell-side — wewnątrz SSP',
    'аукцион': 'aukcja',
    'Данные и ID': 'Dane i ID',
    'сегменты и идентификаторы': 'segmenty i identyfikatory',
    'Трекинг кампании': 'Śledzenie kampanii',
    '3rd-party tag · pixel': '3rd-party tag · pixel',
    'Demand-Side Platform': 'Demand-Side Platform',
    'DSP · Бренд': 'DSP · Brand',
    'DSP · Ретаргетинг': 'DSP · Retargeting',
    'DSP · Перформанс': 'DSP · Performance',
    'DSP · Видео': 'DSP · Wideo',
    'DSP · Mobile-app': 'DSP · Mobile-app',
    'DSP · Аудио': 'DSP · Audio',
    'Бренд': 'Brand',
    'Ретаргетинг': 'Retargeting',
    'Перформанс': 'Performance',
    'Видео': 'Wideo',
    'Mobile-app': 'Mobile-app',
    'Аудио': 'Audio',

    'Заходит на сайт или в приложение со своего устройства (десктоп, мобайл, CTV). Тип устройства определяет доступные форматы рекламы и влияет на ценность показа.':
      'Wchodzi na stronę lub do aplikacji ze swojego urządzenia (desktop, mobile, CTV). Typ urządzenia określa dostępne formaty reklamy i wpływa na wartość odsłony.',
    'Владелец рекламного инвентаря. Каждое свободное рекламное место имеет формат (дисплей, видео, нативный) и хочет продаться как можно дороже — за доли секунды.':
      'Właściciel powierzchni reklamowej. Każde wolne miejsce ma format (display, wideo, natywny) i chce sprzedać się jak najdrożej — w ułamku sekundy.',
    'Представляет интересы паблишера. Упаковывает показ в bid request, выставляет floor price и отправляет инвентарь на аукцион биржи. Берёт свою комиссию с продажи.':
      'Reprezentuje wydawcę. Pakuje odsłonę w bid request, ustawia floor price i wysyła powierzchnię na aukcję giełdy. Pobiera własną prowizję od sprzedaży.',
    'Независимый вендор (типа IAS / DoubleVerify). Проверяет показ до ставки: не бот ли это (fraud / IVT) и безопасен ли контент для бренда (brand safety). После показа 3rd-party pixel замеряет видимость (viewability). Если показ «грязный» — он блокируется.':
      'Niezależny dostawca (jak IAS / DoubleVerify). Sprawdza odsłonę przed licytacją: czy to nie bot (fraud / IVT) i czy treść jest bezpieczna dla marki (brand safety). Po wyświetleniu 3rd-party pixel mierzy widoczność (viewability). „Brudna” odsłona jest blokowana.',
    'Здесь идёт аукцион: запрос от SSP уходит всем DSP, возвращаются ставки, выбирается победитель — меньше чем за 100 мс. На карте это отдельная станция, чтобы шаги было видно; в реальности такой аукционный движок — часть самой SSP, а не отдельная компания. Отдельные биржи ещё существуют (крупнейшая — Google AdX), но перепродажа трафика через лишние звенья — сжимающийся путь. Комиссию за аукцион удерживает sell-side, одной строкой вместе с SSP.':
      'Tu odbywa się aukcja: żądanie od SSP trafia do wszystkich DSP, wracają oferty, wybierany jest zwycięzca — w mniej niż 100 ms. Na mapie to osobna stacja, żeby kroki były widoczne; w rzeczywistości ten silnik aukcyjny jest częścią samej SSP, a nie osobną firmą. Niezależne giełdy wciąż istnieją (największa to Google AdX), ale odsprzedaż ruchu przez dodatkowe ogniwa to kurcząca się ścieżka. Prowizję za aukcję pobiera sell-side, jedną pozycją razem z SSP.',
    'Слой данных: хранит сегменты («был в корзине», «18–24») и связывает идентификаторы пользователя. DSP забирает сегменты заранее, по eids находит их в своём профиле — узнали «горячего», ставка выросла в разы. Классический DMP на 3P-cookie — уходящая категория (Oracle закрыл свой в 2024); его место заняли first-party CDP, ID-графы (UID2 / ID5) и курируемые сделки на стороне SSP.':
      'Warstwa danych: przechowuje segmenty („był w koszyku”, „18–24”) i łączy identyfikatory użytkownika. DSP synchronizuje segmenty z wyprzedzeniem i po eids odnajduje je we własnym profilu — rozpoznasz „gorącego”, oferta rośnie wielokrotnie. Klasyczny DMP na 3P-cookie to kategoria odchodząca (Oracle zamknął swój w 2024); jego miejsce zajęły first-party CDP, grafy ID (UID2 / ID5) i kurowane transakcje po stronie SSP.',
    'В креатив зашит 3rd-party tag / tracking pixel рекламодателя. При показе и клике он шлёт постбэк в ad server рекламодателя и в аналитику (в мобильных кампаниях — в MMP) — так считаются показы, клики, конверсии и оптимизируются следующие ставки. Сегодня события всё чаще уходят server-to-server: браузерные пиксели режут блокировщики и ITP.':
      'W kreację wszyty jest 3rd-party tag / tracking pixel reklamodawcy. Przy wyświetleniu i kliknięciu wysyła postback do ad servera reklamodawcy i do analityki (w kampaniach mobilnych — do MMP) — tak liczone są odsłony, kliknięcia, konwersje i optymalizowane kolejne oferty. Dziś zdarzenia coraz częściej idą server-to-server: blokery i ITP ucinają pikselе w przeglądarce.',
    'Бренд-кампания: важен охват и качественный контекст. Платит за заметные показы нужной аудитории, но не гонится за каждым кликом.':
      'Kampania brandowa: liczy się zasięg i jakościowy kontekst. Płaci za widoczne odsłony właściwej grupie, ale nie goni za każdym kliknięciem.',
    '«догоняет» пользователей, которые уже были на сайте рекламодателя. Если DMP узнаёт человека — ставка резко растёт.':
      '„dogania” użytkowników, którzy już byli na stronie reklamodawcy. Gdy DMP rozpozna osobę — oferta gwałtownie rośnie.',
    'Ретаргетинг: «догоняет» пользователей, которые уже были на сайте рекламодателя. Если DMP узнаёт человека — ставка резко растёт.':
      'Retargeting: „dogania” użytkowników, którzy już byli na stronie reklamodawcy. Gdy DMP rozpozna osobę — oferta gwałtownie rośnie.',
    'Перформанс: оптимизирует ставку под конверсии и CPA. Считает вероятность целевого действия и платит ровно столько, сколько окупится.':
      'Performance: optymalizuje ofertę pod konwersje i CPA. Liczy prawdopodobieństwo akcji docelowej i płaci dokładnie tyle, ile się zwróci.',
    'Видео-реклама: дорогой формат с высоким CPM. Платит премию за досмотры и качественный инвентарь, особенно на CTV.':
      'Reklama wideo: drogi format z wysokim CPM. Płaci premię za dokończone odtworzenia i jakościową powierzchnię, zwłaszcza na CTV.',
    'Продвижение приложений: оптимизирует под установки. Ставка зависит от устройства пользователя и похожести на «платящую» аудиторию.':
      'Promocja aplikacji: optymalizuje pod instalacje. Oferta zależy od urządzenia użytkownika i podobieństwa do „płacącej” grupy.',
    'Аудиореклама (подкасты, стриминг). Узкий, но лояльный охват; ставка выше при точном попадании в сегмент DMP.':
      'Reklama audio (podcasty, streaming). Wąski, ale lojalny zasięg; oferta wyższa przy trafieniu w segment DMP.',

    'Открытие страницы': 'Otwarcie strony',
    'Запрос показа (bid request)': 'Żądanie odsłony (bid request)',
    'В аукцион': 'Do aukcji',
    'Верификация (Fraud / Brand Safety)': 'Weryfikacja (Fraud / Brand Safety)',
    'Рассылка DSP': 'Rozesłanie do DSP',
    'Данные и идентификация': 'Dane i identyfikacja',
    'Ставки (bid response)': 'Oferty (bid response)',
    'Аукцион': 'Aukcja',
    'Возврат победителя': 'Zwrot zwycięzcy',
    'Показ объявления': 'Wyświetlenie reklamy',
    'Трекинг и деньги': 'Śledzenie i pieniądze',
    'Показ заблокирован': 'Odsłona zablokowana',
    'Готово к запуску': 'Gotowe do uruchomienia',

    'Пользователь открывает сайт или приложение со своего устройства. Браузер загружает страницу, и одно из рекламных мест оказывается свободным — его нужно заполнить.':
      'Użytkownik otwiera stronę lub aplikację ze swojego urządzenia. Przeglądarka ładuje stronę i jedno z miejsc reklamowych jest wolne — trzeba je wypełnić.',
    'Код рекламного места обращается к SSP. Та формирует bid request: формат, размер, URL, гео, устройство, данные о пользователе — и выставляет floor price.':
      'Kod miejsca reklamowego zwraca się do SSP. Ta tworzy bid request: format, rozmiar, URL, geo, urządzenie, dane użytkownika — i ustawia floor price.',
    'Запрос попадает в аукционный движок sell-side — на карте он нарисован отдельной станцией «Ad Exchange», чтобы шаги было видно, хотя обычно это часть самой SSP. Запускается таймер торгов (tmax): каждому DSP даётся ~100 мс на ответ. Это бюджет на сбор ставок, а не на весь путь до показа — рендер и трекинг идут уже после закрытия аукциона.':
      'Żądanie trafia do silnika aukcyjnego sell-side — na mapie narysowanego jako osobna stacja „Ad Exchange”, żeby kroki były widoczne, choć zwykle jest to część samej SSP. Rusza zegar licytacji (tmax): każdy DSP dostaje ~100 ms na odpowiedź. To budżet na zebranie ofert, a nie na całą drogę do wyświetlenia — render i tracking dzieją się po zamknięciu aukcji.',
    'Перед аукционом показ проходит верификацию: не бот ли это (fraud / IVT) и безопасен ли контент для бренда (brand safety). На стороне предложения это делают биржа/SSP, на стороне спроса — сам DSP (pre-bid). «Грязный» показ блокируется и на аукцион не попадает.':
      'Przed aukcją odsłona przechodzi weryfikację: czy to bot (fraud / IVT) i czy treść jest brand-safe? Po stronie podaży robią to giełda/SSP, a po stronie popytu — sam DSP (pre-bid). „Brudna” odsłona jest blokowana i nie trafia na aukcję.',
    'Биржа одновременно рассылает bid request всем подключённым DSP. Каждая платформа решает за себя: интересен ли ей этот показ, формат и этот пользователь.':
      'Giełda jednocześnie rozsyła bid request do wszystkich podłączonych DSP. Każda platforma decyduje sama: czy ta odsłona, format i użytkownik ją interesują.',
    'Сегменты пользователя у DSP уже есть — они синхронизированы заранее через cookie-sync с DMP, вне окна аукциона. По eids/ID платформа находит сегменты в своём профиле: узнали «горячего» — ставка вырастет, не узнали — DSP может промолчать.':
      'DSP ma już segmenty użytkownika — zsynchronizowane wcześniej z DMP przez cookie-sync, poza oknem aukcji. Po eids/ID znajduje je we własnym profilu: rozpoznany „gorący” użytkownik podnosi ofertę, nieznany może nie dać oferty.',
    'Каждый DSP считает свою цену за тысячу показов (CPM) с учётом формата и возвращает ставку на биржу. Ставки ниже floor price отбрасываются, кто-то может не успеть ответить (timeout).':
      'Każdy DSP liczy swoją cenę za tysiąc odsłon (CPM) z uwzględnieniem formatu i zwraca ofertę na giełdę. Oferty poniżej floor price są odrzucane, ktoś może nie zdążyć z odpowiedzią (timeout).',
    'Биржа сравнивает ставки и выбирает победителя. Цена, которую он заплатит, зависит от типа аукциона (см. панель Tweaks).':
      'Giełda porównuje oferty i wybiera zwycięzcę. Cena, którą zapłaci, zależy od typu aukcji (zob. konfigurator).',
    'Креатив победившего DSP уходит обратно через биржу и SSP на страницу паблишера. Аукцион закрыт, цена зафиксирована. Последнее слово — за ad server паблишера: он сравнивает победителя header bidding с прямыми продажами и гарантированными сделками и решает, чей креатив реально покажут.':
      'Kreacja zwycięskiego DSP wraca przez giełdę i SSP na stronę wydawcy. Aukcja zamknięta, cena ustalona. Ostatnie słowo należy do ad servera wydawcy: porównuje zwycięzcę header biddingu ze sprzedażą bezpośrednią i transakcjami gwarantowanymi i decyduje, czyja kreacja naprawdę pójdzie.',
    'Ad server паблишера': 'Ad server wydawcy',
    'что показать в этом месте': 'co pokazać w tym miejscu',
    'Финальная точка решения на стороне паблишера. Сравнивает три источника спроса и выбирает, чей креатив показать: прямые продажи (проданные заранее по фиксированной цене), гарантированные сделки и победителя header bidding. Именно ради этого сравнения header bidding и придумали: раньше ad server сначала предлагал остаток собственной бирже, и внешний спрос видел только то, что осталось. Рынок почти целиком за Google Ad Manager — и это ровно тот актив, вокруг которого идут антимонопольные дела: суд признал ad server паблишера и биржу двумя отдельными монополизированными рынками, а их связывание — незаконным; Еврокомиссия отдельно оштрафовала Google на €2,95 млрд.':
      'Finalny punkt decyzyjny po stronie wydawcy. Porównuje trzy źródła popytu i wybiera, czyja kreacja pójdzie: sprzedaż bezpośrednia (sprzedana z góry po stałej cenie), transakcje gwarantowane i zwycięzca header biddingu. Właśnie dla tego porównania wymyślono header bidding: wcześniej ad server najpierw oferował resztę własnej giełdzie, więc popyt zewnętrzny widział tylko to, co zostało. Rynek to niemal w całości Google Ad Manager — i to dokładnie ten aktyw, wokół którego toczą się sprawy antymonopolowe: sąd uznał ad server wydawcy i giełdę za dwa odrębne zmonopolizowane rynki, a ich wiązanie za bezprawne; Komisja Europejska osobno ukarała Google grzywną 2,95 mld €.',
    'Баннер или видео победителя отрисовывается в рекламном месте. Зашитый в креатив 3rd-party pixel срабатывает, а верификатор замеряет видимость (viewability). На CTV браузерного рендера обычно нет: SSAI-сервер вшивает ролик прямо в видеопоток, а события отдаёт плеер.':
      'Baner lub wideo zwycięzcy renderuje się w miejscu reklamowym. Wszyty w kreację 3rd-party pixel odpala się, a weryfikator mierzy widoczność (viewability). Na CTV zwykle nie ma renderu w przeglądarce: serwer SSAI wszywa spot prosto w strumień wideo, a zdarzenia raportuje player.',
    '3rd-party tag / pixel фиксирует показ и клик, отправляет постбэк в ad server рекламодателя и MMP. Из цены вычитается комиссия sell-side (SSP вместе со своим аукционом) — остальное получает паблишер.':
      '3rd-party tag / pixel rejestruje odsłonę i kliknięcie, wysyła postback do ad servera reklamodawcy i MMP. Z ceny odejmowana jest prowizja sell-side (SSP wraz z własną aukcją) — resztę dostaje wydawca.',
    'Нажмите «Запустить аукцион», чтобы прогнать одну сделку через всю цепочку — от открытия страницы до показа. Кликайте по узлам, наводите на подчёркнутые термины. Состав экосистемы и настройки — по кнопке ⚙ вверху (Конфигуратор).':
      'Naciśnij „Uruchom aukcję”, aby przepuścić jedną transakcję przez cały łańcuch — od otwarcia strony do wyświetlenia. Klikaj węzły, najedź na podkreślone terminy. Skład ekosystemu i ustawienia — pod przyciskiem ⚙ u góry (Konfigurator).',

    'Время аукциона': 'Czas aukcji',
    'Ставок': 'Ofert',
    'Клиринговая цена': 'Cena rozliczenia',
    'Победитель': 'Zwycięzca',
    'нет ставок': 'brak ofert',
    'блокировка': 'blokada',
    '1-я цена': '1. cena',
    '2-я цена': '2. cena',
    'Согласие GDPR / TCF': 'Zgoda GDPR / TCF',
    'Режим': 'Tryb',
    'стартовая точка — дальше меняй что угодно по одному': 'punkt wyjścia — dalej zmieniaj co chcesz, przełącznik po przełączniku',
    'Перепродажа (reseller hop)': 'Odsprzedaż (reseller hop)',
    'лишнее звено в цепочке: своя комиссия сверху, а SPO-покупатели такой путь не берут': 'dodatkowe ogniwo w łańcuchu: własna prowizja na wierzchu, a kupujący z SPO takiej ścieżki nie biorą',
    'перепродажа': 'odsprzedaż',
    'Комиссия реселлера': 'Prowizja resellera',
    'лишнее звено в цепочке': 'dodatkowe ogniwo w łańcuchu',
    'не берёт перепродажу': 'odrzuca odsprzedaż',
    'выключи — и нет ни ID, ни сегментов; часть спроса вообще не торгуется': 'wyłącz: nie ma ani ID, ani segmentów — a część popytu w ogóle nie licytuje',
    'нет согласия': 'brak zgody',
    'Десктоп': 'Desktop',
    'Мобайл': 'Mobile',
    'Дисплей': 'Display',
    'Нативный': 'Natywny',
    'Вериф.': 'Weryf.',
    'Верификатор отклонил показ до аукциона — см. красный блок слева. Ни один DSP не получил bid request, деньги не списаны. Выключите «Симулировать угрозу» в Tweaks, чтобы увидеть обычный прогон.':
      'Weryfikator odrzucił odsłonę przed aukcją — zob. czerwony blok po lewej. Żaden DSP nie dostał bid requestu, pieniądze nie zostały pobrane. Wyłącz „Symuluj zagrożenie” w konfiguratorze, aby zobaczyć normalny przebieg.',

    'Показ заблокирован верификатором': 'Odsłona zablokowana przez weryfikator',
    'Обнаружен невалидный трафик (fraud / IVT) — бот, а не живой пользователь. Показ снят с аукциона, деньги не списаны.':
      'Wykryto nieprawidłowy ruch (fraud / IVT) — bot, a nie żywy użytkownik. Odsłona zdjęta z aukcji, pieniądze nie pobrane.',
    'Контент не прошёл brand safety — небезопасное окружение для бренда. Показ снят с аукциона, деньги не списаны.':
      'Treść nie przeszła brand safety — niebezpieczne otoczenie dla marki. Odsłona zdjęta z aukcji, pieniądze nie pobrane.',

    'Денежный поток': 'Przepływ pieniędzy',
    'CPM за показ': 'CPM za odsłonę',
    'Рекламодатель': 'Reklamodawca',
    'платит · ': 'płaci · ',
    'Комиссия биржи': 'Prowizja giełdy',
    'Комиссия SSP': 'Prowizja SSP',
    'Комиссия sell-side': 'Prowizja sell-side',
    'SSP вместе со своим аукционом': 'SSP wraz z własną aukcją',
    'Комиссия DSP': 'Prowizja DSP',
    'сторона спроса': 'strona popytu',
    'с остатка': 'z reszty',
    'чистыми, после комиссий': 'netto, po prowizjach',

    'платит': 'płaci',
    'свою ставку': 'swoją ofertę',
    'Аукцион 1-й цены: победитель платит свою ставку — поэтому DSP заранее занижает её (bid shading) до ожидаемой цены клиринга.':
      'Aukcja pierwszej ceny: zwycięzca płaci swoją ofertę — dlatego DSP zaniża ją z góry (bid shading) do oczekiwanej ceny rozliczenia.',
    'Ставка победителя была': 'Oferta zwycięzcy wynosiła',
    'но платит он': 'ale płaci',
    'цену второго места': 'cenę drugiego miejsca',
    'экономия': 'oszczędność',
    'Ни одна ставка не прошла floor price — показ не продан.': 'Żadna oferta nie przekroczyła floor price — odsłona niesprzedana.',
    'first-look = ': 'first-look = ',
    'фикс.': 'stała',
    'first-look': 'first-look',
    'Preferred deal': 'Preferred deal',
    ': цена согласована заранее, аукцион не проводится.': ': cena ustalona z góry, aukcja się nie odbywa.',
    'приватный аукцион, deal floor': 'aukcja prywatna, deal floor',
    'Сделка прошла floor и победила в приоритете над открытым аукционом.':
      'Transakcja przekroczyła floor i wygrała priorytetowo nad aukcją otwartą.',
    'Сделки не прошли deal floor → ушло в открытый аукцион.':
      'Transakcje nie przekroczyły deal floor → trafiło na aukcję otwartą.',
    'first-look по фикс. цене': 'first-look po stałej cenie',
    'Покупатель взял показ по фикс. цене вне аукциона.':
      'Kupujący wziął odsłonę po stałej cenie poza aukcją.',
    'Покупатель отказался → ушло в открытый аукцион.':
      'Kupujący odmówił → trafiło na aukcję otwartą.',
    'источники по очереди. Показ ушёл': 'źródła po kolei. Odsłona trafiła do',
    'первому подходящему': 'pierwszego pasującego',
    'по приоритету, а не самому высокому.': 'wg priorytetu, a nie najwyższej oferty.',
    'Более высокая ставка': 'Wyższa oferta',
    'не успела поучаствовать —': 'nie zdążyła wziąć udziału —',
    'потеря': 'strata',
    'Это и есть минус waterfall.': 'To właśnie minus waterfalla.',
    'Здесь первый подошедший оказался и лучшим — потерь нет. Но так бывает не всегда.':
      'Tu pierwszy pasujący okazał się najlepszym — bez strat. Ale nie zawsze tak bywa.',

    'ставка CPM': 'oferta CPM',
    'timeout': 'timeout',
    'no bid': 'no bid',
    'отказ': 'odmowa',
    'Прибавка к ставке за счёт данных DMP': 'Wzrost oferty dzięki danym DMP',
    'Прямая сделка — Deal ID': 'Transakcja bezpośrednia — Deal ID',
    'Заглянуть внутрь': 'Zajrzyj do środka',

    'Конфигуратор': 'Konfigurator',
    'экосистема RTB': 'ekosystem RTB',
    'Узлы экосистемы': 'Węzły ekosystemu',
    'вкл / выкл': 'wł / wył',
    'данные и сегменты': 'dane i segmenty',
    'Трекинг кампании ': 'Śledzenie kampanii ',
    'Спрос': 'Popyt',
    'Число DSP': 'Liczba DSP',
    'Число SSP': 'Liczba SSP',
    'Показ': 'Odsłona',
    'Устройство': 'Urządzenie',
    'Формат': 'Format',
    'Тип сделки': 'Typ transakcji',
    'Открытый': 'Otwarty',
    'Тип цены': 'Typ ceny',
    'Floor price': 'Floor price',
    'DMP обогащает ставки': 'DMP wzbogaca oferty',
    'прибавка за сегменты': 'wzrost za segmenty',
    'Путь инвентаря': 'Ścieżka powierzchni',
    'как продаётся показ': 'jak sprzedaje się odsłona',
    'Способ': 'Sposób',
    'Сценарий верификации': 'Scenariusz weryfikacji',
    'Инструменты': 'Narzędzia',
    'Сценарии': 'Scenariusze',
    'один клик — настройка и прогон': 'jedno kliknięcie — konfiguracja i przebieg',
    'Глоссарий': 'Słowniczek',
    'Пройти квиз': 'Rozwiąż quiz',
    'Подача': 'Prezentacja',
    'Глубина пояснений': 'Głębia wyjaśnień',
    'Новичок': 'Początkujący',
    'Профи': 'Pro',
    'Cookieless / приватность': 'Cookieless / prywatność',
    'без 3P cookie (Safari / Firefox / ATT) · alt-ID: UID2 / ID5': 'bez 3P cookie (Safari / Firefox / ATT) · alt-ID: UID2 / ID5',
    'Сессия из 5 показов': 'Sesja 5 odsłon',
    'Поделиться сценарием': 'Udostępnij scenariusz',
    'Сравнить прогоны': 'Porównaj przebiegi',
    'Экспорт PDF': 'Eksport PDF',
    'Латентность': 'Opóźnienie',
    'бюджет 100 мс': 'budżet 100 ms',
    'Симулировать угрозу': 'Symuluj zagrożenie',
    'бот / небезопасный контент → блок': 'bot / niebezpieczna treść → blok',

    'Загрузка страницы': 'Ładowanie strony',
    'Пользователь → Паблишер': 'Użytkownik → Wydawca',
    'Запрос рекламы': 'Żądanie reklamy',
    'Паблишер → SSP': 'Wydawca → SSP',
    '← обратно': '← z powrotem',
    'Bid request · OpenRTB': 'Bid request · OpenRTB',
    'SSP → Ad Exchange': 'SSP → Ad Exchange',
    'Контекст на проверку': 'Kontekst do sprawdzenia',
    'Ad Exchange → Верификатор': 'Ad Exchange → Weryfikator',
    'Bid request → DSP': 'Bid request → DSP',
    'Ad Exchange → DSP': 'Ad Exchange → DSP',
    'Bid response ← DSP': 'Bid response ← DSP',
    'Сегменты пользователя': 'Segmenty użytkownika',
    'DMP ↔ DSP': 'DMP ↔ DSP',
    'События показа / клика': 'Zdarzenia odsłony / kliknięcia',
    'Паблишер → Трекинг': 'Wydawca → Śledzenie',
    'Постбэк': 'Postback',
    'Трекинг → ad server рекламодателя / MMP': 'Śledzenie → ad server reklamodawcy / MMP',
    'размер места': 'rozmiar miejsca',
    'формат': 'format',
    'позиция': 'pozycja',
    'домен': 'domena',
    'категория': 'kategoria',
    'дисплей': 'display',
    'видео': 'wideo',
    'нативный': 'natywny',
    'креатив': 'kreacja',
    'запрос': 'żądanie',
    'по cookie / ID': 'po cookie / ID',
    'сегменты': 'segmenty',
    '«авто», «в корзине»': '„auto”, „w koszyku”',
    'возраст': 'wiek',
    'интересы': 'zainteresowania',
    'событие': 'zdarzenie',
    'клик': 'kliknięcie',
    'кампания': 'kampania',
    'оптимизация': 'optymalizacja',
    'модель CTR / CR': 'model CTR / CR',
    'если PMP': 'jeśli PMP',
    'CPM ставка': 'oferta CPM',
    'win notice': 'win notice',
    'обратно': 'z powrotem',
    'Десктоп · Web': 'Desktop · Web',
    'Мобайл · In-app': 'Mobile · In-app',
    'CTV · видео': 'CTV · wideo',
  };

  // PL glossary (term → definition)
  const GLOSSARY_PL = {
    'RTB': 'Real-Time Bidding — zakup odsłon przez aukcję w czasie rzeczywistym, po jednej odsłonie naraz.',
    'programmatic': 'Programmatic — zautomatyzowany zakup reklamy przez platformy i algorytmy.',
    'SSP': 'Supply-Side Platform — strona wydawcy: sprzedaje jego miejsca reklamowe na aukcji.',
    'DSP': 'Demand-Side Platform — strona reklamodawcy: automatycznie licytuje odsłony.',
    'DMP': 'Data-Management Platform — przechowuje i segmentuje dane o użytkownikach do targetowania. Kategoria legacy: opierała się na 3P cookie, a Oracle zamknął własny DMP w 2024. Funkcje rozeszły się do first-party CDP, grafów ID (UID2 / ID5), clean roomów i kuracji po stronie SSP — dlatego węzeł na mapie nazywa się „Dane i ID”, a nie DMP.',
    'Ad Exchange': 'Ad Exchange — rynek aukcyjny między podażą a popytem. W 2026 każda duża SSP prowadzi własną aukcję, a branża traktuje je jako jedną kategorię — dlatego na ścieżce bezpośredniej jest jedna prowizja sell-side, a nie dwie. Jedyna duża samodzielna giełda to Google AdX, wobec której toczą się postępowania antymonopolowe w USA i UE — wynik wciąż nierozstrzygnięty. Niezależne giełdy odsprzedające cudzy ruch nadal istnieją, ale to kurcząca się i gorzej płacąca ścieżka, którą duże DSP coraz częściej blokują.',
    'bid request': 'Bid request — opis odsłony i użytkownika, który giełda rozsyła do DSP.',
    'bid response': 'Bid response — odpowiedź DSP z ofertą i kreacją gotową do wyświetlenia.',
    'floor price': 'Floor price — cena minimalna, poniżej której wydawca nie sprzeda odsłony.',
    'CPM': 'CPM — koszt za tysiąc odsłon. Podstawowa waluta ofert programmatic.',
    'clearing price': 'Cena rozliczenia — ostateczna cena, którą faktycznie płaci zwycięzca za odsłonę.',
    'postback': 'Postback — sygnał o zdarzeniu (odsłona, kliknięcie, konwersja) odsyłany do optymalizacji.',
    'segments': 'Segmenty — grupy użytkowników wg zainteresowań/zachowań używane przez DSP do wyceny odsłony.',
    'creative': 'Kreacja — sama reklama (baner, wideo, jednostka natywna) pokazywana użytkownikowi.',
    'publisher': 'Wydawca — właściciel strony lub aplikacji sprzedający miejsca reklamowe.',
    'ad slot': 'Miejsce reklamowe — konkretna pozycja na stronie, gdzie wstawiana jest reklama.',
    '3rd-party tag': '3rd-party tag — zewnętrzny tag reklamowy w kreacji, który ładuje reklamę i wysyła dane do zewnętrznego ad servera.',
    '3rd-party pixel': '3rd-party pixel — niewidoczny pixel dostawcy rejestrujący odsłonę/kliknięcie i mierzący widoczność oraz fraud.',
    'pixel': 'Tracking pixel — niewidoczny piksel 1×1 odpalający zdarzenie (odsłona, kliknięcie, konwersja) przy załadowaniu.',
    'fraud': 'Fraud — oszustwo reklamowe: udawanie odsłon i kliknięć botami zamiast prawdziwych ludzi.',
    'IVT': 'IVT (Invalid Traffic) — boty, centra danych, fałszywa aktywność. Weryfikator odfiltrowuje takie odsłony.',
    'brand safety': 'Brand Safety — uniwersalny „próg”: treści, przy których nikt w ogóle nie powinien się reklamować (terroryzm, wykorzystywanie dzieci, piractwo, podżeganie). Takie same dla każdej marki. Dostrojenie do konkretnej marki to już brand suitability.',
    'brand suitability': 'Brand Suitability — dopasowanie do konkretnej marki: ta sama treść pasuje jednemu reklamodawcy, a drugiemu nie. Wiadomość o śmiertelnym wypadku jest zabójcza dla marki motoryzacyjnej i idealna dla ubezpieczyciela. Działa w obie strony: nie tylko unikanie, ale i szukanie właściwego kontekstu.',
    'blocklist': 'Blocklist — lista stop-słów lub domen, wedle której odrzuca się odsłonę. Dopasowuje podciąg i nie rozumie sensu, więc masowo wyłącza normalne newsy: „strzał” w relacji z olimpiady blokowany jest tak samo jak w kronice kryminalnej.',
    'MFA': 'MFA (Made for Advertising) — strony istniejące dla odsłon: agresywna reklama, kupiony ruch, treść jako pretekst. To nie kwestia brand safety (treść bywa nieszkodliwa), lecz jakości: CPM jest tam o około ćwierć niższy, dlatego optymalizatory tam idą.',
    'pre-bid / post-bid': 'Pre-bid — sprawdzenie PRZED licytacją: złej odsłony po prostu się nie kupuje, pieniądze są całe. Post-bid — odsłona już kupiona, a tag na stronie odmawia wyrenderowania kreacji: marka uratowana, pieniądze w większości nie.',
    'viewability': 'Viewability — czy odsłona faktycznie weszła w obszar widoczny, a nie została przewinięta.',
    'attention': 'Attention (uwaga) — czy człowiek faktycznie spojrzał na odsłonę i przez ile sekund. Szczebel jakości ponad viewability: „mógł zobaczyć" ≠ „zobaczył".',
    'attention seconds': 'Attention seconds — ile sekund realnej uwagi zebrała odsłona. Namacalna metryka zamiast binarnego viewable / nie-viewable.',
    'Adelaide AU': 'Adelaide AU — pojedynczy wynik uwagi (0–100) od dostawcy Adelaide, modelowany z sygnałów reklamy i strony; przykład predykcyjnej metryki uwagi.',
    'first-price auction': 'Aukcja pierwszej ceny — zwycięzca płaci własną ofertę. Od ok. 2019 to norma w aukcji otwartej (giełdy i SSP przeszły na first price), dlatego DSP zaniża ofertę (bid shading) do oczekiwanej ceny rozliczenia.',
    'second-price auction': 'Aukcja drugiej ceny — zwycięzca płaci cenę drugiego miejsca plus grosz. Model historyczny: norma do ok. 2019, dziś w aukcji otwartej rzadko spotykany (pozostaje w niektórych stosach i transakcjach prywatnych).',
    'bid shading': 'Bid shading — DSP obniża ofertę do oczekiwanej ceny rozliczenia. Przy pierwszej cenie zwycięzca płaci własną ofertę, więc licytowanie pełnej wartości odsłony się nie opłaca.',
    'SSAI': 'SSAI — server-side ad insertion: reklama jest wszywana w strumień wideo na serwerze, zamiast być pobierana przez player. Norma na CTV: nie ma przeglądarki, blokery nie działają — ale trudniej mierzyć, bo zdarzenia raportuje player albo serwer.',
    'TCF': 'IAB TCF (Transparency & Consent Framework) — unijny standard branżowy zgody: CMP na stronie zbiera zgodę i koduje ją w consent string, który jedzie dalej przez cały łańcuch bid requestu.',
    'consent string': 'Consent string — zakodowana zgoda użytkownika (TCF), przekazywana w bid requeście (user.consent + regs.gdpr). Każdy uczestnik łańcucha odczytuje z niej, co wolno mu zrobić z danymi. Brak zgody = brak ID i segmentów, a popyt żyjący z profilu (retargeting) po prostu nie wchodzi na aukcję. To nie to samo co cookieless: tam ID trudno dopasować technicznie, tu nie wolno go wysłać w ogóle.',
    'verifier': 'Weryfikator — niezależny dostawca (IAS, DoubleVerify) sprawdzający fraud, brand safety i viewability.',
    'CTV': 'CTV (Connected TV) — reklamy na smart TV i dekoderach, zwykle wideo o wysokim CPM.',
    'format': 'Format — typ reklamy: display (baner), wideo (in-stream) lub natywny (in-feed).',
    'device': 'Urządzenie — desktop, mobile lub CTV. Określa dostępne formaty i wpływa na cenę.',
    'video': 'Reklama wideo — format o wysokim CPM: in-stream (w playerze) lub out-stream (w treści).',
    'native': 'Format natywny — reklama wpleciona w treść, dopasowana wyglądem.',
    'PMP': 'PMP (Private Marketplace) — aukcja prywatna: odsłony dostępne tylko zaproszonym kupującym przez Deal ID, zwykle z wyższym floor.',
    'Deal ID': 'Deal ID — identyfikator bezpośredniej transakcji między wydawcą a kupującym z ustalonymi warunkami (cena, dostęp, priorytet).',
    'deal floor': 'Deal floor — podwyższona cena minimalna w ramach transakcji bezpośredniej (PMP), powyżej floor aukcji otwartej.',
    'Preferred': 'Preferred Deal — transakcja first-look: priorytetowy kupujący może kupić odsłonę po stałej cenie przed aukcją otwartą.',
    'first-look': 'First-look — prawo priorytetowego kupującego do pierwszej decyzji o wzięciu odsłony po ustalonej cenie, przed aukcją otwartą.',
    'header bidding': 'Header bidding — wydawca prowadzi jedną aukcję wśród wielu źródeł popytu równolegle (w nagłówku strony) przed wywołaniem ad servera. Wszyscy konkurują naraz — wyższy zysk.',
    'waterfall': 'Waterfall — źródła popytu odpytywane po kolei wg priorytetu. Wygrywa pierwsze, które weźmie odsłonę po swojej cenie — wyższy popyt niżej nigdy nie konkuruje. Model historyczny: norma do ok. 2016–18, w webie wyparty przez header bidding; przetrwał jako fallback w in-app i CTV.',
    'ad server': 'Ad server — po stronie wydawcy to końcowy punkt decyzji: którą reklamę pokazać (sprzedaż bezpośrednia, transakcje, zwycięzca header biddingu); rynek to niemal w całości Google Ad Manager. Reklamodawca ma własny ad server — hostuje kreacje i liczy odsłony/kliknięcia niezależnie, stąd odwieczne rozbieżności w liczbach.',
    'SPO': 'SPO (supply path optimisation) — kupujący świadomie zawęża ścieżki, przez które kupuje odsłonę: mniej ogniw, mniej prowizji, większa przejrzystość. W praktyce duże DSP po prostu przestają licytować na odsprzedanych ścieżkach wieloogniwowych, więc dodatkowy pośrednik kosztuje wydawcę popyt, a nie tylko marżę.',
    'reseller': 'Reseller — pośrednik, który kupuje powierzchnię od innej platformy i odsprzedaje ją dalej. Jego prowizja nakłada się na już pobrane opłaty, a przez SPO najwięksi kupujący coraz częściej odrzucają takie ścieżki. Odsprzedany ruch to kurczący się udział w wydatkach — to jedyny przypadek, w którym stary obraz dwóch prowizji jest naprawdę prawdziwy.',
    'curation': 'Kuracja — inwentarz + dane + reguły pakowane w Deal ID po stronie sell-side. Targetowanie przenosi się z buy-side (gdzie zajmował się nim DMP) do SSP: kurator składa pakiet, kupujący bierze go jedną transakcją. Jedna z kluczowych zmian 2024–26 i faktyczny spadkobierca wzbogacania przez DMP.',
    'eids': 'eids (alt-ID) — tablica alternatywnych identyfikatorów w bid requeście (user.eids): UID2, ID5, RampID. Bywają deterministyczne (z hasha e-maila lub loginu) albo probabilistyczne. Zastąpiły 3P cookie jako nośnik tożsamości między uczestnikami łańcucha.',
    'clean room': 'Clean room — neutralne środowisko, w którym reklamodawca i wydawca dopasowują swoje dane first-party, nie przekazując ich sobie nawzajem: budują audiencje i mierzą efekty. Działa offline, poza oknem 100 ms aukcji — dlatego nie ma go na mapie RTB.',
  };

  window.PRO_NOTES = {
    ru: {
      user: 'Технически: prebid.js в <head>, GPT слоты, lazy-load по viewport.',
      request: 'OpenRTB 2.x: imp[], banner/video obj, regs.ext.gdpr, source.schain.',
      toExchange: 'HTTP POST на endpoint биржи, gzip, keep-alive; tmax обычно 100–120 мс.',
      verify: 'Pre-bid вызовы IAS/DV: IVT-скоринг, GIVT/SIVT, контент-категории.',
      broadcast: 'Биржа множит запрос по seat; QPS-троттлинг и sampling на стороне DSP.',
      enrich: 'Cookie-sync заранее (pixel match table); в запросе — user.eids, segtax.',
      bid: 'seatbid[].bid[] с price, adm/nurl, adomain, cat; ставки в нетто/брутто.',
      auction: 'Second-price + soft floors; bid reduction (shading); unified auction.',
      response: 'nurl = win-notice (не биллинг), burl = billing notice — по нему DSP учитывает расход; адаптер SSP подставляет markup в слот.',
      render: 'Креатив в iframe (SafeFrame); MRAID для in-app; OMID для viewability.',
      track: 'imp/click/conv пиксели; постбэк в DSP; атрибуция → переобучение моделей.',
    },
    en: {
      user: 'Technically: prebid.js in <head>, GPT slots, lazy-load on viewport.',
      request: 'OpenRTB 2.x: imp[], banner/video obj, regs.ext.gdpr, source.schain.',
      toExchange: 'HTTP POST to the exchange endpoint, gzip, keep-alive; tmax usually 100–120 ms.',
      verify: 'Pre-bid IAS/DV calls: IVT scoring, GIVT/SIVT, content categories.',
      broadcast: 'The exchange fans the request per seat; QPS throttling and sampling on the DSP side.',
      enrich: 'Cookie-sync done ahead (pixel match table); request carries user.eids, segtax.',
      bid: 'seatbid[].bid[] with price, adm/nurl, adomain, cat; net/gross bids.',
      auction: 'Second-price + soft floors; bid shading; unified auction.',
      response: 'nurl = win notice (not billing), burl = billing notice — the DSP books spend on it; the SSP adapter injects markup into the slot.',
      render: 'Creative in an iframe (SafeFrame); MRAID for in-app; OMID for viewability.',
      track: 'imp/click/conv pixels; postback to the DSP; attribution → model retraining.',
    },
    pl: {
      user: 'Technicznie: prebid.js w <head>, sloty GPT, lazy-load wg viewportu.',
      request: 'OpenRTB 2.x: imp[], obiekt banner/video, regs.ext.gdpr, source.schain.',
      toExchange: 'HTTP POST na endpoint giełdy, gzip, keep-alive; tmax zwykle 100–120 ms.',
      verify: 'Wywołania pre-bid IAS/DV: scoring IVT, GIVT/SIVT, kategorie treści.',
      broadcast: 'Giełda zwielokrotnia żądanie per seat; throttling QPS i sampling po stronie DSP.',
      enrich: 'Cookie-sync z wyprzedzeniem (pixel match table); w żądaniu user.eids, segtax.',
      bid: 'seatbid[].bid[] z price, adm/nurl, adomain, cat; oferty netto/brutto.',
      auction: 'Second-price + soft floors; bid shading; unified auction.',
      response: 'nurl = win notice (nie rozliczenie), burl = billing notice — na nim DSP księguje wydatek; adapter SSP wstawia markup do slotu.',
      render: 'Kreacja w iframe (SafeFrame); MRAID dla in-app; OMID dla viewability.',
      track: 'piksele imp/click/conv; postback do DSP; atrybucja → retrening modeli.',
    },
  };
  window.RTB_I18N = { RU2EN, GLOSSARY_EN, RU2PL, GLOSSARY_PL };
  window.__lang = window.__lang || 'ru';
  var _trMissSeen = {};
  function _trMiss(s, lng) {
    try {
      if (!(window.__i18nDebug || (location.search || '').indexOf('i18ndebug') >= 0)) return;  // opt-in only
      var k = lng + '|' + s; if (_trMissSeen[k]) return; _trMissSeen[k] = 1;
      console.warn('[i18n] missing ' + lng + ' translation:', JSON.stringify(s));
    } catch (e) {}
  }
  window.tr = function (s) {
    if (s == null) return s;
    if (window.__lang === 'en') { var he = Object.prototype.hasOwnProperty.call(RU2EN, s); if (!he) _trMiss(s, 'en'); return he ? RU2EN[s] : s; }
    if (window.__lang === 'pl') { var hp = Object.prototype.hasOwnProperty.call(RU2PL, s); if (!hp) _trMiss(s, 'pl'); return hp ? RU2PL[s] : s; }
    return s;
  };
  // 3-language inline helper for components with hardcoded ru/en text
  window.L = function (ru, en, pl) {
    if (window.__lang === 'en') return en;
    if (window.__lang === 'pl') return pl != null ? pl : (en != null ? en : ru);
    return ru;
  };
  window.activeGlossary = function () {
    if (window.__lang === 'en') return GLOSSARY_EN;
    if (window.__lang === 'pl') return GLOSSARY_PL;
    return window.RTB ? window.RTB.GLOSSARY : {};
  };
})();

;
/* RTB Engine — pipe paths (SVG) */

// Build a smooth cubic-bezier path string between two node centers.
function rtbPipePath(from, to, orient) {
  const x1 = from.x,
    y1 = from.y,
    x2 = to.x,
    y2 = to.y;
  let c1x, c1y, c2x, c2y;
  if (orient === 'v') {
    const dy = (y2 - y1) * 0.45;
    c1x = x1;
    c1y = y1 + dy;
    c2x = x2;
    c2y = y2 - dy;
  } else {
    const dx = (x2 - x1) * 0.45;
    c1x = x1 + dx;
    c1y = y1;
    c2x = x2 - dx;
    c2y = y2;
  }
  return `M ${x1} ${y1} C ${c1x} ${c1y}, ${c2x} ${c2y}, ${x2} ${y2}`;
}
function Pipe({
  pipe,
  from,
  to,
  active,
  color,
  onHover,
  onLeave
}) {
  const d = rtbPipePath(from, to, pipe.orient);
  return /*#__PURE__*/React.createElement("g", {
    className: "pipe",
    "data-active": active ? '1' : '0'
  }, /*#__PURE__*/React.createElement("path", {
    d: d,
    className: "pipe-base"
  }), /*#__PURE__*/React.createElement("path", {
    id: `pipe-${pipe.id}`,
    d: d,
    className: "pipe-live",
    style: active ? {
      stroke: color,
      opacity: 0.9
    } : {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: d,
    className: "pipe-hit",
    onMouseEnter: e => onHover && onHover(pipe.id, e.clientX, e.clientY),
    onMouseMove: e => onHover && onHover(pipe.id, e.clientX, e.clientY),
    onMouseLeave: () => onLeave && onLeave()
  }));
}

// Static decorative path string lookup so the App can read length without re-deriving geometry.
function PipesLayer({
  pipes,
  nodes,
  activePipes,
  stageColor,
  onHover,
  onLeave
}) {
  return /*#__PURE__*/React.createElement("g", null, pipes.map(p => /*#__PURE__*/React.createElement(Pipe, {
    key: p.id,
    pipe: p,
    from: nodes[p.from],
    to: nodes[p.to],
    active: !!activePipes[p.id],
    color: stageColor,
    onHover: onHover,
    onLeave: onLeave
  })));
}
Object.assign(window, {
  rtbPipePath,
  Pipe,
  PipesLayer
});

;
/* RTB Engine — node components */

const RTB_ICONS = {
  user: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "8",
    r: "3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6",
    strokeLinecap: "round"
  })),
  publisher: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "16",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.2h.01M8.4 6.2h.01",
    strokeLinecap: "round"
  })),
  ssp: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 17V9m5 8V5m5 12v-6m5 6V8",
    strokeLinecap: "round"
  })),
  dsp: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18M7 8l5-5 5 5M7 16l5 5 5-5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })),
  dmp: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: "12",
    cy: "6",
    rx: "7",
    ry: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6v12c0 1.66 3.13 3 7 3s7-1.34 7-3V6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12c0 1.66 3.13 3 7 3s7-1.34 7-3"
  })),
  tracking: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 17l5-6 4 4 5-8 4 5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })),
  verifier: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12l2 2 4-4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))
};
const DEVICE_ICONS = {
  desktop: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "12",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20h6M12 16v4",
    strokeLinecap: "round"
  })),
  mobile: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "7",
    y: "3",
    width: "10",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18h2",
    strokeLinecap: "round"
  })),
  ctv: /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "13",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21h8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.5l4 2.5-4 2.5z",
    fill: "currentColor",
    stroke: "none"
  }))
};
function nodeStyle(n) {
  return {
    left: n.x - n.w / 2,
    top: n.y - n.h / 2,
    width: n.w,
    height: n.h
  };
}

// ── User (device-aware) ──
function UserNode({
  n,
  cat,
  selected,
  hot,
  onClick,
  device,
  deviceLabel
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'node card-node' + (hot ? ' hot' : '') + (selected ? ' selected' : ''),
    style: {
      ...nodeStyle(n),
      '--c': cat.color,
      '--cg': cat.glow
    },
    "data-node": n.id,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "node-ico"
  }, DEVICE_ICONS[device] || RTB_ICONS.user), /*#__PURE__*/React.createElement("div", {
    className: "node-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "node-title"
  }, window.tr(n.title)), /*#__PURE__*/React.createElement("div", {
    className: "node-sub"
  }, deviceLabel)));
}

// ── Verifier (Fraud / Brand Safety gate) ──
function VerifierNode({
  n,
  cat,
  selected,
  hot,
  onClick,
  state,
  blockReason
}) {
  // state: 'idle' | 'check' | 'pass' | 'block'
  const mark = kind => {
    if (state === 'idle') return /*#__PURE__*/React.createElement("span", {
      className: "vf-dot"
    });
    if (state === 'check') return /*#__PURE__*/React.createElement("span", {
      className: "vf-dot pulse"
    });
    const bad = state === 'block' && (blockReason === 'fraud' && kind === 'fraud' || blockReason === 'safety' && kind === 'safety');
    return /*#__PURE__*/React.createElement("span", {
      className: 'vf-mark ' + (bad ? 'bad' : 'ok')
    }, bad ? '✕' : '✓');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: 'node verifier-node' + (hot ? ' hot' : '') + (selected ? ' selected' : '') + (state === 'block' ? ' blocked' : ''),
    style: {
      ...nodeStyle(n),
      '--c': cat.color,
      '--cg': cat.glow
    },
    "data-node": n.id,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "vf-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "node-ico"
  }, RTB_ICONS.verifier), /*#__PURE__*/React.createElement("div", {
    className: "node-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "node-title"
  }, window.tr(n.title)), /*#__PURE__*/React.createElement("div", {
    className: "node-sub"
  }, n.sub))), /*#__PURE__*/React.createElement("div", {
    className: "vf-checks"
  }, /*#__PURE__*/React.createElement("span", {
    className: "vf-check"
  }, mark('fraud'), /*#__PURE__*/React.createElement("i", null, "Fraud / IVT")), /*#__PURE__*/React.createElement("span", {
    className: "vf-check"
  }, mark('safety'), /*#__PURE__*/React.createElement("i", null, "Brand safety"))));
}

// ── Generic card node (SSP, DMP, Tracking) ──
function CardNode({
  n,
  cat,
  selected,
  hot,
  onClick,
  extra
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'node card-node' + (hot ? ' hot' : '') + (selected ? ' selected' : ''),
    style: {
      ...nodeStyle(n),
      '--c': cat.color,
      '--cg': cat.glow
    },
    "data-node": n.id,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "node-ico"
  }, RTB_ICONS[n.cat]), /*#__PURE__*/React.createElement("div", {
    className: "node-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "node-title"
  }, window.tr(n.title)), /*#__PURE__*/React.createElement("div", {
    className: "node-sub"
  }, window.tr(n.sub))), extra);
}

// ── Publisher (site frame with a format-aware ad slot) ──
function PublisherNode({
  n,
  cat,
  selected,
  hot,
  onClick,
  render,
  pixel,
  winnerLabel,
  winnerColor,
  format,
  formatLabel
}) {
  const slotCls = 'ad-slot fmt-' + (format || 'display') + (render ? ' filled' : '');
  return /*#__PURE__*/React.createElement("div", {
    className: 'node pub-node' + (hot ? ' hot' : '') + (selected ? ' selected' : ''),
    style: {
      ...nodeStyle(n),
      '--c': cat.color,
      '--cg': cat.glow
    },
    "data-node": n.id,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "pub-bar"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pub-dot"
  }), /*#__PURE__*/React.createElement("span", {
    className: "pub-dot"
  }), /*#__PURE__*/React.createElement("span", {
    className: "pub-dot"
  }), /*#__PURE__*/React.createElement("span", {
    className: "pub-url"
  }, window.__lang === 'pl' ? 'news-site.pl' : window.__lang === 'en' ? 'news-site.com' : 'news-site.ru'), /*#__PURE__*/React.createElement("span", {
    className: "pub-fmt"
  }, window.tr(formatLabel))), /*#__PURE__*/React.createElement("div", {
    className: "pub-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pub-lines"
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", {
    className: "short"
  })), /*#__PURE__*/React.createElement("div", {
    className: slotCls,
    style: render ? {
      '--w': winnerColor
    } : null
  }, render ? /*#__PURE__*/React.createElement("div", {
    className: "creative",
    style: {
      '--w': winnerColor
    }
  }, format === 'video' ? /*#__PURE__*/React.createElement("span", {
    className: "cr-play"
  }) : /*#__PURE__*/React.createElement("span", {
    className: "cr-tag"
  }, "AD"), /*#__PURE__*/React.createElement("span", {
    className: "cr-label"
  }, window.tr(winnerLabel)), pixel && /*#__PURE__*/React.createElement("span", {
    className: "cr-pixel",
    title: window.tr('3rd-party pixel сработал')
  }, "px")) : /*#__PURE__*/React.createElement("span", {
    className: "slot-label"
  }, window.tr(formatLabel || 'ad')))));
}

// ── Ad Exchange core (rotating engine) ──
function ExchangeNode({
  n,
  cat,
  selected,
  hot,
  onClick,
  spinning,
  clock
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'node ex-node' + (hot ? ' hot' : '') + (selected ? ' selected' : ''),
    style: {
      ...nodeStyle(n),
      '--c': cat.color,
      '--cg': cat.glow
    },
    "data-node": n.id,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: 'ex-ring r1' + (spinning ? ' spin' : '')
  }), /*#__PURE__*/React.createElement("div", {
    className: 'ex-ring r2' + (spinning ? ' spin' : '')
  }), /*#__PURE__*/React.createElement("div", {
    className: "ex-core"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ex-title"
  }, "Ad Exchange"), /*#__PURE__*/React.createElement("div", {
    className: "ex-clock"
  }, clock, /*#__PURE__*/React.createElement("span", null, "ms")), /*#__PURE__*/React.createElement("div", {
    className: "ex-sub"
  }, window.tr('аукцион'))));
}

// ── DSP card (shows bid, DMP uplift, win/no-bid state) ──
function DspNode({
  n,
  cat,
  selected,
  hot,
  onClick,
  bid,
  showBid,
  isWinner,
  decided,
  dealId,
  learning
}) {
  const dimmed = decided && !isWinner;
  let bidText = '—',
    bidCls = '';
  if (showBid && bid) {
    if (!bid.valid) {
      bidText = bid.reason === 'timeout' ? 'timeout' : bid.reason === 'skipped' ? '—' : bid.reason === 'declined' ? window.tr('отказ') : 'no bid';
      bidCls = ' nobid';
    } else bidText = '$' + bid.cpm.toFixed(2);
  }
  const showUplift = showBid && bid && bid.valid && bid.uplift > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: 'node dsp-node' + (hot ? ' hot' : '') + (selected ? ' selected' : '') + (isWinner ? ' winner' : '') + (dimmed ? ' dimmed' : ''),
    style: {
      ...nodeStyle(n),
      '--c': cat.color,
      '--cg': cat.glow
    },
    "data-node": n.id,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "dsp-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "node-ico"
  }, RTB_ICONS.dsp), /*#__PURE__*/React.createElement("div", {
    className: "node-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "node-title"
  }, window.tr(n.title)), /*#__PURE__*/React.createElement("div", {
    className: "node-sub"
  }, window.tr(n.sub))), showUplift && /*#__PURE__*/React.createElement("span", {
    className: "uplift",
    title: window.tr('Прибавка к ставке за счёт данных DMP')
  }, "+$", bid.uplift.toFixed(2), " DMP")), /*#__PURE__*/React.createElement("div", {
    className: "dsp-foot"
  }, dealId ? /*#__PURE__*/React.createElement("span", {
    className: "dsp-deal",
    title: window.tr('Прямая сделка — Deal ID')
  }, "\u26A1 ", dealId) : /*#__PURE__*/React.createElement("span", {
    className: "dsp-bid-label"
  }, window.tr('ставка CPM')), /*#__PURE__*/React.createElement("span", {
    className: 'dsp-bid' + bidCls
  }, bidText)), isWinner && /*#__PURE__*/React.createElement("div", {
    className: "win-badge"
  }, "WIN"), learning && /*#__PURE__*/React.createElement("div", {
    className: "learn-badge"
  }, window.__lang === 'pl' ? '↩ uczy się' : window.__lang === 'en' ? '↩ learns' : '↩ обучается'));
}

// ── Money-flow panel (revenue split after auction) ──
function MoneyPanel({
  money,
  winnerLabel,
  onClose
}) {
  if (!money || !money.advPays) return null;
  const max = money.advPays || 1;
  const row = (label, val, sub, cls) => /*#__PURE__*/React.createElement("div", {
    className: 'mf-row ' + (cls || '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "mf-top"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mf-label"
  }, label), /*#__PURE__*/React.createElement("span", {
    className: "mf-val"
  }, (val < 0 ? '–$' : '$') + Math.abs(val).toFixed(2))), /*#__PURE__*/React.createElement("div", {
    className: "mf-bar"
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      width: Math.abs(val) / max * 100 + '%'
    }
  })), sub && /*#__PURE__*/React.createElement("div", {
    className: "mf-sub"
  }, sub));
  return /*#__PURE__*/React.createElement("div", {
    className: "money-panel"
  }, /*#__PURE__*/React.createElement("button", {
    className: "panel-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "mf-title"
  }, window.tr('Денежный поток'), " ", /*#__PURE__*/React.createElement("span", null, "\xB7 ", window.tr('CPM за показ'))), row(window.tr('Рекламодатель'), money.advPays, winnerLabel ? window.tr('платит · ') + window.tr(winnerLabel) : null, 'pay'), money.dspCut != null && row(window.tr('Комиссия DSP'), -money.dspCut, Math.round(money.dspPct * 100) + '% ' + window.tr('сторона спроса'), 'fee'), row(window.tr('Комиссия sell-side'), -money.sellCut, Math.round(money.sellPct * 100) + '% · ' + window.tr('SSP вместе со своим аукционом'), 'fee'), money.resellCut > 0 && row(window.tr('Комиссия реселлера'), -money.resellCut, Math.round(money.resellPct * 100) + '% · ' + window.tr('лишнее звено в цепочке'), 'fee'), row(window.tr('Паблишер'), money.pubNet, window.tr('чистыми, после комиссий'), 'net'));
}
Object.assign(window, {
  RTB_ICONS,
  DEVICE_ICONS,
  UserNode,
  VerifierNode,
  CardNode,
  PublisherNode,
  ExchangeNode,
  DspNode,
  MoneyPanel,
  nodeStyle
});

;
/* RTB Engine — HUD: controls, narration, counters, info panel */

// glossary term tooltip
function Term({
  def,
  children
}) {
  return /*#__PURE__*/React.createElement("span", {
    className: "term",
    tabIndex: "0"
  }, children, /*#__PURE__*/React.createElement("span", {
    className: "term-pop"
  }, def));
}
let _termRe = {
  ru: null,
  en: null
};
function wrapTerms(text) {
  if (!text) return text;
  const lang = window.__lang || 'ru';
  const G = window.activeGlossary ? window.activeGlossary() : window.RTB.GLOSSARY || {};
  const keys = Object.keys(G).sort((a, b) => b.length - a.length);
  if (!_termRe[lang]) {
    const esc = keys.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    try {
      _termRe[lang] = new RegExp('(?<![\\p{L}0-9])(' + esc.join('|') + ')', 'giu');
    } catch (e) {
      _termRe[lang] = new RegExp('(' + esc.join('|') + ')', 'gi');
    }
  }
  const re = _termRe[lang];
  re.lastIndex = 0;
  const out = [];
  let last = 0,
    m,
    key = 0;
  while (m = re.exec(text)) {
    const matched = m[1];
    if (m.index > last) out.push(text.slice(last, m.index));
    const gk = keys.find(k => k.toLowerCase() === matched.toLowerCase());
    out.push(/*#__PURE__*/React.createElement(Term, {
      key: key++,
      def: G[gk] || ''
    }, matched));
    last = m.index + matched.length;
    if (re.lastIndex <= m.index) re.lastIndex = m.index + 1;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
function IconBtn({
  onClick,
  children,
  label,
  primary,
  disabled
}) {
  return /*#__PURE__*/React.createElement("button", {
    className: 'ctl-btn' + (primary ? ' primary' : '') + (disabled ? ' disabled' : ''),
    onClick: disabled ? undefined : onClick
  }, children, /*#__PURE__*/React.createElement("span", null, label));
}
function TopBar({
  phase,
  stepMode,
  speed,
  theme,
  lang,
  configOpen,
  soundOn,
  fraudLayer,
  onPlay,
  onReset,
  onStep,
  onToggleStep,
  onSpeed,
  onToggleTheme,
  onToggleConfig,
  onToggleLang,
  onToggleSound,
  onTour,
  onGlossary,
  onDemo,
  onFraudLayer,
  onFraudModule,
  onAttentionModule,
  onBrandModule
}) {
  const running = phase === 'running';
  const light = theme === 'light';
  const T = window.tr;
  return /*#__PURE__*/React.createElement("div", {
    className: "topbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brand"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brand-mark"
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement("div", {
    className: "brand-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brand-title"
  }, T('RTB ДВИЖОК')), /*#__PURE__*/React.createElement("div", {
    className: "brand-sub"
  }, T('Programmatic · как устроена закупка рекламы в реальном времени')))), /*#__PURE__*/React.createElement("div", {
    className: "controls"
  }, /*#__PURE__*/React.createElement("button", {
    className: 'theme-btn' + (configOpen ? ' active' : ''),
    onClick: onToggleConfig,
    title: T('Конфигуратор экосистемы')
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 13.5a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.03 1.56V21a2 2 0 0 1-4 0v-.09A1.7 1.7 0 0 0 8.91 19.4a1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.56-1.03H3a2 2 0 0 1 0-4h.09A1.7 1.7 0 0 0 4.6 8.91a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34H9a1.7 1.7 0 0 0 1-1.56V3a2 2 0 0 1 4 0v.09a1.7 1.7 0 0 0 1 1.56 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87V9a1.7 1.7 0 0 0 1.56 1H21a2 2 0 0 1 0 4h-.09a1.7 1.7 0 0 0-1.51 1.03z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("button", {
    className: 'theme-btn' + (light ? '' : ''),
    onClick: onToggleTheme,
    title: light ? T('Тёмная тема') : T('Светлая тема')
  }, light ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z",
    strokeLinejoin: "round"
  })) : /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "speed"
  }, /*#__PURE__*/React.createElement("span", null, T('скорость')), /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: "0.5",
    max: "2",
    step: "0.25",
    value: speed,
    onChange: e => onSpeed(parseFloat(e.target.value))
  }), /*#__PURE__*/React.createElement("b", null, speed.toFixed(2), "\xD7")), /*#__PURE__*/React.createElement("div", {
    className: "seg"
  }, /*#__PURE__*/React.createElement("button", {
    className: !stepMode ? 'on' : '',
    onClick: () => onToggleStep(false)
  }, T('Авто')), /*#__PURE__*/React.createElement("button", {
    className: stepMode ? 'on' : '',
    onClick: () => onToggleStep(true)
  }, T('Пошагово'))), stepMode && running ? /*#__PURE__*/React.createElement(IconBtn, {
    primary: true,
    label: T('Далее'),
    onClick: onStep
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h13M13 6l6 6-6 6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))) : /*#__PURE__*/React.createElement(IconBtn, {
    primary: true,
    label: running ? T('Идёт…') : T('Запустить аукцион'),
    disabled: running,
    onClick: onPlay
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5l12 7-12 7z"
  }))), /*#__PURE__*/React.createElement(IconBtn, {
    label: T('Сброс'),
    onClick: onReset
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4v6h6M20 20v-6h-6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9a8 8 0 0 0-14-3M5 15a8 8 0 0 0 14 3",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "lang-btn",
    onClick: onToggleLang,
    title: "EN / PL"
  }, lang === 'pl' ? 'EN' : 'PL'), /*#__PURE__*/React.createElement("button", {
    className: 'theme-btn' + (soundOn ? ' active' : ''),
    onClick: onToggleSound,
    title: soundOn ? lang === 'pl' ? 'Dźwięk wł.' : lang === 'en' ? 'Sound on' : 'Звук вкл' : lang === 'pl' ? 'Dźwięk wył.' : lang === 'en' ? 'Sound off' : 'Звук выкл'
  }, soundOn ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9v6h4l5 4V5L8 9H4z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5a4 4 0 0 1 0 7M18.5 6a7 7 0 0 1 0 12",
    strokeLinecap: "round"
  })) : /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9v6h4l5 4V5L8 9H4z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9l5 6M22 9l-5 6",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "theme-btn",
    onClick: onTour,
    title: lang === 'pl' ? 'Przewodnik' : lang === 'en' ? 'Tour' : 'Тур'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 9.2a2.8 2.8 0 0 1 5.4 1c0 1.9-2.6 2.4-2.6 4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.4h.01",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "theme-btn",
    onClick: onGlossary,
    title: lang === 'pl' ? 'Słownik' : lang === 'en' ? 'Glossary' : 'Глоссарий'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5A1.5 1.5 0 0 1 5.5 4H18a2 2 0 0 1 2 2v13.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v14.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17.5H20a0 0 0 0 1 0 0v2A1.5 1.5 0 0 1 18.5 21H5.5A1.5 1.5 0 0 1 4 19.5v-.5a1.5 1.5 0 0 1 1.5-1.5z",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "theme-btn",
    href: "/learn",
    title: lang === 'pl' ? 'Materiały' : lang === 'en' ? 'Learn' : 'Материалы'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "3",
    width: "7",
    height: "7",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "3",
    width: "7",
    height: "7",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "14",
    width: "7",
    height: "7",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "14",
    width: "7",
    height: "7",
    rx: "1.5"
  }))), /*#__PURE__*/React.createElement("button", {
    className: 'theme-btn fraud-layer-btn' + (fraudLayer ? ' active' : ''),
    onClick: onFraudLayer,
    title: lang === 'pl' ? 'Warstwa fraud' : lang === 'en' ? 'Fraud layer' : 'Слой фрода'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3 3.2 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.2a2 2 0 0 0-3.4 0Z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v5M12 17.5h.01",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "theme-btn fraud-module-btn",
    onClick: onFraudModule,
    title: lang === 'pl' ? 'Fraud i weryfikacja' : lang === 'en' ? 'Fraud & verification' : 'Фрод и верификация'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 12l1.9 1.9L15 9.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "theme-btn attention-module-btn",
    onClick: onAttentionModule,
    title: lang === 'pl' ? 'Uwaga (attention)' : lang === 'en' ? 'Attention' : 'Внимание (attention)'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "2.6"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "theme-btn brand-module-btn",
    onClick: onBrandModule,
    title: lang === 'pl' ? 'Brand safety i suitability' : lang === 'en' ? 'Brand safety & suitability' : 'Brand safety и suitability'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "4.5",
    width: "18",
    height: "15",
    rx: "2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.2l2.6 2.6L16.5 9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "theme-btn",
    onClick: onDemo,
    title: lang === 'pl' ? 'Prezentacja' : lang === 'en' ? 'Presentation' : 'Презентация'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9l5 3-5 3z",
    fill: "currentColor",
    stroke: "none"
  })))));
}
function Stat({
  label,
  value,
  color,
  big
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'stat' + (big ? ' big' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "stat-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "stat-value",
    style: color ? {
      color
    } : null
  }, value));
}
function BottomBar({
  stage,
  stageIndex,
  total,
  clock,
  auction,
  winnerLabel,
  winnerColor,
  decided,
  blockedView,
  cfg,
  depth,
  canSeek,
  onSeek
}) {
  const T = window.tr;
  const typeLabel = cfg.auctionType === 'first' ? T('1-я цена') : T('2-я цена');
  const DEAL = {
    open: null,
    pmp: 'PMP',
    preferred: 'Preferred'
  };
  const dealLbl = DEAL[cfg.dealType];
  const pathLbl = cfg.supplyPath === 'waterfall' ? 'Waterfall' : 'Header bidding';
  const DEV = {
    desktop: T('Десктоп'),
    mobile: T('Мобайл'),
    ctv: 'CTV'
  };
  const FMT = {
    display: T('Дисплей'),
    video: T('Видео'),
    native: T('Нативный')
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bottombar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "narr"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'narr-dots' + (canSeek ? ' seek' : '')
  }, Array.from({
    length: total
  }).map((_, i) => /*#__PURE__*/React.createElement("span", {
    key: i,
    title: canSeek ? i + 1 + '' : undefined,
    onClick: canSeek ? () => onSeek(i) : undefined,
    className: blockedView && i === stageIndex ? 'blk' : i === stageIndex ? 'on' : i < stageIndex ? 'done' : ''
  }))), /*#__PURE__*/React.createElement("div", {
    className: "narr-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'narr-title' + (blockedView ? ' blk' : '')
  }, blockedView || !stage ? stage ? T(stage.title) : T('Готово к запуску') : String(stageIndex + 1).padStart(2, '0') + ' · ' + T(stage.title.replace(/^\d+\s*·\s*/, ''))), /*#__PURE__*/React.createElement("div", {
    className: "narr-meta"
  }, /*#__PURE__*/React.createElement("span", {
    className: "chip"
  }, DEV[cfg.device], " \xB7 ", FMT[cfg.format]), /*#__PURE__*/React.createElement("span", {
    className: "chip"
  }, pathLbl), dealLbl && /*#__PURE__*/React.createElement("span", {
    className: "chip deal"
  }, dealLbl), /*#__PURE__*/React.createElement("span", {
    className: "chip"
  }, typeLabel), /*#__PURE__*/React.createElement("span", {
    className: 'chip' + (cfg.dmpOn ? ' on' : ' off')
  }, "DMP ", cfg.dmpOn ? '✓' : '✕'), /*#__PURE__*/React.createElement("span", {
    className: 'chip' + (cfg.verify ? ' on' : ' off')
  }, T('Вериф.'), " ", cfg.verify ? '✓' : '✕'), cfg.consent === false && /*#__PURE__*/React.createElement("span", {
    className: "chip off"
  }, T('нет согласия')), cfg.resellerHop && /*#__PURE__*/React.createElement("span", {
    className: "chip off"
  }, T('перепродажа')), cfg.cookieless && /*#__PURE__*/React.createElement("span", {
    className: "chip off"
  }, "cookieless"), /*#__PURE__*/React.createElement("span", {
    className: "chip"
  }, "DSP ", cfg.count))), /*#__PURE__*/React.createElement("div", {
    className: "narr-desc"
  }, blockedView ? wrapTerms(T('Верификатор отклонил показ до аукциона — см. красный блок слева. Ни один DSP не получил bid request, деньги не списаны. Выключите «Симулировать угрозу» в Tweaks, чтобы увидеть обычный прогон.')) : stage ? /*#__PURE__*/React.createElement("span", null, wrapTerms(T(stage.desc)), depth === 'pro' && window.PRO_NOTES && window.PRO_NOTES[window.__lang === 'en' ? 'en' : window.__lang === 'pl' ? 'pl' : 'ru'][stage.id] && /*#__PURE__*/React.createElement("span", {
    className: "narr-pro"
  }, /*#__PURE__*/React.createElement("b", null, "PRO"), " ", window.PRO_NOTES[window.__lang === 'en' ? 'en' : window.__lang === 'pl' ? 'pl' : 'ru'][stage.id])) : wrapTerms(T('Нажмите «Запустить аукцион», чтобы прогнать одну сделку через всю цепочку — от открытия страницы до показа. Кликайте по узлам, наводите на подчёркнутые термины. Состав экосистемы и настройки — по кнопке ⚙ вверху (Конфигуратор).')))), /*#__PURE__*/React.createElement("div", {
    className: "stats"
  }, /*#__PURE__*/React.createElement(Stat, {
    label: T('Время аукциона'),
    value: clock + window.L(' мс', ' ms', ' ms'),
    color: "#67e8f9"
  }), /*#__PURE__*/React.createElement(Stat, {
    label: "Floor price",
    value: auction ? '$' + auction.floor.toFixed(2) : '—'
  }), /*#__PURE__*/React.createElement(Stat, {
    label: T('Ставок'),
    value: auction ? auction.bids.filter(b => b.valid).length + ' / ' + auction.count : '—',
    color: "#a78bfa"
  }), /*#__PURE__*/React.createElement(Stat, {
    label: T('Клиринговая цена'),
    value: decided && auction && auction.clearing ? '$' + auction.clearing.toFixed(2) : '—',
    color: "#fbbf24"
  }), /*#__PURE__*/React.createElement(Stat, {
    big: true,
    label: T('Победитель'),
    value: blockedView ? T('блокировка') : decided ? T(winnerLabel || 'нет ставок') : '—',
    color: blockedView ? '#fb7185' : decided ? winnerColor : undefined
  })));
}
function InfoPanel({
  node,
  cat,
  onClose,
  onOpenInternals,
  onOpenFraud
}) {
  if (!node) return null;
  const kind = node.cat === 'dsp' ? 'dsp' : node.cat === 'ssp' ? 'ssp' : node.cat === 'exchange' ? 'exchange' : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "info-panel",
    style: {
      '--c': cat.color,
      '--cg': cat.glow
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "info-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "info-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info-ico"
  }, RTB_ICONS[node.cat] || RTB_ICONS.dsp), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "info-title"
  }, window.tr(node.title)), /*#__PURE__*/React.createElement("div", {
    className: "info-sub"
  }, window.tr(node.sub)))), /*#__PURE__*/React.createElement("p", {
    className: "info-body"
  }, wrapTerms(window.tr(node.info))), kind && /*#__PURE__*/React.createElement("button", {
    className: "info-dive",
    onClick: () => onOpenInternals(kind)
  }, window.tr('Заглянуть внутрь'), " ", /*#__PURE__*/React.createElement("span", null, "\u2192")), node.id === 'verifier' && onOpenFraud && /*#__PURE__*/React.createElement("button", {
    className: "info-dive fraud",
    onClick: onOpenFraud
  }, window.L('Открыть модуль фрода', 'Open fraud module', 'Otwórz moduł fraud'), " ", /*#__PURE__*/React.createElement("span", null, "\u2192")));
}

// ── Deep-dive: internal architecture of DSP / SSP (schematic factory) ──
function DeepDive({
  kind,
  onClose
}) {
  const [hover, setHover] = React.useState(null);
  const [pinned, setPinned] = React.useState(null);
  const [scenario, setScenario] = React.useState('ok');
  const [playStep, setPlayStep] = React.useState(-1); // -1 idle, >=0 running/finished index
  const [playing, setPlaying] = React.useState(false);
  const [clock, setClock] = React.useState(0);
  const [snap, setSnap] = React.useState(null);
  const timerRef = React.useRef(null);
  const L3 = window.L;
  const lng = window.__lang === 'pl' ? 'pl' : window.__lang === 'en' ? 'en' : 'ru';
  const node = kind ? window.RTB.INTERNALS[kind] : null;
  React.useEffect(() => {
    if (kind && node) {
      setSnap(node.snap());
      setPinned(null);
      setScenario('ok');
      setPlayStep(-1);
      setPlaying(false);
      setClock(0);
    }
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [kind]);
  if (!kind || !node) return null;
  const text = node.text[lng] || node.text.en;
  const layout = node.layout;
  const flow = node.flow || [];
  const drops = node.drops || [];
  const ext = node.ext || {};
  const curDrop = drops.find(d => d.id === scenario) || drops[0];
  const dropAt = curDrop ? curDrop.at : null;
  const dropIdx = dropAt ? flow.indexOf(dropAt) : -1;
  const byId = {};
  layout.modules.forEach(m => {
    byId[m.id] = m;
  });
  const center = m => ({
    x: m.x + m.w / 2,
    y: m.y + m.h / 2
  });
  const path = (a, b) => {
    const A = center(byId[a]),
      B = center(byId[b]);
    const mx = (A.x + B.x) / 2;
    return `M ${A.x} ${A.y} C ${mx} ${A.y}, ${mx} ${B.y}, ${B.x} ${B.y}`;
  };
  const cc = lng === 'pl' ? 'PL' : lng === 'en' ? 'DE' : 'RU';
  const fillJson = tpl => (tpl || '').replace(/\{(\w+)\}/g, (_, k) => {
    if (snap && k in snap.vals) return snap.vals[k];
    if (k === 'cc') return cc;
    if (k === 'dev') return 'desktop';
    return '{' + k + '}';
  });
  const extName = n => (window.RTB_EXT_NAMES[lng] || window.RTB_EXT_NAMES.en)[n] || n;
  const extLabel = mid => {
    const e = ext[mid];
    if (!e) return null;
    const nm = extName(e.node);
    return e.dir === 'in' ? L3('вход ← ', 'input ← ', 'wejście ← ') + nm : L3('выход → ', 'output → ', 'wyjście → ') + nm;
  };

  // run
  const stop = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };
  const play = () => {
    stop();
    const fresh = node.snap();
    setSnap(fresh);
    setPinned(null);
    setPlaying(true);
    setPlayStep(0);
    setClock(rndClock(0));
    let i = 0;
    timerRef.current = setInterval(() => {
      // stop at drop module (inclusive)
      if (dropIdx >= 0 && i >= dropIdx) {
        stop();
        setPlaying(false);
        setPlayStep(i);
        return;
      }
      if (i >= flow.length - 1) {
        stop();
        setPlaying(false);
        setPlayStep(i);
        return;
      }
      i += 1;
      setPlayStep(i);
      setClock(rndClock(i));
    }, 620);
  };
  function rndClock(i) {
    return Math.min(100, Math.round((i + 1) / flow.length * (dropIdx >= 0 ? 70 : 92)));
  }
  const reachedIdx = playStep; // last reached flow index
  const reached = new Set(flow.slice(0, reachedIdx + 1));
  const finished = !playing && playStep >= 0;
  const droppedHere = mid => finished && dropAt === mid;

  // which module's detail is showing
  const activeId = pinned || hover || (playing ? flow[Math.max(0, playStep)] : null);
  const activeM = activeId ? text.m[activeId] || {
    t: activeId,
    h: ''
  } : null;
  const showDrop = finished && dropAt;
  const CORE = L3('МОЗГ', 'CORE', 'RDZEŃ');
  return /*#__PURE__*/React.createElement("div", {
    className: "dive-overlay",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "dive-modal",
    style: {
      '--c': node.accent
    },
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "dive-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "dive-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dive-headrow"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "dive-title"
  }, text.title), /*#__PURE__*/React.createElement("div", {
    className: "dive-sub"
  }, text.sub)), /*#__PURE__*/React.createElement("div", {
    className: "dive-run"
  }, /*#__PURE__*/React.createElement("button", {
    className: 'dive-play' + (playing ? ' on' : ''),
    onClick: play
  }, playing ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "5",
    width: "4",
    height: "14",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "5",
    width: "4",
    height: "14",
    rx: "1"
  })) : /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5l12 7-12 7z"
  })), playStep >= 0 ? L3('Ещё раз', 'Replay', 'Jeszcze raz') : L3('Прогнать запрос', 'Run a request', 'Uruchom żądanie')), /*#__PURE__*/React.createElement("div", {
    className: 'dive-clock' + (clock > 88 ? ' near' : '')
  }, playStep >= 0 ? clock : 0, /*#__PURE__*/React.createElement("i", null, " ms")))), /*#__PURE__*/React.createElement("div", {
    className: "dive-scen"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dive-scen-l"
  }, L3('Сценарий', 'Scenario', 'Scenariusz'), ":"), drops.map(d => /*#__PURE__*/React.createElement("button", {
    key: d.id,
    className: 'dive-chip' + (scenario === d.id ? ' on' : '') + (d.id !== 'ok' ? ' warn' : ''),
    onClick: () => {
      setScenario(d.id);
      setPlayStep(-1);
      setPlaying(false);
      setClock(0);
      stop();
    }
  }, d[lng] || d.en)))), /*#__PURE__*/React.createElement("div", {
    className: "dive-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dive-schem-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dive-schem"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "dive-links",
    viewBox: `0 0 ${layout.w} ${layout.h}`,
    preserveAspectRatio: "none"
  }, layout.links.map((l, i) => {
    const d = path(l[0], l[1]);
    const hoverOn = (hover || pinned) && ((hover || pinned) === l[0] || (hover || pinned) === l[1]);
    const flowOn = playStep >= 0 && reached.has(l[0]) && reached.has(l[1]);
    return /*#__PURE__*/React.createElement("g", {
      key: i
    }, /*#__PURE__*/React.createElement("path", {
      id: `dl-${kind}-${i}`,
      d: d,
      className: 'dl' + (flowOn ? ' flow' : '') + (hoverOn ? ' on' : '')
    }), /*#__PURE__*/React.createElement("circle", {
      r: hoverOn || flowOn ? 3.4 : 2.4,
      className: 'dl-dot' + (hoverOn || flowOn ? ' on' : '')
    }, /*#__PURE__*/React.createElement("animateMotion", {
      dur: 1.6 + i % 5 * 0.25 + 's',
      repeatCount: "indefinite",
      rotate: "auto"
    }, /*#__PURE__*/React.createElement("mpath", {
      href: `#dl-${kind}-${i}`
    }))));
  })), layout.modules.map(m => {
    const tm = text.m[m.id] || {
      t: m.id
    };
    const metric = snap ? snap.metric[m.id] : null;
    const isActive = (pinned || hover) === m.id;
    const onPath = playStep >= 0 && reached.has(m.id);
    const isCur = playing && flow[playStep] === m.id;
    const dropped = droppedHere(m.id);
    const dim = (hover || pinned) && !isActive || playStep >= 0 && !onPath && !dropped && flow.includes(m.id);
    const hasExt = !!ext[m.id];
    return /*#__PURE__*/React.createElement("div", {
      key: m.id,
      className: 'dmod' + (m.brain ? ' brain' : '') + (m.side ? ' side' : '') + (m.io ? ' io io-' + m.io : '') + (isActive ? ' hov' : '') + (onPath ? ' onpath' : '') + (isCur ? ' cur' : '') + (dropped ? ' drop' : '') + (dim ? ' dim' : ''),
      style: {
        left: m.x / layout.w * 100 + '%',
        top: m.y / layout.h * 100 + '%',
        width: m.w / layout.w * 100 + '%',
        height: m.h / layout.h * 100 + '%'
      },
      onMouseEnter: () => setHover(m.id),
      onMouseLeave: () => setHover(null),
      onClick: e => {
        e.stopPropagation();
        setPinned(p => p === m.id ? null : m.id);
      }
    }, m.brain && /*#__PURE__*/React.createElement("span", {
      className: "dmod-tag"
    }, CORE), hasExt && /*#__PURE__*/React.createElement("span", {
      className: 'dmod-ext ' + ext[m.id].dir
    }, ext[m.id].dir === 'in' ? '←' : '→'), /*#__PURE__*/React.createElement("span", {
      className: "dmod-t"
    }, tm.t), metric && /*#__PURE__*/React.createElement("span", {
      className: "dmod-metric"
    }, metric));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "dive-side"
  }, showDrop ? /*#__PURE__*/React.createElement("div", {
    className: "dive-card drop"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dive-card-tag"
  }, L3('Почему нет ставки', 'Why no bid', 'Dlaczego brak oferty')), /*#__PURE__*/React.createElement("div", {
    className: "dive-card-t"
  }, curDrop[lng] || curDrop.en), /*#__PURE__*/React.createElement("div", {
    className: "dive-card-h"
  }, curDrop[lng + '_w'] || curDrop.en_w), /*#__PURE__*/React.createElement("div", {
    className: "dive-card-where"
  }, L3('Остановилось на блоке', 'Stopped at block', 'Zatrzymało się na bloku'), ": ", /*#__PURE__*/React.createElement("b", null, (text.m[dropAt] || {}).t))) : activeM ? /*#__PURE__*/React.createElement("div", {
    className: "dive-card"
  }, pinned && /*#__PURE__*/React.createElement("button", {
    className: "dive-card-x",
    onClick: () => setPinned(null)
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "dive-card-tag",
    style: {
      color: node.accent
    }
  }, pinned ? L3('Блок', 'Block', 'Blok') : L3('Наведение', 'Hover', 'Najazd')), /*#__PURE__*/React.createElement("div", {
    className: "dive-card-t"
  }, activeM.t), /*#__PURE__*/React.createElement("div", {
    className: "dive-card-h"
  }, activeM.h), extLabel(activeId) && /*#__PURE__*/React.createElement("div", {
    className: "dive-card-ext"
  }, extLabel(activeId)), pinned && node.json && node.json[activeId] && /*#__PURE__*/React.createElement("pre", {
    className: "dive-card-json"
  }, fillJson(node.json[activeId])), !pinned && /*#__PURE__*/React.createElement("div", {
    className: "dive-card-hint"
  }, L3('Кликни блок, чтобы закрепить и увидеть данные', 'Click a block to pin it and see data', 'Kliknij blok, aby przypiąć i zobaczyć dane'))) : /*#__PURE__*/React.createElement("div", {
    className: "dive-card intro"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dive-card-h"
  }, text.intro), /*#__PURE__*/React.createElement("div", {
    className: "dive-card-hint"
  }, L3('▶ Прогнать запрос — увидеть, как он бежит по блокам. Клик по блоку — детали и JSON.', '▶ Run a request to watch it flow through the blocks. Click a block for details and JSON.', '▶ Uruchom żądanie, aby zobaczyć, jak biegnie przez bloki. Kliknij blok po szczegóły i JSON.'))), /*#__PURE__*/React.createElement("div", {
    className: "dive-dc"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dive-dc-ico"
  }, "\u25A3"), text.dc)))));
}

// ── Configurator (in-app system menu) ──
function CfgSection({
  label,
  hint
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "cfg-section"
  }, label, hint && /*#__PURE__*/React.createElement("span", null, hint));
}
function CfgToggle({
  label,
  sub,
  value,
  onChange,
  disabled,
  accent
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'cfg-row tog' + (disabled ? ' dis' : ''),
    onClick: disabled ? undefined : () => onChange(!value)
  }, /*#__PURE__*/React.createElement("div", {
    className: "cfg-lab"
  }, /*#__PURE__*/React.createElement("span", null, label), sub && /*#__PURE__*/React.createElement("i", null, sub)), /*#__PURE__*/React.createElement("span", {
    className: 'cfg-switch' + (value ? ' on' : ''),
    style: value && accent ? {
      '--sw': accent
    } : null
  }, /*#__PURE__*/React.createElement("b", null)));
}
function CfgSeg({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "cfg-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cfg-lab"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("div", {
    className: "cfg-seg"
  }, options.map(o => {
    const val = typeof o === 'object' ? o.value : o;
    const lab = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("button", {
      key: val,
      className: val === value ? 'on' : '',
      onClick: () => onChange(val)
    }, lab);
  })));
}
function CfgSlider({
  label,
  value,
  min,
  max,
  step,
  unit,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "cfg-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cfg-lab"
  }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement("b", null, value, unit)), /*#__PURE__*/React.createElement("input", {
    className: "cfg-range",
    type: "range",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(parseFloat(e.target.value))
  }));
}
function ConfigPanel({
  open,
  onClose,
  t,
  set,
  formatOpts,
  FORMATS,
  onCompare,
  onExport,
  onSession,
  onGlossary,
  onPreset,
  presets,
  onMode,
  modes,
  onShare
}) {
  const T = window.tr;
  const lang = window.__lang === 'pl' ? 'pl' : window.__lang === 'en' ? 'en' : 'ru';
  // a mode is "current" only while every switch it sets still matches — touch one control and the
  // highlight drops, which is the honest signal that you are now off-preset and free-styling
  const modeOn = m => Object.keys(m.tweaks).every(k => String(t[k]) === String(m.tweaks[k]));
  return /*#__PURE__*/React.createElement("div", {
    className: 'cfg-panel' + (open ? ' open' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "cfg-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cfg-title"
  }, T('Конфигуратор'), /*#__PURE__*/React.createElement("span", null, T('экосистема RTB'))), /*#__PURE__*/React.createElement("button", {
    className: "cfg-close",
    onClick: onClose
  }, "\xD7")), /*#__PURE__*/React.createElement("div", {
    className: "cfg-body"
  }, /*#__PURE__*/React.createElement(CfgSection, {
    label: T('Режим'),
    hint: T('стартовая точка — дальше меняй что угодно по одному')
  }), /*#__PURE__*/React.createElement("div", {
    className: "mode-grid"
  }, (modes || []).map(m => /*#__PURE__*/React.createElement("button", {
    key: m.id,
    className: 'mode-btn' + (modeOn(m) ? ' on' : ''),
    onClick: () => onMode(m)
  }, /*#__PURE__*/React.createElement("span", {
    className: "mode-t"
  }, window.L(m.ru, m.en, m.pl)), /*#__PURE__*/React.createElement("span", {
    className: "mode-d"
  }, window.L(m.ru_d, m.en_d, m.pl_d))))), /*#__PURE__*/React.createElement(CfgSection, {
    label: T('Сценарии'),
    hint: T('один клик — настройка и прогон')
  }), /*#__PURE__*/React.createElement("div", {
    className: "preset-grid"
  }, (presets || []).map(p => /*#__PURE__*/React.createElement("button", {
    key: p.id,
    className: "preset-btn",
    onClick: () => onPreset(p)
  }, /*#__PURE__*/React.createElement("span", {
    className: "preset-t"
  }, window.L(p.ru, p.en, p.pl)), /*#__PURE__*/React.createElement("span", {
    className: "preset-d"
  }, window.L(p.ru_d, p.en_d, p.pl_d))))), /*#__PURE__*/React.createElement(CfgSection, {
    label: T('Узлы экосистемы'),
    hint: T('вкл / выкл')
  }), /*#__PURE__*/React.createElement(CfgToggle, {
    label: T('Верификатор'),
    sub: "Fraud \xB7 Brand Safety",
    value: t.nodeVerifier,
    accent: "#f472b6",
    onChange: v => set('nodeVerifier', v)
  }), /*#__PURE__*/React.createElement(CfgToggle, {
    label: "DMP",
    sub: T('данные и сегменты'),
    value: t.nodeDmp,
    accent: "#fbbf24",
    onChange: v => set('nodeDmp', v)
  }), /*#__PURE__*/React.createElement(CfgToggle, {
    label: T('Трекинг кампании'),
    sub: "3rd-party tag / pixel",
    value: t.nodeTracking,
    accent: "#fb7185",
    onChange: v => set('nodeTracking', v)
  }), /*#__PURE__*/React.createElement(CfgToggle, {
    label: T('Ad server паблишера'),
    sub: T('что показать в этом месте'),
    value: t.nodeAdServer,
    accent: "#34d399",
    onChange: v => set('nodeAdServer', v)
  }), /*#__PURE__*/React.createElement(CfgSection, {
    label: T('Спрос')
  }), /*#__PURE__*/React.createElement(CfgSeg, {
    label: T('Число SSP'),
    value: String(t.sspCount),
    options: ['1', '2', '3'],
    onChange: v => set('sspCount', v)
  }), /*#__PURE__*/React.createElement(CfgSeg, {
    label: T('Число DSP'),
    value: String(t.dspCount),
    options: ['2', '3', '4', '5', '6'],
    onChange: v => set('dspCount', v)
  }), /*#__PURE__*/React.createElement(CfgSection, {
    label: T('Показ')
  }), /*#__PURE__*/React.createElement(CfgSeg, {
    label: T('Устройство'),
    value: t.device,
    options: [{
      value: 'desktop',
      label: T('Десктоп')
    }, {
      value: 'mobile',
      label: T('Мобайл')
    }, {
      value: 'ctv',
      label: 'CTV'
    }],
    onChange: v => set('device', v)
  }), /*#__PURE__*/React.createElement(CfgSeg, {
    label: T('Формат'),
    value: formatOpts.includes(t.format) ? t.format : formatOpts[0],
    options: formatOpts.map(f => ({
      value: f,
      label: T(FORMATS[f].label)
    })),
    onChange: v => set('format', v)
  }), /*#__PURE__*/React.createElement(CfgSection, {
    label: T('Аукцион')
  }), /*#__PURE__*/React.createElement(CfgSeg, {
    label: T('Тип сделки'),
    value: t.dealType || 'open',
    options: [{
      value: 'open',
      label: T('Открытый')
    }, {
      value: 'pmp',
      label: 'PMP'
    }, {
      value: 'preferred',
      label: 'Preferred'
    }],
    onChange: v => set('dealType', v)
  }), /*#__PURE__*/React.createElement(CfgSeg, {
    label: T('Тип цены'),
    value: t.auctionType,
    options: [{
      value: '2-я цена',
      label: T('2-я цена')
    }, {
      value: '1-я цена',
      label: T('1-я цена')
    }],
    onChange: v => set('auctionType', v)
  }), /*#__PURE__*/React.createElement(CfgSlider, {
    label: "Floor price",
    value: t.floor,
    min: 0.5,
    max: 6,
    step: 0.1,
    unit: "$",
    onChange: v => set('floor', v)
  }), /*#__PURE__*/React.createElement(CfgToggle, {
    label: T('DMP обогащает ставки'),
    sub: T('прибавка за сегменты'),
    value: t.dmpOn,
    disabled: !t.nodeDmp,
    onChange: v => set('dmpOn', v)
  }), /*#__PURE__*/React.createElement(CfgToggle, {
    label: T('Согласие GDPR / TCF'),
    sub: T('выключи — и нет ни ID, ни сегментов; часть спроса вообще не торгуется'),
    value: t.consent !== false,
    accent: "#a78bfa",
    onChange: v => set('consent', v)
  }), /*#__PURE__*/React.createElement(CfgToggle, {
    label: T('Cookieless / приватность'),
    sub: T('без 3P cookie (Safari / Firefox / ATT) · alt-ID: UID2 / ID5'),
    value: !!t.cookieless,
    accent: "#f472b6",
    onChange: v => set('cookieless', v)
  }), /*#__PURE__*/React.createElement(CfgSection, {
    label: T('Путь инвентаря'),
    hint: T('как продаётся показ')
  }), /*#__PURE__*/React.createElement(CfgSeg, {
    label: T('Способ'),
    value: t.supplyPath || 'header',
    options: [{
      value: 'header',
      label: 'Header bidding'
    }, {
      value: 'waterfall',
      label: 'Waterfall (legacy)'
    }],
    onChange: v => set('supplyPath', v)
  }), /*#__PURE__*/React.createElement(CfgToggle, {
    label: T('Перепродажа (reseller hop)'),
    sub: T('лишнее звено в цепочке: своя комиссия сверху, а SPO-покупатели такой путь не берут'),
    value: !!t.resellerHop,
    accent: "#fb7185",
    onChange: v => set('resellerHop', v)
  }), /*#__PURE__*/React.createElement(CfgSection, {
    label: T('Сценарий верификации')
  }), /*#__PURE__*/React.createElement(CfgToggle, {
    label: T('Симулировать угрозу'),
    sub: T('бот / небезопасный контент → блок'),
    value: t.threat,
    disabled: !t.nodeVerifier,
    accent: "#fb7185",
    onChange: v => set('threat', v)
  }), /*#__PURE__*/React.createElement(CfgSection, {
    label: T('Подача')
  }), /*#__PURE__*/React.createElement(CfgSeg, {
    label: T('Глубина пояснений'),
    value: t.depth || 'novice',
    options: [{
      value: 'novice',
      label: T('Новичок')
    }, {
      value: 'pro',
      label: T('Профи')
    }],
    onChange: v => set('depth', v)
  }), /*#__PURE__*/React.createElement(CfgSection, {
    label: T('Инструменты')
  }), /*#__PURE__*/React.createElement("div", {
    className: "cfg-actions"
  }, /*#__PURE__*/React.createElement("button", {
    className: "cfg-act",
    onClick: onShare
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "5",
    r: "3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "12",
    r: "3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "19",
    r: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6 13.5l6.8 4M15.4 6.5l-6.8 4",
    strokeLinecap: "round"
  })), T('Поделиться сценарием')), /*#__PURE__*/React.createElement("button", {
    className: "cfg-act",
    onClick: onCompare
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 4v16M15 4v16M4 9h5M15 15h5",
    strokeLinecap: "round"
  })), T('Сравнить прогоны')), /*#__PURE__*/React.createElement("button", {
    className: "cfg-act",
    onClick: onSession
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "5",
    width: "18",
    height: "4",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "4",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "17",
    width: "12",
    height: "2",
    rx: "1"
  })), T('Сессия из 5 показов')), /*#__PURE__*/React.createElement("button", {
    className: "cfg-act",
    onClick: onGlossary
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5A1.5 1.5 0 0 1 5.5 4H18a2 2 0 0 1 2 2v13.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v14.5"
  })), T('Глоссарий')), /*#__PURE__*/React.createElement("button", {
    className: "cfg-act",
    onClick: onExport
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3v12M8 11l4 4 4-4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h14",
    strokeLinecap: "round"
  })), T('Экспорт PDF')))));
}

// ── Auction result panel (explains 1st vs 2nd price) ──
function AuctionPanel({
  auction,
  winnerColor,
  onClose
}) {
  if (!auction || auction.blocked) return null;
  const T = window.tr;
  const first = auction.firstPrice;
  const dealType = auction.dealType || 'open';
  const valid = auction.bids.filter(b => b.valid).slice().sort((a, b) => b.cpm - a.cpm);
  const invalid = auction.bids.filter(b => !b.valid);
  const ordered = valid.concat(invalid);
  const winner = auction.winnerDsp != null ? auction.bids[auction.winnerDsp] : null;
  const max = (valid[0] ? valid[0].cpm : auction.floor) || 1;
  const clearing = auction.clearing;
  const wonVia = auction.wonVia;
  const waterfall = auction.supplyPath === 'waterfall' && wonVia === 'open';
  // second-highest among the relevant pool for the formula label
  const pool = wonVia === 'deal' ? valid.filter(b => b.deal) : valid;
  const second = pool.filter(b => winner && b.dsp !== winner.dsp)[0];
  const floorUsed = wonVia === 'deal' ? auction.dealFloor : auction.floor;
  const secondVal = second ? second.cpm : floorUsed;
  const secondLbl = second ? T('2-я цена') : wonVia === 'deal' ? 'deal floor' : 'floor';
  const savings = winner ? +(winner.cpm - clearing).toFixed(2) : 0;
  let dealBanner = null;
  if (dealType === 'pmp') {
    dealBanner = /*#__PURE__*/React.createElement("div", {
      className: 'ap-deal' + (wonVia === 'deal' ? ' hit' : '')
    }, /*#__PURE__*/React.createElement("b", null, "PMP"), " \xB7 ", T('приватный аукцион, deal floor'), " ", /*#__PURE__*/React.createElement("b", null, "$", auction.dealFloor.toFixed(2)), ".", ' ', wonVia === 'deal' ? T('Сделка прошла floor и победила в приоритете над открытым аукционом.') : T('Сделки не прошли deal floor → ушло в открытый аукцион.'));
  } else if (dealType === 'preferred') {
    dealBanner = /*#__PURE__*/React.createElement("div", {
      className: 'ap-deal' + (wonVia === 'preferred' ? ' hit' : '')
    }, /*#__PURE__*/React.createElement("b", null, "Preferred"), " \xB7 ", T('first-look по фикс. цене'), " ", /*#__PURE__*/React.createElement("b", null, "$", auction.prefPrice.toFixed(2)), ".", ' ', wonVia === 'preferred' ? T('Покупатель взял показ по фикс. цене вне аукциона.') : T('Покупатель отказался → ушло в открытый аукцион.'));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "auction-panel"
  }, /*#__PURE__*/React.createElement("button", {
    className: "panel-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "ap-title"
  }, T('Аукцион'), /*#__PURE__*/React.createElement("span", null, first ? T('1-я цена') : T('2-я цена'))), dealBanner, waterfall && /*#__PURE__*/React.createElement("div", {
    className: "ap-deal wf"
  }, /*#__PURE__*/React.createElement("b", null, "Waterfall"), " \xB7 ", T('источники по очереди. Показ ушёл'), " ", /*#__PURE__*/React.createElement("b", null, T('первому подходящему')), " ", T('по приоритету, а не самому высокому.')), /*#__PURE__*/React.createElement("div", {
    className: "ap-bars"
  }, ordered.map(b => {
    const isWin = winner && b.dsp === winner.dsp;
    const w = b.valid ? Math.max(7, b.cpm / max * 100) : 0;
    return /*#__PURE__*/React.createElement("div", {
      key: b.dsp,
      className: 'ap-row' + (isWin ? ' win' : '') + (b.valid ? '' : ' inv') + (b.deal ? ' deal' : '')
    }, /*#__PURE__*/React.createElement("span", {
      className: "ap-name"
    }, b.deal ? '⚡ ' : '', T(b.label)), /*#__PURE__*/React.createElement("div", {
      className: "ap-track"
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        width: w + '%',
        background: isWin ? winnerColor : undefined
      }
    })), /*#__PURE__*/React.createElement("span", {
      className: "ap-val"
    }, b.valid ? '$' + b.cpm.toFixed(2) : b.reason === 'noconsent' ? T('нет согласия') : b.reason === 'resold' ? T('не берёт перепродажу') : b.reason === 'timeout' ? 'timeout' : b.reason === 'blocked' ? 'blocked' : b.reason === 'declined' ? T('отказ') : b.reason === 'skipped' ? '—' : 'no bid'), isWin && /*#__PURE__*/React.createElement("span", {
      className: "ap-tag"
    }, "WIN"));
  })), winner ? /*#__PURE__*/React.createElement("div", {
    className: "ap-rule"
  }, wonVia === 'preferred' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ap-formula"
  }, "first-look = ", /*#__PURE__*/React.createElement("b", {
    style: {
      color: winnerColor
    }
  }, "$", clearing.toFixed(2)), " ", /*#__PURE__*/React.createElement("span", null, "(", T('фикс.'), ")")), /*#__PURE__*/React.createElement("div", {
    className: "ap-note"
  }, /*#__PURE__*/React.createElement("b", null, "Preferred deal"), T(': цена согласована заранее, аукцион не проводится.'))) : waterfall ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ap-formula"
  }, T('платит'), " ", /*#__PURE__*/React.createElement("b", null, T('свою ставку')), " \u2192 ", /*#__PURE__*/React.createElement("b", {
    style: {
      color: winnerColor
    }
  }, "$", clearing.toFixed(2))), /*#__PURE__*/React.createElement("div", {
    className: "ap-note"
  }, auction.wasted > 0 ? /*#__PURE__*/React.createElement("span", null, T('Более высокая ставка'), " ", /*#__PURE__*/React.createElement("b", null, "$", (clearing + auction.wasted).toFixed(2)), " ", T('не успела поучаствовать —'), " ", /*#__PURE__*/React.createElement("b", {
    style: {
      color: '#fb7185'
    }
  }, T('потеря'), " $", auction.wasted.toFixed(2)), ". ", T('Это и есть минус waterfall.')) : /*#__PURE__*/React.createElement("span", null, T('Здесь первый подошедший оказался и лучшим — потерь нет. Но так бывает не всегда.')))) : first ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ap-formula"
  }, T('платит'), " ", /*#__PURE__*/React.createElement("b", null, T('свою ставку')), " \u2192 ", /*#__PURE__*/React.createElement("b", {
    style: {
      color: winnerColor
    }
  }, "$", clearing.toFixed(2))), /*#__PURE__*/React.createElement("div", {
    className: "ap-note"
  }, T('Аукцион 1-й цены: победитель платит свою ставку — поэтому DSP заранее занижает её (bid shading) до ожидаемой цены клиринга.'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ap-formula"
  }, secondLbl, " $", secondVal.toFixed(2), " ", /*#__PURE__*/React.createElement("span", null, "+ $0.01"), " = ", /*#__PURE__*/React.createElement("b", {
    style: {
      color: winnerColor
    }
  }, "$", clearing.toFixed(2))), /*#__PURE__*/React.createElement("div", {
    className: "ap-note"
  }, T('Ставка победителя была'), " ", /*#__PURE__*/React.createElement("b", null, "$", winner.cpm.toFixed(2)), ", ", T('но платит он'), " ", /*#__PURE__*/React.createElement("b", null, T('цену второго места')), " \u2014 ", T('экономия'), " ", /*#__PURE__*/React.createElement("b", {
    style: {
      color: winnerColor
    }
  }, "$", savings.toFixed(2)), "."))) : /*#__PURE__*/React.createElement("div", {
    className: "ap-rule"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-note"
  }, T('Ни одна ставка не прошла floor price — показ не продан.'))));
}
function SignalTip({
  data,
  x,
  y
}) {
  if (!data) return null;
  const flip = x > window.innerWidth - 280;
  const style = {
    left: flip ? x - 16 : x + 16,
    top: y + 14,
    transform: flip ? 'translateX(-100%)' : 'none'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "sig-tip",
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "sig-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sig-title"
  }, window.tr(data.title)), /*#__PURE__*/React.createElement("span", {
    className: "sig-dir"
  }, window.tr(data.dir))), /*#__PURE__*/React.createElement("div", {
    className: "sig-fields"
  }, data.fields.map(([k, v], i) => /*#__PURE__*/React.createElement("div", {
    className: "sig-f",
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "sig-k"
  }, window.tr(k)), /*#__PURE__*/React.createElement("span", {
    className: "sig-v"
  }, window.tr(v))))), data.back && /*#__PURE__*/React.createElement("div", {
    className: "sig-back"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sig-bdir"
  }, window.tr(data.back.dir)), data.back.fields.map(([k, v], i) => /*#__PURE__*/React.createElement("div", {
    className: "sig-f",
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "sig-k"
  }, window.tr(k)), /*#__PURE__*/React.createElement("span", {
    className: "sig-v"
  }, window.tr(v))))), data.json && /*#__PURE__*/React.createElement("div", {
    className: "sig-json"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sig-jl"
  }, "OpenRTB"), /*#__PURE__*/React.createElement("pre", null, data.json)));
}

// ── Latency budget (100 ms) ──
function LatencyBar({
  clock,
  flow,
  pos
}) {
  const T = window.tr;
  const BUD = 100;
  const segs = [];
  let prev = 0;
  for (let i = 0; i < flow.length; i++) {
    const s = flow[i];
    segs.push({
      id: s.id,
      color: s.color,
      from: prev,
      to: Math.min(s.clock, BUD),
      done: i <= pos
    });
    prev = Math.min(s.clock, BUD);
  }
  const fillPct = Math.min(100, clock / BUD * 100);
  const near = clock > 88;
  return /*#__PURE__*/React.createElement("div", {
    className: "lat-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lat-top"
  }, /*#__PURE__*/React.createElement("span", {
    className: "lat-label"
  }, T('Латентность')), /*#__PURE__*/React.createElement("span", {
    className: 'lat-ms' + (near ? ' near' : '')
  }, clock, /*#__PURE__*/React.createElement("i", null, " / ", BUD, " ", window.L('мс', 'ms', 'ms')))), /*#__PURE__*/React.createElement("div", {
    className: "lat-track"
  }, segs.map((s, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: 'lat-seg' + (s.done ? ' on' : ''),
    style: {
      left: s.from + '%',
      width: Math.max(0, s.to - s.from) + '%',
      background: s.done ? s.color : undefined
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "lat-head",
    style: {
      left: fillPct + '%'
    }
  })));
}
Object.assign(window, {
  TopBar,
  BottomBar,
  InfoPanel,
  Stat,
  Term,
  wrapTerms,
  ConfigPanel,
  AuctionPanel,
  SignalTip,
  DeepDive,
  LatencyBar
});

;
/* RTB Engine — extras: Tour, Compare, Session, Glossary, RunLog, DemoCaption, Quiz, Presets (RU/EN/PL) */
const L3 = (ru, en, pl) => window.L(ru, en, pl);

// ───────────────────────── Tour ─────────────────────────
const TOUR_STEPS = [{
  node: 'user',
  ru: ['Пользователь', 'Заходит на сайт или в приложение. Его cookie и устройство — отправная точка: по ним строится таргетинг и оценивается ценность показа.'],
  en: ['User', 'Opens a site or app. Their cookie and device are the starting point: targeting and the value of the impression are built on them.'],
  pl: ['Użytkownik', 'Wchodzi na stronę lub do aplikacji. Jego cookie i urządzenie to punkt wyjścia: na ich podstawie buduje się targetowanie i wycenia odsłonę.']
}, {
  node: 'publisher',
  ru: ['Паблишер', 'Владелец рекламного места. Как только место свободно — его нужно продать за доли секунды.'],
  en: ['Publisher', 'Owner of the ad slot. The moment it is free, it must be sold in a fraction of a second.'],
  pl: ['Wydawca', 'Właściciel miejsca reklamowego. Gdy tylko miejsce jest wolne — trzeba je sprzedać w ułamku sekundy.']
}, {
  node: 'ssp0',
  ru: ['SSP', 'Сторона предложения: упаковывает показ в bid request, ставит floor price и выносит на биржу. Паблишер часто подключает несколько SSP.'],
  en: ['SSP', 'The supply side: packages the impression into a bid request, sets a floor price and sends it to the exchange. Publishers often connect several SSPs.'],
  pl: ['SSP', 'Strona podaży: pakuje odsłonę w bid request, ustawia floor price i wysyła na giełdę. Wydawca często podłącza kilka SSP.']
}, {
  node: 'exchange',
  ru: ['Ad Exchange', 'Маркетплейс с аукционом: рассылает запрос всем DSP, собирает ставки и выбирает победителя — меньше чем за 100 мс. Часто — часть SSP.'],
  en: ['Ad Exchange', 'The marketplace with the auction: broadcasts the request to all DSPs, collects bids and picks the winner — in under 100 ms. Often part of an SSP.'],
  pl: ['Ad Exchange', 'Rynek z aukcją: rozsyła żądanie do wszystkich DSP, zbiera oferty i wybiera zwycięzcę — w mniej niż 100 ms. Często część SSP.']
}, {
  node: 'dsp0',
  ru: ['DSP', 'Сторона спроса: за рекламодателя решает, интересен ли показ, и делает ставку. Кликни «Заглянуть внутрь», чтобы увидеть его устройство.'],
  en: ['DSP', 'The demand side: on behalf of the advertiser it decides if the impression is interesting and places a bid. Click "Look inside" to see its internals.'],
  pl: ['DSP', 'Strona popytu: w imieniu reklamodawcy decyduje, czy odsłona jest interesująca, i licytuje. Kliknij „Zajrzyj do środka”, by zobaczyć jego budowę.']
}, {
  node: 'dmp',
  ru: ['DMP', 'Данные о пользователе: отдаёт DSP сегменты («был в корзине», «18–24»). С ними ставка может вырасти в разы.'],
  en: ['DMP', 'User data: hands DSPs segments ("abandoned cart", "18–24"). With them a bid can grow several-fold.'],
  pl: ['DMP', 'Dane o użytkowniku: przekazuje DSP segmenty („był w koszyku”, „18–24”). Dzięki nim oferta może wzrosnąć wielokrotnie.']
}, {
  node: 'verifier',
  ru: ['Верификатор', 'Проверяет показ до аукциона: не бот ли это (fraud) и безопасен ли контент для бренда (brand safety).'],
  en: ['Verifier', 'Checks the impression before the auction: is it a bot (fraud) and is the content brand-safe?'],
  pl: ['Weryfikator', 'Sprawdza odsłonę przed aukcją: czy to nie bot (fraud) i czy treść jest bezpieczna dla marki (brand safety).']
}, {
  node: 'tracking',
  ru: ['Трекинг', '3rd-party пиксель фиксирует показ и клик, шлёт постбэк — так считаются результаты и обучаются модели.'],
  en: ['Tracking', 'A 3rd-party pixel records the impression and click and fires a postback — that is how results are counted and models learn.'],
  pl: ['Śledzenie', '3rd-party pixel rejestruje odsłonę i kliknięcie, wysyła postback — tak liczy się wyniki i uczą modele.']
}];
function curLang() {
  return window.__lang === 'pl' ? 'pl' : window.__lang === 'en' ? 'en' : 'ru';
}
function Tour({
  active,
  onClose
}) {
  const [step, setStep] = React.useState(0);
  const [rect, setRect] = React.useState(null);
  const lang = curLang();
  const steps = TOUR_STEPS;
  const cur = steps[step];
  const measure = React.useCallback(() => {
    if (!cur) return;
    const el = document.querySelector('[data-node="' + cur.node + '"]');
    if (el) setRect(el.getBoundingClientRect());else setRect(null);
  }, [cur]);
  React.useEffect(() => {
    if (!active) return;
    measure();
    const t = setTimeout(measure, 60);
    window.addEventListener('resize', measure);
    return () => {
      clearTimeout(t);
      window.removeEventListener('resize', measure);
    };
  }, [active, step, measure]);
  React.useEffect(() => {
    if (active) setStep(0);
  }, [active]);
  if (!active) return null;
  const pad = 10;
  const ring = rect ? {
    left: rect.left - pad,
    top: rect.top - pad,
    width: rect.width + pad * 2,
    height: rect.height + pad * 2
  } : null;
  let card = {
    left: 24,
    top: 90
  };
  if (rect) {
    const vw = window.innerWidth,
      vh = window.innerHeight,
      cw = 320,
      ch = 190;
    if (rect.right + 18 + cw < vw) card = {
      left: rect.right + 18,
      top: Math.min(Math.max(rect.top, 16), vh - ch - 16)
    };else if (rect.left - 18 - cw > 0) card = {
      left: rect.left - 18 - cw,
      top: Math.min(Math.max(rect.top, 16), vh - ch - 16)
    };else card = {
      left: Math.min(Math.max(rect.left, 16), vw - cw - 16),
      top: rect.bottom + 16 < vh - ch ? rect.bottom + 16 : Math.max(16, rect.top - ch - 16)
    };
  }
  const finish = () => {
    try {
      localStorage.setItem('rtb-tour-done', '1');
    } catch (e) {}
    try {
      if (window.rtbTrack) window.rtbTrack('tour_complete');
    } catch (e) {}
    onClose();
  };
  const txt = cur[lang] || cur.en || cur.ru;
  return /*#__PURE__*/React.createElement("div", {
    className: "tour-overlay"
  }, ring && /*#__PURE__*/React.createElement("div", {
    className: "tour-ring",
    style: ring
  }), /*#__PURE__*/React.createElement("div", {
    className: "tour-card",
    style: card
  }, /*#__PURE__*/React.createElement("div", {
    className: "tour-step"
  }, step + 1, " / ", steps.length), /*#__PURE__*/React.createElement("div", {
    className: "tour-title"
  }, txt[0]), /*#__PURE__*/React.createElement("div", {
    className: "tour-desc"
  }, txt[1]), /*#__PURE__*/React.createElement("div", {
    className: "tour-btns"
  }, /*#__PURE__*/React.createElement("button", {
    className: "tour-skip",
    onClick: finish
  }, L3('Пропустить', 'Skip', 'Pomiń')), /*#__PURE__*/React.createElement("div", {
    className: "tour-nav"
  }, step > 0 && /*#__PURE__*/React.createElement("button", {
    className: "tour-back",
    onClick: () => setStep(s => s - 1)
  }, L3('Назад', 'Back', 'Wstecz')), step < steps.length - 1 ? /*#__PURE__*/React.createElement("button", {
    className: "tour-next",
    onClick: () => setStep(s => s + 1)
  }, L3('Далее', 'Next', 'Dalej')) : /*#__PURE__*/React.createElement("button", {
    className: "tour-next",
    onClick: finish
  }, L3('Готово', 'Done', 'Gotowe'))))));
}

// ───────────────────────── Compare ─────────────────────────
function aggRun(base, overrides) {
  const N = 300;
  let clr = 0,
    net = 0,
    fill = 0,
    bids = 0;
  const wins = {};
  for (let i = 0; i < N; i++) {
    const a = window.RTB.makeAuction(Object.assign({
      count: base.count,
      dmpOn: base.dmpOn,
      auctionType: base.firstPrice ? 'first' : 'second',
      floor: base.floor,
      device: base.device,
      format: base.format,
      verify: false,
      threat: false,
      dealType: base.dealType,
      supplyPath: base.supplyPath
    }, overrides));
    if (a.winnerDsp != null) {
      fill++;
      clr += a.clearing;
      net += a.money.pubNet;
      const l = a.bids[a.winnerDsp].label;
      wins[l] = (wins[l] || 0) + 1;
    }
    bids += a.bids.filter(b => b.valid).length;
  }
  const f = fill || 1;
  return {
    avgClr: clr / f,
    avgNet: net / f,
    fill: fill / N,
    avgBids: bids / N,
    wins,
    N
  };
}
function Compare({
  open,
  onClose,
  base
}) {
  const [axis, setAxis] = React.useState('dmp');
  if (!open) return null;
  const AX = {
    dmp: {
      label: L3('DMP: вкл / выкл', 'DMP: on / off', 'DMP: wł / wył'),
      a: [L3('С DMP', 'With DMP', 'Z DMP'), {
        dmpOn: true
      }],
      b: [L3('Без DMP', 'No DMP', 'Bez DMP'), {
        dmpOn: false
      }]
    },
    path: {
      label: 'Header / Waterfall',
      a: ['Header bidding', {
        supplyPath: 'header'
      }],
      b: ['Waterfall', {
        supplyPath: 'waterfall'
      }]
    },
    price: {
      label: L3('Цена: 2-я / 1-я', 'Price: 2nd / 1st', 'Cena: 2. / 1.'),
      a: [L3('2-я цена', '2nd price', '2. cena'), {
        auctionType: 'second'
      }],
      b: [L3('1-я цена', '1st price', '1. cena'), {
        auctionType: 'first'
      }]
    }
  };
  const ax = AX[axis];
  const A = aggRun(base, ax.a[1]);
  const B = aggRun(base, ax.b[1]);
  const maxClr = Math.max(A.avgClr, B.avgClr, 0.01);
  const maxNet = Math.max(A.avgNet, B.avgNet, 0.01);
  const topWin = w => {
    const e = Object.entries(w).sort((x, y) => y[1] - x[1])[0];
    return e ? window.tr(e[0]) : '—';
  };
  const metric = (label, va, vb, max, unit, hint) => /*#__PURE__*/React.createElement("div", {
    className: "cmp-metric"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-mlabel"
  }, label, hint && /*#__PURE__*/React.createElement("i", null, hint)), /*#__PURE__*/React.createElement("div", {
    className: "cmp-bars"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-fill a",
    style: {
      width: Math.abs(va) / max * 100 + '%'
    }
  }), /*#__PURE__*/React.createElement("span", null, unit + va.toFixed(unit === '$' ? 2 : va < 10 ? 1 : 0))), /*#__PURE__*/React.createElement("div", {
    className: "cmp-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-fill b",
    style: {
      width: Math.abs(vb) / max * 100 + '%'
    }
  }), /*#__PURE__*/React.createElement("span", null, unit + vb.toFixed(unit === '$' ? 2 : vb < 10 ? 1 : 0)))));
  const winsLbl = L3('Чаще побеждает', 'Most often wins', 'Najczęściej wygrywa');
  return /*#__PURE__*/React.createElement("div", {
    className: "compare-overlay",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "compare-modal",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "dive-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "cmp-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-title"
  }, L3('Сравнение прогонов', 'Run comparison', 'Porównanie przebiegów')), /*#__PURE__*/React.createElement("div", {
    className: "cmp-sub"
  }, L3('Средние по 300 аукционам при текущих настройках, меняется только выбранная ось.', 'Averages over 300 auctions at current settings; only the chosen axis changes.', 'Średnie z 300 aukcji przy bieżących ustawieniach; zmienia się tylko wybrana oś.'))), /*#__PURE__*/React.createElement("div", {
    className: "cmp-axis"
  }, Object.keys(AX).map(k => /*#__PURE__*/React.createElement("button", {
    key: k,
    className: k === axis ? 'on' : '',
    onClick: () => setAxis(k)
  }, AX[k].label))), /*#__PURE__*/React.createElement("div", {
    className: "cmp-cols"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-col a"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cmp-dot a"
  }), ax.a[0]), /*#__PURE__*/React.createElement("div", {
    className: "cmp-col b"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cmp-dot b"
  }), ax.b[0])), metric(L3('Клиринговая цена', 'Clearing price', 'Cena rozliczenia'), A.avgClr, B.avgClr, maxClr, '$', L3('сред. CPM', 'avg CPM', 'śr. CPM')), metric(L3('Паблишер получает', 'Publisher net', 'Wydawca dostaje'), A.avgNet, B.avgNet, maxNet, '$', L3('чистыми', 'net', 'netto')), metric(L3('Заполняемость', 'Fill rate', 'Wypełnienie'), A.fill * 100, B.fill * 100, 100, '', '%'), metric(L3('Ставок в среднем', 'Avg bids', 'Śr. ofert'), A.avgBids, B.avgBids, Math.max(A.avgBids, B.avgBids, 1), '', L3('валидных', 'valid', 'ważnych')), /*#__PURE__*/React.createElement("div", {
    className: "cmp-foot"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, winsLbl), /*#__PURE__*/React.createElement("b", {
    className: "a"
  }, topWin(A.wins))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, winsLbl), /*#__PURE__*/React.createElement("b", {
    className: "b"
  }, topWin(B.wins)))), /*#__PURE__*/React.createElement("div", {
    className: "cmp-note"
  }, axis === 'dmp' ? L3('С DMP ставки выше за счёт сегментов → выше и клиринг, и доход паблишера.', 'With DMP, bids rise thanks to segments → higher clearing and publisher revenue.', 'Z DMP oferty rosną dzięki segmentom → wyższy klirowanie i przychód wydawcy.') : axis === 'path' ? L3('Header bidding собирает все ставки сразу; waterfall продаёт первому подходящему — часть дохода теряется.', 'Header bidding collects all bids at once; waterfall sells to the first eligible — some revenue is lost.', 'Header bidding zbiera wszystkie oferty naraz; waterfall sprzedaje pierwszemu pasującemu — część przychodu przepada.') : L3('При 1-й цене победитель платит свою ставку (дороже); при 2-й — цену второго места.', 'First price: the winner pays its own bid (higher); second price: the runner-up price.', 'Pierwsza cena: zwycięzca płaci swoją ofertę (drożej); druga cena: cenę drugiego miejsca.'))));
}

// ───────────────────────── Session (5 impressions) ─────────────────────────
function Session({
  open,
  onClose,
  base
}) {
  if (!open) return null;
  const buyers = [{
    label: L3('Бренд', 'Brand', 'Brand'),
    base: 4.2,
    budget: 9,
    cap: 2
  }, {
    label: L3('Ретаргетинг', 'Retargeting', 'Retargeting'),
    base: 5.0,
    budget: 7,
    cap: 3
  }, {
    label: L3('Перформанс', 'Performance', 'Performance'),
    base: 3.2,
    budget: 12,
    cap: 5
  }].map(b => ({
    ...b,
    left: b.budget,
    wins: 0,
    spend: 0
  }));
  const floor = base.floor || 1.5;
  const capTag = L3(': freq cap', ': freq cap', ': freq cap');
  const budTag = L3(': бюджет↓', ': budget↓', ': budżet↓');
  const rows = [];
  for (let imp = 0; imp < 5; imp++) {
    const offers = buyers.map(b => {
      let bid = b.base * (0.8 + Math.random() * 0.4);
      const pace = b.left / b.budget;
      if (pace < 0.35) bid *= 0.55;
      const freq = b.wins >= b.cap ? 0 : 1 - b.wins * 0.22;
      bid *= freq;
      const valid = bid >= floor && b.left >= floor && freq > 0;
      return {
        b,
        bid: +bid.toFixed(2),
        valid,
        pace,
        capped: b.wins >= b.cap
      };
    });
    const valid = offers.filter(o => o.valid).sort((x, y) => y.bid - x.bid);
    const win = valid[0];
    const second = valid[1];
    let note = '';
    if (!win) note = L3('нет ставок', 'no bids', 'brak ofert');
    const price = win ? +Math.min(win.bid, Math.max(second ? second.bid : floor, floor) + 0.01).toFixed(2) : 0;
    if (win) {
      win.b.wins++;
      win.b.spend += price;
      win.b.left = +(win.b.left - price).toFixed(2);
      const tags = [];
      offers.forEach(o => {
        if (o.capped) tags.push(o.b.label + capTag);else if (o.pace < 0.35) tags.push(o.b.label + budTag);
      });
      note = tags.slice(0, 2).join(' · ');
    }
    rows.push({
      imp: imp + 1,
      winner: win ? win.b.label : '—',
      price,
      note
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "compare-overlay",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "compare-modal",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "dive-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "cmp-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-title"
  }, L3('Сессия из 5 показов', 'Session of 5 impressions', 'Sesja 5 odsłon')), /*#__PURE__*/React.createElement("div", {
    className: "cmp-sub"
  }, L3('Один пользователь, 5 показов подряд. Видно frequency cap (после лимита покупатель выбывает) и pacing бюджета (ставки падают, когда бюджет тает).', 'One user, 5 impressions in a row. Shows the frequency cap (a buyer drops out after its limit) and budget pacing (bids fall as budget runs low).', 'Jeden użytkownik, 5 odsłon z rzędu. Widać frequency cap (po limicie kupujący odpada) i pacing budżetu (oferty spadają, gdy budżet topnieje).'))), /*#__PURE__*/React.createElement("div", {
    className: "sess-rows"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sess-row sess-h"
  }, /*#__PURE__*/React.createElement("span", null, "#"), /*#__PURE__*/React.createElement("span", null, L3('Победитель', 'Winner', 'Zwycięzca')), /*#__PURE__*/React.createElement("span", null, L3('Цена', 'Price', 'Cena')), /*#__PURE__*/React.createElement("span", null, L3('Заметки', 'Notes', 'Uwagi'))), rows.map(r => /*#__PURE__*/React.createElement("div", {
    className: "sess-row",
    key: r.imp
  }, /*#__PURE__*/React.createElement("span", {
    className: "sess-n"
  }, r.imp), /*#__PURE__*/React.createElement("span", {
    className: "sess-w"
  }, r.winner), /*#__PURE__*/React.createElement("span", {
    className: "sess-p"
  }, r.price ? '$' + r.price.toFixed(2) : '—'), /*#__PURE__*/React.createElement("span", {
    className: "sess-note"
  }, r.note)))), /*#__PURE__*/React.createElement("div", {
    className: "sess-sum"
  }, buyers.map((b, i) => /*#__PURE__*/React.createElement("div", {
    className: "sess-card",
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "sess-cl"
  }, b.label), /*#__PURE__*/React.createElement("div", {
    className: "sess-cm"
  }, /*#__PURE__*/React.createElement("span", null, L3('Показы', 'Wins', 'Wygrane')), /*#__PURE__*/React.createElement("b", null, b.wins, " / ", b.cap)), /*#__PURE__*/React.createElement("div", {
    className: "sess-cm"
  }, /*#__PURE__*/React.createElement("span", null, L3('Потрачено', 'Spend', 'Wydano')), /*#__PURE__*/React.createElement("b", null, "$", b.spend.toFixed(2))), /*#__PURE__*/React.createElement("div", {
    className: "sess-cm"
  }, /*#__PURE__*/React.createElement("span", null, L3('Бюджет', 'Budget', 'Budżet')), /*#__PURE__*/React.createElement("b", null, "$", Math.max(0, b.left).toFixed(2)))))), /*#__PURE__*/React.createElement("div", {
    className: "cmp-note"
  }, L3('Как только покупатель достигает frequency cap, он перестаёт бороться за этого пользователя — показ достаётся другим. А pacing растягивает бюджет на день, занижая ставки при его нехватке.', 'Once a buyer hits its frequency cap it stops competing for this user — others win. Pacing stretches the budget across the day by lowering bids when it runs short.', 'Gdy kupujący osiąga frequency cap, przestaje walczyć o tego użytkownika — odsłonę biorą inni. A pacing rozciąga budżet na cały dzień, obniżając oferty przy jego niedoborze.'))));
}

// ───────────────────────── Glossary panel ─────────────────────────
const GLOSS_GROUPS = {
  players: ['RTB', 'programmatic', 'SSP', 'DSP', 'DMP', 'Ad Exchange', 'ad server', 'verifier', 'publisher'],
  auction: ['bid request', 'bid response', 'floor price', 'CPM', 'clearing price', 'first-price auction', 'second-price auction', 'bid shading', 'header bidding', 'waterfall'],
  deals: ['PMP', 'Deal ID', 'deal floor', 'Preferred', 'first-look', 'curation', 'SPO', 'reseller'],
  data: ['segments', 'creative', 'ad slot', 'format', 'device', 'video', 'native', 'CTV', 'SSAI', 'eids', 'clean room', 'TCF', 'consent string'],
  quality: ['3rd-party tag', '3rd-party pixel', 'pixel', 'fraud', 'IVT', 'brand safety', 'brand suitability', 'blocklist', 'MFA', 'pre-bid / post-bid', 'viewability', 'attention', 'attention seconds', 'Adelaide AU', 'postback']
};
function Glossary({
  open,
  onClose
}) {
  const [q, setQ] = React.useState('');
  if (!open) return null;
  const G = window.activeGlossary ? window.activeGlossary() : {};
  const titles = {
    players: L3('Участники', 'Players', 'Uczestnicy'),
    auction: L3('Аукцион и цена', 'Auction & price', 'Aukcja i cena'),
    deals: L3('Сделки', 'Deals', 'Transakcje'),
    data: L3('Данные и форматы', 'Data & formats', 'Dane i formaty'),
    quality: L3('Качество и трекинг', 'Quality & tracking', 'Jakość i śledzenie')
  };
  const needle = q.trim().toLowerCase();
  const match = k => !needle || k.toLowerCase().includes(needle) || (G[k] || '').toLowerCase().includes(needle);
  return /*#__PURE__*/React.createElement("div", {
    className: "compare-overlay",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "gloss-modal",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "dive-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "cmp-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-title"
  }, L3('Глоссарий RTB', 'RTB glossary', 'Słowniczek RTB')), /*#__PURE__*/React.createElement("div", {
    className: "cmp-sub"
  }, L3('Все термины экосистемы в одном месте. Те же определения всплывают по наведению на подчёркнутые слова в подсказках.', 'Every ecosystem term in one place. The same definitions appear on hover over underlined words in the tooltips.', 'Wszystkie terminy ekosystemu w jednym miejscu. Te same definicje pojawiają się po najechaniu na podkreślone słowa w podpowiedziach.'))), /*#__PURE__*/React.createElement("input", {
    className: "gloss-search",
    value: q,
    onChange: e => setQ(e.target.value),
    placeholder: L3('Поиск термина…', 'Search a term…', 'Szukaj terminu…')
  }), /*#__PURE__*/React.createElement("div", {
    className: "gloss-groups"
  }, Object.keys(GLOSS_GROUPS).map(gk => {
    const items = GLOSS_GROUPS[gk].filter(k => G[k] && match(k));
    if (!items.length) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "gloss-group",
      key: gk
    }, /*#__PURE__*/React.createElement("div", {
      className: "gloss-gt"
    }, titles[gk]), /*#__PURE__*/React.createElement("div", {
      className: "gloss-list"
    }, items.map(k => /*#__PURE__*/React.createElement("div", {
      className: "gloss-item",
      key: k
    }, /*#__PURE__*/React.createElement("div", {
      className: "gloss-term"
    }, k), /*#__PURE__*/React.createElement("div", {
      className: "gloss-def"
    }, G[k])))));
  }))));
}

// ───────────────────────── Run log ─────────────────────────
function buildLog(auction, flow) {
  if (!auction) return [];
  const out = [];
  const win = auction.winnerDsp != null ? auction.bids[auction.winnerDsp] : null;
  const declined = L3('отказ', 'declined', 'odmowa');
  for (let p = 0; p < flow.length; p++) {
    const s = flow[p];
    let line = '';
    switch (s.id) {
      case 'user':
        line = L3('Открыта страница, рекламное место свободно.', 'Page opened, ad slot is free.', 'Strona otwarta, miejsce reklamowe wolne.');
        break;
      case 'request':
        line = L3('SSP сформировала bid request, floor = $', 'SSP built a bid request, floor = $', 'SSP zbudował bid request, floor = $') + auction.floor.toFixed(2);
        break;
      case 'toExchange':
        line = L3('Запрос ушёл на биржу, таймер 100 мс пошёл.', 'Request sent to exchange, 100 ms timer started.', 'Żądanie poszło na giełdę, zegar 100 ms ruszył.');
        break;
      case 'verify':
        line = auction.blocked ? L3('✕ Верификатор отклонил показ: ', '✕ Verifier rejected: ', '✕ Weryfikator odrzucił odsłonę: ') + (auction.blockReason === 'fraud' ? 'fraud / IVT' : 'brand safety') : L3('✓ Верификация пройдена (не бот, контент безопасен).', '✓ Verification passed (not a bot, content safe).', '✓ Weryfikacja zaliczona (nie bot, treść bezpieczna).');
        break;
      case 'broadcast':
        line = L3('Биржа разослала запрос ', 'Exchange broadcast to ', 'Giełda rozesłała żądanie do ') + auction.count + ' DSP.';
        break;
      case 'enrich':
        line = auction.dmpOn ? L3('DMP отдала сегменты; узнанные DSP подняли ставки.', 'DMP returned segments; recognized DSPs raised bids.', 'DMP przekazał segmenty; rozpoznane DSP podniosły oferty.') : L3('DMP выключена — обогащения нет.', 'DMP off — no enrichment.', 'DMP wyłączony — brak wzbogacenia.');
        break;
      case 'bid':
        {
          const parts = auction.bids.map(b => window.tr(b.label) + ': ' + (b.valid ? '$' + b.cpm.toFixed(2) : b.reason === 'timeout' ? 'timeout' : b.reason === 'declined' ? declined : 'no bid'));
          line = L3('Ставки — ', 'Bids — ', 'Oferty — ') + parts.join(' · ');
          break;
        }
      case 'auction':
        line = win ? L3('Победил DSP · ', 'Winner: DSP · ', 'Zwycięzca: DSP · ') + window.tr(win.label) + L3(', клиринг $', ', clearing $', ', rozliczenie $') + auction.clearing.toFixed(2) + (auction.firstPrice ? ' (1st)' : ' (2nd)') : L3('Ни одна ставка не прошла floor — показ не продан.', 'No bid cleared the floor — unsold.', 'Żadna oferta nie przekroczyła floor — niesprzedane.');
        break;
      case 'response':
        line = win ? L3('Креатив победителя отправлен на страницу.', "Winner's creative sent to the page.", 'Kreacja zwycięzcy wysłana na stronę.') : L3('Показ не продан.', 'Impression unsold.', 'Odsłona niesprzedana.');
        break;
      case 'render':
        line = win ? L3('Объявление показано, pixel сработал.', 'Ad rendered, pixel fired.', 'Reklama wyświetlona, pixel odpalony.') : L3('Место осталось пустым.', 'Slot left empty.', 'Miejsce pozostało puste.');
        break;
      case 'track':
        line = win ? L3('Постбэк отправлен. Паблишер получил $', 'Postback sent. Publisher got $', 'Postback wysłany. Wydawca dostał $') + (auction.money ? auction.money.pubNet.toFixed(2) : '0.00') + L3(' чистыми.', ' net.', ' netto.') : L3('Трекинг: продажи не было.', 'Tracking: no sale.', 'Śledzenie: brak sprzedaży.');
        break;
      default:
        line = s.title;
    }
    out.push({
      p,
      id: s.id,
      n: String(p + 1).padStart(2, '0'),
      line
    });
  }
  return out;
}
function RunLog({
  open,
  onToggle,
  entries,
  pos,
  done
}) {
  const bodyRef = React.useRef(null);
  const visible = done ? entries : entries.filter(e => e.p <= pos);
  React.useEffect(() => {
    if (open && bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [visible.length, open]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'runlog' + (open ? ' open' : '')
  }, /*#__PURE__*/React.createElement("button", {
    className: "runlog-tab",
    onClick: onToggle
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6h16M4 12h16M4 18h10",
    strokeLinecap: "round"
  })), L3('Лог', 'Log', 'Log'), visible.length ? ' · ' + visible.length : ''), open && /*#__PURE__*/React.createElement("div", {
    className: "runlog-body",
    ref: bodyRef
  }, visible.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "runlog-empty"
  }, L3('Запустите аукцион — события появятся здесь.', 'Run an auction — events will appear here.', 'Uruchom aukcję — zdarzenia pojawią się tutaj.')) : visible.map(e => /*#__PURE__*/React.createElement("div", {
    className: 'runlog-row' + (e.p === pos && !done ? ' cur' : ''),
    key: e.p
  }, /*#__PURE__*/React.createElement("span", {
    className: "runlog-n"
  }, e.n), /*#__PURE__*/React.createElement("span", {
    className: "runlog-line"
  }, e.line)))));
}

// ───────────────────────── Presentation captions ─────────────────────────
function DemoCaption({
  active,
  stage,
  blockedView,
  decided,
  auction,
  onExit
}) {
  if (!active) return null;
  const T = window.tr;
  let title = '',
    desc = '';
  if (blockedView) {
    title = T('Показ заблокирован');
    desc = L3('Верификатор остановил показ до аукциона.', 'The verifier stopped the impression before the auction.', 'Weryfikator zatrzymał odsłonę przed aukcją.');
  } else if (stage) {
    const num = (stage.title.match(/^\d+/) || [''])[0];
    title = (num ? num + ' · ' : '') + T(stage.title.replace(/^\d+\s*·\s*/, ''));
    desc = T(stage.desc);
  } else {
    title = L3('Готово', 'Done', 'Gotowe');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "demo-layer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "demo-exit",
    onClick: onExit
  }, L3('✕ Выйти из презентации', '✕ Exit presentation', '✕ Wyjdź z prezentacji')), /*#__PURE__*/React.createElement("div", {
    className: "demo-cap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "demo-title"
  }, title), desc && /*#__PURE__*/React.createElement("div", {
    className: "demo-desc"
  }, desc)));
}

// ───────────────────────── Quiz ─────────────────────────
function buildQuiz(auction) {
  if (!auction) return [];
  const win = auction.winnerDsp != null ? auction.bids[auction.winnerDsp] : null;
  const qs = [];
  if (win) {
    const opts = auction.bids.map(b => 'DSP · ' + window.tr(b.label));
    qs.push({
      q: L3('Кто выиграл этот аукцион?', 'Who won this auction?', 'Kto wygrał tę aukcję?'),
      options: opts,
      correct: auction.bids.findIndex(b => b.dsp === win.dsp),
      why: auction.wonVia === 'preferred' ? L3('Победил DSP · ' + window.tr(win.label) + ' — он выкупил показ по Preferred Deal (first-look) по фиксированной цене $' + auction.clearing.toFixed(2) + ' ещё до открытого аукциона, поэтому это не самая высокая ставка.', 'DSP · ' + window.tr(win.label) + ' won — it bought the impression via a Preferred Deal (first-look) at a fixed $' + auction.clearing.toFixed(2) + ' before the open auction, so it is not the highest bid.', 'Wygrał DSP · ' + window.tr(win.label) + ' — kupił odsłonę przez Preferred Deal (first-look) po stałej cenie $' + auction.clearing.toFixed(2) + ' jeszcze przed aukcją otwartą, więc to nie najwyższa oferta.') : auction.wonVia === 'deal' ? L3('Победил DSP · ' + window.tr(win.label) + ' — самая высокая ставка среди участников PMP-сделки (выше deal floor).', 'DSP · ' + window.tr(win.label) + ' won — the highest bid among the PMP deal participants (above the deal floor).', 'Wygrał DSP · ' + window.tr(win.label) + ' — najwyższa oferta wśród uczestników transakcji PMP (powyżej deal floor).') : L3('Победил DSP · ' + window.tr(win.label) + ' — у него была самая высокая валидная ставка ($' + win.cpm.toFixed(2) + ').', 'DSP · ' + window.tr(win.label) + ' won — it had the highest valid bid ($' + win.cpm.toFixed(2) + ').', 'Wygrał DSP · ' + window.tr(win.label) + ' — miał najwyższą ważną ofertę ($' + win.cpm.toFixed(2) + ').')
    });
  } else {
    qs.push({
      q: L3('Чем закончился аукцион?', 'How did the auction end?', 'Jak zakończyła się aukcja?'),
      options: [L3('Победил случайный DSP', 'A random DSP won', 'Wygrał losowy DSP'), L3('Показ не продан — ставки ниже floor', 'Unsold — bids below floor', 'Niesprzedane — oferty poniżej floor'), L3('Паблишер заплатил бирже', 'Publisher paid the exchange', 'Wydawca zapłacił giełdzie')],
      correct: 1,
      why: L3('Ни одна ставка не превысила floor price, поэтому показ остался непроданным.', 'No bid exceeded the floor price, so the impression went unsold.', 'Żadna oferta nie przekroczyła floor price, więc odsłona pozostała niesprzedana.')
    });
  }
  qs.push({
    q: L3('Что делает SSP?', 'What does an SSP do?', 'Co robi SSP?'),
    options: [L3('Представляет рекламодателя и делает ставки', 'Represents the advertiser and bids', 'Reprezentuje reklamodawcę i licytuje'), L3('Представляет паблишера и продаёт его инвентарь', 'Represents the publisher and sells its inventory', 'Reprezentuje wydawcę i sprzedaje jego powierzchnię'), L3('Хранит данные о пользователях', 'Stores user data', 'Przechowuje dane o użytkownikach'), L3('Проверяет показ на фрод', 'Checks the impression for fraud', 'Sprawdza odsłonę pod kątem fraudu')],
    correct: 1,
    why: L3('SSP — сторона предложения: упаковывает инвентарь паблишера в bid request и выносит на аукцион.', 'The SSP is the supply side: it packages the publisher inventory into a bid request and brings it to auction.', 'SSP to strona podaży: pakuje powierzchnię wydawcy w bid request i wystawia na aukcję.')
  });
  if (win && auction.firstPrice && auction.wonVia === 'open') {
    qs.push({
      q: L3('Победитель платит свою ставку. Зачем тогда DSP занижает её заранее?', 'The winner pays its own bid. So why does the DSP shade it down beforehand?', 'Zwycięzca płaci własną ofertę. Po co więc DSP zaniża ją z góry?'),
      options: [L3('Bid shading — при первой цене платишь свою ставку, бить в полную оценку невыгодно', 'Bid shading — under first price you pay your own bid, so bidding full value is wasteful', 'Bid shading — przy pierwszej cenie płacisz własną ofertę, więc licytowanie pełnej wartości się nie opłaca'), L3('Так требует floor price', 'The floor price requires it', 'Tak wymaga floor price'), L3('Биржа запрещает высокие ставки', 'The exchange forbids high bids', 'Giełda zakazuje wysokich ofert'), L3('Чтобы пройти верификацию', 'To pass verification', 'Aby przejść weryfikację')],
      correct: 0,
      why: L3('Аукцион первой цены — норма открытого аукциона с ~2019: победитель платит ровно свою ставку, здесь $' + auction.clearing.toFixed(2) + '. Поэтому DSP заранее занижает ставку (bid shading) до ожидаемой цены клиринга — иначе просто переплачивает.', 'A first-price auction has been the open-auction norm since ~2019: the winner pays exactly its own bid — here $' + auction.clearing.toFixed(2) + '. So the DSP shades its bid down to the expected clearing price beforehand, otherwise it simply overpays.', 'Aukcja pierwszej ceny to norma aukcji otwartej od ok. 2019: zwycięzca płaci dokładnie własną ofertę — tu $' + auction.clearing.toFixed(2) + '. Dlatego DSP z góry zaniża ofertę (bid shading) do oczekiwanej ceny rozliczenia — inaczej po prostu przepłaca.')
    });
  } else if (win && !auction.firstPrice && auction.wonVia === 'open') {
    const hasRunnerUp = auction.bids.filter(b => b.valid).length > 1;
    qs.push({
      q: L3('Почему победитель платит не свою ставку?', 'Why does the winner not pay its own bid?', 'Dlaczego zwycięzca nie płaci swojej oferty?'),
      options: [L3('Это аукцион второй цены — платит цену второго места + 1¢', 'Second-price auction — pays runner-up price + 1¢', 'Aukcja drugiej ceny — płaci cenę drugiego miejsca + 1¢'), L3('Биржа берёт половину', 'The exchange takes half', 'Giełda bierze połowę'), L3('Случайная скидка', 'A random discount', 'Losowy rabat'), L3('Floor price так велит', 'The floor price dictates it', 'Tak każe floor price')],
      correct: 0,
      why: hasRunnerUp ? L3('При аукционе второй цены победитель платит цену второго места плюс цент — здесь $' + auction.clearing.toFixed(2) + '.', 'In a second-price auction the winner pays the runner-up price plus a cent — here $' + auction.clearing.toFixed(2) + '.', 'W aukcji drugiej ceny zwycięzca płaci cenę drugiego miejsca plus cent — tu $' + auction.clearing.toFixed(2) + '.') : L3('Аукцион второй цены: победитель платит цену второго места, а если floor прошла лишь одна ставка — floor + 1¢. Здесь прошла одна ставка, поэтому клиринг = $' + auction.clearing.toFixed(2) + '.', 'Second-price: the winner pays the runner-up price, or the floor + 1¢ if only one bid cleared. Here a single bid cleared, so the price = $' + auction.clearing.toFixed(2) + '.', 'Druga cena: zwycięzca płaci cenę drugiego miejsca, a jeśli floor przeszła tylko jedna oferta — floor + 1¢. Tu przeszła jedna oferta, więc cena = $' + auction.clearing.toFixed(2) + '.')
    });
  } else if (win && auction.wonVia === 'preferred') {
    qs.push({
      q: L3('Как победитель купил этот показ?', 'How did the winner buy this impression?', 'Jak zwycięzca kupił tę odsłonę?'),
      options: [L3('Preferred Deal — фикс. цена first-look до открытого аукциона', 'Preferred Deal — a fixed first-look price before the open auction', 'Preferred Deal — stała cena first-look przed aukcją otwartą'), L3('Аукцион второй цены', 'A second-price auction', 'Aukcja drugiej ceny'), L3('Заплатил свою максимальную ставку', 'It paid its maximum bid', 'Zapłacił swoją maksymalną ofertę'), L3('Случайная скидка от биржи', 'A random discount from the exchange', 'Losowy rabat od giełdy')],
      correct: 0,
      why: L3('Preferred Deal: приоритетный покупатель получает first-look и берёт показ по заранее согласованной фиксированной цене ($' + auction.clearing.toFixed(2) + ') ещё до открытого аукциона. Это не аукцион.', 'Preferred Deal: the priority buyer gets a first look and takes the impression at a pre-agreed fixed price ($' + auction.clearing.toFixed(2) + ') before the open auction. It is not an auction.', 'Preferred Deal: priorytetowy kupujący dostaje first-look i bierze odsłonę po wcześniej ustalonej stałej cenie ($' + auction.clearing.toFixed(2) + ') jeszcze przed aukcją otwartą. To nie aukcja.')
    });
  } else if (win && auction.wonVia === 'deal') {
    qs.push({
      q: L3('Что означает Deal ID на этой ставке?', 'What does the Deal ID on this bid mean?', 'Co oznacza Deal ID przy tej ofercie?'),
      options: [L3('PMP-сделка: закрытый аукцион по приглашению со своим floor', 'A PMP deal: an invite-only private auction with its own floor', 'Transakcja PMP: zamknięta aukcja na zaproszenie z własnym floor'), L3('Скидку рекламодателя', 'An advertiser discount', 'Rabat reklamodawcy'), L3('Идентификатор креатива', 'The creative identifier', 'Identyfikator kreacji'), L3('Floor открытого аукциона', 'The open-auction floor', 'Floor aukcji otwartej')],
      correct: 0,
      why: L3('Deal ID помечает сделку Private Marketplace: покупатели только по приглашению, приоритет над открытым аукционом и повышенный deal floor. Цена — вторая среди участников сделки ($' + auction.clearing.toFixed(2) + ').', 'A Deal ID marks a Private Marketplace deal: invite-only buyers, priority over the open auction and an elevated deal floor. The price is the second price among the deal participants ($' + auction.clearing.toFixed(2) + ').', 'Deal ID oznacza transakcję Private Marketplace: kupujący tylko na zaproszenie, priorytet nad aukcją otwartą i podwyższony deal floor. Cena to druga cena wśród uczestników ($' + auction.clearing.toFixed(2) + ').')
    });
  } else {
    qs.push({
      q: L3('Зачем нужен floor price?', 'What is the floor price for?', 'Po co jest floor price?'),
      options: [L3('Минимальная цена, ниже которой паблишер не продаёт', 'Minimum price below which the publisher will not sell', 'Cena minimalna, poniżej której wydawca nie sprzeda'), L3('Максимальная ставка DSP', 'Maximum DSP bid', 'Maksymalna oferta DSP'), L3('Комиссия биржи', 'Exchange fee', 'Prowizja giełdy'), L3('Цена данных DMP', 'Price of DMP data', 'Cena danych DMP')],
      correct: 0,
      why: L3('Floor price — минимальная цена показа; ставки ниже неё отбрасываются.', 'The floor price is the minimum; bids below it are discarded.', 'Floor price to cena minimalna odsłony; oferty poniżej są odrzucane.')
    });
  }
  return qs;
}
function Quiz({
  open,
  onClose,
  auction
}) {
  const [i, setI] = React.useState(0);
  const [pick, setPick] = React.useState(null);
  const [score, setScore] = React.useState(0);
  const qs = React.useMemo(() => buildQuiz(auction), [auction, open]);
  React.useEffect(() => {
    if (open) {
      setI(0);
      setPick(null);
      setScore(0);
    }
  }, [open]);
  if (!open || !qs.length) return null;
  const done = i >= qs.length;
  const cur = qs[i];
  const choose = k => {
    if (pick != null) return;
    setPick(k);
    if (k === cur.correct) setScore(s => s + 1);
  };
  const next = () => {
    setPick(null);
    setI(x => x + 1);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "compare-overlay",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "quiz-modal",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "dive-close",
    onClick: onClose
  }, "\xD7"), !done ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "quiz-step"
  }, L3('Вопрос', 'Question', 'Pytanie'), " ", i + 1, " / ", qs.length), /*#__PURE__*/React.createElement("div", {
    className: "quiz-q"
  }, cur.q), /*#__PURE__*/React.createElement("div", {
    className: "quiz-opts"
  }, cur.options.map((o, k) => {
    const state = pick == null ? '' : k === cur.correct ? ' ok' : k === pick ? ' bad' : ' mute';
    return /*#__PURE__*/React.createElement("button", {
      key: k,
      className: 'quiz-opt' + state,
      onClick: () => choose(k)
    }, o);
  })), pick != null && /*#__PURE__*/React.createElement("div", {
    className: "quiz-why"
  }, /*#__PURE__*/React.createElement("b", null, pick === cur.correct ? L3('Верно. ', 'Correct. ', 'Dobrze. ') : L3('Не совсем. ', 'Not quite. ', 'Niezupełnie. ')), cur.why, /*#__PURE__*/React.createElement("button", {
    className: "quiz-next",
    onClick: next
  }, i < qs.length - 1 ? L3('Дальше', 'Next', 'Dalej') : L3('Итог', 'Result', 'Wynik')))) : /*#__PURE__*/React.createElement("div", {
    className: "quiz-result"
  }, /*#__PURE__*/React.createElement("div", {
    className: "quiz-score"
  }, score, " / ", qs.length), /*#__PURE__*/React.createElement("div", {
    className: "quiz-rtext"
  }, score === qs.length ? L3('Идеально! Ты понял весь цикл RTB.', 'Perfect! You understand the whole RTB cycle.', 'Idealnie! Rozumiesz cały cykl RTB.') : score >= qs.length - 1 ? L3('Почти отлично — мелочи дотянуть.', 'Almost perfect — just a detail to polish.', 'Prawie idealnie — drobiazg do dopracowania.') : L3('Неплохо для старта. Пройди тур и попробуй снова.', 'A good start. Take the tour and try again.', 'Niezły start. Przejdź tour i spróbuj ponownie.')), /*#__PURE__*/React.createElement("button", {
    className: "quiz-next",
    onClick: onClose
  }, L3('Закрыть', 'Close', 'Zamknij')))));
}

// ───────────────────────── Complexity modes ─────────────────────────
// A starting point, not a lock: every switch stays editable afterwards, and the panel deliberately
// stays OPEN when a mode is applied so you can watch the toggles flip and then adjust pointwise.
// "Simple" turns whole nodes off, which also drops their stages (verify / enrich / track) — 11 steps
// become 8, so a beginner sees the spine: publisher → SSP → auction → DSP → render.
const MODES = [{
  id: 'simple',
  ru: 'Простой',
  en: 'Simple',
  pl: 'Prosty',
  ru_d: 'Костяк без надстроек: 8 шагов вместо 11, минимум участников.',
  en_d: 'The spine only: 8 steps instead of 11, fewest participants.',
  pl_d: 'Sam szkielet: 8 kroków zamiast 11, minimum uczestników.',
  tweaks: {
    nodeVerifier: false,
    nodeDmp: false,
    nodeTracking: false,
    nodeAdServer: false,
    sspCount: '1',
    dspCount: '2',
    dealType: 'open',
    auctionType: '1-я цена',
    supplyPath: 'header',
    floor: 1.5,
    dmpOn: false,
    cookieless: false,
    consent: true,
    resellerHop: false,
    threat: false,
    depth: 'novice',
    device: 'desktop',
    format: 'display'
  }
}, {
  id: 'full',
  ru: 'Полный',
  en: 'Full',
  pl: 'Pełny',
  ru_d: 'Вся экосистема: верификация, данные, трекинг, максимум SSP и DSP, PRO-пояснения.',
  en_d: 'The whole ecosystem: verification, data, tracking, max SSPs and DSPs, PRO notes.',
  pl_d: 'Cały ekosystem: weryfikacja, dane, śledzenie, maksimum SSP i DSP, notatki PRO.',
  tweaks: {
    nodeVerifier: true,
    nodeDmp: true,
    nodeTracking: true,
    nodeAdServer: true,
    sspCount: '3',
    dspCount: '6',
    dealType: 'open',
    auctionType: '1-я цена',
    supplyPath: 'header',
    floor: 1.5,
    dmpOn: true,
    cookieless: false,
    consent: true,
    resellerHop: false,
    threat: false,
    depth: 'pro',
    device: 'desktop',
    format: 'display'
  }
}];

// ───────────────────────── Scenario presets ─────────────────────────
const PRESETS = [{
  id: 'retarget',
  ru: 'Ретаргетинг догоняет',
  en: 'Retargeting catches up',
  pl: 'Retargeting dogania',
  ru_d: 'DMP узнаёт пользователя — ставка ретаргетинга взлетает.',
  en_d: 'DMP recognizes the user — the retargeting bid spikes.',
  pl_d: 'DMP rozpoznaje użytkownika — oferta retargetingu skacze.',
  tweaks: {
    nodeDmp: true,
    dmpOn: true,
    cookieless: false,
    dealType: 'open',
    supplyPath: 'header',
    auctionType: '1-я цена',
    threat: false,
    nodeVerifier: true,
    dspCount: '3',
    device: 'desktop',
    format: 'display'
  }
}, {
  id: 'brand',
  ru: 'Брендовая кампания',
  en: 'Brand campaign',
  pl: 'Kampania brandowa',
  ru_d: 'Видео на CTV, высокий CPM, бренд платит за охват.',
  en_d: 'Video on CTV, high CPM, the brand pays for reach.',
  pl_d: 'Wideo na CTV, wysoki CPM, marka płaci za zasięg.',
  tweaks: {
    nodeDmp: true,
    dmpOn: true,
    cookieless: false,
    dealType: 'preferred',
    supplyPath: 'header',
    auctionType: '1-я цена',
    threat: false,
    nodeVerifier: true,
    dspCount: '4',
    device: 'ctv',
    format: 'video'
  }
}, {
  id: 'cookieless',
  ru: 'Cookieless-мир',
  en: 'Cookieless world',
  pl: 'Świat cookieless',
  ru_d: 'Без 3P cookie match-rate падает, ставки ниже.',
  en_d: 'Without 3P cookies match-rate drops and bids fall.',
  pl_d: 'Bez 3P cookie match-rate spada, oferty niższe.',
  tweaks: {
    nodeDmp: true,
    dmpOn: true,
    cookieless: true,
    dealType: 'open',
    supplyPath: 'header',
    auctionType: '1-я цена',
    threat: false,
    nodeVerifier: true,
    dspCount: '3',
    device: 'mobile',
    format: 'display'
  }
}, {
  id: 'fraud',
  ru: 'Fraud заблокирован',
  en: 'Fraud blocked',
  pl: 'Fraud zablokowany',
  ru_d: 'Верификатор ловит бота и снимает показ с аукциона.',
  en_d: 'The verifier catches a bot and pulls the impression.',
  pl_d: 'Weryfikator łapie bota i zdejmuje odsłonę z aukcji.',
  tweaks: {
    nodeVerifier: true,
    threat: true,
    nodeDmp: true,
    dmpOn: true,
    cookieless: false,
    dealType: 'open',
    supplyPath: 'header',
    auctionType: '1-я цена',
    dspCount: '3',
    device: 'desktop',
    format: 'display'
  }
}];
Object.assign(window, {
  Tour,
  Compare,
  Session,
  Glossary,
  buildLog,
  RunLog,
  DemoCaption,
  Quiz,
  PRESETS,
  MODES
});

;
/* RTB Engine — Ad-fraud layer (overlay on the chain) + Fraud & verification module.
   Trilingual via window.L. Keeps the engine aesthetic. */
const FL = (ru, en, pl) => window.L(ru, en, pl);

// ─────────────────────── Overlay: where fraud appears on the chain ───────────────────────
// node = id of a node in the live model; placed as a ⚠ badge near it.
const FRAUD_HOPS = [{
  node: 'user',
  key: 'bot',
  t: () => FL('Bot traffic / Device farms', 'Bot traffic / Device farms', 'Bot traffic / Device farms'),
  d: () => FL('«Пользователь» может быть ботом или фермой реальных устройств: трафик есть, человека нет.', 'The "user" may be a bot or a farm of real devices: there is traffic, but no human.', '„Użytkownik” może być botem lub farmą prawdziwych urządzeń: ruch jest, człowieka brak.'),
  scheme: () => [[FL('Реальный человек', 'Real user', 'Realny człowiek'), FL('скроллит · кликает · читает', 'scrolls · clicks · reads', 'scrolluje · klika · czyta')], [FL('Бот / ферма', 'Bot / farm', 'Bot / farma'), FL('24/7 · идеальный тайминг · 0 вовлечения', '24/7 · perfect timing · 0 engagement', '24/7 · idealny timing · 0 zaangażowania')]]
}, {
  node: 'publisher',
  key: 'mfa',
  t: () => FL('MFA — сайты для рекламы', 'MFA — made-for-advertising', 'MFA — strony pod reklamę'),
  d: () => FL('Made-for-advertising: сайт существует только ради показов — мусорный контент, груда баннеров.', 'Made-for-advertising: the site exists only for impressions — junk content, a wall of ad slots.', 'Made-for-advertising: strona istnieje tylko dla odsłon — śmieciowa treść, ściana reklam.'),
  scheme: () => [[FL('Премиум-сайт', 'Premium site', 'Strona premium'), FL('качественный контент', 'quality content', 'jakościowa treść')], [FL('MFA-сайт', 'MFA site', 'Strona MFA'), FL('авто-рефреш · 10+ слотов · clickbait', 'auto-refresh · 10+ slots · clickbait', 'auto-odświeżanie · 10+ slotów · clickbait')]]
}, {
  node: 'ssp0',
  key: 'supplypath',
  t: () => FL('Supply-path fraud', 'Supply-path fraud', 'Supply-path fraud'),
  d: () => FL('Лишние перепродавцы в цепочке: непрозрачные посредники накручивают и прячут источник инвентаря.', 'Extra resellers in the chain: opaque intermediaries inflate and hide the inventory source.', 'Zbędni resellerzy w łańcuchu: nieprzejrzyści pośrednicy zawyżają i ukrywają źródło powierzchni.'),
  scheme: () => [[FL('Прямой путь', 'Direct path', 'Bezpośrednia ścieżka'), 'Publisher → SSP → Exchange'], [FL('Мутный путь', 'Murky path', 'Mętna ścieżka'), 'Publisher → ? → ? → reseller → Exchange']]
}, {
  node: 'exchange',
  key: 'spoof',
  t: () => FL('Domain / App spoofing', 'Domain / App spoofing', 'Domain / App spoofing'),
  d: () => FL('Домен или bundle ID подменяют выше по цепочке (паблишер/реселлер): в bid request, который видят биржа и DSP, стоит cnn.com или Spotify, а на деле это спам-сайт или fake APK. Биржа и DSP здесь — жертвы.', 'The domain or bundle ID is faked upstream (publisher/reseller): the bid request the exchange and DSP see says cnn.com or Spotify, but it is really a spam site or fake APK. The exchange and DSP are the victims here.', 'Domenę lub bundle ID podmienia się wyżej w łańcuchu (wydawca/reseller): w bid request, który widzą giełda i DSP, jest cnn.com lub Spotify, a naprawdę to spam-strona lub fałszywy APK. Giełda i DSP są tu ofiarami.'),
  scheme: () => [[FL('DSP видит', 'DSP sees', 'DSP widzi'), 'cnn.com · Spotify'], [FL('На самом деле', 'Actually', 'W rzeczywistości'), 'cheap-spam.site · fake.apk']]
}, {
  node: 'tracking',
  key: 'attribution',
  t: () => FL('Attribution fraud', 'Attribution fraud', 'Attribution fraud'),
  d: () => FL('Click injection / SDK spoofing: фейковый клик или поддельные события приписывают установку фродстеру — рекламодатель платит за чужую конверсию.', 'Click injection / SDK spoofing: a fake click or forged events attribute the install to the fraudster — the advertiser pays for a stolen conversion.', 'Click injection / SDK spoofing: fałszywy klik lub podrobione zdarzenia przypisują instalację oszustowi — reklamodawca płaci za cudzą konwersję.'),
  scheme: () => [[FL('Честно', 'Honest', 'Uczciwie'), FL('клик → установка → открытие → покупка', 'click → install → open → buy', 'klik → instalacja → otwarcie → zakup')], [FL('Фрод', 'Fraud', 'Fraud'), FL('фейк-клик → установка → украл атрибуцию', 'fake click → install → stole attribution', 'fałszywy klik → instalacja → ukradł atrybucję')]]
}];
function FraudBadge({
  hop,
  node,
  active,
  onClick
}) {
  if (!node) return null;
  const left = node.x + node.w / 2 - 30;
  const top = node.y - node.h / 2 - 12;
  return /*#__PURE__*/React.createElement("button", {
    className: 'fraud-badge' + (active ? ' active' : ''),
    style: {
      left,
      top
    },
    onClick: e => {
      e.stopPropagation();
      onClick(hop.key);
    },
    "aria-label": hop.t(),
    title: hop.t()
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3 3.2 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.2a2 2 0 0 0-3.4 0Z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v5M12 17.5h.01",
    strokeLinecap: "round"
  })));
}
function FraudOverlay({
  active,
  nodes,
  openKey,
  onOpen,
  onClose,
  onOpenSim
}) {
  if (!active) return null;
  const hop = FRAUD_HOPS.find(h => h.key === openKey);
  return /*#__PURE__*/React.createElement(React.Fragment, null, FRAUD_HOPS.map(h => /*#__PURE__*/React.createElement(FraudBadge, {
    key: h.key,
    hop: h,
    node: nodes[h.node],
    active: openKey === h.key,
    onClick: onOpen
  })), hop && /*#__PURE__*/React.createElement("div", {
    className: "fraud-pop",
    role: "dialog",
    "aria-label": hop.t(),
    style: popPos(nodes[hop.node]),
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "panel-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "fraud-pop-tag"
  }, FL('Риск фрода', 'Fraud risk', 'Ryzyko fraudu')), /*#__PURE__*/React.createElement("div", {
    className: "fraud-pop-t"
  }, hop.t()), /*#__PURE__*/React.createElement("div", {
    className: "fraud-pop-d"
  }, hop.d()), /*#__PURE__*/React.createElement("div", {
    className: "fraud-scheme"
  }, hop.scheme().map((row, i) => /*#__PURE__*/React.createElement("div", {
    className: 'fraud-row' + (i === 1 ? ' bad' : ' good'),
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "fraud-row-k"
  }, row[0]), /*#__PURE__*/React.createElement("span", {
    className: "fraud-row-v"
  }, row[1])))), onOpenSim && HOP2ATTACK[hop.key] && /*#__PURE__*/React.createElement("button", {
    className: "fraud-pop-sim",
    onClick: () => onOpenSim(HOP2ATTACK[hop.key])
  }, FL('Симулировать защиту', 'Simulate defenses', 'Symuluj ochronę'), " \u2192")));
}
function popPos(node) {
  if (!node) return {
    left: 200,
    top: 120
  };
  let left = node.x + node.w / 2 + 14;
  let top = node.y - node.h / 2;
  if (left + 300 > 1440) left = node.x - node.w / 2 - 314;
  if (left < 8) left = 8;
  if (top + 250 > 760) top = 760 - 250;
  if (top < 8) top = 8;
  return {
    left,
    top
  };
}

// ─────────────────────── Module: Fraud & verification ───────────────────────
const FRAUD_TYPES = [['Bot traffic', '#fb7185'], ['Click fraud', '#fb923c'], ['Domain spoofing', '#fbbf24'], ['App spoofing', '#a78bfa'], ['SDK spoofing', '#67e8f9'], ['CTV fraud', '#34d399'], ['App spoofing', '#a78bfa'], ['SDK spoofing', '#67e8f9'], ['CTV fraud', '#34d399'], ['Device farms', '#f472b6'], ['Attribution fraud', '#7aa2ff']];
const DETECT_SIGNALS = [() => FL('IP-репутация', 'IP reputation', 'Reputacja IP'), () => FL('Сигналы устройства', 'Device signals', 'Sygnały urządzenia'), () => FL('Гео', 'Geo', 'Geo'), () => 'User-Agent', () => FL('Поведение', 'Behavior', 'Zachowanie'), () => FL('Путь поставки', 'Supply path', 'Ścieżka dostawy'), () => FL('История', 'Historical data', 'Dane historyczne')];
const SCORE_BANDS = [[0, 20, '#34d399', () => FL('Безопасно', 'Safe', 'Bezpieczne')], [20, 40, '#a3e635', () => FL('Низкий риск', 'Low risk', 'Niskie ryzyko')], [40, 60, '#fbbf24', () => FL('Средний риск', 'Medium risk', 'Średnie ryzyko')], [60, 80, '#fb923c', () => FL('Высокий риск', 'High risk', 'Wysokie ryzyko')], [80, 100, '#fb7185', () => FL('Фрод', 'Fraud', 'Fraud')]];

// ── Simulation: same attack, different defenses → different outcome ──
const SIM_DEFENSES = [{
  id: 'ip',
  n: () => FL('IP-репутация', 'IP reputation', 'Reputacja IP')
}, {
  id: 'device',
  n: () => FL('Сигналы устройства', 'Device signals', 'Sygnały urządzenia')
}, {
  id: 'behavior',
  n: () => FL('Поведенческий анализ', 'Behavioral analysis', 'Analiza behawioralna')
}, {
  id: 'supply',
  n: () => FL('Supply-chain (ads.txt / schain)', 'Supply-chain (ads.txt / schain)', 'Supply-chain (ads.txt / schain)')
}, {
  id: 'attribution',
  n: () => FL('MMP / SDK-валидация', 'MMP / SDK validation', 'Walidacja MMP / SDK')
}];
// each attack: legit? + which defenses detect it and how strongly
const SIM_ATTACKS = [{
  id: 'clean',
  legit: true,
  base: 8,
  detect: {},
  n: () => FL('Чистый трафик', 'Clean traffic', 'Czysty ruch'),
  d: () => FL('Настоящий человек на легальном сайте.', 'A real human on a legitimate site.', 'Prawdziwy człowiek na legalnej stronie.')
}, {
  id: 'bot',
  legit: false,
  base: 14,
  detect: {
    ip: 34,
    device: 28,
    behavior: 40
  },
  n: () => FL('Bot traffic', 'Bot traffic', 'Bot traffic'),
  d: () => FL('Скрипт имитирует пользователя — ловится по IP, устройству и поведению.', 'A script imitates a user — caught by IP, device and behavior.', 'Skrypt udaje użytkownika — wykrywany po IP, urządzeniu i zachowaniu.')
}, {
  id: 'devicefarm',
  legit: false,
  base: 18,
  detect: {
    ip: 30,
    behavior: 44
  },
  n: () => FL('Device farm', 'Device farm', 'Device farm'),
  d: () => FL('Реальные устройства, но фермерское поведение — поведенческий анализ ключевой.', 'Real devices but farm-like behavior — behavioral analysis is key.', 'Prawdziwe urządzenia, ale zachowanie farmy — kluczowa analiza behawioralna.')
}, {
  id: 'mfa',
  legit: false,
  base: 16,
  detect: {
    supply: 40,
    behavior: 34
  },
  n: () => FL('MFA — сайт под рекламу', 'MFA — made-for-advertising', 'MFA — strona pod reklamę'),
  d: () => FL('Сайт ради показов: ловится прозрачностью цепочки и поведением.', 'A site built for impressions: caught by supply-chain transparency and behavior.', 'Strona dla odsłon: łapana przez przejrzystość łańcucha i zachowanie.')
}, {
  id: 'supplypath',
  legit: false,
  base: 14,
  detect: {
    supply: 64
  },
  n: () => FL('Supply-path fraud', 'Supply-path fraud', 'Supply-path fraud'),
  d: () => FL('Лишние перепродавцы — ловит только supply-chain (sellers.json / schain).', 'Extra resellers — only supply-chain (sellers.json / schain) catches it.', 'Zbędni resellerzy — łapie tylko supply-chain (sellers.json / schain).')
}, {
  id: 'domainspoof',
  legit: false,
  base: 12,
  detect: {
    supply: 60
  },
  n: () => FL('Domain spoofing', 'Domain spoofing', 'Domain spoofing'),
  d: () => FL('Подменён домен — ловит только прозрачность цепочки (ads.txt / schain).', 'Faked domain — only supply-chain transparency catches it.', 'Podmieniona domena — łapie tylko przejrzystość łańcucha.')
}, {
  id: 'clickinj',
  legit: false,
  base: 12,
  detect: {
    attribution: 58
  },
  n: () => FL('Click injection', 'Click injection', 'Click injection'),
  d: () => FL('Мобильный фрод атрибуции — ловит только MMP/SDK-валидация.', 'Mobile attribution fraud — only MMP/SDK validation catches it.', 'Mobilny fraud atrybucji — łapie tylko walidacja MMP/SDK.')
}];
const SIM_PRESETS = [{
  id: 'none',
  defs: [],
  n: () => FL('Без защиты', 'No protection', 'Bez ochrony')
}, {
  id: 'basic',
  defs: ['ip'],
  n: () => FL('Базовая', 'Basic', 'Podstawowa')
}, {
  id: 'std',
  defs: ['ip', 'device', 'behavior'],
  n: () => FL('Стандарт', 'Standard', 'Standard')
}, {
  id: 'adv',
  defs: ['ip', 'device', 'behavior', 'supply', 'attribution'],
  n: () => FL('Максимум', 'Advanced', 'Zaawansowana')
}];
// overlay hop key → sim attack id (1:1)
const HOP2ATTACK = {
  bot: 'bot',
  mfa: 'mfa',
  supplypath: 'supplypath',
  spoof: 'domainspoof',
  attribution: 'clickinj'
};
function simScore(attack, defIds) {
  let s = attack.base;
  defIds.forEach(id => {
    if (attack.detect[id]) s += attack.detect[id];
  });
  return Math.min(100, s);
}
function simVerdict(sc) {
  return sc < 40 ? 'allow' : sc < 60 ? 'review' : 'block';
}
function FraudSim({
  seed
}) {
  const [attackId, setAttackId] = React.useState('bot');
  const [defs, setDefs] = React.useState({
    ip: true,
    device: true,
    behavior: true,
    supply: false,
    attribution: false
  });
  const [running, setRunning] = React.useState(false);
  const [stepIx, setStepIx] = React.useState(-1); // index into enabled defense order
  const [score, setScore] = React.useState(null);
  const [batch, setBatch] = React.useState(false);
  const timer = React.useRef(null);
  const attack = SIM_ATTACKS.find(a => a.id === attackId);
  const enabled = SIM_DEFENSES.filter(d => defs[d.id]);
  const idle = !running && stepIx < 0; // before any run → show "who catches"
  const catchers = SIM_DEFENSES.filter(d => attack.detect[d.id]);
  React.useEffect(() => () => {
    if (timer.current) clearInterval(timer.current);
  }, []);
  React.useEffect(() => {
    if (seed && SIM_ATTACKS.some(a => a.id === seed)) {
      setAttackId(seed);
      setRunning(false);
      setStepIx(-1);
      setScore(null);
    }
  }, [seed]);
  const reset = () => {
    if (timer.current) clearInterval(timer.current);
    setRunning(false);
    setStepIx(-1);
    setScore(null);
  };
  const toggle = id => {
    reset();
    setDefs(d => ({
      ...d,
      [id]: !d[id]
    }));
  };
  const applyPreset = p => {
    reset();
    const m = {};
    SIM_DEFENSES.forEach(d => {
      m[d.id] = p.defs.includes(d.id);
    });
    setDefs(m);
  };
  const finalScore = () => {
    let s = attack.base;
    enabled.forEach(d => {
      if (attack.detect[d.id]) s += attack.detect[d.id];
    });
    return Math.min(100, s);
  };
  const run = () => {
    if (timer.current) clearInterval(timer.current);
    setRunning(true);
    setScore(attack.base);
    setStepIx(0);
    let i = 0;
    timer.current = setInterval(() => {
      if (i >= enabled.length) {
        clearInterval(timer.current);
        timer.current = null;
        setRunning(false);
        setScore(finalScore());
        setStepIx(enabled.length);
        return;
      }
      const d = enabled[i];
      setScore(s => Math.min(100, s + (attack.detect[d.id] || 0)));
      i += 1;
      setStepIx(i);
    }, 560);
  };
  const done = !running && stepIx >= 0;
  const sc = score == null ? attack.base : score;
  const band = SCORE_BANDS.find(b => sc >= b[0] && sc < b[1]) || SCORE_BANDS[SCORE_BANDS.length - 1];
  const verdict = sc < 40 ? 'allow' : sc < 60 ? 'review' : 'block';
  const vLabel = verdict === 'allow' ? FL('Пропущен', 'Allowed', 'Przepuszczony') : verdict === 'review' ? FL('На проверку', 'Review', 'Do przeglądu') : FL('Заблокирован', 'Blocked', 'Zablokowany');
  // missing defense that would catch this fraud
  const missing = !attack.legit ? SIM_DEFENSES.filter(d => attack.detect[d.id] && !defs[d.id]) : [];
  let outcome = null;
  if (done) {
    if (attack.legit) outcome = {
      ok: true,
      t: FL('Настоящий пользователь обслужен верно — показ продан.', 'Real user served correctly — impression sold.', 'Prawdziwy użytkownik obsłużony poprawnie — odsłona sprzedana.')
    };else if (verdict === 'block') outcome = {
      ok: true,
      t: FL('Фрод пойман и заблокирован — рекламодатель не заплатил.', 'Fraud caught and blocked — the advertiser did not pay.', 'Fraud złapany i zablokowany — reklamodawca nie zapłacił.')
    };else if (verdict === 'review') outcome = {
      ok: null,
      t: FL('Подозрительно — отправлено на ручную проверку.', 'Suspicious — sent to manual review.', 'Podejrzane — wysłane do ręcznej weryfikacji.')
    };else outcome = {
      ok: false,
      t: FL('Фрод проскочил — рекламодатель заплатил за фейковый трафик.', 'Fraud slipped through — the advertiser paid for fake traffic.', 'Fraud się prześlizgnął — reklamodawca zapłacił za fałszywy ruch.')
    };
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "fsim"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fsim-controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fsim-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, FL('Атака', 'Attack', 'Atak')), /*#__PURE__*/React.createElement("div", {
    className: "fsim-chips"
  }, SIM_ATTACKS.map(a => /*#__PURE__*/React.createElement("button", {
    key: a.id,
    className: 'fsim-chip' + (attackId === a.id ? ' on' : '') + (a.legit ? ' clean' : ''),
    onClick: () => {
      reset();
      setAttackId(a.id);
    }
  }, a.n()))), /*#__PURE__*/React.createElement("div", {
    className: "fsim-adesc"
  }, attack.d()), !attack.legit && /*#__PURE__*/React.createElement("div", {
    className: "fsim-catchers"
  }, FL('Ловят', 'Caught by', 'Łapią'), ": ", catchers.length ? catchers.map((c, i) => /*#__PURE__*/React.createElement("span", {
    key: c.id,
    className: 'fsim-cb' + (defs[c.id] ? ' on' : '')
  }, c.n())) : /*#__PURE__*/React.createElement("span", {
    className: "fsim-cb"
  }, "\u2014"))), /*#__PURE__*/React.createElement("div", {
    className: "fsim-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, FL('Уровень защиты', 'Protection level', 'Poziom ochrony')), /*#__PURE__*/React.createElement("div", {
    className: "fsim-chips"
  }, SIM_PRESETS.map(p => {
    const onp = SIM_DEFENSES.every(d => defs[d.id] === p.defs.includes(d.id));
    return /*#__PURE__*/React.createElement("button", {
      key: p.id,
      className: 'fsim-chip preset' + (onp ? ' on' : ''),
      onClick: () => applyPreset(p)
    }, p.n());
  })))), /*#__PURE__*/React.createElement("div", {
    className: "fsim-defs"
  }, SIM_DEFENSES.map((d, i) => {
    const on = defs[d.id];
    const orderIx = enabled.findIndex(e => e.id === d.id);
    const reached = on && stepIx > orderIx;
    const active = on && running && stepIx === orderIx;
    const caught = reached && attack.detect[d.id];
    return /*#__PURE__*/React.createElement("button", {
      key: d.id,
      className: 'fsim-def' + (on ? ' on' : '') + (active ? ' active' : '') + (caught ? ' caught' : '') + (reached && !caught ? ' pass' : '') + (idle && attack.detect[d.id] ? ' would' : ''),
      onClick: () => toggle(d.id)
    }, /*#__PURE__*/React.createElement("span", {
      className: "fsim-def-dot"
    }), /*#__PURE__*/React.createElement("span", {
      className: "fsim-def-n"
    }, d.n()), caught ? /*#__PURE__*/React.createElement("span", {
      className: "fsim-def-tag bad"
    }, "+", attack.detect[d.id]) : reached ? /*#__PURE__*/React.createElement("span", {
      className: "fsim-def-tag ok"
    }, "\u2713") : idle && attack.detect[d.id] ? /*#__PURE__*/React.createElement("span", {
      className: "fsim-def-tag would"
    }, FL('ловит', 'catches', 'łapie')) : /*#__PURE__*/React.createElement("span", {
      className: "fsim-def-tag mute"
    }, on ? FL('вкл', 'on', 'wł') : FL('выкл', 'off', 'wył')));
  })), /*#__PURE__*/React.createElement("div", {
    className: "fsim-foot"
  }, /*#__PURE__*/React.createElement("button", {
    className: "fsim-run",
    onClick: run,
    disabled: running
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5l12 7-12 7z"
  })), running ? FL('Идёт…', 'Running…', 'Trwa…') : done ? FL('Ещё раз', 'Replay', 'Jeszcze raz') : FL('Запустить показ', 'Run impression', 'Uruchom odsłonę')), /*#__PURE__*/React.createElement("div", {
    className: "fsim-meter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fsim-meter-top"
  }, /*#__PURE__*/React.createElement("span", null, "Fraud score"), /*#__PURE__*/React.createElement("b", {
    style: {
      color: band[2]
    }
  }, Math.round(sc))), /*#__PURE__*/React.createElement("div", {
    className: "fsim-bar"
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      width: sc + '%',
      background: band[2]
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'fsim-verdict ' + verdict
  }, vLabel)), outcome && /*#__PURE__*/React.createElement("div", {
    className: 'fsim-outcome' + (outcome.ok === true ? ' good' : outcome.ok === false ? ' bad' : ' warn')
  }, outcome.t, outcome.ok === false && missing.length > 0 && /*#__PURE__*/React.createElement("span", {
    className: "fsim-hint"
  }, " ", FL('Включи', 'Enable', 'Włącz'), ": ", /*#__PURE__*/React.createElement("b", null, missing.map(m => m.n()).join(', ')))), /*#__PURE__*/React.createElement("button", {
    className: "fsim-batch-toggle",
    onClick: () => setBatch(b => !b)
  }, batch ? FL('Скрыть сравнение', 'Hide comparison', 'Ukryj porównanie') : FL('Сравнить все уровни защиты →', 'Compare all protection levels →', 'Porównaj wszystkie poziomy →')), batch && /*#__PURE__*/React.createElement("div", {
    className: "fsim-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fsim-trow fsim-th"
  }, /*#__PURE__*/React.createElement("span", null, FL('Защита', 'Protection', 'Ochrona')), /*#__PURE__*/React.createElement("span", null, "Score"), /*#__PURE__*/React.createElement("span", null, FL('Итог', 'Verdict', 'Werdykt'))), SIM_PRESETS.map(p => {
    const s = simScore(attack, p.defs);
    const v = simVerdict(s);
    const vl = v === 'allow' ? FL('Пропущен', 'Allowed', 'Przepuszczony') : v === 'review' ? FL('Проверка', 'Review', 'Przegląd') : FL('Блок', 'Blocked', 'Blok');
    const bb = SCORE_BANDS.find(b => s >= b[0] && s < b[1]) || SCORE_BANDS[SCORE_BANDS.length - 1];
    return /*#__PURE__*/React.createElement("div", {
      className: "fsim-trow",
      key: p.id
    }, /*#__PURE__*/React.createElement("span", {
      className: "fsim-tp"
    }, p.n(), /*#__PURE__*/React.createElement("i", null, p.defs.length, " ", FL('защит', 'defenses', 'ochron'))), /*#__PURE__*/React.createElement("span", {
      className: "fsim-tbar"
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        width: s + '%',
        background: bb[2]
      }
    }), /*#__PURE__*/React.createElement("b", {
      style: {
        color: bb[2]
      }
    }, s)), /*#__PURE__*/React.createElement("span", {
      className: 'fsim-tv ' + v
    }, vl));
  }), !attack.legit && /*#__PURE__*/React.createElement("div", {
    className: "fsim-tnote"
  }, FL('Чем больше защит — тем выше score и раньше блок. Слабая защита пропускает фрод.', 'More defenses → higher score and an earlier block. Weak protection lets fraud through.', 'Więcej ochron → wyższy score i wcześniejszy blok. Słaba ochrona przepuszcza fraud.'))));
}

// interactive type detail: def + "how it works" steps + how it's caught + good/bad illustration
const FRAUD_TYPE_DETAIL = [{
  id: 'bot',
  c: '#fb7185',
  icon: 'bot',
  n: () => FL('Bot vs человек', 'Bot vs human', 'Bot vs człowiek'),
  def: () => FL('Скрипт изображает пользователя: грузит страницу, «кликает», но не читает и не покупает — трафик есть, человека нет.', 'A script imitates a user: it loads the page and "clicks", but never reads or buys — there is traffic, no human.', 'Skrypt udaje użytkownika: ładuje stronę i „klika”, ale nie czyta ani nie kupuje — ruch jest, człowieka brak.'),
  vs: [['Человек', 'скроллит · читает · покупает · паузы', 'Real human', 'scrolls · reads · buys · pauses', 'Człowiek', 'przewija · czyta · kupuje · pauzy'], ['Бот', '24/7 · идеальный тайминг · 0 вовлечения', 'Bot', '24/7 · perfect timing · 0 engagement', 'Bot', '24/7 · idealny timing · 0 zaangażowania']],
  catch: () => FL('Ловит поведенческий анализ + IP-репутация.', 'Caught by behavioral analysis + IP reputation.', 'Łapie analiza behawioralna + reputacja IP.')
}, {
  id: 'devicefarm',
  c: '#f472b6',
  icon: 'farm',
  n: () => FL('Device farm', 'Device farm', 'Device farm'),
  def: () => FL('Стеллажи с сотнями реальных телефонов крутят установки, клики и показы. Не бот — настоящие устройства, поэтому device-сигналы чистые.', 'Racks of hundreds of real phones spin installs, clicks and impressions. Not a bot — real devices, so device signals look clean.', 'Regały z setkami prawdziwych telefonów generują instalacje, kliknięcia i odsłony. Nie bot — prawdziwe urządzenia, więc sygnały urządzeń są czyste.'),
  steps: [['📱×500', () => FL('ферма устройств', 'device farm', 'farma urządzeń')], ['→', () => FL('installs · clicks · opens', 'installs · clicks · opens', 'installs · clicks · opens')], ['→', () => FL('фейковая активность', 'fake activity', 'fałszywa aktywność')]],
  catch: () => FL('Ловит поведение (нет нормальной вовлечённости) и аномалии по гео/времени.', 'Caught by behavior (no real engagement) and geo/time anomalies.', 'Łapie zachowanie (brak realnego zaangażowania) i anomalie geo/czasu.')
}, {
  id: 'domainspoof',
  c: '#fbbf24',
  icon: 'swap',
  n: () => FL('Domain spoofing', 'Domain spoofing', 'Domain spoofing'),
  def: () => FL('В bid request подменяют домен: DSP думает, что покупает премиум (cnn.com), а показ идёт на дешёвом спам-сайте.', 'The bid request fakes the domain: the DSP thinks it buys premium (cnn.com), but the ad runs on a cheap spam site.', 'Bid request podmienia domenę: DSP myśli, że kupuje premium (cnn.com), a reklama trafia na tanią spam-stronę.'),
  vs: [['DSP видит', 'cnn.com · premium', 'DSP sees', 'cnn.com · premium', 'DSP widzi', 'cnn.com · premium'], ['На самом деле', 'cheap-spam.site', 'Actually', 'cheap-spam.site', 'Naprawdę', 'cheap-spam.site']],
  catch: () => FL('Ловит supply-chain: ads.txt / sellers.json / schain.', 'Caught by supply-chain: ads.txt / sellers.json / schain.', 'Łapie supply-chain: ads.txt / sellers.json / schain.')
}, {
  id: 'appspoof',
  c: '#a78bfa',
  icon: 'swap',
  n: () => FL('App spoofing', 'App spoofing', 'App spoofing'),
  def: () => FL('Подменяют bundle ID приложения: DSP думает, что показ в Spotify, а это fake APK с накрученным трафиком.', 'The app bundle ID is faked: the DSP thinks the ad is in Spotify, but it is a fake APK with inflated traffic.', 'Podmienia się bundle ID aplikacji: DSP myśli, że reklama jest w Spotify, a to fałszywy APK ze sztucznym ruchem.'),
  vs: [['DSP думает', 'Spotify · Netflix · TikTok', 'DSP thinks', 'Spotify · Netflix · TikTok', 'DSP myśli', 'Spotify · Netflix · TikTok'], ['Реально', 'fake.apk', 'Actually', 'fake.apk', 'Naprawdę', 'fake.apk']],
  catch: () => FL('Ловит app-ads.txt и валидация bundle ID на стороне SSP/биржи.', 'Caught by app-ads.txt and bundle-ID validation on the SSP/exchange.', 'Łapie app-ads.txt i walidacja bundle ID po stronie SSP/giełdy.')
}, {
  id: 'sdkspoof',
  c: '#67e8f9',
  icon: 'server',
  n: () => FL('SDK spoofing', 'SDK spoofing', 'SDK spoofing'),
  def: () => FL('Сервер фродстера притворяется приложением и шлёт в MMP поддельные события (показы, клики, установки) без реальных пользователей.', 'The fraudster server pretends to be an app and sends the MMP forged events (impressions, clicks, installs) with no real users.', 'Serwer oszusta udaje aplikację i wysyła do MMP podrobione zdarzenia (odsłony, kliknięcia, instalacje) bez prawdziwych użytkowników.'),
  vs: [['Real app', 'SDK → MMP (честные события)', 'Real app', 'SDK → MMP (honest events)', 'Real app', 'SDK → MMP (uczciwe zdarzenia)'], ['Fraud server', 'fake SDK events → MMP', 'Fraud server', 'fake SDK events → MMP', 'Fraud server', 'fałszywe zdarzenia SDK → MMP']],
  catch: () => FL('Ловит MMP/SDK-валидация (подпись SDK, server-side проверки).', 'Caught by MMP/SDK validation (SDK signature, server-side checks).', 'Łapie walidacja MMP/SDK (podpis SDK, kontrole server-side).')
}, {
  id: 'clickinj',
  c: '#fb923c',
  icon: 'time',
  n: () => FL('Click injection', 'Click injection', 'Click injection'),
  def: () => FL('Вредоносное приложение ловит системный сигнал об установке (install broadcast / referrer) и в этот момент вбрасывает фейковый клик — last-click атрибуция уходит фродстеру.', 'A malicious app listens for the system install broadcast (install referrer) and injects a fake click in that window — last-click attribution goes to the fraudster.', 'Złośliwa aplikacja nasłuchuje systemowy sygnał instalacji (install broadcast / referrer) i w tym momencie wstrzykuje fałszywy klik — atrybucja last-click trafia do oszusta.'),
  steps: [['1', () => FL('юзер ставит app', 'user installs app', 'user instaluje app')], ['2', () => FL('fraud app шлёт fake click', 'fraud app sends fake click', 'fraud app wysyła fake click')], ['3', () => FL('MMP приписывает фродстеру', 'MMP attributes to fraudster', 'MMP przypisuje oszustowi')], ['4', () => FL('рекламодатель платит', 'advertiser pays', 'reklamodawca płaci')]],
  catch: () => FL('Ловит MMP: аномально короткий CTIT (click-to-install time).', 'Caught by the MMP: an abnormally short CTIT (click-to-install time).', 'Łapie MMP: nienaturalnie krótki CTIT (click-to-install time).')
}, {
  id: 'ctv',
  c: '#34d399',
  icon: 'tv',
  n: () => FL('CTV fraud', 'CTV fraud', 'CTV fraud'),
  def: () => FL('CTV — дорогой формат с высоким CPM, который трудно верифицировать: показ идёт server-side, без браузера и DOM, сигналы устройства и приложения непрозрачны. Фрод имитирует Smart TV: фейковые device ID, server-side «показы видео» без реального экрана.', 'CTV is a high-CPM format that is hard to verify: impressions are served server-side, with no browser or DOM, and device/app signals are opaque. Fraud imitates a smart TV: fake device IDs, server-side "video impressions" with no real screen.', 'CTV to drogi format z wysokim CPM, który trudno zweryfikować: odsłony idą server-side, bez przeglądarki i DOM, a sygnały urządzenia/aplikacji są nieprzejrzyste. Fraud udaje Smart TV: fałszywe device ID, server-side „odsłony wideo” bez realnego ekranu.'),
  vs: [['Real CTV', 'Smart TV · реальный экран · досмотр', 'Real CTV', 'smart TV · real screen · completion', 'Real CTV', 'smart TV · realny ekran · dokończenie'], ['Fraud', 'fake device ID · нет экрана · 100% completion', 'Fraud', 'fake device ID · no screen · 100% completion', 'Fraud', 'fake device ID · brak ekranu · 100% completion']],
  catch: () => FL('Ловит ads.txt для CTV, валидация device ID и подозрительный 100% completion rate.', 'Caught by CTV ads.txt, device-ID validation and a suspicious 100% completion rate.', 'Łapie ads.txt dla CTV, walidacja device ID i podejrzany 100% completion rate.')
}, {
  id: 'mfa',
  c: '#7aa2ff',
  icon: 'mfa',
  n: () => FL('MFA — сайты под рекламу', 'MFA — made-for-advertising', 'MFA — strony pod reklamę'),
  def: () => FL('Made-for-advertising: сайт существует только ради показов — копипаст-контент, авто-рефреш, по 10+ слотов на экран. Технически «настоящий», но мусорный.', 'Made-for-advertising: the site exists only for impressions — copy-paste content, auto-refresh, 10+ slots per screen. Technically "real" but junk.', 'Made-for-advertising: strona istnieje tylko dla odsłon — kopiuj-wklej treść, auto-odświeżanie, 10+ slotów na ekran. Technicznie „prawdziwa”, ale śmieciowa.'),
  vs: [['Premium', 'качественный контент · 1–2 слота', 'Premium', 'quality content · 1–2 slots', 'Premium', 'jakościowa treść · 1–2 sloty'], ['MFA', 'clickbait · auto-refresh · 10+ слотов', 'MFA', 'clickbait · auto-refresh · 10+ slots', 'MFA', 'clickbait · auto-refresh · 10+ slotów']],
  catch: () => FL('Ловит контент-анализ, списки MFA-доменов и аномальная плотность рекламы.', 'Caught by content analysis, MFA domain lists and abnormal ad density.', 'Łapie analiza treści, listy domen MFA i nienaturalna gęstość reklam.')
}];
const FT_ICONS = {
  bot: 'M12 2a4 4 0 0 1 4 4v1h1a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h1V6a4 4 0 0 1 4-4zM9 13h.01M15 13h.01',
  farm: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
  swap: 'M4 8h13l-3-3M20 16H7l3 3',
  server: 'M4 5h16v5H4zM4 14h16v5H4zM8 7.5h.01M8 16.5h.01',
  time: 'M12 7v5l3 2M12 3a9 9 0 1 0 .01 0z',
  tv: 'M3 5h18v12H3zM8 21h8M12 17v4',
  mfa: 'M4 4h16v4H4zM4 11h16v3H4zM4 17h10v3H4z'
};
function FraudTypes() {
  const [sel, setSel] = React.useState('bot');
  const cur = FRAUD_TYPE_DETAIL.find(t => t.id === sel) || FRAUD_TYPE_DETAIL[0];
  const vsRow = r => window.__lang === 'pl' ? [r[4], r[5]] : window.__lang === 'en' ? [r[2], r[3]] : [r[0], r[1]];
  return /*#__PURE__*/React.createElement("div", {
    className: "ftypes"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ftypes-list"
  }, FRAUD_TYPE_DETAIL.map(t => /*#__PURE__*/React.createElement("button", {
    key: t.id,
    className: 'ftypes-item' + (sel === t.id ? ' on' : ''),
    style: {
      '--ft': t.c
    },
    onClick: () => setSel(t.id)
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: FT_ICONS[t.icon] || FT_ICONS.bot
  })), /*#__PURE__*/React.createElement("span", null, t.n())))), /*#__PURE__*/React.createElement("div", {
    className: "ftypes-detail",
    style: {
      '--ft': cur.c
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ftd-head"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: FT_ICONS[cur.icon] || FT_ICONS.bot
  })), /*#__PURE__*/React.createElement("div", {
    className: "ftd-name"
  }, cur.n())), /*#__PURE__*/React.createElement("div", {
    className: "ftd-def"
  }, cur.def()), cur.vs && /*#__PURE__*/React.createElement("div", {
    className: "ftd-vs"
  }, cur.vs.map((r, i) => {
    const v = vsRow(r);
    return /*#__PURE__*/React.createElement("div", {
      className: 'ftd-vsrow' + (i === 1 ? ' bad' : ' good'),
      key: i
    }, /*#__PURE__*/React.createElement("span", {
      className: "ftd-vsk"
    }, v[0]), /*#__PURE__*/React.createElement("span", {
      className: "ftd-vsv"
    }, v[1]));
  })), cur.steps && /*#__PURE__*/React.createElement("div", {
    className: "ftd-steps"
  }, cur.steps.map((s, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "ftd-step"
  }, /*#__PURE__*/React.createElement("b", null, s[0]), /*#__PURE__*/React.createElement("span", null, s[1]())), i < cur.steps.length - 1 && /*#__PURE__*/React.createElement("span", {
    className: "ftd-stepar"
  }, "\u2192")))), /*#__PURE__*/React.createElement("div", {
    className: "ftd-catch"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ftd-catch-l"
  }, FL('Как ловят', 'How it’s caught', 'Jak się łapie')), cur.catch())));
}

// ═══════════ Methodology additions: taxonomy, methods matrix, standards, red flags, business ═══════════

// 1) GIVT vs SIVT + pre/post-bid timing
function FraudTaxonomy() {
  const giv = [FL('Известные боты, кравлеры, спайдеры', 'Known bots, crawlers, spiders', 'Znane boty, crawlery, spidery'), FL('Дата-центры и не-браузерный трафик', 'Data centers & non-browser traffic', 'Centra danych i ruch nieprzeglądarkowy'), FL('Списки IP / User-Agent', 'IP / User-Agent lists', 'Listy IP / User-Agent')];
  const siv = [FL('Боты, имитирующие человека', 'Bots imitating humans', 'Boty udające ludzi'), FL('Device farms, hijacked-устройства', 'Device farms, hijacked devices', 'Device farms, przejęte urządzenia'), FL('Spoofing, click injection, SDK spoofing', 'Spoofing, click injection, SDK spoofing', 'Spoofing, click injection, SDK spoofing')];
  return /*#__PURE__*/React.createElement("div", {
    className: "ftax"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ftax-cols"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ftax-col givt"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ftax-tier"
  }, "GIVT"), /*#__PURE__*/React.createElement("div", {
    className: "ftax-sub"
  }, FL('General Invalid Traffic', 'General Invalid Traffic', 'General Invalid Traffic')), giv.map((x, i) => /*#__PURE__*/React.createElement("div", {
    className: "ftax-row",
    key: i
  }, x)), /*#__PURE__*/React.createElement("div", {
    className: "ftax-meta"
  }, FL('Дёшево · списки/сигнатуры · ловится pre-bid', 'Cheap · lists/signatures · caught pre-bid', 'Tanio · listy/sygnatury · łapane pre-bid'))), /*#__PURE__*/React.createElement("div", {
    className: "ftax-col sivt"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ftax-tier"
  }, "SIVT"), /*#__PURE__*/React.createElement("div", {
    className: "ftax-sub"
  }, FL('Sophisticated Invalid Traffic', 'Sophisticated Invalid Traffic', 'Sophisticated Invalid Traffic')), siv.map((x, i) => /*#__PURE__*/React.createElement("div", {
    className: "ftax-row",
    key: i
  }, x)), /*#__PURE__*/React.createElement("div", {
    className: "ftax-meta"
  }, FL('Дорого · ML/поведение/форензика · часто post-bid', 'Expensive · ML/behavior/forensics · often post-bid', 'Drogo · ML/zachowanie/forensyka · często post-bid')))), /*#__PURE__*/React.createElement("div", {
    className: "fe-cap",
    style: {
      marginTop: 4
    }
  }, FL('Когда ловят: лента ставки', 'When it’s caught: the bidstream', 'Kiedy się łapie: bidstream')), /*#__PURE__*/React.createElement("div", {
    className: "ftime"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ftime-seg pre"
  }, /*#__PURE__*/React.createElement("b", null, "pre-bid"), /*#__PURE__*/React.createElement("span", null, FL('фильтр до ставки → показ не куплен, деньги не списаны', 'filter before the bid → impression not bought, no money spent', 'filtr przed ofertą → odsłona niekupiona, brak wydatku'))), /*#__PURE__*/React.createElement("div", {
    className: "ftime-ar"
  }, "\u2192"), /*#__PURE__*/React.createElement("div", {
    className: "ftime-seg bidwin"
  }, FL('ставка / показ', 'bid / render', 'oferta / odsłona')), /*#__PURE__*/React.createElement("div", {
    className: "ftime-ar"
  }, "\u2192"), /*#__PURE__*/React.createElement("div", {
    className: "ftime-seg post"
  }, /*#__PURE__*/React.createElement("b", null, "post-bid"), /*#__PURE__*/React.createElement("span", null, FL('измерение после показа → отчёт, рефанд, makegood', 'measurement after render → reporting, refund, make-good', 'pomiar po odsłonie → raport, refund, make-good')))), /*#__PURE__*/React.createElement("div", {
    className: "fraud-note"
  }, FL('Идеал — ловить pre-bid (не платить вовсе). Но сложный SIVT часто виден только постфактум, поэтому нужны оба слоя.', 'Ideal is catching pre-bid (never pay). But sophisticated SIVT is often visible only after the fact, so both layers are needed.', 'Ideał to łapać pre-bid (w ogóle nie płacić). Ale złożony SIVT często widać dopiero po fakcie, więc potrzebne są oba poziomy.')));
}

// 2) Methods × fraud-types matrix
const FM_METHODS = [{
  id: 'lists',
  tier: 'GIVT',
  n: () => FL('Списки / сигнатуры', 'Lists / signatures', 'Listy / sygnatury'),
  c: {
    bot: 2,
    df: 0,
    ds: 1,
    as: 1,
    sdk: 0,
    ci: 0,
    ctv: 1,
    mfa: 1
  }
}, {
  id: 'behavior',
  tier: 'SIVT',
  n: () => FL('Поведение / ML', 'Behavior / ML', 'Zachowanie / ML'),
  c: {
    bot: 2,
    df: 2,
    ds: 0,
    as: 0,
    sdk: 1,
    ci: 1,
    ctv: 1,
    mfa: 2
  }
}, {
  id: 'honeypot',
  tier: 'SIVT',
  n: () => FL('Ханипоты', 'Honeypots', 'Honeypoty'),
  c: {
    bot: 2,
    df: 1,
    ds: 0,
    as: 0,
    sdk: 0,
    ci: 0,
    ctv: 0,
    mfa: 1
  }
}, {
  id: 'jsc',
  tier: 'GIVT',
  n: () => FL('JS-челлендж', 'JS challenge', 'JS challenge'),
  c: {
    bot: 2,
    df: 1,
    ds: 0,
    as: 0,
    sdk: 0,
    ci: 0,
    ctv: 0,
    mfa: 0
  }
}, {
  id: 'sensor',
  tier: 'SIVT',
  n: () => FL('Sensor data', 'Sensor data', 'Sensor data'),
  c: {
    bot: 1,
    df: 2,
    ds: 0,
    as: 0,
    sdk: 0,
    ci: 1,
    ctv: 1,
    mfa: 0
  }
}, {
  id: 'server',
  tier: 'SIVT',
  n: () => FL('Server-side валидация', 'Server-side validation', 'Walidacja server-side'),
  c: {
    bot: 0,
    df: 0,
    ds: 1,
    as: 1,
    sdk: 2,
    ci: 2,
    ctv: 1,
    mfa: 0
  }
}, {
  id: 'chain',
  tier: 'GIVT',
  n: () => FL('Supply-chain (ads.txt/schain)', 'Supply-chain (ads.txt/schain)', 'Supply-chain (ads.txt/schain)'),
  c: {
    bot: 0,
    df: 0,
    ds: 2,
    as: 2,
    sdk: 0,
    ci: 0,
    ctv: 1,
    mfa: 1
  }
}];
const FM_COLS = [['bot', 'Bot'], ['df', 'Farm'], ['ds', 'Dom'], ['as', 'App'], ['sdk', 'SDK'], ['ci', 'Click'], ['ctv', 'CTV'], ['mfa', 'MFA']];
function FraudMethods() {
  const cell = v => v === 2 ? '●' : v === 1 ? '◐' : '·';
  return /*#__PURE__*/React.createElement("div", {
    className: "fmethods"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fm-scroll"
  }, /*#__PURE__*/React.createElement("table", {
    className: "fm-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, FL('Метод', 'Method', 'Metoda')), FM_COLS.map(c => /*#__PURE__*/React.createElement("th", {
    key: c[0]
  }, c[1])))), /*#__PURE__*/React.createElement("tbody", null, FM_METHODS.map(m => /*#__PURE__*/React.createElement("tr", {
    key: m.id
  }, /*#__PURE__*/React.createElement("td", {
    className: "fm-mname"
  }, /*#__PURE__*/React.createElement("span", {
    className: 'fm-tier ' + m.tier.toLowerCase()
  }, m.tier), m.n()), FM_COLS.map(c => /*#__PURE__*/React.createElement("td", {
    key: c[0],
    className: 'fm-cell v' + m.c[c[0]]
  }, cell(m.c[c[0]])))))))), /*#__PURE__*/React.createElement("div", {
    className: "fm-legend"
  }, /*#__PURE__*/React.createElement("span", null, "\u25CF ", FL('ловит', 'catches', 'łapie')), /*#__PURE__*/React.createElement("span", null, "\u25D0 ", FL('частично', 'partial', 'częściowo')), /*#__PURE__*/React.createElement("span", null, "\xB7 ", FL('не ловит', 'misses', 'pomija'))), /*#__PURE__*/React.createElement("div", {
    className: "fraud-note"
  }, FL('Ни один метод не ловит всё. Защита — это слои: дешёвые списки (GIVT) + дорогой ML/форензика (SIVT) + прозрачность цепочки.', 'No single method catches everything. Protection is layered: cheap lists (GIVT) + expensive ML/forensics (SIVT) + supply-chain transparency.', 'Żadna metoda nie łapie wszystkiego. Ochrona to warstwy: tanie listy (GIVT) + drogi ML/forensyka (SIVT) + przejrzystość łańcucha.')));
}

// 3) Standards & accreditation
function FraudStandards() {
  const cards = [['MRC', FL('Media Rating Council аккредитует вендоров измерения и фрод-детекта. «MRC-accredited» = методология проверена аудитом.', 'The Media Rating Council accredits measurement & fraud vendors. "MRC-accredited" = audited methodology.', 'Media Rating Council akredytuje dostawców pomiaru i detekcji fraudu. „MRC-accredited” = metodologia po audycie.')], ['TAG', FL('Trustworthy Accountability Group: сертификат «Certified Against Fraud» для участников цепочки.', 'Trustworthy Accountability Group: the "Certified Against Fraud" seal for supply-chain participants.', 'Trustworthy Accountability Group: certyfikat „Certified Against Fraud” dla uczestników łańcucha.')], ['IAB / IVT', FL('IAB задаёт guidelines по IVT (GIVT/SIVT) и форматам — общий язык индустрии.', 'IAB sets IVT guidelines (GIVT/SIVT) and formats — the industry’s common language.', 'IAB ustala wytyczne IVT (GIVT/SIVT) i formaty — wspólny język branży.')], ['ads.cert 2.0', FL('Криптоподпись bid request — потенциально сильнее schain, но это развивающийся стандарт с пока низким внедрением. Рабочая основа сегодня — ads.txt/sellers.json/schain.', 'Cryptographic signing of the bid request — potentially stronger than schain, but an emerging standard with low adoption so far. The deployed backbone today is ads.txt/sellers.json/schain.', 'Kryptograficzny podpis bid request — potencjalnie silniejszy niż schain, ale to wschodzący standard o wciąż niskim wdrożeniu. Działającą podstawą dziś jest ads.txt/sellers.json/schain.')], ['Brand safety / suitability', FL('Brand safety — универсальный «пол»: контент, рядом с которым нельзя рекламироваться никому. Brand suitability — настройка под конкретный бренд. Это разные вещи, и путать их дорого. Отдельная тема со своей экономикой: у неё свой модуль — кнопка в верхней панели.', 'Brand safety is the universal floor: content no one at all should advertise against. Brand suitability is per-advertiser tuning. They are different things, and confusing them is expensive. A separate topic with its own economics: it has its own module — the button in the top bar.', 'Brand safety to uniwersalny „próg”: treści, przy których nikt nie powinien się reklamować. Brand suitability to dostrojenie do konkretnej marki. To różne rzeczy, a mylenie ich jest kosztowne. Osobny temat z własną ekonomią: ma swój moduł — przycisk na górnym pasku.')]];
  return /*#__PURE__*/React.createElement("div", {
    className: "fstd"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fstd-grid"
  }, cards.map(c => /*#__PURE__*/React.createElement("div", {
    className: "fstd-card",
    key: c[0]
  }, /*#__PURE__*/React.createElement("div", {
    className: "fstd-t"
  }, c[0]), /*#__PURE__*/React.createElement("div", {
    className: "fstd-d"
  }, c[1])))), /*#__PURE__*/React.createElement("div", {
    className: "fstd-view"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fstd-view-t"
  }, FL('Стандарт viewability (MRC)', 'Viewability standard (MRC)', 'Standard viewability (MRC)')), /*#__PURE__*/React.createElement("div", {
    className: "fstd-view-row"
  }, /*#__PURE__*/React.createElement("b", null, "Display"), /*#__PURE__*/React.createElement("span", null, FL('≥50% пикселей в зоне видимости ≥1 сек', '≥50% of pixels in view for ≥1s', '≥50% pikseli w polu widzenia ≥1s'))), /*#__PURE__*/React.createElement("div", {
    className: "fstd-view-row"
  }, /*#__PURE__*/React.createElement("b", null, "Video"), /*#__PURE__*/React.createElement("span", null, FL('≥50% пикселей ≥2 сек воспроизведения', '≥50% of pixels for ≥2s of playback', '≥50% pikseli przez ≥2s odtwarzania')))));
}

// 4) Red flags + KPI
const FRED_FLAGS = [() => FL('CTR в 10× выше среднего', 'CTR 10× above average', 'CTR 10× powyżej średniej'), () => FL('CPM в 5× ниже рынка', 'CPM 5× below market', 'CPM 5× poniżej rynku'), () => FL('100% completion rate (видео)', '100% completion rate (video)', '100% completion rate (wideo)'), () => FL('0 конверсий при тысячах кликов', '0 conversions across thousands of clicks', '0 konwersji przy tysiącach kliknięć'), () => FL('Подозрительно высокая viewability 95%+', 'Suspiciously high viewability 95%+', 'Podejrzanie wysoka viewability 95%+'), () => FL('Нет ретенции после установки', 'No retention after install', 'Brak retencji po instalacji'), () => FL('CTIT < 10 сек (click→install)', 'CTIT < 10s (click→install)', 'CTIT < 10s (click→install)'), () => FL('Трафик ровный 24/7 без суточного цикла', 'Flat 24/7 traffic, no daily cycle', 'Płaski ruch 24/7 bez cyklu dobowego')];
const FKPI = [['CTR', () => FL('доля кликов на показ', 'clicks per impression', 'kliknięcia na odsłonę')], ['CVR', () => FL('доля конверсий на клик', 'conversions per click', 'konwersje na kliknięcie')], ['Viewability', () => FL('% реально увиденных показов', '% of impressions actually seen', '% faktycznie zobaczonych odsłon')], ['CTIT', () => FL('время click→install', 'click-to-install time', 'czas click-to-install')], ['Retention', () => FL('возвраты после установки', 'returns after install', 'powroty po instalacji')], ['IVT rate', () => FL('% невалидного трафика', '% invalid traffic', '% nieprawidłowego ruchu')]];
function FraudRedFlags() {
  return /*#__PURE__*/React.createElement("div", {
    className: "fred"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, FL('Красные флаги', 'Red flags', 'Czerwone flagi')), /*#__PURE__*/React.createElement("div", {
    className: "fred-grid"
  }, FRED_FLAGS.map((f, i) => /*#__PURE__*/React.createElement("div", {
    className: "fred-card",
    key: i
  }, f()))), /*#__PURE__*/React.createElement("div", {
    className: "fe-cap",
    style: {
      marginTop: 6
    }
  }, FL('Ключевые метрики', 'Key metrics', 'Kluczowe metryki')), /*#__PURE__*/React.createElement("div", {
    className: "fred-kpi"
  }, FKPI.map(k => /*#__PURE__*/React.createElement("div", {
    className: "fred-kp",
    key: k[0]
  }, /*#__PURE__*/React.createElement("b", null, k[0]), /*#__PURE__*/React.createElement("span", null, k[1]())))), /*#__PURE__*/React.createElement("div", {
    className: "fraud-note"
  }, FL('«Если выглядит слишком хорошо, чтобы быть правдой — скорее всего, так и есть.» Аномалии метрик — первый сигнал фрода.', '“If it looks too good to be true — it probably is.” Metric anomalies are the first signal of fraud.', '„Jeśli wygląda zbyt dobrze, by było prawdziwe — pewnie takie nie jest.” Anomalie metryk to pierwszy sygnał fraudu.')));
}

// 5) Business: economics + playbook
function FraudBusiness() {
  const [spend, setSpend] = React.useState(50);
  const [rate, setRate] = React.useState(20);
  const [lvl, setLvl] = React.useState(2);
  const levels = [['none', 0], ['basic', 0.35], ['std', 0.72], ['adv', 0.92]];
  const lvlNames = [FL('Без защиты', 'No protection', 'Bez ochrony'), FL('Базовая', 'Basic', 'Podstawowa'), FL('Стандарт', 'Standard', 'Standard'), FL('Максимум', 'Advanced', 'Zaawansowana')];
  const catch_ = levels[lvl][1];
  const fraudSpend = spend * 1000 * (rate / 100);
  const saved = fraudSpend * catch_;
  const wasted = fraudSpend - saved;
  const dsp = ['ads.txt / app-ads.txt', 'schain / sellers.json', FL('pre-bid фильтрация (IAS/DV)', 'pre-bid filtering (IAS/DV)', 'filtrowanie pre-bid (IAS/DV)'), 'PMP / Deal ID', FL('блок-листы MFA', 'MFA block lists', 'listy blokad MFA')];
  const ssp = [FL('аудит паблишеров', 'publisher audits', 'audyt wydawców'), FL('traffic validation', 'traffic validation', 'walidacja ruchu'), FL('IVT monitoring', 'IVT monitoring', 'monitoring IVT'), FL('фильтрация MFA-инвентаря', 'MFA inventory filtering', 'filtrowanie powierzchni MFA'), FL('ads.cert 2.0 (пилот)', 'ads.cert 2.0 (pilot)', 'ads.cert 2.0 (pilot)')];
  return /*#__PURE__*/React.createElement("div", {
    className: "fbiz"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fbiz-econ"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fbiz-sliders"
  }, /*#__PURE__*/React.createElement("label", null, FL('Бюджет', 'Budget', 'Budżet'), " ", /*#__PURE__*/React.createElement("b", null, "$", spend, "k"), /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: "5",
    max: "200",
    value: spend,
    onChange: e => setSpend(+e.target.value)
  })), /*#__PURE__*/React.createElement("label", null, FL('Доля фрода', 'Fraud rate', 'Udział fraudu'), " ", /*#__PURE__*/React.createElement("b", null, rate, "%"), /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: "2",
    max: "60",
    value: rate,
    onChange: e => setRate(+e.target.value)
  })), /*#__PURE__*/React.createElement("label", null, FL('Защита', 'Protection', 'Ochrona'), " ", /*#__PURE__*/React.createElement("b", null, lvlNames[lvl]), /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: "0",
    max: "3",
    value: lvl,
    onChange: e => setLvl(+e.target.value)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "fbiz-out"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fbiz-stat saved"
  }, /*#__PURE__*/React.createElement("span", null, FL('Спасено', 'Saved', 'Uratowano')), /*#__PURE__*/React.createElement("b", null, "$", Math.round(saved).toLocaleString())), /*#__PURE__*/React.createElement("div", {
    className: "fbiz-stat wasted"
  }, /*#__PURE__*/React.createElement("span", null, FL('Потеряно', 'Wasted', 'Stracono')), /*#__PURE__*/React.createElement("b", null, "$", Math.round(wasted).toLocaleString())), /*#__PURE__*/React.createElement("div", {
    className: "fbiz-stat"
  }, /*#__PURE__*/React.createElement("span", null, FL('Поймано', 'Caught', 'Złapano')), /*#__PURE__*/React.createElement("b", null, Math.round(catch_ * 100), "%")))), /*#__PURE__*/React.createElement("div", {
    className: "fbiz-play"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fbiz-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fbiz-h"
  }, "DSP"), dsp.map((x, i) => /*#__PURE__*/React.createElement("div", {
    className: "fbiz-li",
    key: i
  }, "\u2713 ", x))), /*#__PURE__*/React.createElement("div", {
    className: "fbiz-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fbiz-h"
  }, "SSP"), ssp.map((x, i) => /*#__PURE__*/React.createElement("div", {
    className: "fbiz-li",
    key: i
  }, "\u2713 ", x)))), /*#__PURE__*/React.createElement("div", {
    className: "fbiz-close"
  }, FL('Боремся не за 0% фрода, а за то, чтобы рекламодатель платил только за ценный контакт с настоящим пользователем.', 'We don’t fight for 0% fraud — we fight so the advertiser pays only for a valuable contact with a real user.', 'Nie walczymy o 0% fraudu — walczymy o to, by reklamodawca płacił tylko za wartościowy kontakt z prawdziwym użytkownikiem.')));
}
function FraudModule({
  open,
  onClose,
  initialAttack
}) {
  const [tab, setTab] = React.useState('sim');
  const [score, setScore] = React.useState(34);
  React.useEffect(() => {
    if (open && initialAttack) setTab('sim');
  }, [open, initialAttack]);
  if (!open) return null;
  const tabs = [['sim', FL('Симуляция', 'Simulation', 'Symulacja')], ['givt', FL('GIVT / SIVT', 'GIVT / SIVT', 'GIVT / SIVT')], ['engine', FL('Детектор', 'Detection engine', 'Detektor')], ['methods', FL('Методы', 'Methods', 'Metody')], ['score', FL('Fraud score', 'Fraud score', 'Fraud score')], ['human', FL('Человек / бот', 'Human / bot', 'Człowiek / bot')], ['types', FL('Типы', 'Types', 'Typy')], ['redflags', FL('Red flags', 'Red flags', 'Red flags')], ['standards', FL('Стандарты', 'Standards', 'Standardy')], ['chain', FL('Прозрачность', 'Transparency', 'Przejrzystość')], ['business', FL('Бизнес', 'Business', 'Biznes')]];
  const band = SCORE_BANDS.find(b => score >= b[0] && score < b[1]) || SCORE_BANDS[SCORE_BANDS.length - 1];
  const verdict = score < 40 ? FL('Пропустить', 'Allow', 'Przepuść') : score < 60 ? FL('На проверку', 'Review', 'Do przeglądu') : FL('Заблокировать', 'Block', 'Zablokuj');
  return /*#__PURE__*/React.createElement("div", {
    className: "compare-overlay",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "fraud-modal",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": FL('Фрод и верификация', 'Fraud & verification', 'Fraud i weryfikacja'),
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "dive-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "cmp-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-title"
  }, FL('Фрод и верификация', 'Fraud & verification', 'Fraud i weryfikacja')), /*#__PURE__*/React.createElement("div", {
    className: "cmp-sub"
  }, FL('Как анти-фрод системы ловят невалидный трафик — системно, а не на одном этапе.', 'How anti-fraud systems catch invalid traffic — systematically, not at a single step.', 'Jak systemy anti-fraud łapią nieprawidłowy ruch — systemowo, nie na jednym etapie.')), /*#__PURE__*/React.createElement("button", {
    className: "fraud-export",
    onClick: () => {
      try {
        document.body.classList.add('fraudprint');
      } catch (e) {}
      setTimeout(() => {
        window.print();
        setTimeout(() => document.body.classList.remove('fraudprint'), 300);
      }, 60);
    },
    title: FL('Сохранить в PDF', 'Save to PDF', 'Zapisz do PDF')
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3v12M8 11l4 4 4-4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h14",
    strokeLinecap: "round"
  })), FL('PDF', 'PDF', 'PDF'))), /*#__PURE__*/React.createElement("div", {
    className: "fraud-tabs"
  }, tabs.map(t => /*#__PURE__*/React.createElement("button", {
    key: t[0],
    className: tab === t[0] ? 'on' : '',
    onClick: () => setTab(t[0])
  }, t[1]))), tab === 'sim' && /*#__PURE__*/React.createElement(FraudSim, {
    seed: initialAttack
  }), tab === 'givt' && /*#__PURE__*/React.createElement(FraudTaxonomy, null), tab === 'methods' && /*#__PURE__*/React.createElement(FraudMethods, null), tab === 'redflags' && /*#__PURE__*/React.createElement(FraudRedFlags, null), tab === 'standards' && /*#__PURE__*/React.createElement(FraudStandards, null), tab === 'business' && /*#__PURE__*/React.createElement(FraudBusiness, null), tab === 'engine' && /*#__PURE__*/React.createElement("div", {
    className: "fraud-engine"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-col fe-signals"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, FL('Входящие сигналы', 'Input signals', 'Sygnały wejściowe')), DETECT_SIGNALS.map((s, i) => /*#__PURE__*/React.createElement("div", {
    className: "fe-sig",
    key: i
  }, s()))), /*#__PURE__*/React.createElement("div", {
    className: "fe-arrow"
  }, "\u2192"), /*#__PURE__*/React.createElement("div", {
    className: "fe-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-box ml"
  }, "Machine Learning"), /*#__PURE__*/React.createElement("div", {
    className: "fe-box score"
  }, "Fraud Score", /*#__PURE__*/React.createElement("span", null, "0\u2013100"))), /*#__PURE__*/React.createElement("div", {
    className: "fe-arrow"
  }, "\u2192"), /*#__PURE__*/React.createElement("div", {
    className: "fe-col fe-decide"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, FL('Решение', 'Decision', 'Decyzja')), /*#__PURE__*/React.createElement("div", {
    className: "fe-verdict allow"
  }, FL('Пропустить', 'Allow', 'Przepuść')), /*#__PURE__*/React.createElement("div", {
    className: "fe-verdict review"
  }, FL('На проверку', 'Review', 'Do przeglądu')), /*#__PURE__*/React.createElement("div", {
    className: "fe-verdict block"
  }, FL('Заблокировать', 'Block', 'Zablokuj')))), tab === 'score' && /*#__PURE__*/React.createElement("div", {
    className: "fraud-score-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fs-readout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fs-num",
    style: {
      color: band[2]
    }
  }, score), /*#__PURE__*/React.createElement("div", {
    className: "fs-band",
    style: {
      color: band[2]
    }
  }, band[3]()), /*#__PURE__*/React.createElement("div", {
    className: "fs-verdict"
  }, verdict)), /*#__PURE__*/React.createElement("input", {
    className: "fs-range",
    type: "range",
    min: "0",
    max: "99",
    value: score,
    onChange: e => setScore(+e.target.value),
    style: {
      accentColor: band[2]
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "fs-scale"
  }, SCORE_BANDS.map((b, i) => /*#__PURE__*/React.createElement("div", {
    className: "fs-seg",
    key: i,
    style: {
      background: b[2] + '33',
      borderColor: b[2] + '88',
      color: b[2]
    }
  }, /*#__PURE__*/React.createElement("b", null, b[0], "\u2013", b[1]), /*#__PURE__*/React.createElement("span", null, b[3]())))), /*#__PURE__*/React.createElement("div", {
    className: "fraud-note"
  }, FL('Скоринг — не «да/нет», а вероятность. Низкий балл пропускают, средний — на ручную проверку, высокий — блок.', 'Scoring is not yes/no but a probability. Low passes, medium goes to manual review, high is blocked.', 'Scoring to nie tak/nie, lecz prawdopodobieństwo. Niski przepuszcza, średni do ręcznej weryfikacji, wysoki blokuje.'))), tab === 'human' && /*#__PURE__*/React.createElement("div", {
    className: "fraud-hvb"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hvb-col good"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hvb-h"
  }, FL('Реальный пользователь', 'Real user', 'Prawdziwy użytkownik')), [FL('скроллит страницу', 'scrolls the page', 'przewija stronę'), FL('кликает осмысленно', 'clicks meaningfully', 'klika sensownie'), FL('читает контент', 'reads content', 'czyta treść'), FL('естественное поведение', 'natural behavior', 'naturalne zachowanie')].map((x, i) => /*#__PURE__*/React.createElement("div", {
    className: "hvb-row",
    key: i
  }, x))), /*#__PURE__*/React.createElement("div", {
    className: "hvb-col bad"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hvb-h"
  }, FL('Бот', 'Bot', 'Bot')), [FL('активность 24/7', '24/7 activity', 'aktywność 24/7'), FL('идеальный тайминг', 'perfect timing', 'idealny timing'), FL('тысячи запросов', 'thousands of requests', 'tysiące żądań'), FL('нет вовлечения', 'no engagement', 'brak zaangażowania')].map((x, i) => /*#__PURE__*/React.createElement("div", {
    className: "hvb-row",
    key: i
  }, x))), /*#__PURE__*/React.createElement("div", {
    className: "fraud-note full"
  }, FL('Бот может выглядеть как пользователь, но ведёт себя иначе — это и ловит поведенческий анализ.', 'A bot can look like a user, but behaves differently — that is what behavioral analysis catches.', 'Bot może wyglądać jak użytkownik, ale zachowuje się inaczej — to wychwytuje analiza behawioralna.'))), tab === 'types' && /*#__PURE__*/React.createElement(FraudTypes, null), tab === 'chain' && /*#__PURE__*/React.createElement("div", {
    className: "fraud-chain"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fc-flow"
  }, ['Publisher', 'SSP', 'Exchange', 'DSP'].map((n, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: n
  }, /*#__PURE__*/React.createElement("span", {
    className: "fc-node"
  }, n), i < 3 && /*#__PURE__*/React.createElement("span", {
    className: "fc-ar"
  }, "\u2192")))), /*#__PURE__*/React.createElement("div", {
    className: "fc-stds"
  }, [['ads.txt', FL('кто вправе продавать инвентарь сайта', 'who may sell the site inventory', 'kto może sprzedawać powierzchnię strony')], ['app-ads.txt', FL('то же для мобильных приложений', 'same for mobile apps', 'to samo dla aplikacji mobilnych')], ['sellers.json', FL('кто стоит за каждым продавцом', 'who is behind each seller', 'kto stoi za każdym sprzedawcą')], ['schain', FL('полная цепочка перепродаж в bid request', 'full reseller chain in the bid request', 'pełny łańcuch resellerów w bid request')]].map(s => /*#__PURE__*/React.createElement("div", {
    className: "fc-std",
    key: s[0]
  }, /*#__PURE__*/React.createElement("code", null, s[0]), /*#__PURE__*/React.createElement("span", null, s[1])))), /*#__PURE__*/React.createElement("div", {
    className: "fraud-note full"
  }, FL('Стандарты прозрачности отвечают на один вопрос: законен ли продавец этого показа? Неизвестное звено в цепочке — красный флаг.', 'Transparency standards answer one question: is the seller of this impression legitimate? An unknown link in the chain is a red flag.', 'Standardy przejrzystości odpowiadają na jedno pytanie: czy sprzedawca tej odsłony jest legalny? Nieznane ogniwo w łańcuchu to czerwona flaga.')))));
}
Object.assign(window, {
  FRAUD_HOPS,
  FraudOverlay,
  FraudModule
});

;
/* RTB Engine — Attention module. The quality rung above viewability.
   Tabs: quality ladder · cases (when attention exists and when it doesn't) ·
   interactive meter · how it is measured · who measures it.
   Cases are clickable presets that seed the meter, so every number in the module
   comes from ONE model (attScore) — the tabs can never contradict each other.
   Trilingual via window.L. Reuses the fraud-modal shell; violet accent (#a78bfa).
   The model is directional/illustrative (Lumen / Adelaide / Nelson-Field),
   NOT a vendor metric — labelled as such in the UI.
   NOTE: modules share ONE top-level scope after concat — helper must be uniquely
   named (rtb-fraud owns FL, rtb-extras owns L3), hence AL. */
const AL = (ru, en, pl) => window.L(ru, en, pl);

// signal → options [id, label, weight]. Weights feed a 0–100 attention score.
const AT_SIGNALS = {
  format: {
    cap: () => AL('Формат', 'Format', 'Format'),
    opts: () => [['banner', AL('Баннер', 'Banner', 'Baner'), 6], ['rich', AL('Rich / большой', 'Rich / large', 'Rich / duży'), 14], ['video', AL('Видео', 'Video', 'Wideo'), 20], ['full', AL('Фуллскрин / CTV', 'Full-screen / CTV', 'Pełny ekran / CTV'), 26]]
  },
  position: {
    cap: () => AL('Позиция', 'Position', 'Pozycja'),
    opts: () => [['below', AL('Ниже сгиба', 'Below the fold', 'Poniżej zgięcia'), 0], ['above', AL('Над сгибом', 'Above the fold', 'Nad zgięciem'), 10], ['center', AL('В центре контента', 'In-content', 'W treści'), 16]]
  },
  time: {
    cap: () => AL('Время в поле зрения', 'In-view time', 'Czas w polu widzenia'),
    opts: () => [['t1', '1 ' + AL('с', 's', 's'), 2], ['t5', '5 ' + AL('с', 's', 's'), 7], ['t15', '15 ' + AL('с', 's', 's'), 12]]
  },
  audio: {
    cap: () => AL('Звук', 'Audio', 'Dźwięk'),
    opts: () => [['off', AL('Выкл', 'Off', 'Wył'), 0], ['on', AL('Вкл', 'On', 'Wł'), 7]]
  },
  clutter: {
    cap: () => AL('Страница', 'Page', 'Strona'),
    opts: () => [['busy', AL('Захламлена', 'Cluttered', 'Zagracona'), -7], ['mod', AL('Средне', 'Moderate', 'Umiarkowana'), 0], ['clean', AL('Чистая', 'Clean', 'Czysta'), 7]]
  },
  device: {
    cap: () => AL('Девайс', 'Device', 'Urządzenie'),
    opts: () => [['mobile', AL('Мобайл', 'Mobile', 'Mobile'), 5], ['desktop', AL('Десктоп', 'Desktop', 'Desktop'), 7], ['ctv', 'CTV', 14]]
  }
};
const AT_ORDER = ['format', 'position', 'time', 'audio', 'clutter', 'device'];
const AT_BASE = 8;
const AT_TIME_S = {
  t1: 1,
  t5: 5,
  t15: 15
};
const AT_BANDS = [[0, 35, '#fb7185'], [35, 65, '#fbbf24'], [65, 101, '#34d399']];
const AT_DEFAULT = {
  format: 'rich',
  position: 'above',
  time: 't5',
  audio: 'off',
  clutter: 'mod',
  device: 'desktop'
};
function attScore(sel) {
  let raw = AT_BASE;
  AT_ORDER.forEach(k => {
    const opt = AT_SIGNALS[k].opts().find(o => o[0] === sel[k]);
    let w = opt ? opt[2] : 0;
    if (k === 'audio' && !(sel.format === 'video' || sel.format === 'full')) w = 0; // audio only matters for video
    raw += w;
  });
  return Math.max(3, Math.min(100, raw));
}
const attBand = s => AT_BANDS.find(b => s >= b[0] && s < b[1]) || AT_BANDS[2];
const attVerdict = s => s < 35 ? AL('Проигнорирован', 'Ignored', 'Zignorowany') : s < 65 ? AL('Замечен мельком', 'Glanced at', 'Zauważony przelotnie') : AL('В фокусе', 'In focus', 'W centrum uwagi');

/* Cases: real placements, ordered low → high attention. Scores are computed by the
   SAME attScore() the meter uses, so the two tabs can never disagree. */
const AT_CASES = () => [{
  id: 'footer',
  sel: {
    format: 'banner',
    position: 'below',
    time: 't1',
    audio: 'off',
    clutter: 'busy',
    device: 'desktop'
  },
  n: AL('Баннер в подвале', 'Footer banner', 'Baner w stopce'),
  why: AL('Засчитан как viewable, пока пользователь пролистывал мимо. Внимания — почти ноль. Это и есть разрыв между «видимый» и «увиденный».', 'Counted as viewable while the user scrolled past. Attention ≈ zero. This is exactly the gap between “viewable” and “seen”.', 'Zaliczony jako viewable, gdy użytkownik przewijał obok. Uwaga ≈ zero. To właśnie przepaść między „widoczny” a „zauważony”.')
}, {
  id: 'autoplay',
  sel: {
    format: 'video',
    position: 'below',
    time: 't1',
    audio: 'off',
    clutter: 'busy',
    device: 'mobile'
  },
  n: AL('Автоплей без звука ниже сгиба', 'Muted autoplay below the fold', 'Autoplay bez dźwięku poniżej zgięcia'),
  why: AL('Дорогой видеоформат — и почти ноль внимания: без звука, вне фокуса, пользователь листает. Формат сам по себе внимания не покупает.', 'An expensive video format — and almost no attention: muted, out of focus, the user is scrolling. Format alone does not buy attention.', 'Drogi format wideo — i prawie zero uwagi: bez dźwięku, poza polem uwagi, użytkownik przewija. Sam format nie kupuje uwagi.')
}, {
  id: 'sticky',
  sel: {
    format: 'banner',
    position: 'above',
    time: 't15',
    audio: 'off',
    clutter: 'busy',
    device: 'mobile'
  },
  n: AL('Sticky-баннер на мобиле, 15 с', 'Mobile sticky banner, 15s', 'Sticky baner na mobile, 15 s'),
  why: AL('15 секунд в поле зрения — и всё равно мало внимания: баннерная слепота. Главный урок: время в кадре ≠ внимание.', '15 seconds in view and still little attention: banner blindness. The key lesson: time in view ≠ attention.', '15 sekund w polu widzenia i wciąż mało uwagi: ślepota banerowa. Kluczowa lekcja: czas w kadrze ≠ uwaga.')
}, {
  id: 'prerollmute',
  sel: {
    format: 'video',
    position: 'center',
    time: 't5',
    audio: 'off',
    clutter: 'mod',
    device: 'desktop'
  },
  n: AL('Pre-roll без звука', 'Muted pre-roll', 'Pre-roll bez dźwięku'),
  why: AL('Позиция и формат работают, но выключенный звук снимает заметную часть внимания.', 'Position and format work, but muting strips away a meaningful part of the attention.', 'Pozycja i format działają, ale wyciszenie zabiera znaczną część uwagi.')
}, {
  id: 'incontent',
  sel: {
    format: 'rich',
    position: 'center',
    time: 't15',
    audio: 'off',
    clutter: 'clean',
    device: 'desktop'
  },
  n: AL('Rich-media в центре лонгрида', 'Rich media in-content', 'Rich media w treści'),
  why: AL('Крупный формат в потоке чтения на чистой странице набирает внимание даже без звука — контекст важнее звука.', 'A large format inside the reading flow on a clean page builds attention even without audio — context beats sound.', 'Duży format w toku czytania na czystej stronie zbiera uwagę nawet bez dźwięku — kontekst ważniejszy niż dźwięk.')
}, {
  id: 'preroll',
  sel: {
    format: 'video',
    position: 'center',
    time: 't15',
    audio: 'on',
    clutter: 'clean',
    device: 'desktop'
  },
  n: AL('Pre-roll со звуком', 'Pre-roll with sound', 'Pre-roll z dźwiękiem'),
  why: AL('Звук, центр экрана и время совпали. Пользователь ждёт контент — реклама в фокусе.', 'Audio, screen centre and time all line up. The user is waiting for the content — the ad is in focus.', 'Dźwięk, centrum ekranu i czas zgrały się. Użytkownik czeka na treść — reklama jest w centrum.')
}, {
  id: 'ctv',
  sel: {
    format: 'full',
    position: 'center',
    time: 't15',
    audio: 'on',
    clutter: 'clean',
    device: 'ctv'
  },
  n: AL('CTV-спот в стриминге', 'CTV spot in streaming', 'Spot CTV w streamingu'),
  why: AL('Большой экран, звук, lean-back — потолок внимания в индустрии. Обратная сторона: дорого и труднее верифицировать (см. фрод-модуль).', 'Big screen, sound, lean-back — the industry’s attention ceiling. The flip side: expensive and harder to verify (see the fraud module).', 'Duży ekran, dźwięk, lean-back — sufit uwagi w branży. Druga strona: drogo i trudniej zweryfikować (zob. moduł fraud).')
}];
function AttentionCases({
  onOpen
}) {
  const cases = AT_CASES().map(c => ({
    ...c,
    score: attScore(c.sel)
  })).sort((a, b) => a.score - b.score);
  return /*#__PURE__*/React.createElement("div", {
    className: "att-cases"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-lad-intro"
  }, AL('Одни и те же деньги — разное внимание. Слева направо: от «засчитано, но не увидено» до «в фокусе». Баллы считает та же модель, что и метр — нажми кейс, чтобы открыть его в метре.', 'Same money, very different attention. From “counted but never seen” to “in focus”. The scores come from the same model as the meter — click a case to open it there.', 'Te same pieniądze — bardzo różna uwaga. Od „zaliczone, ale niezauważone” po „w centrum uwagi”. Wyniki liczy ten sam model co miernik — kliknij kejs, aby otworzyć go w mierniku.')), cases.map(c => {
    const b = attBand(c.score);
    return /*#__PURE__*/React.createElement("button", {
      className: "att-case",
      key: c.id,
      onClick: () => onOpen(c.sel)
    }, /*#__PURE__*/React.createElement("div", {
      className: "att-case-head"
    }, /*#__PURE__*/React.createElement("span", {
      className: "att-case-n"
    }, c.n), /*#__PURE__*/React.createElement("span", {
      className: "att-case-score",
      style: {
        color: b[2],
        borderColor: b[2]
      }
    }, c.score, /*#__PURE__*/React.createElement("i", null, "/100"))), /*#__PURE__*/React.createElement("div", {
      className: "att-case-track"
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        width: c.score + '%',
        background: b[2]
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "att-case-why"
    }, c.why), /*#__PURE__*/React.createElement("div", {
      className: "att-case-open",
      style: {
        color: b[2]
      }
    }, attVerdict(c.score), " \xB7 ", AL('открыть в метре →', 'open in the meter →', 'otwórz w mierniku →')));
  }), /*#__PURE__*/React.createElement("div", {
    className: "att-take"
  }, AL('Вывод: внимание появляется, когда совпадают НЕСКОЛЬКО сигналов — крупный формат + фокусная позиция + время + (для видео) звук + чистый контекст. Один сигнал ничего не решает. Именно поэтому viewability, которая смотрит на один порог, переоценивает качество.', 'Takeaway: attention appears when SEVERAL signals line up — large format + focal position + time + (for video) audio + a clean context. No single signal saves it. That is exactly why viewability, which checks one threshold, over-counts quality.', 'Wniosek: uwaga pojawia się, gdy zgrywa się KILKA sygnałów — duży format + pozycja w centrum + czas + (dla wideo) dźwięk + czysty kontekst. Żaden pojedynczy sygnał nie wystarczy. Właśnie dlatego viewability, które sprawdza jeden próg, zawyża jakość.')));
}
function AttentionMeter({
  sel,
  setSel
}) {
  const set = (k, v) => setSel({
    ...sel,
    [k]: v
  });
  const score = attScore(sel);
  const inView = AT_TIME_S[sel.time];
  const attSec = Math.round(score / 100 * inView * 10) / 10;
  const band = attBand(score);
  const audioDead = sel.audio === 'on' && !(sel.format === 'video' || sel.format === 'full');
  let insight;
  if (sel.position === 'below' && sel.format === 'banner') {
    insight = AL('Viewable по счётчику ≠ увиденный: маленький баннер ниже сгиба почти не собирает внимания — именно так viewability переоценивает качество.', 'Viewable by the counter ≠ actually seen: a small banner below the fold gathers almost no attention — exactly how viewability over-counts quality.', 'Viewable według licznika ≠ faktycznie zauważony: mały baner poniżej zgięcia prawie nie zbiera uwagi — właśnie tak viewability zawyża jakość.');
  } else if (sel.device === 'ctv' && (sel.format === 'full' || sel.format === 'video')) {
    insight = AL('CTV + большой экран + lean-back = самое высокое внимание в индустрии (звук обычно включён).', 'CTV + a big screen + lean-back = the highest attention in the industry (audio is usually on).', 'CTV + duży ekran + lean-back = najwyższa uwaga w branży (dźwięk zwykle włączony).');
  } else if (sel.time === 't15' && sel.format === 'banner') {
    insight = AL('Долго в кадре — но это баннер: время в поле зрения само по себе внимания не даёт (баннерная слепота).', 'A long time in view — but it is a banner: in-view time alone does not create attention (banner blindness).', 'Długo w kadrze — ale to baner: sam czas w polu widzenia nie tworzy uwagi (ślepota banerowa).');
  } else if (sel.clutter === 'busy') {
    insight = AL('Захламлённая страница делит внимание — тот же показ на чистой странице заметят сильнее.', 'A cluttered page splits attention — the same impression on a clean page gets noticed more.', 'Zagracona strona dzieli uwagę — ta sama odsłona na czystej stronie zostanie bardziej zauważona.');
  } else {
    insight = AL('Внимание складывается из размера, позиции, времени и контекста — а не из одного сигнала.', 'Attention builds from size, position, time and context — not from any single signal.', 'Uwaga składa się z rozmiaru, pozycji, czasu i kontekstu — nie z jednego sygnału.');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "att-meter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-sigs"
  }, AT_ORDER.map(k => /*#__PURE__*/React.createElement("div", {
    className: "att-sig",
    key: k
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, AT_SIGNALS[k].cap()), /*#__PURE__*/React.createElement("div", {
    className: "att-chips"
  }, AT_SIGNALS[k].opts().map(o => /*#__PURE__*/React.createElement("button", {
    key: o[0],
    className: 'att-chip' + (sel[k] === o[0] ? ' on' : '') + (k === 'audio' && o[0] === 'on' && audioDead ? ' dead' : ''),
    onClick: () => set(k, o[0])
  }, o[1])))))), /*#__PURE__*/React.createElement("div", {
    className: "att-readout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-gauge"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-gauge-top"
  }, /*#__PURE__*/React.createElement("span", null, AL('Оценка внимания', 'Attention score', 'Ocena uwagi')), /*#__PURE__*/React.createElement("b", {
    style: {
      color: band[2]
    }
  }, Math.round(score), /*#__PURE__*/React.createElement("i", null, "/100"))), /*#__PURE__*/React.createElement("div", {
    className: "att-bar"
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      width: score + '%',
      background: band[2]
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "att-nums"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-sec"
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      color: band[2]
    }
  }, attSec), /*#__PURE__*/React.createElement("span", null, AL('attention-секунд', 'attention-seconds', 'sekund uwagi'), /*#__PURE__*/React.createElement("i", null, AL('из', 'of', 'z'), " ", inView, " ", AL('с в поле зрения', 's in view', 's w polu widzenia')))), /*#__PURE__*/React.createElement("div", {
    className: "att-verdict",
    style: {
      color: band[2],
      borderColor: band[2]
    }
  }, attVerdict(score)))), /*#__PURE__*/React.createElement("div", {
    className: "att-insight"
  }, insight, audioDead && /*#__PURE__*/React.createElement("span", {
    className: "att-note"
  }, " ", AL('(звук на баннере ничего не даёт)', '(audio does nothing on a banner)', '(dźwięk na banerze nic nie daje)'))), /*#__PURE__*/React.createElement("div", {
    className: "att-illus"
  }, AL('Модель иллюстративная — направление, не метрика конкретного вендора.', 'Illustrative model — the direction, not any one vendor’s metric.', 'Model ilustracyjny — kierunek, nie metryka konkretnego dostawcy.')));
}
function AttentionLadder() {
  const steps = [['served', 100, '#8aa0c6', AL('Показан', 'Served', 'Wyświetlony'), AL('Показ доставлен — но, может, боту, за экраном или так и не отрисован.', 'The impression was delivered — but maybe to a bot, off-screen, or never rendered.', 'Odsłona dostarczona — ale może botowi, poza ekranem lub nigdy nie wyrenderowana.')], ['viewable', 60, '#67e8f9', AL('Viewable (видимый)', 'Viewable', 'Widoczny'), AL('MRC: ≥50% пикселей ≥1 с. Мог быть увиден — но «мог» ещё не значит «увиден».', 'MRC: ≥50% of pixels for ≥1s. Could have been seen — but “could” is not “was”.', 'MRC: ≥50% pikseli przez ≥1s. Mógł zostać zauważony — ale „mógł” to nie „został”.')], ['attention', 22, '#a78bfa', AL('Attention (внимание)', 'Attention', 'Uwaga'), AL('Человек реально посмотрел — и сколько секунд. Куда сильнее коррелирует с запоминанием и продажами, чем viewability.', 'A human actually looked — and for how many seconds. Correlates far better with recall and sales than viewability.', 'Człowiek faktycznie spojrzał — i przez ile sekund. Znacznie lepiej koreluje z zapamiętaniem i sprzedażą niż viewability.')], ['outcome', 9, '#34d399', AL('Результат', 'Outcome', 'Wynik'), AL('Запоминание бренда, выбор, продажа — то, за что в итоге платит рекламодатель.', 'Brand recall, choice, a sale — what the advertiser ultimately pays for.', 'Zapamiętanie marki, wybór, sprzedaż — to, za co reklamodawca ostatecznie płaci.')]];
  return /*#__PURE__*/React.createElement("div", {
    className: "att-ladder"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-lad-intro"
  }, AL('От «доставлен» до «сработал» теряется почти всё. Viewability закрывает только вторую ступень — увиденным показ делает внимание.', 'Almost everything drops between “delivered” and “worked”. Viewability only covers the second rung — attention is what makes an impression seen.', 'Prawie wszystko gubi się między „dostarczony” a „zadziałał”. Viewability pokrywa tylko drugi szczebel — to uwaga sprawia, że odsłona jest zauważona.')), steps.map(s => /*#__PURE__*/React.createElement("div", {
    className: "att-rung",
    key: s[0]
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-rung-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "att-rung-t",
    style: {
      color: s[2]
    }
  }, s[3]), /*#__PURE__*/React.createElement("span", {
    className: "att-rung-pct",
    style: {
      color: s[2]
    }
  }, s[1], /*#__PURE__*/React.createElement("i", null, "%"))), /*#__PURE__*/React.createElement("div", {
    className: "att-rung-track"
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      width: s[1] + '%',
      background: s[2]
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "att-rung-d"
  }, s[4]))), /*#__PURE__*/React.createElement("div", {
    className: "att-illus"
  }, AL('Проценты иллюстративны (порядок величин по индустрии) — воронка, не замер конкретной кампании.', 'Percentages are illustrative (industry order-of-magnitude) — the funnel, not any one campaign’s measurement.', 'Procenty są ilustracyjne (rząd wielkości wg branży) — lejek, nie pomiar konkretnej kampanii.')));
}
function AttentionMethods() {
  const flow = [[AL('Панель — «истина»', 'The panel — ground truth', 'Panel — „prawda”'), AL('Небольшая группа людей смотрит рекламу с включённой камерой: eye-tracking или машинное зрение фиксируют, куда человек реально смотрел и сколько. Масштаб маленький, но это единственная настоящая правда о внимании.', 'A small group watches ads with the camera on: eye-tracking or machine vision records where the person actually looked and for how long. Small scale — but the only real ground truth about attention.', 'Niewielka grupa ogląda reklamy z włączoną kamerą: eye-tracking lub wizja maszynowa rejestruje, gdzie człowiek naprawdę patrzył i jak długo. Mała skala — ale to jedyna prawdziwa prawda o uwadze.')], [AL('Модель — обучение на панели', 'The model — trained on the panel', 'Model — uczony na panelu'), AL('На панельных данных учат предиктивную модель: она связывает СИГНАЛЫ показа (формат, доля экрана, позиция, время в поле зрения, звук, девайс, захламлённость, скорость скролла) с вероятностью и длительностью внимания.', 'A predictive model is trained on that panel data: it maps impression SIGNALS (format, share of screen, position, in-view time, audio, device, clutter, scroll speed) to the probability and duration of attention.', 'Na danych panelowych uczy się model predykcyjny: wiąże SYGNAŁY odsłony (format, udział ekranu, pozycja, czas w polu widzenia, dźwięk, urządzenie, zagracenie, prędkość scrolla) z prawdopodobieństwem i długością uwagi.')], [AL('Масштаб — без камеры', 'Scale — without a camera', 'Skala — bez kamery'), AL('Обученную модель применяют к миллиардам показов, где никакой камеры нет: на вход идут те же сигналы — на выходе attention-балл на каждый показ или плейсмент. Это то, чем торгуют.', 'The trained model is applied to billions of impressions where there is no camera: the same signals go in, an attention score per impression or placement comes out. That is what actually gets traded.', 'Wytrenowany model stosuje się do miliardów odsłon, gdzie kamery nie ma: na wejściu te same sygnały, na wyjściu wynik uwagi na odsłonę lub placement. To właśnie jest przedmiotem obrotu.')], [AL('Куда подключают', 'Where it plugs in', 'Gdzie się podpina'), AL('Pre-bid: покупать высокоattention инвентарь, attention-курирование и PMP, корректировать ставку. Post-bid: мерить, оптимизировать креатив и плейсменты, отчитываться. Отсюда и «цена за секунду внимания» вместо голого CPM.', 'Pre-bid: buy high-attention inventory, attention-based curation and PMPs, adjust the bid. Post-bid: measure, optimise creative and placements, report. Hence “cost per attentive second” instead of a bare CPM.', 'Pre-bid: kupować inwentarz o wysokiej uwadze, kuracja i PMP oparte na uwadze, korekta stawki. Post-bid: mierzyć, optymalizować kreację i placementy, raportować. Stąd „koszt za sekundę uwagi” zamiast gołego CPM.')]];
  const nots = [AL('≠ viewability — та говорит лишь «мог увидеть», а не «увидел».', '≠ viewability — that only says “could have seen”, not “did see”.', '≠ viewability — to mówi tylko „mógł zobaczyć”, a nie „zobaczył”.'), AL('≠ клик — клик бывает случайным, а внимание бывает без клика.', '≠ a click — clicks can be accidental, and attention happens without any click.', '≠ kliknięcie — kliknięcia bywają przypadkowe, a uwaga zdarza się bez kliknięcia.'), AL('≠ гарантия результата — это сильный прокси, но всё же прокси.', '≠ a guarantee of outcome — a strong proxy, but still a proxy.', '≠ gwarancja wyniku — mocny wskaźnik zastępczy, ale wciąż zastępczy.')];
  const limits = [AL('Единой метрики нет: методологию стандартизировали, а шкалу — нет. У каждого вендора своя единица измерения, поэтому баллы между вендорами напрямую НЕ сравнимы.', 'There is no single metric: the methodology has been standardised, the scale has not. Every vendor has its own unit, so scores are NOT directly comparable across vendors.', 'Nie ma jednej metryki: metodologię ustandaryzowano, skali — nie. Każdy dostawca ma własną jednostkę, więc wyniki NIE są bezpośrednio porównywalne między dostawcami.'), AL('Панели маленькие и смещённые — далеко не каждый согласится смотреть рекламу с включённой камерой.', 'Panels are small and skewed — not everyone agrees to watch ads with their camera on.', 'Panele są małe i obciążone — nie każdy zgodzi się oglądać reklamy z włączoną kamerą.'), AL('Модель можно «переоптимизировать»: если гнаться за сигналом (сделать баннер огромным и липким), балл вырастет, а реального внимания — не факт. Закон Гудхарта.', 'The model can be gamed: chase the signal (make the banner huge and sticky) and the score goes up while real attention may not. Goodhart’s law.', 'Model można „przeoptymalizować”: goniąc za sygnałem (ogromny, lepki baner) wynik rośnie, a realna uwaga niekoniecznie. Prawo Goodharta.'), AL('Гайдлайны IAB/MRC v1.0 финализированы в ноябре 2025: четыре семейства методов и путь к MRC-аккредитации (первым её получил DoubleVerify, IAS проходит аудит). Это стандарт методологии — но не единая метрика, как viewability.', 'The IAB/MRC Attention Measurement Guidelines v1.0 were finalised in November 2025: four method families and a path to MRC accreditation (DoubleVerify got it first, IAS is in audit). That standardises the methodology — but not the metric, the way viewability has one.', 'Wytyczne IAB/MRC v1.0 sfinalizowano w listopadzie 2025: cztery rodziny metod i ścieżka do akredytacji MRC (pierwszy uzyskał ją DoubleVerify, IAS jest w audycie). To standard metodologii — ale nie jedna metryka, jaką ma viewability.')];
  return /*#__PURE__*/React.createElement("div", {
    className: "att-methods"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-lad-intro"
  }, AL('Камеры на каждом показе нет — поэтому внимание не «замеряют», а моделируют. Цепочка одна и та же у всех вендоров:', 'There is no camera on every impression — so attention is not “measured”, it is modelled. The chain is the same at every vendor:', 'Nie ma kamery przy każdej odsłonie — więc uwagi się nie „mierzy”, tylko modeluje. Łańcuch jest ten sam u każdego dostawcy:')), flow.map((f, i) => /*#__PURE__*/React.createElement("div", {
    className: "att-step",
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-step-n"
  }, i + 1), /*#__PURE__*/React.createElement("div", {
    className: "att-step-b"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-step-t"
  }, f[0]), /*#__PURE__*/React.createElement("div", {
    className: "att-step-d"
  }, f[1])))), /*#__PURE__*/React.createElement("div", {
    className: "att-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, AL('Чем внимание НЕ является', 'What attention is NOT', 'Czym uwaga NIE jest')), nots.map((t, i) => /*#__PURE__*/React.createElement("div", {
    className: "att-li",
    key: i
  }, t))), /*#__PURE__*/React.createElement("div", {
    className: "att-block warn"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, AL('Ограничения — честно', 'Limits — honestly', 'Ograniczenia — szczerze')), limits.map((t, i) => /*#__PURE__*/React.createElement("div", {
    className: "att-li",
    key: i
  }, t))));
}
function AttentionVendors() {
  const P = () => AL('панель', 'panel', 'panel');
  const M = () => AL('модель', 'predictive', 'model');
  const rows = [['Adelaide', M(), 'AU (Attention Unit)', AL('Единый балл 0–100, омниканальный — часто используют как валюту закупки.', 'A single 0–100 omnichannel score — often used as a buying currency.', 'Pojedynczy wynik 0–100, omnikanałowy — często używany jako waluta zakupu.')], ['Lumen Research', P() + ' + ' + M(), AL('attention-секунды', 'attention seconds', 'sekundy uwagi'), AL('Классические eye-tracking панели; на них учат модель для масштаба.', 'Classic eye-tracking panels; the model for scale is trained on them.', 'Klasyczne panele eye-tracking; na nich uczy się model do skali.')], ['Amplified Intelligence', P(), 'attentionPROVE', AL('Машинное зрение на девайсе; исследования Karen Nelson-Field.', 'On-device machine vision; the Karen Nelson-Field research base.', 'Wizja maszynowa na urządzeniu; badania Karen Nelson-Field.')], ['DoubleVerify', M(), 'Authentic Attention', AL('Внутри стека верификации — рядом с фродом и brand safety.', 'Inside the verification stack — next to fraud and brand safety.', 'Wewnątrz stosu weryfikacji — obok fraudu i brand safety.')], ['Integral Ad Science (IAS)', M(), 'Quality Attention', AL('Тоже верификатор: соединяет viewability, вовлечение и контекст.', 'Also a verifier: blends viewability, engagement and context.', 'Też weryfikator: łączy viewability, zaangażowanie i kontekst.')], ['TVision', P(), AL('внимание на уровне человека', 'person-level attention', 'uwaga na poziomie osoby'), AL('Панели в домах — TV и CTV, где вебки нет.', 'In-home panels — TV and CTV, where there is no webcam.', 'Panele domowe — TV i CTV, gdzie nie ma kamerki.')], ['Realeyes', P(), AL('внимание + эмоция', 'attention + emotion', 'uwaga + emocja'), AL('Вебка и AI: не только «смотрел», но и «как реагировал».', 'Webcam and AI: not just “looked” but “how they reacted”.', 'Kamerka i AI: nie tylko „patrzył”, ale i „jak zareagował”.')]];
  return /*#__PURE__*/React.createElement("div", {
    className: "att-vendors"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-lad-intro"
  }, AL('Две школы: кто-то мерит панелью (истина, мало данных), кто-то моделирует по сигналам (масштаб). Верификаторы (DV, IAS) добавили attention к фроду и brand safety — так квалификация показа собирается в одном месте.', 'Two schools: some measure with a panel (truth, little data), some model from signals (scale). The verifiers (DV, IAS) bolted attention onto fraud and brand safety — so impression quality is assessed in one place.', 'Dwie szkoły: jedni mierzą panelem (prawda, mało danych), inni modelują z sygnałów (skala). Weryfikatorzy (DV, IAS) dołożyli uwagę do fraudu i brand safety — jakość odsłony ocenia się w jednym miejscu.')), /*#__PURE__*/React.createElement("div", {
    className: "att-vtable"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-vrow att-vth"
  }, /*#__PURE__*/React.createElement("span", null, AL('Вендор', 'Vendor', 'Dostawca')), /*#__PURE__*/React.createElement("span", null, AL('Подход', 'Approach', 'Podejście')), /*#__PURE__*/React.createElement("span", null, AL('Метрика', 'Metric', 'Metryka'))), rows.map(r => /*#__PURE__*/React.createElement("div", {
    className: "att-vrow",
    key: r[0]
  }, /*#__PURE__*/React.createElement("span", {
    className: "att-vn"
  }, r[0], /*#__PURE__*/React.createElement("i", null, r[3])), /*#__PURE__*/React.createElement("span", {
    className: 'att-vap' + (r[1].indexOf(AL('панель', 'panel', 'panel')) === 0 ? ' panel' : '')
  }, r[1]), /*#__PURE__*/React.createElement("span", {
    className: "att-vm"
  }, r[2])))), /*#__PURE__*/React.createElement("div", {
    className: "att-block warn"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, AL('Список — ориентир рынка, не рейтинг и не рекомендация. И главное: цифры разных вендоров НЕ сравнимы между собой — единого стандарта пока нет.', 'The list is a market reference, not a ranking or an endorsement. And crucially: numbers from different vendors are NOT comparable — there is no single standard yet.', 'Lista to punkt odniesienia rynku, nie ranking ani rekomendacja. I najważniejsze: liczby różnych dostawców NIE są porównywalne — wspólnego standardu jeszcze nie ma.'))));
}
function AttentionModule({
  open,
  onClose
}) {
  const [tab, setTab] = React.useState('ladder');
  const [sel, setSel] = React.useState(AT_DEFAULT);
  if (!open) return null;
  const tabs = [['ladder', AL('Лестница качества', 'Quality ladder', 'Drabina jakości')], ['cases', AL('Кейсы: есть / нет', 'Cases: yes / no', 'Kejsy: jest / nie ma')], ['meter', AL('Attention-метр', 'Attention meter', 'Miernik uwagi')], ['how', AL('Как меряют', 'How it is measured', 'Jak się mierzy')], ['who', AL('Кто меряет', 'Who measures', 'Kto mierzy')]];
  const openInMeter = s => {
    setSel(s);
    setTab('meter');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "compare-overlay",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "fraud-modal att",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": AL('Внимание (attention)', 'Attention', 'Uwaga'),
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "dive-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "cmp-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-title"
  }, AL('Внимание — attention', 'Attention', 'Uwaga — attention')), /*#__PURE__*/React.createElement("div", {
    className: "cmp-sub"
  }, AL('Следующая ступень качества после viewability: не «мог увидеть», а реально ли посмотрел и сколько.', 'The quality rung above viewability: not “could have seen” but did they actually look, and for how long.', 'Szczebel jakości ponad viewability: nie „mógł zobaczyć”, lecz czy naprawdę spojrzał i jak długo.'))), /*#__PURE__*/React.createElement("div", {
    className: "fraud-tabs att-tabs"
  }, tabs.map(t => /*#__PURE__*/React.createElement("button", {
    key: t[0],
    className: tab === t[0] ? 'on' : '',
    onClick: () => setTab(t[0])
  }, t[1]))), tab === 'ladder' && /*#__PURE__*/React.createElement(AttentionLadder, null), tab === 'cases' && /*#__PURE__*/React.createElement(AttentionCases, {
    onOpen: openInMeter
  }), tab === 'meter' && /*#__PURE__*/React.createElement(AttentionMeter, {
    sel: sel,
    setSel: setSel
  }), tab === 'how' && /*#__PURE__*/React.createElement(AttentionMethods, null), tab === 'who' && /*#__PURE__*/React.createElement(AttentionVendors, null)));
}
Object.assign(window, {
  AttentionModule
});

;
/* RTB Engine — Brand safety / suitability module.
   Tabs: floor vs suitability · same content different brands · the blocking tuner ·
   how it actually works · where it breaks · who measures and who decides.
   Two interactive surfaces: the brand switcher in the cases tab (the SAME content
   flips verdict per brand — the whole point of suitability) and bsRun(), the tuner
   that prices over-blocking. Every number in the tuner comes from ONE model so the
   tabs can never contradict each other.
   The tuner is directional/illustrative — the field has no audited quantification
   of blocklist-driven CPM inflation (the single credible estimate is a Hearst/Mobian
   "up to 27%"), so the UI labels it as a model, not a measurement.
   Trilingual via window.L. Reuses the fraud-modal shell; sky accent (#38bdf8).
   NOTE: modules share ONE top-level scope after concat — helper must be uniquely
   named (rtb-fraud owns FL, rtb-extras L3, rtb-attention AL), hence BL. */
const BL = (ru, en, pl) => window.L(ru, en, pl);

/* ─────────────────── Floor + suitability framework ─────────────────── */
/* The 12 categories of the GARM Brand Safety Floor + Suitability Framework
   (final version, June 2022 — the PDF's own prose still says "eleven", stale text
   from the Sept 2020 original). GARM closed in Aug 2024; the structure survived,
   de-branded, inside the IAB Tech Lab Content Taxonomy as "Sensitive Topics". */
const BS_CATS = () => [BL('Секс и откровенный контент', 'Adult & explicit sexual content', 'Treści dla dorosłych i seksualne'), BL('Оружие и боеприпасы', 'Arms & ammunition', 'Broń i amunicja'), BL('Преступления и нарушения прав человека', 'Crime & human rights violations', 'Przestępstwa i łamanie praw człowieka'), BL('Смерть, травмы, военный конфликт', 'Death, injury or military conflict', 'Śmierć, obrażenia, konflikt zbrojny'), BL('Онлайн-пиратство', 'Online piracy', 'Piractwo internetowe'), BL('Язык вражды и агрессия', 'Hate speech & acts of aggression', 'Mowa nienawiści i agresja'), BL('Обсценная лексика и шок-контент', 'Obscenity & profanity', 'Wulgaryzmy i treści szokujące'), BL('Наркотики, табак, вейпы, алкоголь', 'Drugs, tobacco, vaping, alcohol', 'Narkotyki, tytoń, vaping, alkohol'), BL('Спам и вредоносный контент', 'Spam or harmful content', 'Spam i treści szkodliwe'), BL('Терроризм', 'Terrorism', 'Terroryzm'), BL('Острые социальные темы', 'Debated sensitive social issues', 'Sporne kwestie społeczne'), BL('Дезинформация', 'Misinformation', 'Dezinformacja')];
function BrandFloor() {
  const tiers = [['floor', '#fb7185', BL('Brand Safety Floor — ворота', 'Brand Safety Floor — a gate', 'Brand Safety Floor — bramka'), BL('Отдельный СПИСОК контента, который не должен монетизироваться вообще никем: детская эксплуатация, терроризм, пиратство, разжигание ненависти. Это не «уровень риска» — это бинарные ворота. Прошёл или нет.', 'A separate LIST of content that should not be monetised by anyone at all: child exploitation, terrorism, piracy, incitement. This is not a "risk level" — it is a binary gate. You pass or you do not.', 'Osobna LISTA treści, których nikt nie powinien monetyzować: wykorzystywanie dzieci, terroryzm, piractwo, podżeganie. To nie „poziom ryzyka” — to bramka binarna. Przechodzisz albo nie.')], ['high', '#fb923c', BL('High Risk', 'High Risk', 'Wysokie ryzyko'), BL('Прошло ворота, но подано как ГЛОРИФИКАЦИЯ или самоцельная демонстрация: романтизация насилия, наркотиков, оружия ради шока.', 'Past the gate, but framed as GLORIFICATION or gratuitous depiction: romanticising violence, drugs or weapons for shock value.', 'Za bramką, ale podane jako GLORYFIKACJA lub demonstracja dla samej demonstracji: romantyzowanie przemocy, narkotyków, broni dla szoku.')], ['med', '#fbbf24', BL('Medium Risk', 'Medium Risk', 'Średnie ryzyko'), BL('Драматическая подача в художественном контенте — и срочные новости, репортаж с места, авторская колонка.', 'Dramatic depiction in entertainment — and breaking news, on-the-ground reporting, op-ed.', 'Dramatyczne ujęcie w treściach rozrywkowych — oraz pilne wiadomości, reportaż z miejsca, felieton.')], ['low', '#34d399', BL('Low Risk', 'Low Risk', 'Niskie ryzyko'), BL('Образовательная, научная, справочная подача — и новостные фичеры, разборы, аналитика.', 'Educational, scientific, informative treatment — and news features, explainers, analysis.', 'Ujęcie edukacyjne, naukowe, informacyjne — oraz materiały pogłębione, wyjaśnienia, analizy.')]];
  return /*#__PURE__*/React.createElement("div", {
    className: "bs-floor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-lad-intro"
  }, BL('Главное недоразумение в этой теме: «Floor / High / Medium / Low» — это НЕ одна шкала из четырёх делений. Это два разных объекта. Сначала бинарные ворота, потом — шкала риска для всего, что ворота прошло.', 'The core confusion in this field: "Floor / High / Medium / Low" is NOT one four-step scale. They are two different objects. First a binary gate, then a risk scale for everything that passed it.', 'Główne nieporozumienie w tym temacie: „Floor / High / Medium / Low” to NIE jedna czterostopniowa skala. To dwa różne obiekty. Najpierw bramka binarna, potem skala ryzyka dla wszystkiego, co ją przeszło.')), tiers.map(t => /*#__PURE__*/React.createElement("div", {
    className: 'bs-tier' + (t[0] === 'floor' ? ' gate' : ''),
    key: t[0]
  }, /*#__PURE__*/React.createElement("div", {
    className: "bs-tier-bar",
    style: {
      background: t[1]
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "bs-tier-b"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bs-tier-t",
    style: {
      color: t[1]
    }
  }, t[2]), /*#__PURE__*/React.createElement("div", {
    className: "bs-tier-d"
  }, t[3])))), /*#__PURE__*/React.createElement("div", {
    className: "att-take"
  }, BL('Обрати внимание на градиент: одна и та же тема падает в High, Medium или Low в зависимости от ПОДАЧИ, а не от темы. И по устройству самой рамки новостное освещение никогда не попадает в High Risk. То есть массовая блокировка новостей — это нарушение той самой рамки, на которую при этом ссылаются.', 'Notice the gradient: the same topic lands in High, Medium or Low depending on the TREATMENT, not the topic. And by the framework’s own design, news coverage is never High Risk. So blocking news wholesale violates the very framework people cite while doing it.', 'Zwróć uwagę na gradient: ten sam temat trafia do High, Medium lub Low w zależności od UJĘCIA, nie od tematu. I z samej konstrukcji ram informacje prasowe nigdy nie są High Risk. Masowe blokowanie newsów łamie więc te ramy, na które przy tym się powołuje.')), /*#__PURE__*/React.createElement("div", {
    className: "att-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('12 категорий рамки', 'The 12 framework categories', '12 kategorii ram')), /*#__PURE__*/React.createElement("div", {
    className: "bs-cats"
  }, BS_CATS().map((c, i) => /*#__PURE__*/React.createElement("span", {
    className: "bs-cat",
    key: i
  }, c)))), /*#__PURE__*/React.createElement("div", {
    className: "att-illus"
  }, BL('GARM Brand Safety Floor + Suitability Framework, финальная версия — июнь 2022. В самом PDF в тексте написано «одиннадцать»: строку не обновили, когда в 2021-м добавили «Дезинформацию». Отсюда вечный спор 11 или 12 — категорий 12.', 'GARM Brand Safety Floor + Suitability Framework, final version June 2022. The PDF’s own prose says "eleven": the sentence was never updated when Misinformation was added in 2021. Hence the perennial 11-vs-12 argument — there are 12.', 'GARM Brand Safety Floor + Suitability Framework, wersja finalna — czerwiec 2022. W samym PDF tekst mówi „jedenaście”: zdania nie zaktualizowano, gdy w 2021 dodano „Dezinformację”. Stąd wieczny spór 11 czy 12 — kategorii jest 12.')));
}

/* ─────────────────── Cases: same content, different brand ─────────────────── */
/* verdict codes: bad = не подходит, ok = нейтрально, good = идеальный контекст */
const BS_BRANDS = () => [{
  id: 'kids',
  n: BL('Детский бренд', 'Kids’ brand', 'Marka dziecięca'),
  note: BL('Игрушки, детское питание. Самый узкий коридор — и по репутации, и по закону.', 'Toys, baby food. The narrowest corridor — reputationally and legally.', 'Zabawki, żywność dla dzieci. Najwęższy korytarz — reputacyjnie i prawnie.')
}, {
  id: 'beer',
  n: BL('Алкогольный бренд', 'Alcohol brand', 'Marka alkoholowa'),
  note: BL('Обратный случай: детский контент для него запрещён, а «взрослый» — норма. Ограничение работает в другую сторону.', 'The inverse case: kids’ content is forbidden for it, while "adult" context is normal. The constraint runs the other way.', 'Przypadek odwrotny: treści dziecięce są dla niej zakazane, a kontekst „dorosły” jest normą. Ograniczenie działa w drugą stronę.')
}, {
  id: 'auto',
  n: BL('Автомобильный бренд', 'Automotive brand', 'Marka motoryzacyjna'),
  note: BL('Классическая проблема соседства: авария в новостях рядом с рекламой машины.', 'The classic adjacency problem: a crash in the news next to a car ad.', 'Klasyczny problem sąsiedztwa: wypadek w newsach obok reklamy samochodu.')
}, {
  id: 'ins',
  n: BL('Страхование / финансы', 'Insurance / finance', 'Ubezpieczenia / finanse'),
  note: BL('Тот же самый контент, что убивает автобренд, для него — целевая аудитория в момент потребности.', 'The very content that kills the auto brand is, for this one, the target audience at the moment of need.', 'Ta sama treść, która zabija markę motoryzacyjną, dla niej jest grupą docelową w momencie potrzeby.')
}, {
  id: 'game',
  n: BL('Игровой бренд', 'Gaming brand', 'Marka gamingowa'),
  note: BL('Насилие в игровом контексте — его родная среда, а не риск.', 'Violence in a gaming context is its native habitat, not a risk.', 'Przemoc w kontekście gier to jego naturalne środowisko, nie ryzyko.')
}];
const BS_CONTENT = () => [{
  id: 'cartoon',
  n: BL('Детский мультсериал', 'Kids’ cartoon series', 'Serial animowany dla dzieci'),
  v: {
    kids: 'good',
    beer: 'bad',
    auto: 'ok',
    ins: 'ok',
    game: 'ok'
  },
  w: {
    beer: BL('Запрещено регулятором — и вдобавок чистая трата денег: аудитория не может купить продукт.', 'Forbidden by the regulator — and on top of that pure waste: the audience cannot buy the product.', 'Zakazane przez regulatora — i do tego czysta strata: ta widownia nie może kupić produktu.'),
    kids: BL('Идеальное совпадение контекста и аудитории.', 'A perfect match of context and audience.', 'Idealne dopasowanie kontekstu i odbiorcy.')
  }
}, {
  id: 'binge',
  n: BL('«5 коктейлей, которые валят с ног»', '"5 drinks that knock you out fast"', '„5 drinków, które szybko zwalają z nóg”'),
  v: {
    kids: 'bad',
    beer: 'bad',
    auto: 'bad',
    ins: 'bad',
    game: 'bad'
  },
  w: {
    beer: BL('Категория «алкоголь» — своя, но подача глорифицирует злоупотребление. Для алкобренда это High Risk по его же кодексу ответственного маркетинга.', 'The "alcohol" category is its own, but the treatment glorifies abuse. For an alcohol brand that is High Risk under its own responsible-marketing code.', 'Kategoria „alkohol” jest własna, ale ujęcie gloryfikuje nadużywanie. Dla marki alkoholowej to High Risk wg jej własnego kodeksu.'),
    ins: BL('Единственная строка, которая не подходит вообще никому из пятерых. Это и есть признак близости к «полу»: чем ближе контент к Floor, тем меньше остаётся места для разных мнений.', 'The one row that suits none of the five. That is precisely the signature of proximity to the Floor: the closer content sits to it, the less room is left for differing opinions.', 'Jedyny wiersz, który nie pasuje żadnej z pięciu marek. To właśnie sygnatura bliskości „progu”: im bliżej Floor, tym mniej miejsca na różne opinie.'),
    game: BL('Аудитория игровых брендов заметно моложе — глорификация опьянения вне коридора даже для довольно свободного бренда.', 'Gaming brands skew notably younger — glorified intoxication is outside the corridor even for a fairly permissive brand.', 'Widownia marek gamingowych jest wyraźnie młodsza — gloryfikacja upojenia jest poza korytarzem nawet dla dość swobodnej marki.')
  }
}, {
  id: 'wine',
  n: BL('«Вина к праздничному столу»', '"Wines to pair with the holiday table"', '„Wina na świąteczny stół”'),
  v: {
    kids: 'bad',
    beer: 'good',
    auto: 'ok',
    ins: 'ok',
    game: 'ok'
  },
  w: {
    beer: BL('Та же категория «алкоголь» — и прямо противоположный вердикт: подача про ответственное потребление. Категория не решает, решает подача.', 'The same "alcohol" category — and the opposite verdict: the treatment is about responsible consumption. The category does not decide, the treatment does.', 'Ta sama kategoria „alkohol” — i przeciwny werdykt: ujęcie dotyczy odpowiedzialnej konsumpcji. Nie kategoria decyduje, lecz ujęcie.')
  }
}, {
  id: 'crash',
  n: BL('Новость о смертельном ДТП', 'News report on a fatal car crash', 'Wiadomość o śmiertelnym wypadku'),
  v: {
    kids: 'bad',
    beer: 'ok',
    auto: 'bad',
    ins: 'good',
    game: 'ok'
  },
  w: {
    auto: BL('Соседство убийственное: реклама машины рядом с репортажем о гибели в машине.', 'The adjacency is lethal: a car ad next to a report about people dying in a car.', 'Sąsiedztwo zabójcze: reklama auta obok reportażu o śmierci w aucie.'),
    ins: BL('Для страховщика это точный момент потребности — тот же показ, обратный знак.', 'For an insurer this is the exact moment of need — the same impression, opposite sign.', 'Dla ubezpieczyciela to dokładny moment potrzeby — ta sama odsłona, przeciwny znak.')
  }
}, {
  id: 'invest',
  n: BL('Расследование о мировой преступности', 'Long-form investigation into global crime', 'Śledztwo o przestępczości na świecie'),
  v: {
    kids: 'bad',
    beer: 'ok',
    auto: 'ok',
    ins: 'good',
    game: 'ok'
  },
  w: {
    ins: BL('Премиальный, дорогой, тщательно проверенный материал — и почти всегда заблокирован списком слов. Ровно та потеря, о которой вкладка «Где ломается».', 'Premium, expensive, heavily fact-checked journalism — and almost always blocked by a keyword list. Exactly the loss the "Where it breaks" tab is about.', 'Premium, drogi, rzetelnie sprawdzony materiał — i niemal zawsze zablokowany listą słów. Dokładnie ta strata, o której mówi zakładka „Gdzie się psuje”.')
  }
}, {
  id: 'mma',
  n: BL('Трансляция боёв MMA', 'MMA fight broadcast', 'Transmisja walk MMA'),
  v: {
    kids: 'bad',
    beer: 'good',
    auto: 'ok',
    ins: 'ok',
    game: 'good'
  },
  w: {
    kids: BL('Насилие как развлечение — вне коридора детского бренда.', 'Violence as entertainment — outside a kids’ brand’s corridor.', 'Przemoc jako rozrywka — poza korytarzem marki dziecięcej.')
  }
}, {
  id: 'shooter',
  n: BL('Стрим шутера на Twitch', 'Shooter stream on Twitch', 'Stream strzelanki na Twitchu'),
  v: {
    kids: 'bad',
    beer: 'ok',
    auto: 'ok',
    ins: 'ok',
    game: 'good'
  },
  w: {
    game: BL('Формально категории «оружие» и «насилие» — но в игровом контексте это и есть целевая среда. Классификатор, который смотрит только на категорию, теряет здесь всю аудиторию.', 'Formally the "arms" and "violence" categories — but in a gaming context this IS the target environment. A classifier that only looks at the category loses the entire audience here.', 'Formalnie kategorie „broń” i „przemoc” — ale w kontekście gier to właśnie środowisko docelowe. Klasyfikator patrzący tylko na kategorię traci tu całą widownię.')
  }
}];
const BS_VMARK = {
  good: '✓',
  ok: '~',
  bad: '✗'
};
const BS_VCOLOR = {
  good: '#34d399',
  ok: '#8aa0c6',
  bad: '#fb7185'
};
const BS_VTEXT = v => v === 'good' ? BL('идеальный контекст', 'ideal context', 'idealny kontekst') : v === 'ok' ? BL('нейтрально', 'neutral', 'neutralnie') : BL('не подходит', 'unsuitable', 'nieodpowiednie');
function BrandCases() {
  const brands = BS_BRANDS();
  const [b, setB] = React.useState('auto');
  const brand = brands.find(x => x.id === b) || brands[0];
  const items = BS_CONTENT();
  const bad = items.filter(c => c.v[b] === 'bad').length;
  return /*#__PURE__*/React.createElement("div", {
    className: "bs-cases"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-lad-intro"
  }, BL('Brand safety одинакова для всех. Suitability — у каждого своя. Выбери бренд и смотри, как ОДИН И ТОТ ЖЕ набор контента меняет вердикты.', 'Brand safety is the same for everyone. Suitability is different for each. Pick a brand and watch the SAME set of content flip its verdicts.', 'Brand safety jest jednakowe dla wszystkich. Suitability — dla każdego inne. Wybierz markę i zobacz, jak TEN SAM zestaw treści zmienia werdykty.')), /*#__PURE__*/React.createElement("div", {
    className: "att-chips bs-brandpick"
  }, brands.map(x => /*#__PURE__*/React.createElement("button", {
    key: x.id,
    className: 'att-chip' + (b === x.id ? ' on' : ''),
    onClick: () => setB(x.id)
  }, x.n))), /*#__PURE__*/React.createElement("div", {
    className: "bs-brandnote"
  }, brand.note), /*#__PURE__*/React.createElement("div", {
    className: "bs-clist"
  }, items.map(c => {
    const v = c.v[b];
    const why = c.w && c.w[b];
    return /*#__PURE__*/React.createElement("div", {
      className: 'bs-citem ' + v,
      key: c.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "bs-cmark",
      style: {
        color: BS_VCOLOR[v],
        borderColor: BS_VCOLOR[v]
      }
    }, BS_VMARK[v]), /*#__PURE__*/React.createElement("div", {
      className: "bs-cb"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bs-cn"
    }, c.n), /*#__PURE__*/React.createElement("div", {
      className: "bs-cv",
      style: {
        color: BS_VCOLOR[v]
      }
    }, BS_VTEXT(v)), why && /*#__PURE__*/React.createElement("div", {
      className: "bs-cw"
    }, why)));
  })), /*#__PURE__*/React.createElement("div", {
    className: "att-take"
  }, BL('Для этого бренда не подходит ' + bad + ' из ' + items.length + '. Смени бренд — набор изменится, контент останется тем же. Отсюда два вывода: suitability невозможно свести к одному списку «плохих» сайтов, и она работает не только на запрет — «идеальный контекст» это тоже suitability, только со знаком плюс (inclusion-листы вместо exclusion).', 'For this brand ' + bad + ' of ' + items.length + ' are unsuitable. Switch brands and the set changes while the content stays identical. Two conclusions: suitability cannot be reduced to one list of "bad" sites, and it is not only about blocking — "ideal context" is suitability too, with a plus sign (inclusion lists, not exclusion).', 'Dla tej marki nieodpowiednie jest ' + bad + ' z ' + items.length + '. Zmień markę — zestaw się zmieni, treść pozostanie ta sama. Dwa wnioski: suitability nie da się sprowadzić do jednej listy „złych” stron, i nie chodzi tylko o blokowanie — „idealny kontekst” to też suitability, ze znakiem plus (listy inclusion zamiast exclusion).')));
}

/* ─────────────────── The tuner: what blocking actually costs ─────────────────── */
/* Illustrative composition of a broad open-web buy, shares sum to 100.
   tier = the worst suitability tier that applies; news = professional editorial. */
const BS_POOL = () => [{
  id: 'floorreal',
  share: 2,
  tier: 'floor',
  news: false,
  n: BL('Реально запрещённый контент', 'Genuinely prohibited content', 'Treści faktycznie zakazane')
}, {
  id: 'ugc',
  share: 10,
  tier: 'high',
  news: false,
  n: BL('UGC-площадки без модерации', 'Unmoderated UGC platforms', 'Platformy UGC bez moderacji')
}, {
  id: 'newshard',
  share: 13,
  tier: 'med',
  news: true,
  n: BL('Новости: война, катастрофы, преступления', 'News: war, disasters, crime', 'Newsy: wojna, katastrofy, przestępstwa')
}, {
  id: 'newssoft',
  share: 11,
  tier: 'low',
  news: true,
  n: BL('Новости: аналитика, разборы, фичеры', 'News: analysis, explainers, features', 'Newsy: analizy, wyjaśnienia, materiały pogłębione')
}, {
  id: 'ent',
  share: 16,
  tier: 'med',
  news: false,
  n: BL('Развлечения, сериалы, музыка', 'Entertainment, series, music', 'Rozrywka, seriale, muzyka')
}, {
  id: 'games',
  share: 9,
  tier: 'med',
  news: false,
  n: BL('Игры и киберспорт', 'Games and esports', 'Gry i esport')
}, {
  id: 'sport',
  share: 10,
  tier: 'low',
  news: false,
  n: BL('Спорт', 'Sport', 'Sport')
}, {
  id: 'life',
  share: 24,
  tier: 'none',
  news: false,
  n: BL('Лайфстайл, рецепты, дом, авто', 'Lifestyle, recipes, home, auto', 'Lifestyle, przepisy, dom, auto')
}, {
  id: 'mfa',
  share: 5,
  tier: 'none',
  news: false,
  n: BL('MFA — сайты, сделанные под рекламу', 'MFA — made-for-advertising sites', 'MFA — strony zrobione pod reklamę')
}];

/* catch = доля целевого контента, которую метод реально ловит;
   fpNews / fpOther = доля ЛОЖНЫХ срабатываний на нецелевом контенте. */
const BS_METHODS = {
  none: {
    catch: 0,
    fpNews: 0,
    fpOther: 0
  },
  keyword: {
    catch: 0.55,
    fpNews: 0.42,
    fpOther: 0.07
  },
  context: {
    catch: 0.80,
    fpNews: 0.11,
    fpOther: 0.03
  },
  content: {
    catch: 0.92,
    fpNews: 0.05,
    fpOther: 0.015
  }
};
const BS_METHOD_OPTS = () => [['none', BL('Ничего', 'Nothing', 'Nic')], ['keyword', BL('Список слов', 'Keyword list', 'Lista słów')], ['context', BL('Контекстный анализ', 'Contextual analysis', 'Analiza kontekstowa')], ['content', BL('Разбор контента (AI)', 'Content-level AI', 'Analiza treści (AI)')]];
const BS_THRESH = {
  floor: {
    hits: ['floor'],
    aggr: 0.30
  },
  high: {
    hits: ['floor', 'high'],
    aggr: 0.65
  },
  med: {
    hits: ['floor', 'high', 'med'],
    aggr: 1.00
  },
  all: {
    hits: ['floor', 'high', 'med', 'low'],
    aggr: 1.55
  }
};
const BS_THRESH_OPTS = () => [['floor', BL('Только Floor', 'Floor only', 'Tylko Floor')], ['high', BL('+ High Risk', '+ High Risk', '+ High Risk')], ['med', BL('+ Medium Risk', '+ Medium Risk', '+ Medium Risk')], ['all', BL('Блокировать всё спорное', 'Block anything debatable', 'Blokować wszystko sporne')]];
const BS_TUNER_DEFAULT = {
  method: 'keyword',
  thresh: 'med'
};
function bsRun(sel) {
  const m = BS_METHODS[sel.method] || BS_METHODS.none;
  const th = BS_THRESH[sel.thresh] || BS_THRESH.floor;
  let hit = 0,
    fp = 0,
    missed = 0,
    newsLost = 0,
    newsTotal = 0;
  BS_POOL().forEach(p => {
    if (p.news) newsTotal += p.share;
    if (th.hits.indexOf(p.tier) >= 0) {
      const b = p.share * m.catch;
      hit += b;
      missed += p.share - b;
      if (p.news) newsLost += b;
    } else {
      const f = Math.min(p.share, p.share * (p.news ? m.fpNews : m.fpOther) * th.aggr);
      fp += f;
      if (p.news) newsLost += f;
    }
  });
  const blocked = Math.min(99, hit + fp);
  const reach = Math.max(1, 100 - blocked);
  // bid density falls with the pool → the same budget pays more per impression.
  const cpm = Math.round((Math.pow(100 / reach, 0.35) - 1) * 100);
  const precision = hit + fp > 0 ? Math.round(hit / (hit + fp) * 100) : 0;
  return {
    blocked: Math.round(blocked),
    reach: Math.round(reach),
    cpm,
    precision,
    missed: Math.round(missed * 10) / 10,
    newsLost: Math.round(newsLost / newsTotal * 100)
  };
}
function BrandTuner({
  sel,
  setSel
}) {
  const set = (k, v) => setSel({
    ...sel,
    [k]: v
  });
  const r = bsRun(sel);
  const band = r.newsLost > 45 ? '#fb7185' : r.newsLost > 20 ? '#fbbf24' : '#34d399';
  let insight;
  if (sel.method === 'none') {
    insight = BL('Без всякой фильтрации ты не теряешь охват — и покупаешь всё, включая то, что действительно нельзя. Ноль защиты это тоже решение, просто редко осознанное.', 'With no filtering at all you lose no reach — and you buy everything, including what genuinely must not be bought. Zero protection is a decision too, just rarely a conscious one.', 'Bez żadnego filtrowania nie tracisz zasięgu — i kupujesz wszystko, łącznie z tym, czego naprawdę nie wolno. Zero ochrony to też decyzja, tylko rzadko świadoma.');
  } else if (sel.method === 'keyword' && (sel.thresh === 'med' || sel.thresh === 'all')) {
    insight = BL('Худшая из распространённых комбинаций: список слов не понимает контекста, а высокий порог усиливает каждое ложное срабатывание. Основной удар приходится по профессиональным новостям — по тому самому инвентарю, который рамка никогда не относила к High Risk.', 'The worst of the common combinations: a keyword list has no understanding of context, and a high threshold amplifies every false positive. The damage lands on professional news — the very inventory the framework never classified as High Risk.', 'Najgorsza z popularnych kombinacji: lista słów nie rozumie kontekstu, a wysoki próg wzmacnia każdy fałszywy alarm. Uderzenie spada na profesjonalne newsy — dokładnie ten inwentarz, którego ramy nigdy nie uznały za High Risk.');
  } else if (sel.thresh === 'floor' && sel.method !== 'none') {
    insight = BL('Порог только по Floor — это то, что реально универсально. Охват почти цел, но всё, что выше пола, ты покупаешь как есть: дальше начинается уже suitability, то есть твоё собственное решение.', 'A Floor-only threshold is the part that is genuinely universal. Reach stays almost intact, but everything above the floor you buy as-is: beyond that it is suitability — that is, your own decision.', 'Próg tylko na Floor to część naprawdę uniwersalna. Zasięg pozostaje niemal nietknięty, ale wszystko powyżej progu kupujesz jak leci: dalej zaczyna się suitability, czyli twoja własna decyzja.');
  } else if (sel.thresh === 'all') {
    insight = BL('Осторожно с этой цифрой: «попало в твоё правило» здесь почти 100% — но только потому, что правило ты растянул на всё подряд. Точность измеряет соответствие твоей же политике, а не разумность политики. Реальная цена видна в соседней колонке — доле потерянных новостей.', 'Careful with that number: "matches the rule you set" is near 100% here — but only because you stretched the rule to cover everything. Precision measures conformance to your own policy, not whether the policy is sensible. The real price is in the next column: the share of news lost.', 'Ostrożnie z tą liczbą: „trafia w twoją regułę” jest tu bliskie 100% — ale tylko dlatego, że rozciągnąłeś regułę na wszystko. Precyzja mierzy zgodność z twoją własną polityką, a nie to, czy polityka jest sensowna. Prawdziwa cena jest w sąsiedniej kolumnie: udział utraconych newsów.');
  } else if (sel.method === 'content') {
    insight = BL('Разбор самого контента (картинка, видео, звук, речь) даёт лучшую точность — но он дороже и покрывает не весь инвентарь. Именно нехватка покрытия, а не качество модели, обычно и остаётся узким местом.', 'Analysing the content itself (image, video, audio, speech) gives the best precision — but it costs more and does not cover all inventory. It is usually the coverage gap, not model quality, that remains the bottleneck.', 'Analiza samej treści (obraz, wideo, dźwięk, mowa) daje najlepszą precyzję — ale kosztuje więcej i nie pokrywa całego inwentarza. To zwykle luka w pokryciu, a nie jakość modelu, pozostaje wąskim gardłem.');
  } else {
    insight = BL('Контекстный анализ понимает, что «стрельба» в спортивном репортаже и в криминальной хронике — разные вещи. Точность заметно выше списка слов при сопоставимом охвате.', 'Contextual analysis understands that "shooting" in a sports report and in a crime report are different things. Precision is markedly better than a keyword list at comparable reach.', 'Analiza kontekstowa rozumie, że „strzał” w relacji sportowej i w kronice kryminalnej to co innego. Precyzja jest wyraźnie lepsza niż przy liście słów przy porównywalnym zasięgu.');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "bs-tuner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-lad-intro"
  }, BL('Блокировка не бесплатна. Каждый фильтр одновременно убирает опасное и режет нормальное — и обе стороны за это платят. Покрути настройки и смотри на цену.', 'Blocking is not free. Every filter removes the dangerous and cuts the legitimate at the same time — and both sides pay for it. Turn the dials and watch the price.', 'Blokowanie nie jest darmowe. Każdy filtr jednocześnie usuwa niebezpieczne i tnie normalne — i obie strony za to płacą. Pokręć ustawieniami i patrz na cenę.')), /*#__PURE__*/React.createElement("div", {
    className: "att-sigs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-sig"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('Чем классифицируем', 'Classification method', 'Metoda klasyfikacji')), /*#__PURE__*/React.createElement("div", {
    className: "att-chips"
  }, BS_METHOD_OPTS().map(o => /*#__PURE__*/React.createElement("button", {
    key: o[0],
    className: 'att-chip' + (sel.method === o[0] ? ' on' : ''),
    onClick: () => set('method', o[0])
  }, o[1])))), /*#__PURE__*/React.createElement("div", {
    className: "att-sig"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('Что блокируем', 'Blocking threshold', 'Próg blokowania')), /*#__PURE__*/React.createElement("div", {
    className: "att-chips"
  }, BS_THRESH_OPTS().map(o => /*#__PURE__*/React.createElement("button", {
    key: o[0],
    className: 'att-chip' + (sel.thresh === o[0] ? ' on' : ''),
    onClick: () => set('thresh', o[0])
  }, o[1]))))), /*#__PURE__*/React.createElement("div", {
    className: "bs-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bs-metric"
  }, /*#__PURE__*/React.createElement("b", null, r.reach, /*#__PURE__*/React.createElement("i", null, "%")), /*#__PURE__*/React.createElement("span", null, BL('охвата осталось', 'of reach left', 'zasięgu zostało'))), /*#__PURE__*/React.createElement("div", {
    className: "bs-metric"
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      color: band
    }
  }, r.newsLost, /*#__PURE__*/React.createElement("i", null, "%")), /*#__PURE__*/React.createElement("span", null, BL('новостей потеряно', 'of news lost', 'newsów utracone'))), /*#__PURE__*/React.createElement("div", {
    className: "bs-metric"
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      color: r.blocked === 0 ? 'var(--faint)' : r.precision < 55 ? '#fb7185' : r.precision < 80 ? '#fbbf24' : '#34d399'
    }
  }, r.blocked === 0 ? '—' : r.precision, r.blocked > 0 && /*#__PURE__*/React.createElement("i", null, "%")), /*#__PURE__*/React.createElement("span", null, BL('блокировок попало в твоё правило', 'of blocks match the rule you set', 'blokad trafia w twoją regułę'))), /*#__PURE__*/React.createElement("div", {
    className: "bs-metric"
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      color: r.cpm > 25 ? '#fb7185' : r.cpm > 10 ? '#fbbf24' : '#34d399'
    }
  }, "+", r.cpm, /*#__PURE__*/React.createElement("i", null, "%")), /*#__PURE__*/React.createElement("span", null, BL('к цене за показ', 'to cost per impression', 'do ceny za odsłonę')))), /*#__PURE__*/React.createElement("div", {
    className: "bs-split"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bs-splitrow"
  }, /*#__PURE__*/React.createElement("span", null, BL('Заблокировано всего', 'Blocked in total', 'Zablokowano łącznie')), /*#__PURE__*/React.createElement("b", null, r.blocked, "%")), /*#__PURE__*/React.createElement("div", {
    className: "bs-splittrack"
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      width: r.precision * r.blocked / 100 + '%',
      background: '#38bdf8'
    }
  }), /*#__PURE__*/React.createElement("i", {
    style: {
      width: (100 - r.precision) * r.blocked / 100 + '%',
      background: '#fb7185'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "bs-legend"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("em", {
    style: {
      background: '#38bdf8'
    }
  }), BL('по твоему правилу', 'match your rule', 'zgodnie z regułą')), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("em", {
    style: {
      background: '#fb7185'
    }
  }), BL('ложные срабатывания', 'false positives', 'fałszywe alarmy')), /*#__PURE__*/React.createElement("span", {
    className: "bs-missed"
  }, BL('и всё равно прошло мимо: ', 'and still got through: ', 'i tak przeszło: '), /*#__PURE__*/React.createElement("b", null, r.missed, "%")))), /*#__PURE__*/React.createElement("div", {
    className: "att-insight"
  }, insight), /*#__PURE__*/React.createElement("div", {
    className: "att-block warn"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('Обрати внимание: обе стороны в минусе. Паблишер теряет проданный инвентарь, а рекламодатель тем же бюджетом гонится за меньшим пулом — и платит больше за меньший охват. Это не осторожность, это игра с отрицательной суммой.', 'Notice that both sides lose. The publisher loses sold inventory, while the advertiser chases a smaller pool with the same budget — paying more for less reach. This is not caution, it is a negative-sum trade.', 'Zauważ, że obie strony tracą. Wydawca traci sprzedany inwentarz, a reklamodawca tym samym budżetem goni mniejszą pulę — płacąc więcej za mniejszy zasięg. To nie ostrożność, to gra o sumie ujemnej.'))), /*#__PURE__*/React.createElement("div", {
    className: "att-illus"
  }, BL('Модель иллюстративная. Доли инвентаря и ошибки методов — порядок величин по индустрии; надбавка к цене выведена из падения плотности ставок, а не измерена. Единственная публичная количественная оценка этого эффекта — совместная прикидка Hearst и Mobian: исправление ошибочной классификации новостей могло бы снизить CPM «до 27%». Независимого аудита этой цифры нет.', 'Illustrative model. Inventory shares and method error rates are industry order-of-magnitude; the price uplift is derived from falling bid density, not measured. The only public quantified estimate of this effect is a joint Hearst/Mobian figure: fixing news misclassification could cut CPMs by "up to 27%". No independent audit of that number exists.', 'Model ilustracyjny. Udziały inwentarza i błędy metod to rząd wielkości wg branży; narzut cenowy wyprowadzono ze spadku gęstości stawek, nie zmierzono. Jedyne publiczne oszacowanie tego efektu to wspólna kalkulacja Hearst i Mobian: naprawa błędnej klasyfikacji newsów mogłaby obniżyć CPM „nawet o 27%”. Nie ma niezależnego audytu tej liczby.')));
}

/* ─────────────────── How it actually works ─────────────────── */
function BrandHow() {
  const flow = [[BL('Классификация — заранее, не в момент ставки', 'Classification happens up front, not at bid time', 'Klasyfikacja z wyprzedzeniem, nie w momencie licytacji'), BL('Вендор краулит страницы и разбирает контент заранее: текст, а у сильных — картинку, видео, звук и речь. На это есть часы или дни. В момент аукциона на разбор есть ~10 миллисекунд, поэтому там уже ничего не анализируют.', 'The vendor crawls pages and analyses content ahead of time: text, and at the stronger vendors image, video, audio and speech. That has hours or days. At auction time there are ~10 milliseconds, so nothing is analysed there.', 'Dostawca craweluje strony i analizuje treść z wyprzedzeniem: tekst, a u mocniejszych obraz, wideo, dźwięk i mowę. Na to są godziny lub dni. W momencie aukcji jest ~10 milisekund, więc tam już nic się nie analizuje.')], [BL('Результат кладут в таблицу по идентификатору', 'The result is stored in a table keyed by identifier', 'Wynik trafia do tabeli po identyfikatorze'), BL('Вердикт привязывают к URL, домену, app-bundle или content ID. Дальше это просто справочник: ключ → категории и уровни риска.', 'The verdict is attached to a URL, domain, app bundle or content ID. From then on it is just a lookup table: key → categories and risk levels.', 'Werdykt przypisuje się do URL, domeny, app bundle lub content ID. Dalej to już zwykły słownik: klucz → kategorie i poziomy ryzyka.')], [BL('В аукционе это ПОИСК ПО КЭШУ, а не сигнал в запросе', 'At auction it is a CACHE LOOKUP, not a signal in the request', 'Na aukcji to ODCZYT Z CACHE, nie sygnał w zapytaniu'), BL('Вот главное недопонимание. Классификация крупных вендоров в основном НЕ едет внутри bid request. DSP получает запрос, берёт оттуда домен или content ID и смотрит в свою закэшированную таблицу. Косвенное подтверждение: в реестре segtax — стандартном механизме передачи сегментов — зарегистрировано больше шести десятков поставщиков, и IAS, DoubleVerify и Peer39 в нём отсутствуют.', 'This is the key misunderstanding. The major vendors’ classification mostly does NOT travel inside the bid request. The DSP receives the request, takes the domain or content ID from it and looks into its own cached table. Corroborating evidence: the segtax registry — the standard mechanism for passing segments — lists over sixty providers, and IAS, DoubleVerify and Peer39 are not among them.', 'To jest kluczowe nieporozumienie. Klasyfikacja dużych dostawców w większości NIE jedzie wewnątrz bid requestu. DSP dostaje zapytanie, bierze z niego domenę lub content ID i zagląda do własnej tabeli w cache. Poszlaka: w rejestrze segtax — standardowym mechanizmie przekazywania segmentów — jest ponad sześćdziesięciu dostawców, a IAS, DoubleVerify i Peer39 w nim nie występują.')], [BL('Курирование — тот же поиск, только на хоп раньше', 'Curation — the same lookup, one hop earlier', 'Kuracja — ten sam odczyt, jeden hop wcześniej'), BL('Сдвиг 2025–26: фильтрацию переносят на сторону SSP. Биржа отсеивает инвентарь ДО отправки запроса и отдаёт выживших одним deal ID. Тот же кэш, просто выше по цепочке — и не тратится QPS на заведомо мёртвые запросы.', 'The 2025–26 shift: filtering moves to the SSP side. The exchange screens inventory BEFORE the request is sent and exposes the survivors as a single deal ID. The same cache, just further upstream — and no QPS wasted on requests that were doomed anyway.', 'Przesunięcie 2025–26: filtrowanie przenosi się na stronę SSP. Giełda odsiewa inwentarz PRZED wysłaniem zapytania i udostępnia ocalałych jako jedno deal ID. Ten sam cache, tylko wyżej w łańcuchu — i bez marnowania QPS na zapytania z góry skazane.')]];
  return /*#__PURE__*/React.createElement("div", {
    className: "att-methods"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-lad-intro"
  }, BL('Как brand safety попадает в аукцион, который длится 100 миллисекунд:', 'How brand safety gets into an auction that lasts 100 milliseconds:', 'Jak brand safety trafia do aukcji trwającej 100 milisekund:')), flow.map((f, i) => /*#__PURE__*/React.createElement("div", {
    className: "att-step",
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-step-n bs-n"
  }, i + 1), /*#__PURE__*/React.createElement("div", {
    className: "att-step-b"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-step-t"
  }, f[0]), /*#__PURE__*/React.createElement("div", {
    className: "att-step-d"
  }, f[1])))), /*#__PURE__*/React.createElement("div", {
    className: "att-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('Pre-bid против post-bid', 'Pre-bid vs post-bid', 'Pre-bid kontra post-bid')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('Pre-bid — не ставить на плохой показ вообще. Денег не потрачено, потерь нет.', 'Pre-bid — simply never bid on the bad impression. No money spent, nothing lost.', 'Pre-bid — po prostu nie licytować złej odsłony. Pieniądze niewydane, nic nie stracone.')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('Post-bid — аукцион уже выигран, показ куплен, тег на странице отказывается отрисовать креатив. Бренд спасён, деньги в основном нет: ты заплатил за пустое место. Контраргумент индустрии честный — post-bid ловит то, что pre-bid увидеть не мог: реальную страницу после загрузки, а не её прошлую версию в кэше.', 'Post-bid — the auction is already won and the impression bought; the tag on the page refuses to render the creative. The brand is saved, the money mostly is not: you paid for a blank space. The industry’s counter-argument is fair — post-bid catches what pre-bid could not see: the actual page after load, rather than its earlier cached version.', 'Post-bid — aukcja już wygrana, odsłona kupiona, tag na stronie odmawia wyrenderowania kreacji. Marka uratowana, pieniądze w większości nie: zapłaciłeś za puste miejsce. Kontrargument branży jest uczciwy — post-bid łapie to, czego pre-bid nie mógł zobaczyć: realną stronę po załadowaniu, a nie jej starszą wersję z cache.'))), /*#__PURE__*/React.createElement("div", {
    className: "att-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('Что реально есть в bid request', 'What actually exists in the bid request', 'Co realnie jest w bid request')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('site.domain, site.page, site.cat / sectioncat / pagecat, site.keywords, site.content.data — плюс поле cattax, которое указывает, КАКОЙ таксономией размечены категории (Content Taxonomy 3.1 — это cattax 9). Важная деталь: cattax появился только в OpenRTB 2.6, в 2.5 таксономия подразумевалась молча.', 'site.domain, site.page, site.cat / sectioncat / pagecat, site.keywords, site.content.data — plus the cattax field, which states WHICH taxonomy the categories use (Content Taxonomy 3.1 is cattax 9). An important detail: cattax only arrived in OpenRTB 2.6; in 2.5 the taxonomy was implicit.', 'site.domain, site.page, site.cat / sectioncat / pagecat, site.keywords, site.content.data — plus pole cattax, które wskazuje, JAKĄ taksonomią oznaczono kategorie (Content Taxonomy 3.1 to cattax 9). Ważny szczegół: cattax pojawił się dopiero w OpenRTB 2.6; w 2.5 taksonomia była domyślna.')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('Частая ошибка: класть контекст в user.data. Это поле про АУДИТОРИЮ, про человека. Контент живёт в site.content.data / app.content.data.', 'A common mistake: putting context into user.data. That field is about the AUDIENCE, about the person. Content belongs in site.content.data / app.content.data.', 'Częsty błąd: wkładanie kontekstu do user.data. To pole dotyczy ODBIORCY, człowieka. Treść mieszka w site.content.data / app.content.data.'))), /*#__PURE__*/React.createElement("div", {
    className: "att-block warn"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('CTV: почему там всё хуже', 'CTV: why it is worse there', 'CTV: dlaczego tam jest gorzej')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('В вебе есть URL — можно скачать страницу и разобрать. В CTV URL нет: есть app bundle и в лучшем случае жанр. Поле content.contentrating в OpenRTB — свободный текст без словаря, а перечислимое content.qagmediarating имеет ровно ТРИ значения: для всех / старше 12 / для взрослых. Шестиуровневая шкала TV Parental Guidelines и пятиуровневая MPA схлопываются в три ведра.', 'On the web there is a URL — you can fetch the page and analyse it. On CTV there is none: there is an app bundle and, at best, a genre. The OpenRTB content.contentrating field is free text with no vocabulary, and the enumerated content.qagmediarating has exactly THREE values: all audiences / over 12 / mature. The six-level TV Parental Guidelines scale and the five-level MPA scale collapse into three buckets.', 'W webie jest URL — można pobrać stronę i przeanalizować. W CTV go nie ma: jest app bundle i w najlepszym razie gatunek. Pole content.contentrating w OpenRTB to wolny tekst bez słownika, a wyliczeniowe content.qagmediarating ma dokładnie TRZY wartości: dla wszystkich / powyżej 12 / dla dorosłych. Sześciostopniowa skala TV Parental Guidelines i pięciostopniowa MPA zgniatają się do trzech kubełków.')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('И добивающая деталь спецификации: если макрос не передан, подставляется −1, что означает ОДНОВРЕМЕННО «мы не знаем» и «мы знаем, но не скажем». Покупатель не может отличить незнание от отказа. Отсюда и результат: ни один вендор не имеет аккредитации MRC на контентный brand safety в обычном стриминге.', 'And the finishing detail from the spec: when a macro is not passed, −1 is substituted, which means BOTH "we do not know" and "we know but cannot tell you". The buyer cannot distinguish ignorance from refusal. Hence the outcome: no vendor holds MRC accreditation for content-level brand safety in general streaming.', 'I dobijający szczegół specyfikacji: gdy makro nie jest przekazane, podstawia się −1, co oznacza JEDNOCZEŚNIE „nie wiemy” i „wiemy, ale nie powiemy”. Kupujący nie odróżni niewiedzy od odmowy. Stąd wynik: żaden dostawca nie ma akredytacji MRC na content-level brand safety w zwykłym streamingu.'))));
}

/* ─────────────────── Where it breaks ─────────────────── */
function BrandFails() {
  const over = [['Reuters', '54%', BL('новостных URL, которые контекстный анализ признал безопасными, список слов заблокировал бы', 'of news URLs that contextual analysis cleared would have been blocked by a keyword list', 'newsowych URL uznanych przez analizę kontekstową za bezpieczne zablokowałaby lista słów')], ['Washington Post', '>40%', BL('инвентаря заблокировано рекламодателями', 'of inventory blocked by advertisers', 'inwentarza zablokowane przez reklamodawców')], ['Newsweek', '63%', BL('помечено списками слов — при 98% реально безопасного контента по независимому замеру', 'flagged by keyword lists — against 98% genuinely brand-safe on an independent measurement', 'oznaczone przez listy słów — przy 98% faktycznie bezpiecznych treści wg niezależnego pomiaru')], ['Hearst', '38%', BL('газетных показов классифицированы ошибочно', 'of newspaper impressions misclassified', 'odsłon prasowych sklasyfikowanych błędnie')], [BL('Тест IAS на 4 крупных медиа', 'IAS test on 4 major media sites', 'Test IAS na 4 dużych mediach'), '70%', BL('показов заблокировано — при том что сам IAS считал этот контент подходящим', 'of impressions blocked — even though IAS itself deemed the content suitable', 'odsłon zablokowanych — mimo że sam IAS uznał te treści za odpowiednie')]];
  return /*#__PURE__*/React.createElement("div", {
    className: "bs-fails"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-lad-intro"
  }, BL('Список стоп-слов ищет подстроку и не понимает смысла. «Стрельба» в репортаже с Олимпиады, «взрыв» в статье про вулкан, «жертва» в разборе мошенничества — всё это выключает показ. Масштаб проблемы измеряли многие:', 'A stop-word list matches substrings and understands no meaning. "Shooting" in an Olympics report, "explosion" in a volcano piece, "victim" in a fraud explainer — each one kills the impression. The scale has been measured many times:', 'Lista stop-słów dopasowuje podciąg i nie rozumie sensu. „Strzelanie” w relacji z olimpiady, „wybuch” w tekście o wulkanie, „ofiara” w analizie oszustwa — każde wyłącza odsłonę. Skalę mierzono wielokrotnie:')), /*#__PURE__*/React.createElement("div", {
    className: "bs-table"
  }, over.map((r, i) => /*#__PURE__*/React.createElement("div", {
    className: "bs-trow",
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "bs-tn"
  }, r[0]), /*#__PURE__*/React.createElement("span", {
    className: "bs-tv"
  }, r[1]), /*#__PURE__*/React.createElement("span", {
    className: "bs-td"
  }, r[2])))), /*#__PURE__*/React.createElement("div", {
    className: "att-take"
  }, BL('Самая показательная цифра во всей теме: на wsj.com два крупных вендора верификации сходились в оценке «безопасно / небезопасно» примерно в 58,7% случаев. Чуть чаще, чем подбрасывание монеты. Если два аккредитованных измерителя не согласны друг с другом, «brand safe» — это не свойство контента, а мнение конкретного поставщика.', 'The single most telling number in the field: on wsj.com two major verification vendors agreed on safe/unsafe classification about 58.7% of the time. Barely better than a coin flip. If two accredited measurers disagree with each other, "brand safe" is not a property of the content — it is one vendor’s opinion.', 'Najbardziej wymowna liczba w całym temacie: na wsj.com dwaj duzi dostawcy weryfikacji zgadzali się co do oceny „bezpieczne / niebezpieczne” w około 58,7% przypadków. Ledwie lepiej niż rzut monetą. Jeśli dwaj akredytowani mierzący nie zgadzają się ze sobą, „brand safe” nie jest cechą treści — to opinia konkretnego dostawcy.')), /*#__PURE__*/React.createElement("div", {
    className: "att-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('Кого это выключает из экономики', 'Who this switches off economically', 'Kogo to wyłącza z ekonomii')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('В 2019 году нейтральные слова идентичности — «gay», «lesbian», «transgender», «bisexual» — блокировали около двух третей неоткровенного ЛГБТ-контента. PinkNews потерял порядка половины веб-продаж рекламы. В том же году Vice публично отказалась принимать 25 таких терминов, среди которых были также «муслим», «еврей», «беженец», «изменение климата» и «беременная».', 'In 2019, neutral identity words — "gay", "lesbian", "transgender", "bisexual" — blocked roughly two thirds of non-explicit LGBTQ+ content. PinkNews lost around half of its web ad sales. That same year Vice publicly refused a list of 25 such terms, which also included "Muslim", "Jewish", "refugee", "climate change" and "pregnant".', 'W 2019 neutralne słowa tożsamościowe — „gay”, „lesbian”, „transgender”, „bisexual” — blokowały około dwóch trzecich nieeksplicytnych treści LGBTQ+. PinkNews stracił około połowy sprzedaży reklam w webie. W tym samym roku Vice publicznie odmówiła przyjęcia listy 25 takich terminów, wśród których były też „muzułmanin”, „żyd”, „uchodźca”, „zmiana klimatu” i „w ciąży”.')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('Для равновесия — контраргумент индустрии: IAS утверждает, что исключительно из-за списков слов на её платформе блокируется всего 0,25% показов. Знаменатель другой (без категорийной блокировки и без списков на стороне DSP), но спор о том, кто именно создаёт переблокировку, действительно не закрыт.', 'For balance, the industry’s counter-argument: IAS states that only 0.25% of impressions on its platform are blocked from keyword lists alone. That is a different denominator (it excludes category-based blocking and DSP-side lists), but the argument over who actually causes the over-blocking is genuinely not settled.', 'Dla równowagi kontrargument branży: IAS twierdzi, że wyłącznie z powodu list słów na jej platformie blokowane jest zaledwie 0,25% odsłon. To inny mianownik (bez blokowania kategorialnego i bez list po stronie DSP), ale spór o to, kto właściwie powoduje przeblokowanie, naprawdę nie jest zamknięty.'))), /*#__PURE__*/React.createElement("div", {
    className: "att-block warn"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('«Brand safe» не значит «безопасно»', '"Brand safe" does not mean safe', '„Brand safe” nie znaczy „bezpieczne”')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('В феврале 2025 независимый аудит показал, что реклама крупных брендов и госструктур США годами шла на файлообменных площадках, где размещались материалы с сексуализированным насилием над детьми. Отчёты о brand safety при этом помечали такие площадки как «100% brand safe». Двое сенаторов США направили письма руководству IAS и DoubleVerify; DoubleVerify в ответ завела отдельную категорию «Highly Illicit: Do Not Monetize» и отчётность на уровне URL.', 'In February 2025 an independent audit showed that ads from major brands and US government agencies had for years been running on file-sharing platforms hosting child sexual abuse material. The brand safety reports meanwhile labelled those platforms "100% brand safe". Two US senators wrote to the leadership of IAS and DoubleVerify; DoubleVerify responded by adding a separate "Highly Illicit: Do Not Monetize" category and URL-level reporting.', 'W lutym 2025 niezależny audyt wykazał, że reklamy dużych marek i amerykańskich agencji rządowych latami trafiały na platformy wymiany plików, na których znajdowały się materiały przedstawiające seksualne wykorzystywanie dzieci. Raporty brand safety oznaczały tymczasem te platformy jako „100% brand safe”. Dwoje amerykańskich senatorów wysłało pisma do kierownictwa IAS i DoubleVerify; DoubleVerify dodała w odpowiedzi osobną kategorię „Highly Illicit: Do Not Monetize” i raportowanie na poziomie URL.')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('Вывод, который стоит унести: «verified brand safe» — это утверждение о ПОКРЫТИИ вендора, а не гарантия. Оно означает «мы проверили то, что смогли проверить».', 'The takeaway worth keeping: "verified brand safe" is a claim about a vendor’s COVERAGE, not a guarantee. It means "we checked what we were able to check".', 'Wniosek wart zapamiętania: „verified brand safe” to twierdzenie o POKRYCIU dostawcy, a nie gwarancja. Znaczy „sprawdziliśmy to, co byliśmy w stanie sprawdzić”.'))), /*#__PURE__*/React.createElement("div", {
    className: "att-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('MFA — соседняя проблема, которую часто путают', 'MFA — the adjacent problem that gets conflated', 'MFA — sąsiedni problem, który bywa mylony')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('Made for Advertising — сайты, существующие ради показов: агрессивная реклама, купленный трафик, контент как предлог. Исследование ANA 2023 года на 35,5 млрд показов: 21% показов и 15% бюджета уходили на MFA. К 2025-му доля упала до единиц процентов, но в первом квартале 2026-го впервые с 2023 года снова выросла — ANA связывает это с «AI slop», массовым генеративным контентом.', 'Made for Advertising — sites that exist for the impressions: aggressive ad load, purchased traffic, content as a pretext. The ANA’s 2023 study across 35.5bn impressions: 21% of impressions and 15% of spend went to MFA. By 2025 the share had fallen to low single digits, but in Q1 2026 it rose for the first time since 2023 — the ANA attributes this to "AI slop", mass generative content.', 'Made for Advertising — strony istniejące dla odsłon: agresywna reklama, kupiony ruch, treść jako pretekst. Badanie ANA z 2023 na 35,5 mld odsłon: 21% odsłon i 15% budżetu szło na MFA. Do 2025 udział spadł do kilku procent, ale w I kwartale 2026 wzrósł po raz pierwszy od 2023 — ANA wiąże to z „AI slop”, masowymi treściami generatywnymi.')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('Ключевое: ANA прямо говорит, что MFA — НЕ вопрос brand safety. Контент там обычно безобидный. Это вопрос качества и эффективности. И причина, по которой алгоритмы туда идут, чисто механическая: CPM у MFA примерно на четверть ниже, а оптимизатор, которому поставили цель по цене за клик или показ, честно выбирает самое дешёвое.', 'The key point: the ANA states explicitly that MFA is NOT a brand safety issue. The content there is usually harmless. It is a quality and efficiency issue. And the reason algorithms go there is purely mechanical: MFA CPMs run about a quarter lower, and an optimiser given a cost-per-click or cost-per-impression goal honestly picks the cheapest thing available.', 'Kluczowe: ANA mówi wprost, że MFA to NIE kwestia brand safety. Treść bywa tam nieszkodliwa. To kwestia jakości i efektywności. A powód, dla którego algorytmy tam idą, jest czysto mechaniczny: CPM na MFA jest o około ćwierć niższy, a optymalizator z celem kosztu za kliknięcie lub odsłonę uczciwie wybiera najtańsze.'))));
}

/* ─────────────────── Who measures, and who decides ─────────────────── */
function BrandVendors() {
  const C = () => BL('контент', 'content', 'treść');
  const P = () => BL('домен/приложение', 'property', 'domena/apka');
  const rows = [['Integral Ad Science', P(), BL('Верификация + курирование. С января 2026 — частная компания (выкуплена фондом). Аккредитация MRC на верификацию: десктоп и мобильный веб, без CTV.', 'Verification plus curation. Private since January 2026 (bought out by a fund). MRC verification accreditation: desktop and mobile web, no CTV.', 'Weryfikacja plus kuracja. Od stycznia 2026 spółka prywatna (wykupiona przez fundusz). Akredytacja MRC na weryfikację: desktop i mobile web, bez CTV.')], ['DoubleVerify', P(), BL('Самое широкое покрытие аккредитаций, включая CTV и pre-bid — но на уровне приложения, а не программы. Публичная компания.', 'The broadest accreditation coverage, including CTV and pre-bid — but at app level, not programme level. Publicly traded.', 'Najszersze pokrycie akredytacji, w tym CTV i pre-bid — ale na poziomie aplikacji, nie programu. Spółka publiczna.')], ['Zefr', C(), BL('Первый в истории сторонний вендор, получивший аккредитацию MRC на КОНТЕНТНЫЙ brand safety — март 2026, для YouTube. Разбирает кадр, звук и текст.', 'The first third party ever accredited by the MRC for CONTENT-level brand safety — March 2026, for YouTube. Analyses frame, audio and text.', 'Pierwszy w historii zewnętrzny dostawca z akredytacją MRC na brand safety na poziomie TREŚCI — marzec 2026, dla YouTube. Analizuje klatkę, dźwięk i tekst.')], ['Peer39', P(), BL('Контекстная разметка, работает на метаданных и content ID, без разбора кадра. В июне 2026 купила Adloox и вышла в DV360, Meta и Amazon DSP.', 'Contextual classification, works from metadata and content IDs, no frame analysis. Acquired Adloox in June 2026, extending into DV360, Meta and Amazon DSP.', 'Klasyfikacja kontekstowa, działa na metadanych i content ID, bez analizy klatki. W czerwcu 2026 kupiła Adloox i weszła do DV360, Meta i Amazon DSP.')], ['GumGum · Mobian · Mantis · Illuma', C(), BL('Контекстные челленджеры. GumGum первым получил аккредитацию MRC на контентную классификацию для CTV ещё в 2023-м.', 'Contextual challengers. GumGum was the first to be MRC-accredited for content-level classification on CTV, back in 2023.', 'Kontekstowi challengerzy. GumGum jako pierwszy uzyskał akredytację MRC na klasyfikację treści dla CTV, jeszcze w 2023.')], ['Oracle Advertising / Moat', '—', BL('Закрыт 30 сентября 2024 года. Один из трёх крупнейших измерителей просто перестал существовать — полезное напоминание, что этот слой рынка не вечен.', 'Shut down on 30 September 2024. One of the three largest measurers simply ceased to exist — a useful reminder that this layer of the market is not permanent.', 'Zamknięty 30 września 2024. Jeden z trzech największych mierzących po prostu przestał istnieć — pożyteczne przypomnienie, że ta warstwa rynku nie jest wieczna.')]];
  return /*#__PURE__*/React.createElement("div", {
    className: "att-vendors"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-lad-intro"
  }, BL('Ключевое различие при выборе вендора — на каком УРОВНЕ он смотрит. «Домен/приложение» — это оценка площадки целиком. «Контент» — разбор конкретного материала: кадра, звука, речи. Разница огромная: на уровне приложения нельзя узнать, какая идёт программа.', 'The key distinction when picking a vendor is the LEVEL it looks at. "Property" means judging the whole site or app. "Content" means analysing the specific material: frame, audio, speech. The difference is large: at app level you cannot know which programme is playing.', 'Kluczowe rozróżnienie przy wyborze dostawcy to POZIOM, na którym patrzy. „Domena/apka” to ocena całej witryny lub aplikacji. „Treść” to analiza konkretnego materiału: klatki, dźwięku, mowy. Różnica jest duża: na poziomie aplikacji nie da się wiedzieć, jaki program leci.')), /*#__PURE__*/React.createElement("div", {
    className: "att-vtable"
  }, /*#__PURE__*/React.createElement("div", {
    className: "att-vrow att-vth"
  }, /*#__PURE__*/React.createElement("span", null, BL('Вендор', 'Vendor', 'Dostawca')), /*#__PURE__*/React.createElement("span", null, BL('Уровень', 'Level', 'Poziom')), /*#__PURE__*/React.createElement("span", null, BL('Статус', 'Status', 'Status'))), rows.map(r => /*#__PURE__*/React.createElement("div", {
    className: "att-vrow bs-vrow",
    key: r[0]
  }, /*#__PURE__*/React.createElement("span", {
    className: "att-vn"
  }, r[0]), /*#__PURE__*/React.createElement("span", {
    className: 'att-vap' + (r[1] === C() ? ' panel' : '')
  }, r[1]), /*#__PURE__*/React.createElement("span", {
    className: "att-vm"
  }, r[2])))), /*#__PURE__*/React.createElement("div", {
    className: "att-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('MRC переопределил сами слова', 'The MRC redefined the words themselves', 'MRC przedefiniował same słowa')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('В октябре 2025 MRC выпустил политику, которая привязала термины к глубине измерения, а не к универсальности. Вендор, аккредитованный только на уровне домена и ключевых слов, больше не имеет права называть свою услугу «brand safety» — только «suitability», и обязан раскрывать, что картинка, видео и звук в анализ не входят. Переходный период закончился 18 апреля 2026 года.', 'In October 2025 the MRC issued a policy tying the terms to measurement depth rather than universality. A vendor accredited only at domain and keyword level may no longer call its service "brand safety" — only "suitability" — and must disclose that image, video and audio are excluded from the analysis. The grace period ended on 18 April 2026.', 'W październiku 2025 MRC wydał politykę wiążącą te terminy z głębokością pomiaru, a nie z uniwersalnością. Dostawca akredytowany tylko na poziomie domeny i słów kluczowych nie może już nazywać swojej usługi „brand safety” — tylko „suitability” — i musi ujawnić, że obraz, wideo i dźwięk nie wchodzą do analizy. Okres przejściowy zakończył się 18 kwietnia 2026.')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('Практическое следствие: встретив в презентации слова «brand safety» и «suitability», сначала уточни, в каком смысле их употребляют — в классическом (универсальное против пер-брендового) или в новом MRC-овском (контентное против доменного). Это разные оси.', 'The practical consequence: when you meet "brand safety" and "suitability" in a deck, first establish which sense is meant — the classical one (universal vs per-advertiser) or the new MRC one (content-level vs property-level). Those are different axes.', 'Praktyczna konsekwencja: spotykając w prezentacji słowa „brand safety” i „suitability”, najpierw ustal, w jakim sensie są użyte — klasycznym (uniwersalne kontra per-marka) czy nowym MRC-owskim (poziom treści kontra poziom domeny). To różne osie.'))), /*#__PURE__*/React.createElement("div", {
    className: "att-block warn"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fe-cap"
  }, BL('Кто вообще имеет право задавать категории', 'Who is even allowed to set the categories', 'Kto w ogóle może ustalać kategorie')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('GARM — отраслевой альянс, создавший эту рамку, — закрылся в августе 2024 года после иска X. Сам иск в марте 2026 был отклонён окончательно, без права подачи заново: суд не нашёл антимонопольного вреда. То есть рамку убил процесс, который в итоге проиграли.', 'GARM — the industry alliance that created the framework — shut down in August 2024 after X sued. That suit was dismissed with prejudice in March 2026: the court found no antitrust injury. So the framework was killed by a case that ultimately failed.', 'GARM — branżowy sojusz, który stworzył te ramy — zamknął się w sierpniu 2024 po pozwie X. Sam pozew w marcu 2026 oddalono ostatecznie, bez prawa ponownego wniesienia: sąd nie stwierdził szkody antymonopolowej. Ramy zabił więc proces, który ostatecznie przegrano.')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('А в апреле 2026 FTC и восемь штатов подали иск против трёх крупнейших рекламных холдингов и одновременно утвердили с ними мировое соглашение: десятилетние запреты и независимые наблюдатели. Суть предписания важно понять точно — оно запрещает не brand safety, а КОЛЛЕКТИВНЫЕ отраслевые стандарты. Отдельный рекламодатель по-прежнему вправе исключать что угодно, но решать он должен сам, а не присоединяться к общей рамке по договорённости.', 'And in April 2026 the FTC and eight states sued the three largest advertising holding groups while simultaneously entering consent orders with them: ten-year injunctions and independent monitors. The substance matters and is easy to get wrong — the order does not ban brand safety, it bans COLLECTIVE industry standards. An individual advertiser may still exclude whatever it likes, but it has to decide for itself rather than adopt a shared framework by agreement.', 'A w kwietniu 2026 FTC i osiem stanów pozwały trzy największe holdingi reklamowe, jednocześnie zawierając z nimi ugody: dziesięcioletnie zakazy i niezależni obserwatorzy. Istota jest ważna i łatwo ją przekręcić — nakaz nie zakazuje brand safety, lecz KOLEKTYWNYCH standardów branżowych. Pojedynczy reklamodawca wciąż może wykluczać, co chce, ale musi decydować sam, a nie przyłączać się do wspólnych ram na podstawie porozumienia.')), /*#__PURE__*/React.createElement("div", {
    className: "att-li"
  }, BL('Сама рамка при этом никуда не делась — она выжила без имени. Её структура лежит внутри IAB Tech Lab Content Taxonomy: узел «Sensitive Topics» с одиннадцатью категориями (дезинформацию туда не перенесли) и вектор «Brand Suitability and Risk» со значениями Floor, High, Medium, Low. Ни слова GARM в этих файлах нет.', 'The framework itself did not disappear — it survived without its name. Its structure sits inside the IAB Tech Lab Content Taxonomy: a "Sensitive Topics" node with eleven categories (Misinformation was not carried over) and a "Brand Suitability and Risk" vector with the values Floor, High, Medium, Low. The word GARM appears nowhere in those files.', 'Same ramy nie zniknęły — przetrwały bez nazwy. Ich struktura leży w IAB Tech Lab Content Taxonomy: węzeł „Sensitive Topics” z jedenastoma kategoriami (dezinformacji nie przeniesiono) oraz wektor „Brand Suitability and Risk” z wartościami Floor, High, Medium, Low. Słowo GARM nie występuje w tych plikach ani razu.'))), /*#__PURE__*/React.createElement("div", {
    className: "att-illus"
  }, BL('Список — ориентир рынка, не рейтинг и не рекомендация. Статусы и даты — по состоянию на середину 2026 года; этот слой рынка меняется быстро.', 'The list is a market reference, not a ranking or an endorsement. Statuses and dates are as of mid-2026; this layer of the market moves fast.', 'Lista to punkt odniesienia rynku, nie ranking ani rekomendacja. Statusy i daty według stanu na połowę 2026; ta warstwa rynku zmienia się szybko.')));
}
function BrandModule({
  open,
  onClose
}) {
  const [tab, setTab] = React.useState('floor');
  const [sel, setSel] = React.useState(BS_TUNER_DEFAULT);
  if (!open) return null;
  const tabs = [['floor', BL('Пол и пригодность', 'Floor & suitability', 'Próg i dopasowanie')], ['cases', BL('Один контент — разные бренды', 'One content, many brands', 'Jedna treść, różne marki')], ['tuner', BL('Цена блокировки', 'The cost of blocking', 'Cena blokowania')], ['how', BL('Как это устроено', 'How it works', 'Jak to działa')], ['fails', BL('Где ломается', 'Where it breaks', 'Gdzie się psuje')], ['who', BL('Кто меряет и кто решает', 'Who measures, who decides', 'Kto mierzy, kto decyduje')]];
  return /*#__PURE__*/React.createElement("div", {
    className: "compare-overlay",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "fraud-modal bs",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": BL('Brand safety и suitability', 'Brand safety and suitability', 'Brand safety i suitability'),
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "dive-close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "cmp-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cmp-title"
  }, BL('Brand safety и suitability', 'Brand safety & suitability', 'Brand safety i suitability')), /*#__PURE__*/React.createElement("div", {
    className: "cmp-sub"
  }, BL('Рядом с каким контентом окажется реклама — и сколько стоит попытка это контролировать.', 'What content the ad ends up next to — and what it costs to try to control that.', 'Obok jakich treści znajdzie się reklama — i ile kosztuje próba kontrolowania tego.'))), /*#__PURE__*/React.createElement("div", {
    className: "fraud-tabs bs-tabs"
  }, tabs.map(t => /*#__PURE__*/React.createElement("button", {
    key: t[0],
    className: tab === t[0] ? 'on' : '',
    onClick: () => setTab(t[0])
  }, t[1]))), tab === 'floor' && /*#__PURE__*/React.createElement(BrandFloor, null), tab === 'cases' && /*#__PURE__*/React.createElement(BrandCases, null), tab === 'tuner' && /*#__PURE__*/React.createElement(BrandTuner, {
    sel: sel,
    setSel: setSel
  }), tab === 'how' && /*#__PURE__*/React.createElement(BrandHow, null), tab === 'fails' && /*#__PURE__*/React.createElement(BrandFails, null), tab === 'who' && /*#__PURE__*/React.createElement(BrandVendors, null)));
}
Object.assign(window, {
  BrandModule
});

;
/* BEGIN USAGE */
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
// Exports (to window): useTweaks, TweaksPanel, TweakSection, TweakRow, TweakSlider,
//   TweakToggle, TweakRadio, TweakSelect, TweakText, TweakNumber, TweakColor, TweakButton.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// TweakRadio is the segmented control for 2–3 short options (auto-falls-back to
// TweakSelect past ~16/~10 chars per label); reach for TweakSelect directly when
// options are many or long. For color tweaks always curate 3-4 options rather than
// a free picker; an option can also be a whole 2–5 color palette (the stored value
// is the array). The Tweak* controls are a floor, not a ceiling — build custom
// controls inside the panel if a tweak calls for UI they don't cover.
/* END USAGE */
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({
  title = 'Tweaks',
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, __TWEAKS_STYLE), /*#__PURE__*/React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-omelette-chrome": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "twk-body"
  }, children)));
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label), value != null && /*#__PURE__*/React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-row twk-row-h"
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, /*#__PURE__*/React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return /*#__PURE__*/React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-num"
  }, /*#__PURE__*/React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && /*#__PURE__*/React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "twk-row twk-row-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "twk-lbl"
    }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && /*#__PURE__*/React.createElement("span", null, sup.map((c, j) => /*#__PURE__*/React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && /*#__PURE__*/React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});

;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* RTB Engine v3 — App: configurable system (toggleable nodes, counts) */
const {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo
} = React;
const POOL = 64;
const WIN_COLOR = '#34d399';
const DURS = {
  user: 1100,
  request: 1200,
  toExchange: 1000,
  verify: 1500,
  broadcast: 1400,
  enrich: 1500,
  bid: 1700,
  auction: 1800,
  response: 1500,
  render: 1400,
  track: 1700
};
const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "nodeVerifier": true,
  "nodeDmp": true,
  "nodeTracking": true,
  "nodeAdServer": true,
  "device": "desktop",
  "format": "display",
  "auctionType": "1-я цена",
  "dealType": "open",
  "supplyPath": "header",
  "floor": 1.5,
  "dspCount": "3",
  "sspCount": "1",
  "dmpOn": true,
  "cookieless": false,
  "consent": true,
  "resellerHop": false,
  "depth": "novice",
  "threat": false
} /*EDITMODE-END*/;
function App() {
  const {
    CW,
    CH,
    CAT,
    CAT_LIGHT,
    STAGE_LIGHT,
    DEVICES,
    FORMATS,
    buildModel,
    STAGES,
    BLOCK_STAGE,
    makeAuction
  } = window.RTB;
  const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
  const dspCount = Math.max(2, Math.min(6, parseInt(t.dspCount, 10) || 3));
  const sspCount = Math.max(1, Math.min(3, parseInt(t.sspCount, 10) || 1));
  const firstPrice = t.auctionType === '1-я цена';
  const device = DEVICES[t.device] ? t.device : 'desktop';
  let format = FORMATS[t.format] ? t.format : 'display';
  if (!DEVICES[device].formats.includes(format)) format = DEVICES[device].formats[0];
  const useVerifier = !!t.nodeVerifier,
    useDmp = !!t.nodeDmp,
    useTracking = !!t.nodeTracking;
  const useAdServer = !!t.nodeAdServer;
  const model = useMemo(() => buildModel({
    count: dspCount,
    sspCount: sspCount,
    verifier: useVerifier,
    dmp: useDmp,
    tracking: useTracking,
    adserver: useAdServer
  }), [dspCount, sspCount, useVerifier, useDmp, useTracking, useAdServer]);
  // active stage flow (skips disabled nodes' stages)
  const flow = useMemo(() => STAGES.filter(s => (s.id !== 'verify' || useVerifier) && (s.id !== 'enrich' || useDmp) && (s.id !== 'track' || useTracking)), [useVerifier, useDmp, useTracking]);
  const verifyPos = useMemo(() => flow.findIndex(s => s.id === 'verify'), [flow]);
  const [phase, setPhase] = useState('idle');
  const [pos, setPos] = useState(-1); // position within `flow`
  const [blockedView, setBlockedView] = useState(false);
  const [stepMode, setStepMode] = useState(false);
  const [speed, setSpeed] = useState(1);
  const [configOpen, setConfigOpen] = useState(false);
  const [auction, setAuction] = useState(null);
  const [activePipes, setActivePipes] = useState({});
  const [selected, setSelected] = useState(null);
  const [clockDisp, setClockDisp] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const [showBids, setShowBids] = useState(false);
  const [decided, setDecided] = useState(false);
  const [render, setRender] = useState(false);
  const [pixel, setPixel] = useState(false);
  const [scale, setScale] = useState(1);
  const [pan, setPan] = useState(false);
  const [theme, setTheme] = useState('dark');
  const [lang, setLang] = useState(() => {
    try {
      const p = (location.pathname.match(/^\/(en|ru|pl)(?:\/|$)/) || [])[1]; // /en /ru /pl in the URL wins (RU only via a manual /ru)
      if (p) return p;
      const v = localStorage.getItem('rtb-lang');
      if (v === 'en' || v === 'pl') return v; // RU is never auto-restored
      return (navigator.language || '').slice(0, 2).toLowerCase() === 'pl' ? 'pl' : 'en'; // default: PL or EN, never RU
    } catch (e) {
      return 'en';
    }
  });
  window.__lang = lang; // set synchronously so tr() in this render uses the right language
  const [hoverSig, setHoverSig] = useState(null); // {data,x,y}
  const [deepDive, setDeepDive] = useState(null); // 'dsp' | 'ssp' | null
  const [soundOn, setSoundOn] = useState(false);
  const [tourActive, setTourActive] = useState(false);
  const [compareOpen, setCompareOpen] = useState(false);
  const [sessionOpen, setSessionOpen] = useState(false);
  const [hideMoney, setHideMoney] = useState(false);
  const [hideAuction, setHideAuction] = useState(false);
  const [logOpen, setLogOpen] = useState(false);
  const [glossaryOpen, setGlossaryOpen] = useState(false);
  const [quizOpen, setQuizOpen] = useState(false);
  const [demoMode, setDemoMode] = useState(false);
  const [fraudLayer, setFraudLayer] = useState(false);
  const [fraudKey, setFraudKey] = useState(null);
  const [fraudModule, setFraudModule] = useState(false);
  const [attentionModule, setAttentionModule] = useState(false);
  const [brandModule, setBrandModule] = useState(false);
  const [fraudSeed, setFraudSeed] = useState(null);
  const [pendingRun, setPendingRun] = useState(0);
  const poolRef = useRef([]);
  const busyRef = useRef(new Array(POOL).fill(false));
  const packetsRef = useRef([]);
  const lenCache = useRef({});
  const timersRef = useRef([]);
  const stepTimerRef = useRef(null);
  const speedRef = useRef(1);
  const themeRef = useRef('dark');
  const countRef = useRef(dspCount);
  const sspCountRef = useRef(sspCount);
  const blockedRef = useRef(false);
  const flowRef = useRef(flow);
  const clockCur = useRef(0);
  const clockTarget = useRef(0);
  const lastClock = useRef(-1);
  const posRef = useRef(-1);
  useEffect(() => {
    speedRef.current = speed;
  }, [speed]);
  useEffect(() => {
    countRef.current = dspCount;
  }, [dspCount]);
  useEffect(() => {
    sspCountRef.current = sspCount;
  }, [sspCount]);
  useEffect(() => {
    flowRef.current = flow;
  }, [flow]);
  useEffect(() => {
    document.body.classList.toggle('light', theme === 'light');
    themeRef.current = theme;
  }, [theme]);
  useEffect(() => {
    window.__lang = lang;
    try {
      localStorage.setItem('rtb-lang', lang);
    } catch (e) {}
    try {
      document.documentElement.lang = lang;
    } catch (e) {} // a11y/SEO: <html lang> follows the UI
    // reflect the language in a short, shareable path: /ru · /en · /pl
    try {
      const want = '/' + lang;
      if (location.pathname !== want) history.replaceState(null, '', want + location.search);
    } catch (e) {}
    // localize the tab/share title
    try {
      document.title = lang === 'en' ? 'RTB Engine — how programmatic works' : lang === 'pl' ? 'Silnik RTB — jak działa programmatic' : 'RTB Движок — как работает programmatic';
    } catch (e) {}
  }, [lang]);

  // The URL carries only the language. Scenario config is intentionally NOT serialized
  // into the URL — keeps links short; opt-in sharing is via the ?s= link below.

  // ── opt-in scenario share-link (?s=): decode on mount, generate on demand ──
  useEffect(() => {
    try {
      const s = new URLSearchParams(location.search).get('s');
      if (!s) return;
      const diff = JSON.parse(decodeURIComponent(escape(atob(s.replace(/-/g, '+').replace(/_/g, '/')))));
      Object.keys(diff).forEach(k => {
        // validate: own key + same type as the default (the app already clamps numbers / falls back on bad enums)
        if (Object.prototype.hasOwnProperty.call(TWEAK_DEFAULTS, k) && typeof diff[k] === typeof TWEAK_DEFAULTS[k]) setTweak(k, diff[k]);
      });
    } catch (e) {}
  }, []);
  const shareScenario = useCallback(() => {
    try {
      const diff = {};
      Object.keys(TWEAK_DEFAULTS).forEach(k => {
        if (t[k] !== TWEAK_DEFAULTS[k]) diff[k] = t[k];
      });
      const enc = btoa(unescape(encodeURIComponent(JSON.stringify(diff)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      const path = '/' + lang + (enc ? '?s=' + enc : '');
      try {
        history.replaceState(null, '', path);
      } catch (e) {}
      const url = location.origin + path;
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).catch(() => {});
      try {
        if (window.rtbTrack) window.rtbTrack('scenario_share', {
          language: lang
        });
      } catch (e) {}
      return url;
    } catch (e) {
      return null;
    }
  }, [t, lang]);
  const soundRef = useRef(false);
  const acRef = useRef(null);
  useEffect(() => {
    soundRef.current = soundOn;
  }, [soundOn]);
  const tick = type => {
    if (!soundRef.current) return;
    try {
      let ac = acRef.current;
      if (!ac) {
        ac = new (window.AudioContext || window.webkitAudioContext)();
        acRef.current = ac;
      }
      if (ac.state === 'suspended') ac.resume();
      const o = ac.createOscillator(),
        g = ac.createGain(),
        now = ac.currentTime;
      const f = type === 'win' ? 680 : type === 'block' ? 150 : type === 'reveal' ? 540 : 360;
      o.type = type === 'block' ? 'sawtooth' : 'triangle';
      o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, now);
      g.gain.exponentialRampToValueAtTime(type === 'reveal' || type === 'win' ? 0.14 : 0.07, now + 0.008);
      g.gain.exponentialRampToValueAtTime(0.0001, now + 0.15);
      o.connect(g);
      g.connect(ac.destination);
      o.start(now);
      o.stop(now + 0.17);
    } catch (e) {}
  };
  const tickRef = useRef(tick);
  tickRef.current = tick;
  useEffect(() => {
    let done = false;
    try {
      done = localStorage.getItem('rtb-tour-done') === '1';
    } catch (e) {}
    if (!done) {
      const t = setTimeout(() => setTourActive(true), 700);
      return () => clearTimeout(t);
    }
  }, []);
  useEffect(() => {
    const onKey = e => {
      if (e.key === 'Escape') {
        setDeepDive(null);
        setSelected(null);
        setFraudModule(false);
        setAttentionModule(false);
        setBrandModule(false);
        setFraudKey(null);
        setQuizOpen(false);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  useEffect(() => {
    const fit = () => {
      const vw = window.innerWidth,
        vh = window.innerHeight;
      const narrow = vw < 760;
      const pad = narrow ? 0 : 24;
      const fitS = Math.min((vw - pad) / 1440, (vh - pad) / 960);
      if (narrow) {
        // mobile: scale to fit the viewport HEIGHT (minus the fixed action bar) so nodes/text stay
        // legible; the map is wider than the screen, so pan horizontally to follow the left→right flow.
        const barH = 62;
        const fitH = (vh - barH - pad) / 960;
        const s = Math.min(Math.max(fitH, 0.5), 1.1);
        setScale(s);
        setPan(true);
      } else {
        setScale(Math.max(0.3, Math.min(fitS, 1.35)));
        setPan(false);
      }
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, []);

  // mobile: the auction panel sits at the (off-screen) centre of the wide canvas — pan the map to
  // bring the result into view when it settles. (The node info panel is a viewport bottom sheet, see CSS.)
  useEffect(() => {
    if (window.innerWidth >= 760 || !decided || !auction || auction.blocked) return;
    const t = setTimeout(() => {
      const el = document.querySelector('.auction-panel');
      if (el && el.scrollIntoView) el.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }, 240);
    return () => clearTimeout(t);
  }, [decided]);
  const getLen = id => {
    let c = lenCache.current[id];
    const el = document.getElementById('pipe-' + id);
    if (!el) return null;
    if (!c || c.el !== el) {
      c = {
        el,
        len: el.getTotalLength()
      };
      lenCache.current[id] = c;
    }
    return c;
  };
  const reduceMotionRef = useRef(false);
  useEffect(() => {
    if (!window.matchMedia) return;
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var set = function () {
      reduceMotionRef.current = mq.matches;
    };
    set();
    if (mq.addEventListener) {
      mq.addEventListener('change', set);
      return function () {
        mq.removeEventListener('change', set);
      };
    }
    if (mq.addListener) {
      mq.addListener(set);
      return function () {
        mq.removeListener(set);
      };
    }
  }, []);
  const spawnPacket = (pipeId, dir, color, r) => {
    if (reduceMotionRef.current) return; // honor prefers-reduced-motion (JS-driven animation)
    const c = getLen(pipeId);
    if (!c) return;
    let slot = busyRef.current.indexOf(false);
    if (slot < 0) return;
    busyRef.current[slot] = true;
    const el = poolRef.current[slot];
    if (el) el.style.filter = `drop-shadow(0 0 7px ${color})`;
    packetsRef.current.push({
      slot,
      pipeId,
      dir,
      color,
      r: r || 3.8,
      t: 0,
      speed: 0.85 + Math.random() * 0.4
    });
  };
  const spawnStream = (pipeId, dir, color, count, gap, r) => {
    if (reduceMotionRef.current) return;
    for (let k = 0; k < count; k++) {
      const tm = setTimeout(() => spawnPacket(pipeId, dir, color, r), k * gap / speedRef.current);
      timersRef.current.push(tm);
    }
  };
  useEffect(() => {
    const iv = setInterval(() => {
      clockCur.current += (clockTarget.current - clockCur.current) * 0.18;
      if (Math.abs(clockTarget.current - clockCur.current) < 0.5) clockCur.current = clockTarget.current;
      const rc = Math.round(clockCur.current);
      if (rc !== lastClock.current) {
        lastClock.current = rc;
        setClockDisp(rc);
      }
    }, 55);
    return () => clearInterval(iv);
  }, []);
  useEffect(() => {
    let raf,
      last = performance.now();
    const tick = now => {
      const dt = Math.min(64, now - last);
      last = now;
      const live = packetsRef.current;
      for (let i = live.length - 1; i >= 0; i--) {
        const p = live[i];
        p.t += p.speed * (dt / 1000) * speedRef.current;
        const el = poolRef.current[p.slot];
        if (p.t >= 1) {
          if (el) el.setAttribute('opacity', '0');
          busyRef.current[p.slot] = false;
          live.splice(i, 1);
          continue;
        }
        const c = lenCache.current[p.pipeId];
        if (!c || !el) continue;
        const at = (p.dir > 0 ? p.t : 1 - p.t) * c.len;
        const pt = c.el.getPointAtLength(at);
        const fade = p.t < 0.14 ? p.t / 0.14 : p.t > 0.86 ? (1 - p.t) / 0.14 : 1;
        el.setAttribute('cx', pt.x);
        el.setAttribute('cy', pt.y);
        el.setAttribute('r', p.r);
        el.setAttribute('fill', p.color);
        el.setAttribute('opacity', (0.95 * fade).toFixed(3));
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);
  const clearTimers = () => {
    timersRef.current.forEach(clearTimeout);
    timersRef.current = [];
    if (stepTimerRef.current) {
      clearTimeout(stepTimerRef.current);
      stepTimerRef.current = null;
    }
  };
  const killPackets = () => {
    packetsRef.current.forEach(p => {
      const el = poolRef.current[p.slot];
      if (el) el.setAttribute('opacity', '0');
    });
    packetsRef.current = [];
    busyRef.current.fill(false);
  };
  const stagePipes = stage => {
    const list = stage.pipes.slice();
    const fanList = stage.fans || (stage.fan ? [stage.fan] : []);
    fanList.forEach(f => {
      const isSsp = f.prefix === 'pubSSP' || f.prefix === 'sspEx';
      const n = isSsp ? sspCountRef.current : countRef.current;
      for (let i = 0; i < n; i++) {
        if (f.prefix === 'dmpD' && !useDmp) continue;
        list.push({
          id: f.prefix + i,
          dir: f.dir
        });
      }
    });
    return list;
  };
  const enterBlocked = useCallback(() => {
    setBlockedView(true);
    if (tickRef.current) tickRef.current('block');
    setSpinning(false);
    setActivePipes({});
    clockTarget.current = BLOCK_STAGE.clock;
    setPhase('done');
  }, []);
  const enterStage = useCallback(p => {
    const fl = flowRef.current;
    const stage = fl[p];
    if (!stage) {
      setPhase('done');
      return;
    }
    posRef.current = p;
    setPos(p);
    tickRef.current(stage.id === 'auction' ? 'reveal' : stage.id === 'render' ? 'win' : 'step');
    const pipes = stagePipes(stage);
    const ap = {};
    pipes.forEach(pp => {
      ap[pp.id] = true;
    });
    setActivePipes(ap);
    clockTarget.current = stage.clock;
    setSpinning(stage.id === 'auction');
    if (stage.id === 'bid') setShowBids(true);
    if (stage.reveal) setDecided(true);
    if (stage.render) setRender(true);
    if (stage.pixel) setPixel(true);
    const col = themeRef.current === 'light' ? STAGE_LIGHT[stage.id] : stage.color;
    const waterfall = t.supplyPath === 'waterfall';
    const fanGap = waterfall && (stage.fan || stage.fans) ? 300 : 80;
    pipes.forEach((pp, idx) => {
      const r = stage.id === 'bid' ? 4.8 : 3.8;
      if (stage.id === 'enrich') {
        // DSP queries DMP (dsp→dmp), then DMP returns segments (dmp→dsp)
        const tmq = setTimeout(() => spawnStream(pp.id, -1, col, 3, 130, 3.2), idx * fanGap);
        const tmr = setTimeout(() => spawnStream(pp.id, 1, col, 5, 150, 4.4), idx * fanGap + 430 / speedRef.current);
        timersRef.current.push(tmq, tmr);
      } else {
        const tm = setTimeout(() => spawnStream(pp.id, pp.dir, col, 5, 150, r), idx * fanGap);
        timersRef.current.push(tm);
      }
    });
    if (!stepMode) {
      const last = fl.length - 1;
      stepTimerRef.current = setTimeout(() => {
        if (stage.id === 'verify' && blockedRef.current) enterBlocked();else if (p < last) enterStage(p + 1);else setPhase('done');
      }, (DURS[stage.id] || 1500) / speedRef.current);
    }
  }, [stepMode, enterBlocked, useDmp]);
  const start = () => {
    clearTimers();
    killPackets();
    const a = makeAuction({
      count: dspCount,
      dmpOn: useDmp && t.dmpOn,
      auctionType: firstPrice ? 'first' : 'second',
      floor: t.floor,
      device,
      format,
      verify: useVerifier,
      threat: t.threat,
      dealType: t.dealType,
      supplyPath: t.supplyPath,
      cookieless: t.cookieless,
      consent: t.consent !== false,
      resellerHop: !!t.resellerHop
    });
    blockedRef.current = a.blocked;
    setAuction(a);
    setBlockedView(false);
    setShowBids(false);
    setDecided(false);
    setRender(false);
    setPixel(false);
    setSpinning(false);
    setHideMoney(false);
    setHideAuction(false);
    clockCur.current = 0;
    clockTarget.current = 0;
    lastClock.current = -1;
    setClockDisp(0);
    setPhase('running');
    setTimeout(() => enterStage(0), 30);
  };
  const startRef = useRef(start);
  startRef.current = start;
  const reset = () => {
    clearTimers();
    killPackets();
    setPhase('idle');
    setPos(-1);
    posRef.current = -1;
    blockedRef.current = false;
    setBlockedView(false);
    setActivePipes({});
    setAuction(null);
    setShowBids(false);
    setDecided(false);
    setRender(false);
    setPixel(false);
    setSpinning(false);
    clockTarget.current = 0;
    clockCur.current = 0;
    lastClock.current = -1;
    setClockDisp(0);
  };

  // ── presets + pending run (apply tweaks, then run on next render) ──
  const pendingRunRef = useRef(false);
  const runPreset = pre => {
    setConfigOpen(false);
    Object.keys(pre.tweaks).forEach(k => setTweak(k, pre.tweaks[k]));
    setStepMode(false);
    pendingRunRef.current = true;
    setPendingRun(n => n + 1);
  };
  // A complexity mode is a starting point, not a scenario to watch: apply the tweaks but keep the
  // panel open and do NOT auto-run, so the switches visibly flip and can be adjusted one by one.
  const applyMode = m => {
    Object.keys(m.tweaks).forEach(k => setTweak(k, m.tweaks[k]));
    setStepMode(false);
  };
  useEffect(() => {
    if (!pendingRun) return;
    const id = setTimeout(() => {
      pendingRunRef.current = false;
      startRef.current();
    }, 170);
    return () => clearTimeout(id);
    // eslint-disable-next-line
  }, [pendingRun]);

  // ── presentation auto-demo: loop runs while demoMode on ──
  useEffect(() => {
    if (!demoMode) return;
    if (phase === 'idle') {
      const id = setTimeout(() => start(), 120);
      return () => clearTimeout(id);
    }
    if (phase === 'done') {
      const id = setTimeout(() => {
        reset();
        setTimeout(() => start(), 200);
      }, 4200);
      return () => clearTimeout(id);
    }
    // eslint-disable-next-line
  }, [demoMode, phase]);
  const startDemo = () => {
    reset();
    setStepMode(false);
    setSpeed(0.85);
    setSelected(null);
    setConfigOpen(false);
    setDemoMode(true);
  };
  const exitDemo = () => {
    setDemoMode(false);
    reset();
  };
  const step = () => {
    if (phase !== 'running' || !stepMode) return;
    const fl = flowRef.current;
    const p = posRef.current;
    if (fl[p] && fl[p].id === 'verify' && blockedRef.current) enterBlocked();else if (p < fl.length - 1) enterStage(p + 1);else setPhase('done');
  };
  const toggleStep = v => {
    setStepMode(v);
    if (v && stepTimerRef.current) {
      clearTimeout(stepTimerRef.current);
      stepTimerRef.current = null;
    }
  };

  // ── scrubber: jump to any stage of a finished run (static, no timers) ──
  const seek = p => {
    if (!auction || auction.blocked) return;
    clearTimers();
    killPackets();
    const fl = flowRef.current;
    p = Math.max(0, Math.min(fl.length - 1, p));
    const idxOf = id => fl.findIndex(s => s.id === id);
    const bidI = idxOf('bid'),
      aucI = idxOf('auction'),
      rndI = idxOf('render');
    setBlockedView(false);
    posRef.current = p;
    setPos(p);
    setShowBids(bidI >= 0 && p >= bidI);
    setDecided(aucI >= 0 && p >= aucI);
    setRender(rndI >= 0 && p >= rndI);
    setPixel(rndI >= 0 && p >= rndI);
    setSpinning(fl[p].id === 'auction');
    const pipes = stagePipes(fl[p]);
    const ap = {};
    pipes.forEach(pp => {
      ap[pp.id] = true;
    });
    setActivePipes(ap);
    clockTarget.current = fl[p].clock;
    clockCur.current = fl[p].clock;
    lastClock.current = fl[p].clock;
    setClockDisp(fl[p].clock);
  };
  useEffect(() => () => clearTimers(), []);
  // re-arm when structure changes (but not when a preset run is pending)
  useEffect(() => {
    if (pendingRunRef.current) return;
    reset(); /* eslint-disable-next-line */
  }, [dspCount, sspCount, useVerifier, useDmp, useTracking]);

  // ── derived ──
  const stage = blockedView ? BLOCK_STAGE : pos >= 0 ? flow[pos] : null;
  const cats = theme === 'light' ? CAT_LIGHT : CAT;
  const stageColor = blockedView ? '#fb7185' : stage ? theme === 'light' ? STAGE_LIGHT[stage.id] : stage.color : theme === 'light' ? '#0c95b6' : '#67e8f9';
  const winnerDsp = auction ? auction.winnerDsp : null;
  const winnerLabel = winnerDsp != null && auction ? 'DSP · ' + auction.bids[winnerDsp].label : decided ? 'нет ставок' : null;
  const actor = blockedView ? 'verifier' : stage ? stage.actor : null;
  const isHot = n => phase !== 'idle' && actor === (n.cat === 'dsp' ? 'dsp' : n.cat);
  let verifierState = 'idle';
  if (blockedView) verifierState = 'block';else if (verifyPos >= 0 && pos === verifyPos) verifierState = 'check';else if (verifyPos >= 0 && pos > verifyPos) verifierState = 'pass';
  const cfg = {
    auctionType: (auction ? auction.firstPrice : firstPrice) ? 'first' : 'second',
    dmpOn: auction ? auction.dmpOn : useDmp && t.dmpOn,
    count: auction ? auction.count : dspCount,
    device: auction ? auction.device : device,
    format: auction ? auction.format : format,
    verify: auction ? auction.verify : useVerifier,
    dealType: auction ? auction.dealType : t.dealType || 'open',
    supplyPath: auction ? auction.supplyPath : t.supplyPath || 'header',
    cookieless: auction ? auction.cookieless : t.cookieless,
    consent: auction ? auction.consent : t.consent !== false,
    resellerHop: auction ? auction.resellerHop : !!t.resellerHop
  };

  // signal context for hover tooltips
  const sigCtx = {
    device: cfg.device,
    format: cfg.format,
    floor: auction ? auction.floor : t.floor,
    clearing: decided && auction ? auction.clearing : 0,
    cookieless: auction ? auction.cookieless : t.cookieless,
    consent: auction ? auction.consent : t.consent !== false
  };
  const onPipeHover = (pipeId, x, y) => {
    const data = window.RTB.getSignal(pipeId, sigCtx);
    if (data) setHoverSig({
      data,
      x,
      y
    });
  };
  const onPipeLeave = () => setHoverSig(null);
  const renderNode = n => {
    const cat = cats[n.cat];
    const common = {
      n,
      cat,
      selected: selected === n.id,
      hot: isHot(n),
      onClick: () => setSelected(n.id)
    };
    if (n.id === 'user') return /*#__PURE__*/React.createElement(UserNode, _extends({
      key: n.id
    }, common, {
      device: cfg.device,
      deviceLabel: window.tr(DEVICES[cfg.device].label) + ' · ' + window.tr(DEVICES[cfg.device].sub)
    }));
    if (n.id === 'verifier') return /*#__PURE__*/React.createElement(VerifierNode, _extends({
      key: n.id
    }, common, {
      state: verifierState,
      blockReason: auction ? auction.blockReason : ''
    }));
    if (n.id === 'exchange') return /*#__PURE__*/React.createElement(ExchangeNode, _extends({
      key: n.id
    }, common, {
      spinning: spinning,
      clock: clockDisp
    }));
    if (n.id === 'publisher') return /*#__PURE__*/React.createElement(PublisherNode, _extends({
      key: n.id
    }, common, {
      render: render,
      pixel: pixel && useTracking,
      format: cfg.format,
      formatLabel: FORMATS[cfg.format].label,
      winnerLabel: winnerDsp != null && auction ? auction.bids[winnerDsp].label : '—',
      winnerColor: WIN_COLOR
    }));
    if (n.cat === 'dsp') return /*#__PURE__*/React.createElement(DspNode, _extends({
      key: n.id
    }, common, {
      bid: auction ? auction.bids[n.dsp] : null,
      showBid: showBids,
      dealId: auction && auction.bids[n.dsp] ? auction.bids[n.dsp].dealId : null,
      isWinner: decided && winnerDsp === n.dsp,
      decided: decided,
      learning: !blockedView && stage && stage.id === 'track' && decided && winnerDsp === n.dsp
    }));
    return /*#__PURE__*/React.createElement(CardNode, _extends({
      key: n.id
    }, common));
  };
  const formatOpts = DEVICES[device].formats;
  const logEntries = useMemo(() => window.buildLog(auction, flow), [auction, flow, lang]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'viewport' + (pan ? ' pan' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "stage-wrap",
    style: {
      width: 1440 * scale,
      height: 960 * scale
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "stage",
    style: {
      transform: `scale(${scale})`
    }
  }, /*#__PURE__*/React.createElement(TopBar, {
    phase: phase,
    stepMode: stepMode,
    speed: speed,
    theme: theme,
    lang: lang,
    configOpen: configOpen,
    soundOn: soundOn,
    onPlay: start,
    onReset: reset,
    onStep: step,
    onToggleStep: toggleStep,
    onSpeed: setSpeed,
    onToggleTheme: () => setTheme(x => x === 'light' ? 'dark' : 'light'),
    onToggleConfig: () => setConfigOpen(v => !v),
    onToggleLang: () => setLang(x => x === 'pl' ? 'en' : 'pl'),
    onToggleSound: () => setSoundOn(v => !v),
    onTour: () => setTourActive(true),
    onGlossary: () => setGlossaryOpen(true),
    onDemo: startDemo,
    fraudLayer: fraudLayer,
    onFraudLayer: () => {
      setFraudLayer(v => !v);
      setFraudKey(null);
    },
    onFraudModule: () => setFraudModule(true),
    onAttentionModule: () => setAttentionModule(true),
    onBrandModule: () => setBrandModule(true)
  }), /*#__PURE__*/React.createElement("div", {
    className: "canvas"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-bg"
  }), /*#__PURE__*/React.createElement("svg", {
    className: "wires",
    viewBox: `0 0 ${CW} ${CH}`,
    preserveAspectRatio: "none"
  }, /*#__PURE__*/React.createElement(PipesLayer, {
    pipes: model.pipes,
    nodes: model.N,
    activePipes: activePipes,
    stageColor: stageColor,
    onHover: onPipeHover,
    onLeave: onPipeLeave
  }), /*#__PURE__*/React.createElement("g", {
    className: "packets"
  }, Array.from({
    length: POOL
  }).map((_, i) => /*#__PURE__*/React.createElement("circle", {
    key: i,
    ref: el => poolRef.current[i] = el,
    r: "3.8",
    opacity: "0"
  })))), model.nodes.map(renderNode), /*#__PURE__*/React.createElement(FraudOverlay, {
    active: fraudLayer,
    nodes: model.N,
    openKey: fraudKey,
    onOpen: k => setFraudKey(p => p === k ? null : k),
    onClose: () => setFraudKey(null),
    onOpenSim: atk => {
      setFraudKey(null);
      setFraudSeed(atk);
      setFraudModule(true);
    }
  }), phase !== 'idle' && /*#__PURE__*/React.createElement(LatencyBar, {
    clock: clockDisp,
    flow: flow,
    pos: blockedView ? verifyPos >= 0 ? verifyPos : pos : pos
  }), !hideAuction && /*#__PURE__*/React.createElement(AuctionPanel, {
    auction: decided && auction ? auction : null,
    winnerColor: WIN_COLOR,
    onClose: () => setHideAuction(true)
  }), !hideMoney && /*#__PURE__*/React.createElement(MoneyPanel, {
    money: decided && auction && !auction.blocked ? auction.money : null,
    winnerLabel: winnerLabel,
    onClose: () => setHideMoney(true)
  }), blockedView && auction && /*#__PURE__*/React.createElement("div", {
    className: "block-banner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bb-icon"
  }, "\u26D4"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "bb-title"
  }, window.tr('Показ заблокирован верификатором')), /*#__PURE__*/React.createElement("div", {
    className: "bb-desc"
  }, auction.blockReason === 'fraud' ? window.tr('Обнаружен невалидный трафик (fraud / IVT) — бот, а не живой пользователь. Показ снят с аукциона, деньги не списаны.') : window.tr('Контент не прошёл brand safety — небезопасное окружение для бренда. Показ снят с аукциона, деньги не списаны.'))))), /*#__PURE__*/React.createElement(BottomBar, {
    stage: stage,
    stageIndex: pos,
    total: flow.length,
    clock: clockDisp,
    auction: auction,
    winnerLabel: winnerLabel,
    winnerColor: WIN_COLOR,
    decided: decided,
    blockedView: blockedView,
    cfg: cfg,
    depth: t.depth,
    canSeek: phase === 'done' && !!auction && !auction.blocked,
    onSeek: seek
  }))), /*#__PURE__*/React.createElement(ConfigPanel, {
    open: configOpen,
    onClose: () => setConfigOpen(false),
    t: t,
    set: setTweak,
    formatOpts: formatOpts,
    FORMATS: FORMATS,
    onCompare: () => {
      setConfigOpen(false);
      setCompareOpen(true);
    },
    onSession: () => {
      setConfigOpen(false);
      setSessionOpen(true);
    },
    onGlossary: () => {
      setConfigOpen(false);
      setGlossaryOpen(true);
    },
    onPreset: runPreset,
    presets: window.PRESETS,
    onMode: applyMode,
    modes: window.MODES,
    onShare: shareScenario,
    onExport: () => window.print()
  }), hoverSig && /*#__PURE__*/React.createElement(SignalTip, {
    data: hoverSig.data,
    x: hoverSig.x,
    y: hoverSig.y
  }), /*#__PURE__*/React.createElement(DeepDive, {
    kind: deepDive,
    onClose: () => setDeepDive(null)
  }), /*#__PURE__*/React.createElement(Tour, {
    active: tourActive,
    onClose: () => setTourActive(false)
  }), /*#__PURE__*/React.createElement(Compare, {
    open: compareOpen,
    onClose: () => setCompareOpen(false),
    base: {
      count: dspCount,
      dmpOn: useDmp && t.dmpOn,
      firstPrice,
      floor: t.floor,
      device,
      format,
      dealType: t.dealType,
      supplyPath: t.supplyPath,
      consent: t.consent !== false,
      resellerHop: !!t.resellerHop
    }
  }), /*#__PURE__*/React.createElement(Session, {
    open: sessionOpen,
    onClose: () => setSessionOpen(false),
    base: {
      floor: t.floor
    }
  }), /*#__PURE__*/React.createElement(Glossary, {
    open: glossaryOpen,
    onClose: () => setGlossaryOpen(false)
  }), /*#__PURE__*/React.createElement(Quiz, {
    open: quizOpen,
    onClose: () => setQuizOpen(false),
    auction: auction
  }), /*#__PURE__*/React.createElement(RunLog, {
    open: logOpen,
    onToggle: () => setLogOpen(v => !v),
    entries: logEntries,
    pos: pos,
    done: phase === 'done'
  }), /*#__PURE__*/React.createElement(DemoCaption, {
    active: demoMode,
    stage: stage,
    blockedView: blockedView,
    decided: decided,
    auction: auction,
    onExit: exitDemo
  }), /*#__PURE__*/React.createElement(FraudModule, {
    open: fraudModule,
    onClose: () => setFraudModule(false),
    initialAttack: fraudSeed
  }), /*#__PURE__*/React.createElement(AttentionModule, {
    open: attentionModule,
    onClose: () => setAttentionModule(false)
  }), /*#__PURE__*/React.createElement(BrandModule, {
    open: brandModule,
    onClose: () => setBrandModule(false)
  }), phase === 'done' && !blockedView && auction && !auction.blocked && !demoMode && !quizOpen && /*#__PURE__*/React.createElement("button", {
    className: "quiz-cta",
    onClick: () => setQuizOpen(true)
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 9.2a2.8 2.8 0 0 1 5.4 1c0 1.9-2.6 2.4-2.6 4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.4h.01",
    strokeLinecap: "round"
  })), window.tr('Пройти квиз')), /*#__PURE__*/React.createElement(InfoPanel, {
    node: selected && model.N[selected] ? model.N[selected] : null,
    cat: selected && model.N[selected] ? cats[model.N[selected].cat] : cats.user,
    onClose: () => setSelected(null),
    onOpenInternals: k => setDeepDive(k),
    onOpenFraud: () => {
      setSelected(null);
      setFraudModule(true);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mobile-bar"
  }, /*#__PURE__*/React.createElement("button", {
    className: "mb-btn mb-primary",
    onClick: start
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5v14l11-7z",
    fill: "currentColor",
    stroke: "none"
  })), lang === 'pl' ? 'Uruchom' : lang === 'en' ? 'Run' : 'Пуск'), /*#__PURE__*/React.createElement("button", {
    className: "mb-btn",
    onClick: reset,
    "aria-label": "Reset"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4v6h6M20 20v-6h-6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9a8 8 0 0 0-14-3M5 15a8 8 0 0 0 14 3",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "mb-btn",
    onClick: () => setConfigOpen(true),
    "aria-label": lang === 'pl' ? 'Konfigurator' : lang === 'en' ? 'Configure' : 'Конфигуратор'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 7h9M17 7h4M3 17h4M12 17h9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "7",
    r: "2.3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "17",
    r: "2.3"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "mb-btn",
    onClick: () => setFraudModule(true),
    "aria-label": lang === 'pl' ? 'Fraud' : lang === 'en' ? 'Fraud' : 'Фрод'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 12l1.9 1.9L15 9.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "mb-btn attention-module-btn",
    onClick: () => setAttentionModule(true),
    "aria-label": lang === 'pl' ? 'Uwaga' : lang === 'en' ? 'Attention' : 'Внимание'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "2.6"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "mb-btn brand-module-btn",
    onClick: () => setBrandModule(true),
    "aria-label": lang === 'pl' ? 'Brand safety' : lang === 'en' ? 'Brand safety' : 'Brand safety'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "4.5",
    width: "18",
    height: "15",
    rx: "2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.2l2.6 2.6L16.5 9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "mb-btn",
    href: "/learn",
    "aria-label": lang === 'pl' ? 'Materiały' : lang === 'en' ? 'Learn' : 'Материалы'
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "3",
    width: "7",
    height: "7",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "3",
    width: "7",
    height: "7",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "14",
    width: "7",
    height: "7",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "14",
    width: "7",
    height: "7",
    rx: "1.5"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "mb-btn mb-lang",
    onClick: () => setLang(x => x === 'pl' ? 'en' : 'pl')
  }, lang === 'pl' ? 'EN' : 'PL')), /*#__PURE__*/React.createElement("div", {
    className: "author-credit",
    style: {
      position: 'fixed',
      right: '12px',
      bottom: '7px',
      zIndex: 4,
      fontSize: '10px',
      fontFamily: 'var(--font-mono, ui-monospace, monospace)',
      letterSpacing: '0.03em',
      color: 'var(--text-faint, #6b7280)',
      opacity: 0.6,
      pointerEvents: 'none',
      userSelect: 'none'
    }
  }, lang === 'pl' ? 'Stworzył Andrzej Goleta' : lang === 'en' ? 'Made by Andrey Goleta' : 'Сделал Андрей Голета'));
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(App, null));

;
